import Units from '../../../components/util/units';
/* eslint-disable no-undef, no-unused-expressions, no-new-func */

export default function loadBaseReplay3DApp() {
  const Cesium = window.Cesium;

  if (!Cesium) {
    throw new Error(getReplay3DText("CESIUM_NAO_CARREGADO"));
  }

  const UI = {
    appRoot: document.getElementById("replay3dBaseApp"),
    panelToggleBtn: document.getElementById("panelToggleBtn"),
    panelRestoreBtn: document.getElementById("panelRestoreBtn"),
    compactControls: document.getElementById("compactControls"),
    aircraftSelect: document.getElementById("aircraftSelect"),
    modelUrl: document.getElementById("modelUrl"),
    kmzFile: document.getElementById("kmzFile"),
    loadBtn: document.getElementById("loadBtn"),
    playBtn: document.getElementById("playBtn"),
    pauseBtn: document.getElementById("pauseBtn"),
    repeatBtn: document.getElementById("repeatBtn"),
    zoomInBtn: document.getElementById("zoomInBtn"),
    zoomOutBtn: document.getElementById("zoomOutBtn"),
    centerPlaneBtn: document.getElementById("centerPlaneBtn"),
    pathToggleBtn: document.getElementById("pathToggleBtn"),
    qualitySprayToggleBtn: document.getElementById("qualitySprayToggleBtn"),
    qualitySprayParameterSelect: document.getElementById("qualitySprayParameterSelect"),
    aircraftMarkerToggleBtn: document.getElementById("aircraftMarkerToggleBtn"),
    transitFocusToggleBtn: document.getElementById("transitFocusToggleBtn"),
    measureToggleBtn: document.getElementById("measureToggleBtn"),
    balloonMeasureToggleBtn: document.getElementById("balloonMeasureToggleBtn"),
    viewModeSelect: document.getElementById("viewModeSelect"),
    cameraHeadingOffset: document.getElementById("cameraHeadingOffset"),
    cameraPitch: document.getElementById("cameraPitch"),
    cameraRange: document.getElementById("cameraRange"),
    cameraHeadingOffsetValue: document.getElementById("cameraHeadingOffsetValue"),
    cameraPitchValue: document.getElementById("cameraPitchValue"),
    cameraRangeValue: document.getElementById("cameraRangeValue"),
    modelScale: document.getElementById("modelScale"),
    modelScaleValue: document.getElementById("modelScaleValue"),
    sprayFootprintColor: document.getElementById("sprayFootprintColor"),
    sprayFootprintOpacity: document.getElementById("sprayFootprintOpacity"),
    sprayFootprintOpacityValue: document.getElementById("sprayFootprintOpacityValue"),
    copySetupBtn: document.getElementById("copySetupBtn"),
    timelineSlider: document.getElementById("timelineSlider"),
    miniTimelineSlider: document.getElementById("miniTimelineSlider"),
    speedSelect: document.getElementById("speedSelect"),
    miniSpeedSelect: document.getElementById("miniSpeedSelect"),
    miniViewModeSelect: document.getElementById("miniViewModeSelect"),
    miniPlayBtn: document.getElementById("miniPlayBtn"),
    miniPauseBtn: document.getElementById("miniPauseBtn"),
    miniRepeatBtn: document.getElementById("miniRepeatBtn"),
    miniPathToggleBtn: document.getElementById("miniPathToggleBtn"),
    miniAircraftMarkerToggleBtn: document.getElementById("miniAircraftMarkerToggleBtn"),
    miniTransitFocusToggleBtn: document.getElementById("miniTransitFocusToggleBtn"),
    telemetryHectaresApplied: document.getElementById("telemetryHectaresApplied"),
    telemetryAircraftSpeed: document.getElementById("telemetryAircraftSpeed"),
    telemetryFlowInstant: document.getElementById("telemetryFlowInstant"),
    telemetryFlowAverage: document.getElementById("telemetryFlowAverage"),
    telemetryAltitude: document.getElementById("telemetryAltitude"),
    telemetryAltitudeAverage: document.getElementById("telemetryAltitudeAverage"),
    telemetryYieldHaPerHour: document.getElementById("telemetryYieldHaPerHour"),
    telemetryShot: document.getElementById("telemetryShot"),
    telemetryStrip: document.getElementById("telemetryStrip"),
    telemetryTimeSpray: document.getElementById("telemetryTimeSpray"),
    telemetryTimeBalloon: document.getElementById("telemetryTimeBalloon"),
    telemetryTimeTransit: document.getElementById("telemetryTimeTransit"),
    telemetryTimeRefuel: document.getElementById("telemetryTimeRefuel"),
    telemetryTimeTotal: document.getElementById("telemetryTimeTotal"),
    telemetryFuelLevel: document.getElementById("telemetryFuelLevel"),
    telemetryFuelPercent: document.getElementById("telemetryFuelPercent"),
    telemetryRefuelCount: document.getElementById("telemetryRefuelCount"),
    statusBox: document.getElementById("statusBox")
  };

  const replay3DTexts = window.__travicarReplay3DTexts || {};

  function getReplay3DText(key) {
    return replay3DTexts[key];
  }

  const appConfigUrl = "./config.json";
  const aircraftCustomOption = "__custom__";
  const defaultAppConfig = {
    cesiumIonToken: "",
    modelUrl: "./assets/replay_3d/models/emb-200/aeronave.glb",
    defaultFlightFileUrl: "",
    aircraftCatalogUrl: "./assets/replay_3d/models/catalog.json",
    defaultAircraftId: "emb200",
    aircraftModels: [],
    useArcGisBasemap: true,
    useWorldTerrain: false,
    maxTrackPoints: 8000,
    modelScale: 0.2,
    autoScaleBySprayWidth: true,
    minimumPixelSize: 18,
    enableTurnBanking: true,
    turnBankMaxDeg: 35,
    turnBankFactor: 3.2,
    turnBankSmoothing: 0.52,
    turnBankDeadzoneDegPerSec: 0.5,
    turnBankSign: 1,
    enableInferredSprayDirectionFilter: true,
    inferredSprayDirectionToleranceDeg: 35,
    inferredSprayMinAlignedPoints: 3,
    inferredSprayGapBridgePoints: 2,
    sprayEnterConfirmSegments: 2,
    sprayExitConfirmSegments: 3,
    sprayBridgeGapSegments: 1,
    sprayManeuverHeadingDeltaDeg: 30,
    sprayManeuverCooldownSegments: 3,
    sprayAntiRepaintGridMeters: 2.5,
    sprayPolygonInnerBufferMeters: 1.5,
    enableRealSpeedAltitudeAdjustment: true,
    realSpeedAltitudeLowSpeedMps: 45,
    realSpeedAltitudeHighSpeedMps: 75,
    realSpeedAltitudeLowSpeedDeltaMeters: -7,
    realSpeedAltitudeHighSpeedDeltaMeters: -1.5,
    realSpeedAltitudeSmoothing: 0.25,
    realSpeedAltitudeBlendDistanceMeters: 450,
    realSpeedAltitudeMinClampMeters: 8,
    realSpeedAltitudeApplyOnlyWhenSpraying: false,
    enableInitialStableAltitudeStart: true,
    initialStableAltitudeMaxMeters: 18,
    initialStableAltitudeWindowSeconds: 8,
    initialStableAltitudeRangeMeters: 5,
    initialStableAltitudeRequiredPreviousPeakMeters: 35,
    initialStableAltitudeRequiredDropMeters: 20,
    initialStableAltitudeMaxSearchSeconds: 180,
    initialStableAltitudeKeepBackSeconds: 0,
    enableObstacleAltitudeDropFilter: true,
    obstacleAltitudeDropMinMeters: 7,
    obstacleAltitudeDropMinRateMetersPerSecond: 2.5,
    obstacleAltitudeDropMaxRecoverySeconds: 18,
    obstacleAltitudeDropMaxRecoveryDistanceMeters: 800,
    obstacleAltitudeDropRecoveryToleranceMeters: 6,
    obstacleAltitudeDropMinStartAltitudeMeters: 10,
    obstacleAltitudeDropMaxPasses: 2,
    enableAltitudeValuePointLog: false,
    altitudeValueJumpLogMinMeters: 5,
    initialSpeed: 1,
    initialViewMode: "orbit",
    cameraHeadingOffsetDeg: 61,
    cameraPitchDeg: -20,
    cameraRangeMeters: 640,
    cameraChaseHeadingSmoothingSec: 0.26,
    positionInterpolationAlgorithm: "linear",
    positionInterpolationDegree: 1,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: 90,
    modelRollOffsetDeg: 0,
    modelAltitudeOffsetMeters: 5,
    modelBrightnessMix: 0,
    modelBrightnessColor: "#ffffff",
    sprayFootprintColor: "#32a852",
    sprayFootprintOpacity: 0.8,
    enableSprayMist: true,
    sprayMistColor: "",
    sprayMistOpacity: 0.72,
    sprayMistGlowPower: 0.55,
    sprayMistLineCount: 8,
    sprayMistWhiteness: 0.62,
    sprayMistTurbulenceMeters: 0.95,
    sprayMistVerticalTurbulenceMeters: 0.36,
    sprayMistTurbulenceFrequency: 1.35,
    sprayMistLaneBackSpreadMeters: 1.45,
    sprayMistWidthFactor: 1,
    sprayMistBackOffsetMeters: 4.5,
    sprayMistVerticalOffsetMeters: -1.4,
    sprayMistTrailSpacingMeters: 4.8,
    sprayMistMaxTrailPoints: 42,
    sprayMistFadeOutSeconds: 0.95,
    sprayMistLineWidthFactor: 0.14,
    sprayMistMinLineWidthPx: 1.8,
    sprayMistMaxLineWidthPx: 6,
    enablePropellerAnimation: true,
    enableTransitFocusMode: false,
    transitFocusDistanceMeters: 4000,
    balloonMeasureTransladoHideDistanceMeters: 1800,
    propellerGroups: []
  };

  const state = {
    viewer: null,
    flightEntity: null,
    aircraftMarker: null,
    pathEntities: [],
    progressivePathEntity: null,
    progressivePathPositions: [],
    timelinePoints: [],
    sprayFlags: [],
    segmentSprayDecisions: [],
    startSec: 0,
    endSec: 0,
    durationSec: 0,
    isPlaying: false,
    repeatEnabled: false,
    panelCollapsed: false,
    speed: 1,
    rafId: null,
    lastFrameMs: 0,
    isScrubbing: false,
    cameraMode: "follow",
    cameraTickBound: null,
    appConfig: { ...defaultAppConfig },
    modelOffsetsDeg: {
      heading: defaultAppConfig.modelHeadingOffsetDeg,
      pitch: defaultAppConfig.modelPitchOffsetDeg,
      roll: defaultAppConfig.modelRollOffsetDeg
    },
    cameraOffsets: {
      headingDeg: 0,
      pitchDeg: -30,
      rangeMeters: 240
    },
    orientationProperty: null,
    flightHeadingProperty: null,
    turnBankProperty: null,
    modelScale: defaultAppConfig.modelScale,
    estimatedSprayWidthMeters: null,
    lastStatusUpdateMs: 0,
    lastShownNearestIndex: -1,
    lastQuerySec: null,
    currentBankDeg: 0,
    sprayFootprintRuns: [],
    sprayFootprintAreaLabels: [],
    sprayFootprintLastIndex: -1,
    officialSprayFootprintSourceData: null,
    officialSprayFootprintAvailable: false,
    sprayDefaultWidthMeters: null,
    pathVisibilityMode: "none",
    progressivePathVisible: true,
    aircraftMarkerVisible: false,
    transitFocusEnabled: false,
    sprayAreaReferencePoint: null,
    measureVisible: false,
    measureAvailable: false,
    measureEntities: [],
    balloonMeasureVisible: false,
    balloonMeasureAvailable: false,
    balloonMeasureRuns: [],
    balloonMeasureRunByPoint: [],
    trackCumulativeMeters: [],
    balloonMeasureEntities: {
      lengthLine: null,
      widthLine: null,
      lengthLabel: null,
      widthLabel: null
    },
    balloonMeasureActiveRunIndex: -1,
    balloonMeasureSmoothedLengthMeters: null,
    balloonMeasureSmoothedWidthMeters: null,
    balloonMeasureSuppressedRunIndex: -1,
    telemetryCumulativeSpraySec: [],
    telemetryCumulativeBalloonSec: [],
    telemetryCumulativeTransitSec: [],
    telemetryCumulativeAreaM2: [],
    telemetryCumulativeRefuelSec: [],
    telemetrySegmentTypes: [],
    telemetryAverageAltitudeMeters: null,
    telemetryOfficialTotalSec: null,
    telemetryLastUiUpdateMs: 0,
    aircraftModels: [],
    activeAircraftId: "",
    cameraSmoothedHeadingRad: null,
    cameraHeadingLastUpdateMs: 0,
    mouseMapInputHandler: null,
    hasShownMouseFreeModeHint: false,
    renderRecoveryLevel: 0,
    sprayFootprintGpuSafeMode: false,
    disableSprayFootprintRendering: false,
    disableModelSilhouette: false,
    propellerEnabled: false,
    propellerGroupsRuntime: [],
    sprayMistEntities: [],
    sprayMistTrails: [],
    sprayMistLaneMeta: [],
    sprayMistLastNearestIndex: -1,
    sprayMistLastSpraySec: null,
    sprayMistCurrentLineWidthPx: 6,
    sprayMistMaterials: [],
    sprayMistStyleSignature: "",
    sprayDisplayActive: false,
    sprayDisplayOnStreak: 0,
    sprayDisplayOffStreak: 0,
    sprayDisplayLastIndex: -1,
    sprayQualityEnabled: false,
    sprayQualityParameter: "aplicacao",
    sprayQualityAvailability: {},
    sprayQualityConfig: null,
    sprayFootprintStyle: {
      color: defaultAppConfig.sprayFootprintColor,
      opacity: defaultAppConfig.sprayFootprintOpacity
    },
    screenCompassElements: {},
    screenCompassOverlay: null,
    screenCompassPostRenderListener: null,
    initialTilesReadyListener: null,
    initialTilesReadyTimer: null,
    initialTilesReadyTimeout: null,
    initialStableAltitudeTrimInfo: null,
    obstacleAltitudeDropFilterInfo: null,
    lastAltitudeValueLogIndex: -1,
    holdAircraftPositionDuringRefuel: true,
    refuelPositionHoldSampleCount: 0
  };

  const scratchBaseOrientation = new Cesium.Quaternion();
  const scratchBankQuat = new Cesium.Quaternion();
  const scratchWithBankOrientation = new Cesium.Quaternion();
  const scratchModelOffsetQuat = new Cesium.Quaternion();
  const scratchBankHpr = new Cesium.HeadingPitchRoll();
  const scratchModelHpr = new Cesium.HeadingPitchRoll();
  const scratchFinalOrientation = new Cesium.Quaternion();
  const scratchAheadTime = new Cesium.JulianDate();
  const scratchCurrentPosition = new Cesium.Cartesian3();
  const scratchNextPosition = new Cesium.Cartesian3();
  const scratchCurrentCartographic = new Cesium.Cartographic();
  const scratchNextCartographic = new Cesium.Cartographic();
  const webMercatorProjection = new Cesium.WebMercatorProjection();
  const scratchGridCartographic = new Cesium.Cartographic();
  const scratchGridCartesian = new Cesium.Cartesian3();
  const scratchPropellerQuat = new Cesium.Quaternion();
  const scratchPropellerSpinQuat = new Cesium.Quaternion();
  const scratchPropellerTiltQuat = new Cesium.Quaternion();
  const scratchPropellerMatrix = new Cesium.Matrix3();
  const scratchPropellerRotatedPivot = new Cesium.Cartesian3();
  const scratchMistPosition = new Cesium.Cartesian3();
  const scratchMistEnuMatrix4 = new Cesium.Matrix4();
  const scratchMistEnuMatrix3 = new Cesium.Matrix3();
  const scratchMistEast = new Cesium.Cartesian3();
  const scratchMistNorth = new Cesium.Cartesian3();
  const scratchMistUp = new Cesium.Cartesian3();
  const scratchMistScaledNorth = new Cesium.Cartesian3();
  const scratchMistScaledEast = new Cesium.Cartesian3();
  const scratchMistForward = new Cesium.Cartesian3();
  const scratchMistRight = new Cesium.Cartesian3();
  const scratchMistOffset = new Cesium.Cartesian3();
  const scratchMistCenter = new Cesium.Cartesian3();
  const scratchMistRightPos = new Cesium.Cartesian3();

  init();

  async function init() {
    state.viewer = createViewer();
    installScreenCompass();
    ensureReplay3DStyleAdjustments();
    createProgressivePathToggleButton();
    installRenderErrorRecovery();
    configureMouseMapControls();

    UI.loadBtn.addEventListener("click", handleLoadFlight);
    UI.playBtn.addEventListener("click", play);
    UI.pauseBtn.addEventListener("click", pause);
    UI.repeatBtn.addEventListener("click", toggleRepeatMode);
    UI.panelToggleBtn?.addEventListener("click", togglePanelVisibility);
    UI.panelRestoreBtn?.addEventListener("click", togglePanelVisibility);
    UI.miniPlayBtn?.addEventListener("click", play);
    UI.miniPauseBtn?.addEventListener("click", pause);
    UI.miniRepeatBtn?.addEventListener("click", toggleRepeatMode);
    UI.miniPathToggleBtn?.addEventListener("click", togglePathVisibilityMini);
    UI.miniAircraftMarkerToggleBtn?.addEventListener("click", toggleAircraftMarkerVisibility);
    UI.zoomInBtn.addEventListener("click", zoomInMap);
    UI.zoomOutBtn.addEventListener("click", zoomOutMap);
    UI.centerPlaneBtn.addEventListener("click", centerOnAircraft);
    UI.pathToggleBtn.addEventListener("click", togglePathVisibility);
    if (UI.qualitySprayToggleBtn) UI.qualitySprayToggleBtn.addEventListener("click", toggleSprayQualityMode);
    if (UI.qualitySprayParameterSelect) UI.qualitySprayParameterSelect.addEventListener("change", onSprayQualityParameterChange);
    if (UI.progressivePathToggleBtn) {
      UI.progressivePathToggleBtn.addEventListener("click", toggleProgressivePathVisibility);
    }
    UI.aircraftMarkerToggleBtn.addEventListener("click", toggleAircraftMarkerVisibility);
    UI.transitFocusToggleBtn.addEventListener("click", toggleTransitFocusMode);
    UI.miniTransitFocusToggleBtn?.addEventListener("click", toggleTransitFocusMode);
    UI.measureToggleBtn.addEventListener("click", toggleMeasureVisibility);
    UI.balloonMeasureToggleBtn.addEventListener("click", toggleBalloonMeasureVisibility);
    UI.aircraftSelect.addEventListener("change", onAircraftSelectChange);
    UI.modelUrl.addEventListener("change", onModelUrlManualChange);
    UI.viewModeSelect.addEventListener("change", () => {
      onViewModeSelectChanged(UI.viewModeSelect.value);
    });
    UI.miniViewModeSelect?.addEventListener("change", () => {
      onViewModeSelectChanged(UI.miniViewModeSelect.value);
    });
    UI.cameraHeadingOffset.addEventListener("input", onCameraSettingsInput);
    UI.cameraPitch.addEventListener("input", onCameraSettingsInput);
    UI.cameraRange.addEventListener("input", onCameraSettingsInput);
    UI.modelScale.addEventListener("input", onModelScaleInput);
    if (UI.sprayFootprintColor) UI.sprayFootprintColor.addEventListener("input", onSprayFootprintStyleInput);
    UI.sprayFootprintOpacity.addEventListener("input", onSprayFootprintStyleInput);
    if (UI.copySetupBtn) UI.copySetupBtn.addEventListener("click", copyCurrentSetupToClipboard);
    UI.speedSelect.addEventListener("change", () => {
      setPlaybackSpeedFromControl(UI.speedSelect.value);
    });
    UI.miniSpeedSelect?.addEventListener("change", () => {
      setPlaybackSpeedFromControl(UI.miniSpeedSelect.value);
    });

    UI.timelineSlider.addEventListener("input", () => handleTimelineInput(UI.timelineSlider));
    UI.timelineSlider.addEventListener("change", handleTimelineChange);
    UI.miniTimelineSlider?.addEventListener("input", () => handleTimelineInput(UI.miniTimelineSlider));
    UI.miniTimelineSlider?.addEventListener("change", handleTimelineChange);

    setFlightControlsEnabled(false);
    state.cameraTickBound = () => updateCameraForMode();
    state.viewer.scene.preRender.addEventListener(state.cameraTickBound);

    await loadAppConfig();
    await loadAircraftCatalog();
    applyInitialAircraftSelection();
    applyInitialRuntimeSettingsFromConfig();
    syncCameraControlsUI();
    syncModelAlignmentUI();
    syncModelScaleUI();
    syncSprayFootprintStyleUI();
    syncPathToggleButtonUI();
    syncSprayQualityControlsUI();
    syncProgressivePathToggleButtonUI();
    syncAircraftMarkerToggleButtonUI();
    syncTransitFocusToggleButtonUI();
    syncMeasureToggleButtonUI();
    syncBalloonMeasureToggleButtonUI();
    syncRepeatButtonUI();
    syncPanelToggleButtonUI();
    await applyBasemapFromConfig();
    state.telemetryCumulativeRefuelSec = computeCumulativeRefuelSeconds(state.timelinePoints);
    resetTelemetryBoard();
    await tryAutoLoadDefaultFlight();
  }

  function ensureReplay3DStyleAdjustments() {
    const styleId = "replay3dStyleAdjustments";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        #telemetryHectaresApplied,
        #telemetryAircraftSpeed,
        #telemetryFlowInstant,
        #telemetryFlowAverage,
        #telemetryAltitude,
        #telemetryAltitudeAverage,
        #telemetryYieldHaPerHour,
        #telemetryShot,
        #telemetryStrip,
        #telemetryTimeSpray,
        #telemetryTimeBalloon,
        #telemetryTimeTransit,
        #telemetryTimeRefuel,
        #telemetryTimeTotal,
        #telemetryFuelLevel,
        #telemetryFuelPercent,
        #telemetryRefuelCount {
          color: #ffffff !important;
        }
      `;
      document.head.appendChild(style);
    }

    applyTelemetryBoardTextColor();
  }

  function applyTelemetryBoardTextColor() {
    applyTelemetryBoardLabels();
    const telemetryElements = [
      UI.telemetryHectaresApplied,
      UI.telemetryAircraftSpeed,
      UI.telemetryFlowInstant,
      UI.telemetryFlowAverage,
      UI.telemetryAltitude,
      UI.telemetryAltitudeAverage,
      UI.telemetryYieldHaPerHour,
      UI.telemetryShot,
      UI.telemetryStrip,
      UI.telemetryTimeSpray,
      UI.telemetryTimeBalloon,
      UI.telemetryTimeTransit,
      UI.telemetryTimeRefuel,
      UI.telemetryTimeTotal
    ].filter(Boolean);

    for (const element of telemetryElements) {
      element.style.setProperty("color", "#ffffff", "important");
      if (element.parentElement) {
        element.parentElement.style.setProperty("color", "#ffffff", "important");
        const rowItems = element.parentElement.children || [];
        for (let i = 0; i < rowItems.length; i++) {
          rowItems[i].style.setProperty("color", "#ffffff", "important");
        }
      }
    }

    const board = findTelemetryBoardContainer(telemetryElements);
    if (!board) {
      return;
    }

    const titleElement = findTelemetryBoardTitleElement(board);
    if (titleElement) {
      titleElement.style.setProperty("color", "#ffffff", "important");
      titleElement.style.setProperty("font-weight", "700", "important");
      titleElement.style.setProperty("font-size", "14px", "important");
    }
  }


  function applyTelemetryBoardLabels() {
    setTelemetryRowLabel(UI.telemetryFlowInstant, getReplay3DText("FLUXO_INSTANTANEO"), getReplay3DText("FLUXO"));
  }

  function setTelemetryRowLabel(valueElement, oldLabel, newLabel) {
    if (!valueElement || !valueElement.parentElement) {
      return;
    }

    const parent = valueElement.parentElement;
    const oldNormalized = normalizeTelemetryLabelText(oldLabel);

    for (let i = 0; i < parent.childNodes.length; i++) {
      const node = parent.childNodes[i];
      if (node === valueElement || valueElement.contains(node)) {
        continue;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const normalized = normalizeTelemetryLabelText(node.textContent);
        if (normalized === oldNormalized || normalized.indexOf(oldNormalized) !== -1) {
          node.textContent = String(node.textContent || "").replace(oldLabel, newLabel).replace("Fluxo instantaneo", newLabel);
          return;
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const normalized = normalizeTelemetryLabelText(node.textContent);
        if (normalized === oldNormalized || normalized.indexOf(oldNormalized) !== -1) {
          node.textContent = newLabel;
          return;
        }
      }
    }
  }

  function normalizeTelemetryLabelText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function findTelemetryBoardTitleElement(board) {
    const candidates = board.querySelectorAll("h1, h2, h3, h4, h5, h6, strong, div, span, p");
    for (let i = 0; i < candidates.length; i++) {
      const text = String(candidates[i].textContent || "").trim().toLowerCase();
      if (text === "placar de operação" || text === "placar de operacao") {
        return candidates[i];
      }
    }

    const children = board.children || [];
    for (let i = 0; i < children.length; i++) {
      const text = String(children[i].textContent || "").trim().toLowerCase();
      if (text.indexOf("placar de operação") === 0 || text.indexOf("placar de operacao") === 0) {
        return children[i];
      }
    }

    return null;
  }

  function findTelemetryBoardContainer(telemetryElements) {
    if (!telemetryElements.length) {
      return null;
    }

    let current = telemetryElements[0];
    let fallback = null;

    while (current && current !== document.body && current !== UI.appRoot) {
      let containsAll = true;
      for (const element of telemetryElements) {
        if (!current.contains(element)) {
          containsAll = false;
          break;
        }
      }

      if (containsAll) {
        const rect = current.getBoundingClientRect ? current.getBoundingClientRect() : null;
        if (!rect || rect.width <= 520) {
          if (!fallback) {
            fallback = current;
          }

          const text = String(current.textContent || "").toLowerCase();
          if (text.indexOf("placar de operação") !== -1 || text.indexOf("placar de operacao") !== -1) {
            return current;
          }
        }
      }

      current = current.parentElement;
    }

    return fallback;
  }

  function createProgressivePathToggleButton() {
    if (!UI.pathToggleBtn || UI.progressivePathToggleBtn) {
      return;
    }

    let button = document.getElementById("progressivePathToggleBtn");
    if (!button) {
      button = document.createElement("button");
      button.id = "progressivePathToggleBtn";
      button.type = "button";
      button.className = UI.pathToggleBtn.className || "";
      button.style.width = UI.pathToggleBtn.style.width || "";
      button.style.marginBottom = "6px";
      UI.pathToggleBtn.parentElement.insertBefore(button, UI.pathToggleBtn);
    }

    UI.pathToggleBtn.style.marginTop = "0";
    UI.progressivePathToggleBtn = button;
    syncProgressivePathToggleButtonUI();
  }

  function handleTimelineInput(sliderEl) {
    if (!sliderEl || !state.timelinePoints.length) {
      return;
    }
    state.isScrubbing = true;
    const tSec = sliderToTime(Number(sliderEl.value));
    setCurrentTime(tSec, true);
  }

  function handleTimelineChange() {
    state.isScrubbing = false;
  }

  function setPlaybackSpeedFromControl(rawValue) {
    const speedValue = normalizeSpeedValue(rawValue);
    state.speed = speedValue;
    UI.speedSelect.value = String(speedValue);
    if (UI.miniSpeedSelect) {
      UI.miniSpeedSelect.value = String(speedValue);
    }
  }

  function syncViewModeSelectUI() {
    const mode = normalizeViewMode(state.cameraMode);
    UI.viewModeSelect.value = mode;
    if (UI.miniViewModeSelect) {
      UI.miniViewModeSelect.value = mode;
    }
  }

  function onViewModeSelectChanged(modeValue) {
    const mode = normalizeViewMode(modeValue);
    applyViewMode(mode);
    syncViewModeSelectUI();
  }

  function setFlightControlsEnabled(enabled) {
    UI.playBtn.disabled = !enabled;
    UI.pauseBtn.disabled = !enabled;
    UI.repeatBtn.disabled = !enabled;
    if (UI.miniPlayBtn) UI.miniPlayBtn.disabled = !enabled;
    if (UI.miniPauseBtn) UI.miniPauseBtn.disabled = !enabled;
    if (UI.miniRepeatBtn) UI.miniRepeatBtn.disabled = !enabled;
    if (UI.miniPathToggleBtn) UI.miniPathToggleBtn.disabled = !enabled;
    if (UI.miniAircraftMarkerToggleBtn) UI.miniAircraftMarkerToggleBtn.disabled = !enabled;
    UI.timelineSlider.disabled = !enabled;
    if (UI.miniTimelineSlider) UI.miniTimelineSlider.disabled = !enabled;
    UI.speedSelect.disabled = !enabled;
    if (UI.miniSpeedSelect) UI.miniSpeedSelect.disabled = !enabled;
    if (UI.miniViewModeSelect) UI.miniViewModeSelect.disabled = !enabled;
    UI.centerPlaneBtn.disabled = !enabled;
    UI.pathToggleBtn.disabled = !enabled;
    if (UI.qualitySprayToggleBtn) UI.qualitySprayToggleBtn.disabled = !enabled;
    if (UI.qualitySprayParameterSelect) UI.qualitySprayParameterSelect.disabled = !enabled || !state.sprayQualityEnabled;
    if (UI.progressivePathToggleBtn) UI.progressivePathToggleBtn.disabled = !enabled;
    UI.aircraftMarkerToggleBtn.disabled = !enabled;
    const transitFocusAvailable = enabled && !!state.sprayAreaReferencePoint;
    UI.transitFocusToggleBtn.disabled = !transitFocusAvailable;
    if (UI.miniTransitFocusToggleBtn) UI.miniTransitFocusToggleBtn.disabled = !transitFocusAvailable;
    UI.measureToggleBtn.disabled = !enabled || !state.measureAvailable;
    UI.balloonMeasureToggleBtn.disabled = !enabled || !state.balloonMeasureAvailable;
    UI.viewModeSelect.disabled = !enabled;
    UI.cameraHeadingOffset.disabled = !enabled;
    UI.cameraPitch.disabled = !enabled;
    UI.cameraRange.disabled = !enabled;
    UI.modelScale.disabled = !enabled;
    if (UI.sprayFootprintColor) UI.sprayFootprintColor.disabled = !enabled || state.sprayQualityEnabled;
    UI.sprayFootprintOpacity.disabled = !enabled || state.sprayQualityEnabled;
  }

  async function loadAppConfig() {
    try {
      const response = await fetch(appConfigUrl, { cache: "no-store" });
      if (!response.ok) {
        return;
      }

      const parsed = await response.json();
      state.appConfig = {
        ...defaultAppConfig,
        ...(parsed || {})
      };

      state.modelOffsetsDeg.heading = Number(state.appConfig.modelHeadingOffsetDeg ?? defaultAppConfig.modelHeadingOffsetDeg);
      state.modelOffsetsDeg.pitch = Number(state.appConfig.modelPitchOffsetDeg ?? defaultAppConfig.modelPitchOffsetDeg);
      state.modelOffsetsDeg.roll = Number(state.appConfig.modelRollOffsetDeg ?? defaultAppConfig.modelRollOffsetDeg);
      state.modelScale = Number(state.appConfig.modelScale ?? defaultAppConfig.modelScale);

      if (state.appConfig.modelUrl) {
        UI.modelUrl.value = normalizeModelUrl(state.appConfig.modelUrl);
      }
    } catch (error) { }
  }

  async function loadAircraftCatalog() {
    let models = normalizeAircraftModelsArray(window.__travicarReplay3DAircraftModels);

    if (!models.length) {
      models = normalizeAircraftModelsArray(state.appConfig.aircraftModels);
    }

    if (!models.length) {
      const catalogUrl = String(state.appConfig.aircraftCatalogUrl || defaultAppConfig.aircraftCatalogUrl || "").trim();
      if (catalogUrl) {
        try {
          const response = await fetch(catalogUrl, { cache: "no-store" });
          if (response.ok) {
            const parsed = await response.json();
            const rawModels = Array.isArray(parsed) ? parsed : parsed?.models;
            models = normalizeAircraftModelsArray(rawModels);
          }
        } catch (error) { }
      }
    }

    if (!models.length) {
      models = buildFallbackAircraftModels();
    }

    state.aircraftModels = models;
    syncAircraftSelectOptions();
  }

  function normalizeAircraftModelsArray(rawModels) {
    if (!Array.isArray(rawModels)) {
      return [];
    }

    const usedIds = new Set();
    const out = [];

    for (let i = 0; i < rawModels.length; i++) {
      const item = rawModels[i];
      if (!item || typeof item !== "object") {
        continue;
      }

      const url = normalizeModelUrl(item.url ?? item.modelUrl);
      if (!url) {
        continue;
      }

      const baseId = sanitizeAircraftId(item.id ?? item.name ?? `model_${i + 1}`);
      const id = makeUniqueAircraftId(baseId, usedIds);
      usedIds.add(id);

      const label = normalizeAircraftModelLabel(item.label ?? item.name, url, id, i + 1);
      out.push({
        id,
        label,
        url,
        scale: toFiniteNumberOrNull(item.scale ?? item.modelScale),
        modelHeadingOffsetDeg: toFiniteNumberOrNull(item.modelHeadingOffsetDeg),
        modelPitchOffsetDeg: toFiniteNumberOrNull(item.modelPitchOffsetDeg),
        modelRollOffsetDeg: toFiniteNumberOrNull(item.modelRollOffsetDeg),
        modelAltitudeOffsetMeters: toFiniteNumberOrNull(item.modelAltitudeOffsetMeters),
        minimumPixelSize: toFiniteNumberOrNull(item.minimumPixelSize),
        modelBrightnessMix: toFiniteNumberOrNull(item.modelBrightnessMix),
        modelBrightnessColor: normalizeOptionalHexColor(item.modelBrightnessColor),
        sprayMistBackOffsetMeters: toFiniteNumberOrNull(item.sprayMistBackOffsetMeters),
        sprayMistVerticalOffsetMeters: toFiniteNumberOrNull(item.sprayMistVerticalOffsetMeters),
        propellerGroups: normalizePropellerGroups(item.propellerGroups)
      });
    }

    return out;
  }

  function buildFallbackAircraftModels() {
    const rawCandidates = [
      state.appConfig.modelUrl,
      UI.modelUrl.value,
      defaultAppConfig.modelUrl
    ];

    const seen = new Set();
    const out = [];

    for (const rawUrl of rawCandidates) {
      const normalizedUrl = normalizeModelUrl(rawUrl);
      if (!normalizedUrl) {
        continue;
      }

      const key = comparableModelUrl(normalizedUrl);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);

      const idx = out.length + 1;
      out.push({
        id: idx === 1 ? "default" : `model_${idx}`,
        label: normalizeAircraftModelLabel("", normalizedUrl, idx === 1 ? "default" : `model_${idx}`, idx),
        url: normalizedUrl,
        scale: null,
        modelHeadingOffsetDeg: null,
        modelPitchOffsetDeg: null,
        modelRollOffsetDeg: null,
        modelAltitudeOffsetMeters: null,
        minimumPixelSize: null,
        modelBrightnessMix: null,
        modelBrightnessColor: null,
        sprayMistBackOffsetMeters: null,
        sprayMistVerticalOffsetMeters: null,
        propellerGroups: []
      });
    }

    return out;
  }

  function normalizeAircraftModelLabel(rawLabel, rawUrl, fallbackId, index) {
    const label = String(rawLabel || "").trim();
    if (label) {
      return label;
    }

    const url = normalizeModelUrl(rawUrl);
    const comparableUrl = comparableModelUrl(url);
    if (comparableUrl.indexOf("emb-200") !== -1 || comparableUrl.indexOf("emb200") !== -1) {
      return "EMB-200 Ipanema";
    }

    const parts = url.split("/").filter(Boolean);
    const filename = parts.length ? parts[parts.length - 1] : "";
    const folder = parts.length > 1 ? parts[parts.length - 2] : "";
    const nameFromPath = String(folder || filename || fallbackId || "").replace(/\.glb$/i, "").replace(/[-_]+/g, " ").trim();
    if (nameFromPath) {
      return nameFromPath.split(" ").filter(Boolean).map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }

    return `${getReplay3DText("AERONAVE")} ${index || 1}`;
  }

  function sanitizeAircraftId(rawId) {
    const text = String(rawId || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
    return text || "modelo";
  }

  function makeUniqueAircraftId(baseId, usedIds) {
    if (!usedIds.has(baseId)) {
      return baseId;
    }

    let idx = 2;
    while (usedIds.has(`${baseId}_${idx}`)) {
      idx += 1;
    }
    return `${baseId}_${idx}`;
  }

  function toFiniteNumberOrNull(raw) {
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  }

  function normalizeOptionalHexColor(raw) {
    if (raw === undefined || raw === null || raw === "") {
      return null;
    }
    const normalized = normalizeHexColor(raw, "");
    return normalized || null;
  }

  function normalizePropellerNodes(raw) {
    if (!Array.isArray(raw)) {
      return [];
    }
    const out = [];
    for (const item of raw) {
      const value = String(item || "").trim();
      if (value && !out.includes(value)) {
        out.push(value);
      }
    }
    return out;
  }

  function normalizePropellerAxis(raw) {
    const axis = String(raw || "").trim().toLowerCase();
    if (axis === "x" || axis === "y" || axis === "z") {
      return axis;
    }
    return null;
  }

  function normalizePropellerAxisVector(raw) {
    const vec = normalizeOptionalVector3(raw);
    if (!vec) {
      return null;
    }
    const mag = Math.hypot(vec[0], vec[1], vec[2]);
    if (!Number.isFinite(mag) || mag < 1e-9) {
      return null;
    }
    return [vec[0] / mag, vec[1] / mag, vec[2] / mag];
  }

  function normalizeOptionalVector3(raw) {
    if (!Array.isArray(raw) || raw.length < 3) {
      return null;
    }
    const x = Number(raw[0]);
    const y = Number(raw[1]);
    const z = Number(raw[2]);
    if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(z)) {
      return null;
    }
    return [x, y, z];
  }

  function normalizePropellerPivotByNode(raw) {
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
      return {};
    }
    const out = {};
    for (const [key, value] of Object.entries(raw)) {
      const nodeName = String(key || "").trim();
      const vec = normalizeOptionalVector3(value);
      if (!nodeName || !vec) {
        continue;
      }
      out[nodeName] = vec;
    }
    return out;
  }

  function normalizePropellerGroup(raw, fallbackId = "") {
    if (!raw || typeof raw !== "object") {
      return null;
    }
    const nodes = normalizePropellerNodes(raw.nodes);
    if (!nodes.length) {
      return null;
    }
    const id = sanitizeAircraftId((raw.id ?? raw.name ?? fallbackId) || "grupo");
    const axis = normalizePropellerAxis(raw.axis) || "y";
    const axisVector = normalizePropellerAxisVector(raw.axisVector);
    const rpmRaw = Number(raw.rpm);
    const rpm = Number.isFinite(rpmRaw) ? clamp(rpmRaw, 0, 5000) : 1200;
    const spinSign = Number(raw.spinSign) >= 0 ? 1 : -1;
    const pivot = normalizeOptionalVector3(raw.pivot);
    const pivotByNode = normalizePropellerPivotByNode(raw.pivotByNode);
    const translationOffset = normalizeOptionalVector3(raw.translationOffset);
    const scale = normalizeOptionalVector3(raw.scale);
    const tiltAxis = normalizePropellerAxis(raw.tiltAxis);
    const tiltDegRaw = Number(raw.tiltDeg);
    const tiltDeg = Number.isFinite(tiltDegRaw) ? tiltDegRaw : 0;
    return {
      id,
      nodes,
      axis,
      axisVector,
      rpm,
      spinSign,
      pivot,
      pivotByNode,
      translationOffset,
      scale,
      tiltAxis,
      tiltDeg
    };
  }

  function normalizePropellerGroups(raw) {
    if (!Array.isArray(raw)) {
      return [];
    }
    const out = [];
    for (let i = 0; i < raw.length; i++) {
      const group = normalizePropellerGroup(raw[i], `grupo_${i + 1}`);
      if (group) {
        out.push(group);
      }
    }
    return out;
  }

  function normalizeModelUrl(rawUrl) {
    const text = String(rawUrl || "").trim();
    if (!text) {
      return "";
    }
    return text.replace(/\\/g, "/");
  }

  function comparableModelUrl(rawUrl) {
    return normalizeModelUrl(rawUrl).toLowerCase();
  }

  function syncAircraftSelectOptions() {
    if (!UI.aircraftSelect) {
      return;
    }

    UI.aircraftSelect.innerHTML = "";

    for (const model of state.aircraftModels) {
      const opt = document.createElement("option");
      opt.value = model.id;
      opt.textContent = model.label;
      UI.aircraftSelect.appendChild(opt);
    }

    syncAircraftSelectValueFromCurrentUrl();
  }

  function syncAircraftSelectValueFromCurrentUrl() {
    if (!UI.aircraftSelect) {
      return;
    }

    if (state.activeAircraftId && state.aircraftModels.some((m) => m.id === state.activeAircraftId)) {
      UI.aircraftSelect.value = state.activeAircraftId;
      return;
    }

    const currentUrl = normalizeModelUrl(UI.modelUrl.value);
    const match = findAircraftByUrl(currentUrl);
    if (match) {
      state.activeAircraftId = match.id;
      UI.aircraftSelect.value = match.id;
      return;
    }

    const firstModel = state.aircraftModels[0] || null;
    if (firstModel) {
      state.activeAircraftId = firstModel.id;
      UI.aircraftSelect.value = firstModel.id;
      UI.modelUrl.value = firstModel.url;
      return;
    }

    state.activeAircraftId = "";
  }

  function getRuntimeDefaultAircraftId() {
    const runtimeId = window.__travicarReplay3DDefaultAircraftId || "";
    const runtimeType = window.__travicarReplay3DDefaultModelType || "";
    return runtimeId || runtimeType || "";
  }

  function normalizeRequestedAircraftId(rawValue) {
    let text = String(rawValue || "").trim().toLowerCase();

    if (text.normalize) {
      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    text = text.replace(/_/g, "-");

    if (!text) {
      return "";
    }

    const compactText = text.replace(/[\s-]+/g, "");

    if (text === "cessna-188" || compactText === "cessna" || compactText === "cessna188") {
      return "cessna-188";
    }

    if (
      text === "air-tractor-at-802" ||
      compactText === "at802" ||
      compactText === "at802a"
    ) {
      return "air-tractor-at-802";
    }

    if (
      compactText === "airtractor" ||
      text === "air-tractor-at-502b"
    ) {
      return "air-tractor-at-502b";
    }

    if (text === "thrush-510" || compactText === "thrush510") {
      return "thrush-510";
    }

    if (text === "emb-203" || compactText === "emb203") {
      return "emb-203";
    }

    if (
      compactText === "embraer" ||
      compactText === "emb200" ||
      compactText === "emb200ipanema" ||
      compactText === "ipanema"
    ) {
      return "emb200";
    }

    return "";
  }

  function findAircraftByRequestedId(rawValue) {
    const requestedId = normalizeRequestedAircraftId(rawValue);

    if (!requestedId) {
      return null;
    }

    const direct = findAircraftById(requestedId);
    if (direct) {
      return direct;
    }

    const requestedComparable = comparableModelUrl(requestedId);

    return state.aircraftModels.find((model) => {
      const idComparable = comparableModelUrl(model.id);
      const labelComparable = comparableModelUrl(model.label);
      const urlComparable = comparableModelUrl(model.url);

      return idComparable === requestedComparable ||
        labelComparable.indexOf(requestedComparable) >= 0 ||
        urlComparable.indexOf(requestedComparable) >= 0;
    }) || null;
  }

  function applyInitialAircraftSelection() {
    const runtimeDesiredId = normalizeRequestedAircraftId(getRuntimeDefaultAircraftId());
    const desiredId = runtimeDesiredId || normalizeRequestedAircraftId(state.appConfig.defaultAircraftId || "");
    const desiredUrl = normalizeModelUrl(state.appConfig.modelUrl);
    let selected = null;

    if (desiredId) {
      selected = findAircraftByRequestedId(desiredId);
    }
    if (!selected && desiredUrl) {
      selected = findAircraftByUrl(desiredUrl);
    }
    if (!selected && state.aircraftModels.length) {
      selected = state.aircraftModels[0];
    }

    if (selected) {
      applyAircraftModelSelection(selected, true);
      return;
    }

    UI.modelUrl.value = desiredUrl || defaultAppConfig.modelUrl;
    state.activeAircraftId = "";
    syncAircraftSelectValueFromCurrentUrl();
  }

  function findAircraftById(id) {
    return state.aircraftModels.find((model) => model.id === id) || null;
  }

  function findAircraftByUrl(url) {
    if (typeof url !== "string") {
      return null;
    }

    const key = comparableModelUrl(url);
    if (!key) {
      return null;
    }
    return state.aircraftModels.find((model) => comparableModelUrl(model.url) === key) || null;
  }

  function onAircraftSelectChange() {
    const selectedId = String(UI.aircraftSelect.value || "").trim();
    if (!selectedId) {
      return;
    }

    const selected = findAircraftById(selectedId);
    if (!selected) {
      return;
    }

    applyAircraftModelSelection(selected, true);
    setStatus(`Modelo selecionado: ${selected.label}`);
  }

  function onModelUrlManualChange() {
    const normalizedUrl = normalizeModelUrl(UI.modelUrl.value);
    UI.modelUrl.value = normalizedUrl || defaultAppConfig.modelUrl;

    const matched = findAircraftByUrl(UI.modelUrl.value);
    state.activeAircraftId = matched?.id || "";
    syncAircraftSelectValueFromCurrentUrl();

    state.appConfig.modelUrl = UI.modelUrl.value;
    state.appConfig.defaultAircraftId = state.activeAircraftId || "";
    applyModelUrlToCurrentEntity();
    applyModelAltitudeOffsetToCurrentEntity();
  }

  function applyAircraftModelSelection(model, applyPreset) {
    if (!model) {
      return;
    }

    UI.modelUrl.value = model.url;
    state.activeAircraftId = model.id;
    state.appConfig.modelUrl = model.url;
    state.appConfig.defaultAircraftId = model.id;

    if (applyPreset) {
      if (Number.isFinite(model.scale)) {
        state.modelScale = clamp(model.scale, 0.05, 1000);
      }
      if (Number.isFinite(model.modelHeadingOffsetDeg)) {
        state.modelOffsetsDeg.heading = model.modelHeadingOffsetDeg;
      }
      if (Number.isFinite(model.modelPitchOffsetDeg)) {
        state.modelOffsetsDeg.pitch = model.modelPitchOffsetDeg;
      }
      if (Number.isFinite(model.modelRollOffsetDeg)) {
        state.modelOffsetsDeg.roll = model.modelRollOffsetDeg;
      }
      if (Number.isFinite(model.modelAltitudeOffsetMeters)) {
        state.appConfig.modelAltitudeOffsetMeters = model.modelAltitudeOffsetMeters;
      } else {
        state.appConfig.modelAltitudeOffsetMeters = defaultAppConfig.modelAltitudeOffsetMeters;
      }
      if (Number.isFinite(model.minimumPixelSize)) {
        state.appConfig.minimumPixelSize = model.minimumPixelSize;
      }
      if (Number.isFinite(model.modelBrightnessMix)) {
        state.appConfig.modelBrightnessMix = clamp(model.modelBrightnessMix, 0, 1);
      }
      if (model.modelBrightnessColor) {
        state.appConfig.modelBrightnessColor = normalizeHexColor(
          model.modelBrightnessColor,
          defaultAppConfig.modelBrightnessColor
        );
      }
      if (Number.isFinite(model.sprayMistBackOffsetMeters)) {
        state.appConfig.sprayMistBackOffsetMeters = model.sprayMistBackOffsetMeters;
      } else {
        state.appConfig.sprayMistBackOffsetMeters = defaultAppConfig.sprayMistBackOffsetMeters;
      }
      if (Number.isFinite(model.sprayMistVerticalOffsetMeters)) {
        state.appConfig.sprayMistVerticalOffsetMeters = model.sprayMistVerticalOffsetMeters;
      } else {
        state.appConfig.sprayMistVerticalOffsetMeters = defaultAppConfig.sprayMistVerticalOffsetMeters;
      }
    }

    syncAircraftSelectValueFromCurrentUrl();
    syncModelScaleUI();
    syncModelAlignmentUI();
    applyModelScaleToEntity();
    applyModelUrlToCurrentEntity();
    applyModelAltitudeOffsetToCurrentEntity();
    applyPropellerNodeTransformationsToCurrentEntity();
  }

  function applyModelUrlToCurrentEntity() {
    if (!state.flightEntity?.model) {
      return;
    }

    state.flightEntity.model.uri = UI.modelUrl.value.trim() || defaultAppConfig.modelUrl;
    state.flightEntity.model.minimumPixelSize = resolveMinimumPixelSize();
    applyPropellerNodeTransformationsToCurrentEntity();
    applyModelAppearanceToEntity();
    applyModelSilhouetteState();
  }

  function applyInitialRuntimeSettingsFromConfig() {
    state.cameraOffsets.headingDeg = clamp(
      Number(state.appConfig.cameraHeadingOffsetDeg ?? defaultAppConfig.cameraHeadingOffsetDeg),
      -180,
      180
    );
    state.cameraOffsets.pitchDeg = clamp(
      Number(state.appConfig.cameraPitchDeg ?? defaultAppConfig.cameraPitchDeg),
      -85,
      -5
    );
    state.cameraOffsets.rangeMeters = clamp(
      Number(state.appConfig.cameraRangeMeters ?? defaultAppConfig.cameraRangeMeters),
      80,
      3000
    );

    const speedValue = normalizeSpeedValue(state.appConfig.initialSpeed ?? defaultAppConfig.initialSpeed);
    setPlaybackSpeedFromControl(speedValue);

    const viewMode = normalizeViewMode(state.appConfig.initialViewMode ?? defaultAppConfig.initialViewMode);
    state.cameraMode = viewMode;
    syncViewModeSelectUI();
    state.transitFocusEnabled = !!state.appConfig.enableTransitFocusMode;
    syncTransitFocusToggleButtonUI();

    state.sprayFootprintStyle.color = normalizeHexColor(
      state.appConfig.sprayFootprintColor ?? defaultAppConfig.sprayFootprintColor,
      defaultAppConfig.sprayFootprintColor
    );
    state.sprayFootprintStyle.opacity = normalizeOpacity(
      state.appConfig.sprayFootprintOpacity ?? defaultAppConfig.sprayFootprintOpacity,
      defaultAppConfig.sprayFootprintOpacity
    );
  }

  function normalizeSpeedValue(raw) {
    const allowed = [1, 2.5, 5, 10, 15, 20, 30];
    const target = Number(raw);
    if (!Number.isFinite(target)) {
      return 1;
    }
    let best = allowed[0];
    let bestDist = Math.abs(target - best);
    for (let i = 1; i < allowed.length; i++) {
      const d = Math.abs(target - allowed[i]);
      if (d < bestDist) {
        best = allowed[i];
        bestDist = d;
      }
    }
    return best;
  }

  function normalizeViewMode(raw) {
    const valid = new Set(["follow", "chase", "orbit", "top", "free"]);
    const mode = String(raw || "").trim().toLowerCase();
    return valid.has(mode) ? mode : "follow";
  }

  async function copyCurrentSetupToClipboard() {
    const setup = buildCurrentSetupSnapshot();
    const json = JSON.stringify(setup, null, 2);

    try {
      await writeClipboardText(json);
      setStatus(getReplay3DText("SETUP_COPIADO_AREA_TRANSFERENCIA"));
    } catch (error) {
    }
  }

  function buildCurrentSetupSnapshot() {
    const profile = resolvePropellerProfile();
    const setup = {
      cesiumIonToken: state.appConfig.cesiumIonToken || "",
      modelUrl: UI.modelUrl.value.trim() || defaultAppConfig.modelUrl,
      defaultFlightFileUrl: String(state.appConfig.defaultFlightFileUrl || defaultAppConfig.defaultFlightFileUrl || ""),
      aircraftCatalogUrl: state.appConfig.aircraftCatalogUrl || defaultAppConfig.aircraftCatalogUrl,
      defaultAircraftId: state.activeAircraftId || state.appConfig.defaultAircraftId || "",
      useArcGisBasemap: !!state.appConfig.useArcGisBasemap,
      useWorldTerrain: !!state.appConfig.useWorldTerrain,
      maxTrackPoints: Number(state.appConfig.maxTrackPoints ?? defaultAppConfig.maxTrackPoints),
      modelScale: Number(state.modelScale),
      autoScaleBySprayWidth: !!state.appConfig.autoScaleBySprayWidth,
      minimumPixelSize: Number(resolveMinimumPixelSize()),
      enableTurnBanking: !!state.appConfig.enableTurnBanking,
      turnBankMaxDeg: Number(state.appConfig.turnBankMaxDeg ?? defaultAppConfig.turnBankMaxDeg),
      turnBankFactor: Number(state.appConfig.turnBankFactor ?? defaultAppConfig.turnBankFactor),
      turnBankSmoothing: Number(state.appConfig.turnBankSmoothing ?? defaultAppConfig.turnBankSmoothing),
      turnBankDeadzoneDegPerSec: Number(state.appConfig.turnBankDeadzoneDegPerSec ?? defaultAppConfig.turnBankDeadzoneDegPerSec),
      turnBankSign: Number(state.appConfig.turnBankSign ?? defaultAppConfig.turnBankSign),
      enableInferredSprayDirectionFilter: state.appConfig.enableInferredSprayDirectionFilter !== false,
      inferredSprayDirectionToleranceDeg: Number(
        state.appConfig.inferredSprayDirectionToleranceDeg ?? defaultAppConfig.inferredSprayDirectionToleranceDeg
      ),
      inferredSprayMinAlignedPoints: Number(
        state.appConfig.inferredSprayMinAlignedPoints ?? defaultAppConfig.inferredSprayMinAlignedPoints
      ),
      inferredSprayGapBridgePoints: Number(
        state.appConfig.inferredSprayGapBridgePoints ?? defaultAppConfig.inferredSprayGapBridgePoints
      ),
      sprayEnterConfirmSegments: Number(
        state.appConfig.sprayEnterConfirmSegments ?? defaultAppConfig.sprayEnterConfirmSegments
      ),
      sprayExitConfirmSegments: Number(
        state.appConfig.sprayExitConfirmSegments ?? defaultAppConfig.sprayExitConfirmSegments
      ),
      sprayBridgeGapSegments: Number(
        state.appConfig.sprayBridgeGapSegments ?? defaultAppConfig.sprayBridgeGapSegments
      ),
      sprayManeuverHeadingDeltaDeg: Number(
        state.appConfig.sprayManeuverHeadingDeltaDeg ?? defaultAppConfig.sprayManeuverHeadingDeltaDeg
      ),
      sprayManeuverCooldownSegments: Number(
        state.appConfig.sprayManeuverCooldownSegments ?? defaultAppConfig.sprayManeuverCooldownSegments
      ),
      sprayAntiRepaintGridMeters: Number(
        state.appConfig.sprayAntiRepaintGridMeters ?? defaultAppConfig.sprayAntiRepaintGridMeters
      ),
      sprayPolygonInnerBufferMeters: Number(
        state.appConfig.sprayPolygonInnerBufferMeters ?? defaultAppConfig.sprayPolygonInnerBufferMeters
      ),
      modelBrightnessMix: Number(resolveModelBrightnessMix().toFixed(3)),
      modelBrightnessColor: resolveModelBrightnessColor(),
      enableRealSpeedAltitudeAdjustment: state.appConfig.enableRealSpeedAltitudeAdjustment !== false,
      realSpeedAltitudeLowSpeedMps: Number(
        state.appConfig.realSpeedAltitudeLowSpeedMps ?? defaultAppConfig.realSpeedAltitudeLowSpeedMps
      ),
      realSpeedAltitudeHighSpeedMps: Number(
        state.appConfig.realSpeedAltitudeHighSpeedMps ?? defaultAppConfig.realSpeedAltitudeHighSpeedMps
      ),
      realSpeedAltitudeLowSpeedDeltaMeters: Number(
        state.appConfig.realSpeedAltitudeLowSpeedDeltaMeters ?? defaultAppConfig.realSpeedAltitudeLowSpeedDeltaMeters
      ),
      realSpeedAltitudeHighSpeedDeltaMeters: Number(
        state.appConfig.realSpeedAltitudeHighSpeedDeltaMeters ?? defaultAppConfig.realSpeedAltitudeHighSpeedDeltaMeters
      ),
      realSpeedAltitudeSmoothing: Number(
        state.appConfig.realSpeedAltitudeSmoothing ?? defaultAppConfig.realSpeedAltitudeSmoothing
      ),
      realSpeedAltitudeBlendDistanceMeters: Number(
        state.appConfig.realSpeedAltitudeBlendDistanceMeters ?? defaultAppConfig.realSpeedAltitudeBlendDistanceMeters
      ),
      realSpeedAltitudeMinClampMeters: Number(
        state.appConfig.realSpeedAltitudeMinClampMeters ?? defaultAppConfig.realSpeedAltitudeMinClampMeters
      ),
      realSpeedAltitudeApplyOnlyWhenSpraying: !!state.appConfig.realSpeedAltitudeApplyOnlyWhenSpraying,
      enableTransitFocusMode: !!state.transitFocusEnabled,
      transitFocusDistanceMeters: Number(resolveTransitFocusDistanceMeters()),
      initialSpeed: Number(UI.speedSelect.value || state.speed || defaultAppConfig.initialSpeed),
      initialViewMode: normalizeViewMode(UI.viewModeSelect.value || state.cameraMode),
      cameraHeadingOffsetDeg: Number(state.cameraOffsets.headingDeg),
      cameraPitchDeg: Number(state.cameraOffsets.pitchDeg),
      cameraRangeMeters: Number(state.cameraOffsets.rangeMeters),
      cameraChaseHeadingSmoothingSec: Number(resolveCameraChaseHeadingSmoothingSec().toFixed(2)),
      positionInterpolationAlgorithm: String(state.appConfig.positionInterpolationAlgorithm || defaultAppConfig.positionInterpolationAlgorithm),
      positionInterpolationDegree: Number(resolvePositionInterpolationDegree(resolvePositionInterpolationAlgorithm())),
      modelHeadingOffsetDeg: Number(state.modelOffsetsDeg.heading),
      modelPitchOffsetDeg: Number(state.modelOffsetsDeg.pitch),
      modelRollOffsetDeg: Number(state.modelOffsetsDeg.roll),
      modelAltitudeOffsetMeters: Number(resolveModelAltitudeOffsetMeters()),
      sprayFootprintColor: state.sprayFootprintStyle.color,
      sprayFootprintOpacity: Number(state.sprayFootprintStyle.opacity.toFixed(2)),
      enableSprayMist: state.appConfig.enableSprayMist !== false,
      sprayMistColor: String(state.appConfig.sprayMistColor || ""),
      sprayMistOpacity: Number(state.appConfig.sprayMistOpacity ?? defaultAppConfig.sprayMistOpacity),
      sprayMistGlowPower: Number(state.appConfig.sprayMistGlowPower ?? defaultAppConfig.sprayMistGlowPower),
      sprayMistLineCount: Number(state.appConfig.sprayMistLineCount ?? defaultAppConfig.sprayMistLineCount),
      sprayMistWhiteness: Number(state.appConfig.sprayMistWhiteness ?? defaultAppConfig.sprayMistWhiteness),
      sprayMistTurbulenceMeters: Number(
        state.appConfig.sprayMistTurbulenceMeters ?? defaultAppConfig.sprayMistTurbulenceMeters
      ),
      sprayMistVerticalTurbulenceMeters: Number(
        state.appConfig.sprayMistVerticalTurbulenceMeters ?? defaultAppConfig.sprayMistVerticalTurbulenceMeters
      ),
      sprayMistTurbulenceFrequency: Number(
        state.appConfig.sprayMistTurbulenceFrequency ?? defaultAppConfig.sprayMistTurbulenceFrequency
      ),
      sprayMistLaneBackSpreadMeters: Number(
        state.appConfig.sprayMistLaneBackSpreadMeters ?? defaultAppConfig.sprayMistLaneBackSpreadMeters
      ),
      sprayMistWidthFactor: Number(state.appConfig.sprayMistWidthFactor ?? defaultAppConfig.sprayMistWidthFactor),
      sprayMistBackOffsetMeters: Number(
        state.appConfig.sprayMistBackOffsetMeters ?? defaultAppConfig.sprayMistBackOffsetMeters
      ),
      sprayMistVerticalOffsetMeters: Number(
        state.appConfig.sprayMistVerticalOffsetMeters ?? defaultAppConfig.sprayMistVerticalOffsetMeters
      ),
      sprayMistTrailSpacingMeters: Number(
        state.appConfig.sprayMistTrailSpacingMeters ?? defaultAppConfig.sprayMistTrailSpacingMeters
      ),
      sprayMistMaxTrailPoints: Number(
        state.appConfig.sprayMistMaxTrailPoints ?? defaultAppConfig.sprayMistMaxTrailPoints
      ),
      sprayMistFadeOutSeconds: Number(
        state.appConfig.sprayMistFadeOutSeconds ?? defaultAppConfig.sprayMistFadeOutSeconds
      ),
      sprayMistLineWidthFactor: Number(
        state.appConfig.sprayMistLineWidthFactor ?? defaultAppConfig.sprayMistLineWidthFactor
      ),
      sprayMistMinLineWidthPx: Number(
        state.appConfig.sprayMistMinLineWidthPx ?? defaultAppConfig.sprayMistMinLineWidthPx
      ),
      sprayMistMaxLineWidthPx: Number(
        state.appConfig.sprayMistMaxLineWidthPx ?? defaultAppConfig.sprayMistMaxLineWidthPx
      ),
      enablePropellerAnimation: profile.enabled
    };

    const exportedModels = serializeAircraftModelsForSetup();
    if (exportedModels.length) {
      setup.aircraftModels = exportedModels;
    }
    if (profile.groups.length) {
      setup.propellerGroups = serializePropellerGroupsForSetup(profile.groups);
    }

    return setup;
  }

  function serializeAircraftModelsForSetup() {
    if (!Array.isArray(state.aircraftModels) || !state.aircraftModels.length) {
      return [];
    }

    return state.aircraftModels.map((model) => {
      const out = {
        id: model.id,
        label: model.label,
        url: model.url
      };
      if (Number.isFinite(model.scale)) out.scale = Number(model.scale);
      if (Number.isFinite(model.modelHeadingOffsetDeg)) out.modelHeadingOffsetDeg = Number(model.modelHeadingOffsetDeg);
      if (Number.isFinite(model.modelPitchOffsetDeg)) out.modelPitchOffsetDeg = Number(model.modelPitchOffsetDeg);
      if (Number.isFinite(model.modelRollOffsetDeg)) out.modelRollOffsetDeg = Number(model.modelRollOffsetDeg);
      if (Number.isFinite(model.modelAltitudeOffsetMeters)) out.modelAltitudeOffsetMeters = Number(model.modelAltitudeOffsetMeters);
      if (Number.isFinite(model.minimumPixelSize)) out.minimumPixelSize = Number(model.minimumPixelSize);
      if (Number.isFinite(model.modelBrightnessMix)) out.modelBrightnessMix = Number(model.modelBrightnessMix);
      if (model.modelBrightnessColor) out.modelBrightnessColor = model.modelBrightnessColor;
      if (Array.isArray(model.propellerGroups) && model.propellerGroups.length) {
        out.propellerGroups = serializePropellerGroupsForSetup(model.propellerGroups);
      }
      return out;
    });
  }

  function serializePropellerGroupsForSetup(groups) {
    if (!Array.isArray(groups) || !groups.length) {
      return [];
    }
    return groups.map((group, idx) => {
      const out = {
        id: String(group.id || `grupo_${idx + 1}`),
        nodes: Array.isArray(group.nodes) ? [...group.nodes] : []
      };
      if (group.axis) out.axis = group.axis;
      if (Array.isArray(group.axisVector) && group.axisVector.length === 3) out.axisVector = [...group.axisVector];
      if (Number.isFinite(group.rpm)) out.rpm = Number(group.rpm);
      if (Number.isFinite(group.spinSign)) out.spinSign = Number(group.spinSign);
      if (Array.isArray(group.pivot) && group.pivot.length === 3) out.pivot = [...group.pivot];
      if (group.pivotByNode && Object.keys(group.pivotByNode).length) out.pivotByNode = { ...group.pivotByNode };
      if (Array.isArray(group.translationOffset) && group.translationOffset.length === 3) {
        out.translationOffset = [...group.translationOffset];
      }
      if (Array.isArray(group.scale) && group.scale.length === 3) {
        out.scale = [...group.scale];
      }
      if (group.tiltAxis) out.tiltAxis = group.tiltAxis;
      if (Number.isFinite(group.tiltDeg)) out.tiltDeg = Number(group.tiltDeg);
      return out;
    });
  }

  function writeClipboardText(text) {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        if (ok) resolve();
        else reject(new Error("execCommand copy falhou"));
      } catch (err) {
        reject(err);
      }
    });
  }

  async function applyBasemapFromConfig() {
    if (!state.appConfig.useArcGisBasemap) {
      return;
    }

    try {
      const provider = await Cesium.ArcGisMapServerImageryProvider.fromUrl(
        "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
      );
      state.viewer.imageryLayers.removeAll();
      state.viewer.imageryLayers.addImageryProvider(provider);
    } catch (error) {
    }
  }

  function onCameraSettingsInput() {
    ensureCameraModeForManualControl();
    state.cameraOffsets.headingDeg = Number(UI.cameraHeadingOffset.value || 0);
    state.cameraOffsets.pitchDeg = Number(UI.cameraPitch.value || -30);
    state.cameraOffsets.rangeMeters = Number(UI.cameraRange.value || 240);
    syncCameraControlsUI();
    updateCameraForMode();
  }

  function onModelOffsetsInput() {
    if (UI.modelHeadingOffset) {
      state.modelOffsetsDeg.heading = Number(UI.modelHeadingOffset.value || 0);
    }
    if (UI.modelPitchOffset) {
      state.modelOffsetsDeg.pitch = Number(UI.modelPitchOffset.value || 0);
    }
    if (UI.modelRollOffset) {
      state.modelOffsetsDeg.roll = Number(UI.modelRollOffset.value || 0);
    }
    syncModelAlignmentUI();
  }

  function onModelAltitudeOffsetInput() {
    if (!UI.modelAltitudeOffset) return;

    const altitudeOffset = Number(UI.modelAltitudeOffset.value || 0);
    state.appConfig.modelAltitudeOffsetMeters = altitudeOffset;
    const active = findAircraftById(state.activeAircraftId);
    if (active) {
      active.modelAltitudeOffsetMeters = altitudeOffset;
    }
    syncModelAlignmentUI();
    applyModelAltitudeOffsetToCurrentEntity();
  }

  function onModelScaleInput() {
    state.modelScale = clamp(
      Number(UI.modelScale.value || defaultAppConfig.modelScale),
      0.05,
      1000
    );
    syncModelScaleUI();
    applyModelScaleToEntity();
  }


  function toggleSprayQualityMode() {
    state.sprayQualityEnabled = !state.sprayQualityEnabled;
    if (state.sprayQualityEnabled && !isSprayQualityParameterAvailable(state.sprayQualityParameter)) {
      state.sprayQualityParameter = resolveFirstAvailableSprayQualityParameter();
    }

    syncSprayQualityControlsUI();
    scheduleSprayQualityRefresh();
  }

  function onSprayQualityParameterChange() {
    const value = UI.qualitySprayParameterSelect ? UI.qualitySprayParameterSelect.value : "aplicacao";
    if (!isSprayQualityParameterAvailable(value)) {
      syncSprayQualityControlsUI();
      return;
    }

    state.sprayQualityParameter = value || "aplicacao";
    syncSprayQualityControlsUI();
    scheduleSprayQualityRefresh();
  }

  function scheduleSprayQualityRefresh() {
    setSprayQualityControlsProcessing(true);
    setStatus(getReplay3DText("ATUALIZANDO_ANALISE_APLICACAO"));

    setTimeout(() => {
      try {
        if (state.officialSprayFootprintAvailable) {
          refreshOfficialSprayQualitySegments();
          state.sprayFootprintLastIndex = -1;
          updateSprayFootprint(findNearestPointIndex(currentClockSec()));
        } else {
          rebuildSprayFootprintEntities();
        }

        applySprayMistStyleToAllEntities();
        setStatus(getReplay3DText("ANALISE_APLICACAO_ATUALIZADA"));
      } finally {
        setSprayQualityControlsProcessing(false);
        syncSprayQualityControlsUI();
      }
    }, 40);
  }

  function setSprayQualityControlsProcessing(processing) {
    if (UI.qualitySprayToggleBtn) {
      UI.qualitySprayToggleBtn.disabled = !!processing || !state.timelinePoints.length;
      UI.qualitySprayToggleBtn.classList.toggle("is-processing", !!processing);
    }

    if (UI.qualitySprayParameterSelect) {
      UI.qualitySprayParameterSelect.disabled = !!processing || !state.timelinePoints.length || !state.sprayQualityEnabled;
    }
  }

  function isSprayQualityParameterAvailable(parameter) {
    if (parameter === "aplicacao") {
      return true;
    }
    return !!(state.sprayQualityAvailability && state.sprayQualityAvailability[parameter]);
  }

  function resolveFirstAvailableSprayQualityParameter() {
    const options = getSprayQualityOptions();
    for (let i = 0; i < options.length; i++) {
      if (isSprayQualityParameterAvailable(options[i].value)) {
        return options[i].value;
      }
    }
    return "aplicacao";
  }

  function getSprayQualityOptions() {
    return [
      { value: "aplicacao", label: getReplay3DText("APLICACAO") },
      { value: "altura", label: getReplay3DText("ALTURA") },
      { value: "fluxo", label: getReplay3DText("FLUXO") },
      { value: "velocidade", label: getReplay3DText("VELOCIDADE") },
      { value: "velocidadeVento", label: getReplay3DText("VELOCIDADE_VENTO") },
      { value: "direcaoVento", label: getReplay3DText("DIRECAO_VENTO") },
      { value: "deltaT", label: getReplay3DText("DELTA_T") },
      { value: "temperatura", label: getReplay3DText("TEMPERATURA_") },
      { value: "humidade", label: getReplay3DText("UMIDADE_") }
    ];
  }

  function syncSprayQualityControlsUI() {
    if (UI.qualitySprayToggleBtn) {
      UI.qualitySprayToggleBtn.textContent = state.sprayQualityEnabled ? getReplay3DText("QUALIDADE_ATIVADA") : getReplay3DText("QUALIDADE_DESATIVADA");
      UI.qualitySprayToggleBtn.setAttribute("aria-pressed", state.sprayQualityEnabled ? "true" : "false");
      UI.qualitySprayToggleBtn.classList.toggle("active", !!state.sprayQualityEnabled);
      applySprayQualityButtonStyle();
    }

    if (UI.qualitySprayParameterSelect) {
      const options = getSprayQualityOptions();
      for (let i = 0; i < UI.qualitySprayParameterSelect.options.length; i++) {
        const option = UI.qualitySprayParameterSelect.options[i];
        const available = isSprayQualityParameterAvailable(option.value);
        option.disabled = !available;
        option.style.backgroundColor = available ? "#ffffff" : "#eeeeee";
        option.style.color = available ? "#1f2d1f" : "#9ca3af";
      }
      UI.qualitySprayParameterSelect.value = state.sprayQualityParameter || "aplicacao";
      UI.qualitySprayParameterSelect.disabled = !state.timelinePoints.length || !state.sprayQualityEnabled;
    }

    if (UI.sprayFootprintColor) {
      UI.sprayFootprintColor.disabled = !state.timelinePoints.length || state.sprayQualityEnabled;
    }
    if (UI.sprayFootprintOpacity) {
      UI.sprayFootprintOpacity.disabled = !state.timelinePoints.length || state.sprayQualityEnabled;
    }
  }

  function applySprayQualityButtonStyle() {
    if (!UI.qualitySprayToggleBtn) {
      return;
    }

    const active = !!state.sprayQualityEnabled;
    UI.qualitySprayToggleBtn.style.setProperty("background-color", active ? "#1f8f47" : "#d8f3df", "important");
    UI.qualitySprayToggleBtn.style.setProperty("border-color", active ? "#1f8f47" : "#b9e7c5", "important");
    UI.qualitySprayToggleBtn.style.setProperty("color", active ? "#ffffff" : "#1f5f35", "important");
    UI.qualitySprayToggleBtn.style.setProperty("opacity", "1", "important");
  }

  function onSprayFootprintStyleInput() {
    state.sprayFootprintStyle.color = normalizeHexColor(
      UI.sprayFootprintColor ? UI.sprayFootprintColor.value : state.sprayFootprintStyle.color,
      defaultAppConfig.sprayFootprintColor
    );
    state.sprayFootprintStyle.opacity = normalizeOpacity(
      Number(UI.sprayFootprintOpacity.value) / 100,
      defaultAppConfig.sprayFootprintOpacity
    );
    syncSprayFootprintStyleUI();
    applySprayFootprintStyleToAllRuns();
    applySprayMistStyleToAllEntities();
  }


  function resolveModelScale() {
    let scale = Number.isFinite(state.modelScale) ? state.modelScale : defaultAppConfig.modelScale;
    if (state.appConfig.autoScaleBySprayWidth && Number.isFinite(state.estimatedSprayWidthMeters) && state.estimatedSprayWidthMeters > 0) {
      const ratio = clamp(state.estimatedSprayWidthMeters / 35, 0.65, 2.0);
      scale *= ratio;
    }
    return clamp(scale, 0.05, 1000);
  }

  function resolveMinimumPixelSize() {
    const active = findAircraftById(state.activeAircraftId);
    if (Number.isFinite(active?.minimumPixelSize)) {
      return clamp(active.minimumPixelSize, 1, 200);
    }

    const fallback = Number(state.appConfig.minimumPixelSize ?? defaultAppConfig.minimumPixelSize);
    if (Number.isFinite(fallback)) {
      return clamp(fallback, 1, 200);
    }

    return defaultAppConfig.minimumPixelSize;
  }

  function resolveModelAltitudeOffsetMeters() {
    const active = findAircraftById(state.activeAircraftId);
    if (Number.isFinite(active?.modelAltitudeOffsetMeters)) {
      return clamp(active.modelAltitudeOffsetMeters, -200, 200);
    }

    const fallback = Number(state.appConfig.modelAltitudeOffsetMeters ?? defaultAppConfig.modelAltitudeOffsetMeters);
    if (Number.isFinite(fallback)) {
      return clamp(fallback, -200, 200);
    }
    return defaultAppConfig.modelAltitudeOffsetMeters;
  }

  function applyModelScaleToEntity() {
    if (!state.flightEntity?.model) {
      return;
    }
    state.flightEntity.model.scale = resolveModelScale();
  }

  function resolveVisualAltitudeMeters(point, altitudeOffsetMeters) {
    const baseAltitude = Number.isFinite(point && point.alt) ? point.alt : (Number.isFinite(point && point.altOriginal) ? point.altOriginal : 6);
    const offset = Number.isFinite(altitudeOffsetMeters) ? altitudeOffsetMeters : 0;
    const visualFactor = Number(state.appConfig.officialAltitudeVisualFactor || 2.2);
    const clampedFactor = Number.isFinite(visualFactor) ? Math.max(1, Math.min(visualFactor, 4)) : 2.2;
    return Math.max(3, baseAltitude * clampedFactor + offset);
  }

  function buildFlightPositionProperty(points, altitudeOffsetMeters = 0) {
    const property = new Cesium.SampledPositionProperty();
    const altOffset = Number.isFinite(altitudeOffsetMeters) ? altitudeOffsetMeters : 0;

    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      const t = Cesium.JulianDate.fromDate(new Date(point.tSec * 1000));
      const baseAltitude = normalizeTimelinePointRelativeAltitude(point);
      const pos = Cesium.Cartesian3.fromDegrees(point.lon, point.lat, baseAltitude + altOffset);
      property.addSample(t, pos);
    }

    property.setInterpolationOptions({
      interpolationDegree: 1,
      interpolationAlgorithm: Cesium.LinearApproximation
    });
    return property;
  }

  function buildRefuelHoldPositionProperty(points, altitudeOffsetMeters, sourceProperty) {
    if (!shouldHoldAircraftPositionDuringRefuel(points)) {
      return sourceProperty;
    }

    const altOffset = Number.isFinite(altitudeOffsetMeters) ? altitudeOffsetMeters : 0;
    const holdPositionCache = {};
    let refuelSegmentCount = 0;

    for (let i = 0; i < state.telemetrySegmentTypes.length; i++) {
      if (state.telemetrySegmentTypes[i] === "refuel") {
        refuelSegmentCount++;
      }
    }

    if (altOffset > 0) {
      state.refuelPositionHoldSampleCount = refuelSegmentCount;
    }

    return new Cesium.CallbackProperty((time, result) => {
      const tSec = Cesium.JulianDate.toDate(time).getTime() / 1000;
      const segmentIndex = findTimelineSegmentIndexBySecond(points, tSec);

      if (segmentIndex >= 0 && state.telemetrySegmentTypes[segmentIndex] === "refuel") {
        const point = points[segmentIndex];
        const baseAltitude = normalizeTimelinePointRelativeAltitude(point);
        const cacheKey = segmentIndex + "_" + altOffset;

        if (!holdPositionCache[cacheKey]) {
          holdPositionCache[cacheKey] = Cesium.Cartesian3.fromDegrees(point.lon, point.lat, baseAltitude + altOffset);
        }

        return Cesium.Cartesian3.clone(holdPositionCache[cacheKey], result);
      }

      return sourceProperty.getValue(time, result);
    }, false);
  }

  function findTimelineSegmentIndexBySecond(points, tSec) {
    if (!Array.isArray(points) || points.length < 2 || !Number.isFinite(tSec)) {
      return -1;
    }

    if (tSec < points[0].tSec || tSec > points[points.length - 1].tSec) {
      return -1;
    }

    let left = 0;
    let right = points.length - 2;

    while (left <= right) {
      const mid = Math.floor((left + right) / 2);
      const startSec = points[mid].tSec;
      const endSec = points[mid + 1].tSec;

      if (tSec < startSec) {
        right = mid - 1;
      } else if (tSec > endSec) {
        left = mid + 1;
      } else {
        return mid;
      }
    }

    return -1;
  }

  function shouldHoldAircraftPositionDuringRefuel(points) {
    if (!state.holdAircraftPositionDuringRefuel) {
      return false;
    }

    if (!Array.isArray(points) || points.length < 2) {
      return false;
    }

    if (!Array.isArray(state.telemetrySegmentTypes) || !state.telemetrySegmentTypes.length) {
      return false;
    }

    for (let i = 0; i < state.telemetrySegmentTypes.length; i++) {
      if (state.telemetrySegmentTypes[i] === "refuel") {
        return true;
      }
    }

    return false;
  }

  function applyModelAltitudeOffsetToCurrentEntity() {
    if (!state.flightEntity || !Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      return;
    }

    const modelAltitudeOffsetMeters = resolveModelAltitudeOffsetMeters();
    const originalModelPosition = buildFlightPositionProperty(state.timelinePoints, modelAltitudeOffsetMeters);
    const originalMarkerPosition = buildFlightPositionProperty(state.timelinePoints, 0);
    const modelPosition = buildRefuelHoldPositionProperty(state.timelinePoints, modelAltitudeOffsetMeters, originalModelPosition);
    const markerPosition = buildRefuelHoldPositionProperty(state.timelinePoints, 0, originalMarkerPosition);

    state.flightEntity.position = modelPosition;
    state.orientationProperty = buildAircraftOrientationProperty(originalModelPosition, state.turnBankProperty);
    state.flightEntity.orientation = state.orientationProperty;

    if (state.aircraftMarker) {
      state.aircraftMarker.position = markerPosition;
    }
  }

  function resolveModelBrightnessMix() {
    const active = findAircraftById(state.activeAircraftId);
    if (Number.isFinite(active?.modelBrightnessMix)) {
      return clamp(active.modelBrightnessMix, 0, 1);
    }

    const fallback = Number(state.appConfig.modelBrightnessMix ?? defaultAppConfig.modelBrightnessMix);
    if (Number.isFinite(fallback)) {
      return clamp(fallback, 0, 1);
    }
    return 0;
  }

  function resolveModelBrightnessColor() {
    const active = findAircraftById(state.activeAircraftId);
    if (active?.modelBrightnessColor) {
      return normalizeHexColor(active.modelBrightnessColor, defaultAppConfig.modelBrightnessColor);
    }

    return normalizeHexColor(
      state.appConfig.modelBrightnessColor ?? defaultAppConfig.modelBrightnessColor,
      defaultAppConfig.modelBrightnessColor
    );
  }

  function inferPropellerGroupsForCurrentModel(activeModel, modelUrl) {
    const id = String(activeModel?.id || "").toLowerCase();
    const url = comparableModelUrl(modelUrl || "");

    if (id.includes("airtractor") || id.includes("at502") || url.includes("air-tractor") || url.includes("at-502")) {
      return normalizePropellerGroups([
        {
          id: "helice_aviao",
          nodes: ["objpropeller_basic_airtractor"],
          axis: "z",
          rpm: 900,
          spinSign: -1,
          pivot: [-0.5831, 87.3068, 531.6978]
        },
        {
          id: "bomba_eolica",
          nodes: ["objpropeller_small_airtractor"],
          axis: "z",
          rpm: 1400,
          spinSign: -1,
          pivot: [-0.1409, -59.7121, 262.3489]
        }
      ]);
    }

    if (id.includes("emb200") || id.includes("ipanema") || url.includes("emb-200") || url.includes("ipanema")) {
      return normalizePropellerGroups([
        {
          id: "helice_aviao",
          nodes: [
            "Cylinder32_pivot",
            "Cylinder104_pivot",
            "Cylinder108_pivot",
            "Cylinder01",
            "Cylinder31",
            "Cylinder301",
            "Cylinder102_pivot",
            "Cylinder106_pivot",
            "Cylinder110_pivot"
          ],
          axis: "y",
          rpm: 920,
          spinSign: -1,
          pivot: [-0.05, -83.95, 60.03]
        },
        {
          id: "bomba_eolica_cubo",
          nodes: ["Turbine_2_Spinner", "Cylinder144", "Cylinder136"],
          axis: "y",
          rpm: 1283,
          spinSign: -1,
          pivot: [-23.242, -5.978, 33.37]
        },
        {
          id: "bomba_eolica_pas",
          nodes: [
            "Cylinder145",
            "Cylinder146",
            "Cylinder147",
            "Cylinder148",
            "Cylinder149",
            "Cylinder150",
            "Cylinder151"
          ],
          axis: "y",
          rpm: 1319,
          spinSign: -1,
          pivot: [-23.242, -5.978, 33.37]
        }
      ]);
    }

    return [];
  }

  function resolvePropellerProfile() {
    const enabled = state.appConfig.enablePropellerAnimation !== false;
    const active = findAircraftById(state.activeAircraftId) || findAircraftByUrl(UI.modelUrl.value);

    const modelGroups = normalizePropellerGroups(active?.propellerGroups);
    const configGroups = normalizePropellerGroups(state.appConfig.propellerGroups);
    const inferredGroups = inferPropellerGroupsForCurrentModel(active, UI.modelUrl.value);

    const groups = modelGroups.length
      ? modelGroups
      : (configGroups.length ? configGroups : inferredGroups);

    return { enabled, groups };
  }

  function axisToCartesian3(axis) {
    switch (axis) {
      case "x":
        return new Cesium.Cartesian3(1, 0, 0);
      case "z":
        return new Cesium.Cartesian3(0, 0, 1);
      default:
        return new Cesium.Cartesian3(0, 1, 0);
    }
  }

  function configurePropellerForCurrentModel() {
    const profile = resolvePropellerProfile();
    state.propellerEnabled = profile.enabled;
    state.propellerGroupsRuntime = [];

    for (const group of profile.groups) {
      const normalized = normalizePropellerGroup(group, group.id || `grupo_${state.propellerGroupsRuntime.length + 1}`);
      if (!normalized) {
        continue;
      }
      const pivotByNode = {};
      for (const [nodeName, pivot] of Object.entries(normalized.pivotByNode || {})) {
        const vec = normalizeOptionalVector3(pivot);
        if (vec) {
          pivotByNode[nodeName] = Cesium.Cartesian3.fromArray(vec);
        }
      }
      const axisFromConfig = normalized.axisVector ? Cesium.Cartesian3.fromArray(normalized.axisVector) : null;
      const axisDefault = axisToCartesian3(normalized.axis);
      const axisVector = axisFromConfig && Cesium.Cartesian3.magnitude(axisFromConfig) > 1e-9
        ? Cesium.Cartesian3.normalize(axisFromConfig, axisFromConfig)
        : axisDefault;

      state.propellerGroupsRuntime.push({
        id: normalized.id,
        nodes: normalized.nodes,
        axisVector,
        rpm: normalized.rpm,
        spinSign: normalized.spinSign,
        pivot: normalized.pivot ? Cesium.Cartesian3.fromArray(normalized.pivot) : null,
        pivotByNode,
        translationOffset: normalized.translationOffset
          ? Cesium.Cartesian3.fromArray(normalized.translationOffset)
          : null,
        scale: normalized.scale
          ? Cesium.Cartesian3.fromArray(normalized.scale)
          : null,
        tiltAxisVector: normalized.tiltAxis ? axisToCartesian3(normalized.tiltAxis) : null,
        tiltDeg: Number.isFinite(normalized.tiltDeg) ? normalized.tiltDeg : 0
      });
    }
  }

  function computePropellerQuaternionForGroup(time, group, result) {
    const out = result || scratchPropellerQuat;
    if (!state.propellerEnabled || !group || !Number.isFinite(group.rpm) || group.rpm <= 0) {
      return Cesium.Quaternion.clone(Cesium.Quaternion.IDENTITY, out);
    }
    if (!time) {
      return Cesium.Quaternion.clone(Cesium.Quaternion.IDENTITY, out);
    }

    const tSec = Cesium.JulianDate.toDate(time).getTime() / 1000;
    const referenceSec = Number.isFinite(state.startSec) ? state.startSec : tSec;
    const elapsedSec = Math.max(0, tSec - referenceSec);
    const radPerSec = (group.rpm * Math.PI * 2) / 60;
    const angle = (elapsedSec * radPerSec * group.spinSign) % (Math.PI * 2);
    const spinRotation = Cesium.Quaternion.fromAxisAngle(group.axisVector, angle, scratchPropellerSpinQuat);

    if (!group.tiltAxisVector || !Number.isFinite(group.tiltDeg) || Math.abs(group.tiltDeg) < 1e-9) {
      return Cesium.Quaternion.clone(spinRotation, out);
    }

    const tiltRotation = Cesium.Quaternion.fromAxisAngle(
      group.tiltAxisVector,
      Cesium.Math.toRadians(group.tiltDeg),
      scratchPropellerTiltQuat
    );

    return Cesium.Quaternion.multiply(spinRotation, tiltRotation, out);
  }

  function resolvePropellerPivotForNode(group, nodeName) {
    if (group?.pivotByNode && group.pivotByNode[nodeName]) {
      return group.pivotByNode[nodeName];
    }
    return group?.pivot || null;
  }

  function computePropellerTranslationForGroupTime(time, group, nodeName, result) {
    const out = result || scratchPropellerRotatedPivot;
    const pivot = resolvePropellerPivotForNode(group, nodeName);
    if (!pivot) {
      return group?.translationOffset
        ? Cesium.Cartesian3.clone(group.translationOffset, out)
        : Cesium.Cartesian3.clone(Cesium.Cartesian3.ZERO, out);
    }

    const rotation = computePropellerQuaternionForGroup(time, group, scratchPropellerQuat);
    Cesium.Matrix3.fromQuaternion(rotation, scratchPropellerMatrix);
    const rotatedPivot = Cesium.Matrix3.multiplyByVector(
      scratchPropellerMatrix,
      pivot,
      scratchPropellerRotatedPivot
    );

    out.x = pivot.x - rotatedPivot.x + (group.translationOffset?.x || 0);
    out.y = pivot.y - rotatedPivot.y + (group.translationOffset?.y || 0);
    out.z = pivot.z - rotatedPivot.z + (group.translationOffset?.z || 0);
    return out;
  }

  function buildPropellerNodeTransformations() {
    configurePropellerForCurrentModel();

    const transforms = {};

    if (state.propellerEnabled && state.propellerGroupsRuntime.length) {
      for (const group of state.propellerGroupsRuntime) {
        for (const nodeName of group.nodes) {
          transforms[nodeName] = new Cesium.NodeTransformationProperty({
            rotation: new Cesium.CallbackProperty(
              (time, result) => computePropellerQuaternionForGroup(time, group, result),
              false
            ),
            translation: new Cesium.CallbackProperty(
              (time, result) => computePropellerTranslationForGroupTime(time, group, nodeName, result),
              false
            ),
            scale: group.scale
              ? new Cesium.ConstantProperty(Cesium.Cartesian3.clone(group.scale))
              : undefined
          });
        }
      }
    }

    const activeAircraft = findAircraftById(state.activeAircraftId) || findAircraftByUrl(UI.modelUrl.value);
    if (activeAircraft?.id === "thrush-510") {
      transforms.thrush510_barra_agricola_airtractor502 = new Cesium.NodeTransformationProperty({
        scale: new Cesium.ConstantProperty(new Cesium.Cartesian3(1, 1, 1.16))
      });
    }

    return Object.keys(transforms).length ? transforms : undefined;
  }

  function applyPropellerNodeTransformationsToCurrentEntity() {
    if (!state.flightEntity?.model) {
      configurePropellerForCurrentModel();
      return;
    }
    state.flightEntity.model.nodeTransformations = buildPropellerNodeTransformations();
  }

  function applyModelAppearanceToEntity() {
    if (!state.flightEntity?.model) {
      return;
    }

    const mix = resolveModelBrightnessMix();
    if (!Number.isFinite(mix) || mix <= 0) {
      state.flightEntity.model.colorBlendAmount = 0;
      return;
    }

    const color = resolveModelBrightnessColor();
    state.flightEntity.model.color = Cesium.Color.fromCssColorString(color);
    state.flightEntity.model.colorBlendMode = Cesium.ColorBlendMode.MIX;
    state.flightEntity.model.colorBlendAmount = mix;
  }

  function nudgeCameraHeading(deltaDeg) {
    ensureCameraModeForManualControl();
    state.cameraOffsets.headingDeg = clamp(state.cameraOffsets.headingDeg + deltaDeg, -180, 180);
    syncCameraControlsUI();
    updateCameraForMode();
  }

  function nudgeCameraPitch(deltaDeg) {
    ensureCameraModeForManualControl();
    state.cameraOffsets.pitchDeg = clamp(state.cameraOffsets.pitchDeg + deltaDeg, -85, -5);
    syncCameraControlsUI();
    updateCameraForMode();
  }

  function nudgeCameraRange(deltaMeters) {
    ensureCameraModeForManualControl();
    state.cameraOffsets.rangeMeters = clamp(state.cameraOffsets.rangeMeters + deltaMeters, 80, 3000);
    syncCameraControlsUI();
    updateCameraForMode();
  }

  function ensureCameraModeForManualControl() {
    if (!state.flightEntity) {
      return;
    }
    if (state.cameraMode === "follow") {
      onViewModeSelectChanged("chase");
    }
  }

  function syncCameraControlsUI() {
    UI.cameraHeadingOffset.value = String(Math.round(state.cameraOffsets.headingDeg));
    UI.cameraPitch.value = String(Math.round(state.cameraOffsets.pitchDeg));
    UI.cameraRange.value = String(Math.round(state.cameraOffsets.rangeMeters));

    UI.cameraHeadingOffsetValue.textContent = `${Math.round(state.cameraOffsets.headingDeg)}°`;
    UI.cameraPitchValue.textContent = `${Math.round(state.cameraOffsets.pitchDeg)}°`;
    UI.cameraRangeValue.textContent = `${Math.round(state.cameraOffsets.rangeMeters)} m`;
  }

  function syncModelAlignmentUI() {
    if (UI.modelHeadingOffset) {
      UI.modelHeadingOffset.value = String(Math.round(state.modelOffsetsDeg.heading));
    }
    if (UI.modelPitchOffset) {
      UI.modelPitchOffset.value = String(Math.round(state.modelOffsetsDeg.pitch));
    }
    if (UI.modelRollOffset) {
      UI.modelRollOffset.value = String(Math.round(state.modelOffsetsDeg.roll));
    }
    if (UI.modelAltitudeOffset) {
      UI.modelAltitudeOffset.value = String(resolveModelAltitudeOffsetMeters());
    }

    if (UI.modelHeadingOffsetValue) {
      UI.modelHeadingOffsetValue.textContent = `${Math.round(state.modelOffsetsDeg.heading)}°`;
    }
    if (UI.modelPitchOffsetValue) {
      UI.modelPitchOffsetValue.textContent = `${Math.round(state.modelOffsetsDeg.pitch)}°`;
    }
    if (UI.modelRollOffsetValue) {
      UI.modelRollOffsetValue.textContent = `${Math.round(state.modelOffsetsDeg.roll)}°`;
    }
    if (UI.modelAltitudeOffsetValue) {
      UI.modelAltitudeOffsetValue.textContent = `${resolveModelAltitudeOffsetMeters().toFixed(1)} m`;
    }
  }

  function syncModelScaleUI() {
    const uiScale = clamp(
      Number.isFinite(state.modelScale) ? state.modelScale : defaultAppConfig.modelScale,
      0.05,
      8
    );
    const labelScale = Number.isFinite(state.modelScale) ? state.modelScale : defaultAppConfig.modelScale;

    if (UI.modelScale) {
      UI.modelScale.value = String(Number(uiScale.toFixed(2)));
    }
    if (UI.modelScaleValue) {
      UI.modelScaleValue.textContent = `${Number(labelScale.toFixed(2))}x`;
    }
  }

  function syncSprayFootprintStyleUI() {
    if (UI.sprayFootprintColor) {
      UI.sprayFootprintColor.value = state.sprayFootprintStyle.color;
    }
    UI.sprayFootprintOpacity.value = String(Math.round(state.sprayFootprintStyle.opacity * 100));
    UI.sprayFootprintOpacityValue.textContent = `${Math.round(state.sprayFootprintStyle.opacity * 100)}%`;
    syncSprayQualityControlsUI();
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function normalizeOpacity(raw, fallback) {
    const value = Number(raw);
    if (!Number.isFinite(value)) {
      return fallback;
    }
    if (value > 1 && value <= 100) {
      return clamp(value / 100, 0, 1);
    }
    return clamp(value, 0, 1);
  }

  function normalizeHexColor(raw, fallback) {
    const value = String(raw || "").trim().toLowerCase();
    if (/^#[0-9a-f]{6}$/.test(value)) {
      return value;
    }
    if (/^#[0-9a-f]{3}$/.test(value)) {
      const r = value[1];
      const g = value[2];
      const b = value[3];
      return `#${r}${r}${g}${g}${b}${b}`;
    }
    return fallback;
  }

  function scheduleInitialTilesReadyNotification() {
    clearInitialTilesReadyNotification();

    const scene = state.viewer && state.viewer.scene;
    const globe = scene && scene.globe;

    if (!globe || !globe.tileLoadProgressEvent) {
      notifyInitialTilesReady();
      return;
    }

    let settledTimer = null;

    const finishWhenSettled = (pendingTiles) => {
      if (pendingTiles > 0) {
        if (settledTimer) {
          clearTimeout(settledTimer);
          settledTimer = null;
        }
        return;
      }

      if (settledTimer) {
        clearTimeout(settledTimer);
      }

      settledTimer = setTimeout(() => {
        notifyInitialTilesReady();
      }, 800);
    };

    state.initialTilesReadyListener = finishWhenSettled;
    state.initialTilesReadyTimeout = setTimeout(() => {
      notifyInitialTilesReady();
    }, 20000);

    globe.tileLoadProgressEvent.addEventListener(finishWhenSettled);
    finishWhenSettled(Number(globe.tilesLoaded) ? 0 : 1);
    scene.requestRender();
  }

  function notifyInitialTilesReady() {
    clearInitialTilesReadyNotification();

    if (typeof window.__travicarReplay3DInitialTilesReady === "function") {
      window.__travicarReplay3DInitialTilesReady();
    }
  }

  function clearInitialTilesReadyNotification() {
    const scene = state.viewer && state.viewer.scene;
    const globe = scene && scene.globe;

    if (state.initialTilesReadyListener && globe && globe.tileLoadProgressEvent) {
      try {
        globe.tileLoadProgressEvent.removeEventListener(state.initialTilesReadyListener);
      } catch (error) { }
    }

    if (state.initialTilesReadyTimer) {
      clearTimeout(state.initialTilesReadyTimer);
      state.initialTilesReadyTimer = null;
    }

    if (state.initialTilesReadyTimeout) {
      clearTimeout(state.initialTilesReadyTimeout);
      state.initialTilesReadyTimeout = null;
    }

    state.initialTilesReadyListener = null;
  }


  function getScreenCompassPosition(worldBearingDeg) {
    const viewer = state.viewer;
    const cameraHeadingDeg = viewer && !viewer.isDestroyed()
      ? Cesium.Math.toDegrees(viewer.camera.heading)
      : 0;
    const screenBearingRad = Cesium.Math.toRadians(worldBearingDeg - cameraHeadingDeg);
    const directionX = Math.sin(screenBearingRad);
    const directionY = -Math.cos(screenBearingRad);
    const halfWidthPercent = 48.2;
    const halfHeightPercent = 47.2;
    const scaleX = Math.abs(directionX) > 0.000001
      ? halfWidthPercent / Math.abs(directionX)
      : Number.POSITIVE_INFINITY;
    const scaleY = Math.abs(directionY) > 0.000001
      ? halfHeightPercent / Math.abs(directionY)
      : Number.POSITIVE_INFINITY;
    const edgeScale = Math.min(scaleX, scaleY);

    return {
      left: 50 + (directionX * edgeScale),
      top: 50 + (directionY * edgeScale)
    };
  }

  function updateScreenCompassCardinals() {
    if (!state.viewer || state.viewer.isDestroyed()) return;
    const bearings = { north: 0, east: 90, south: 180, west: 270 };
    Object.keys(bearings).forEach((key) => {
      const element = state.screenCompassElements && state.screenCompassElements[key];
      if (!element) return;
      const position = getScreenCompassPosition(bearings[key]);
      element.style.left = position.left + '%';
      element.style.top = position.top + '%';
    });
  }

  function installScreenCompass() {
    const viewer = state.viewer;
    const container = document.getElementById('cesiumContainer');
    if (!viewer || viewer.isDestroyed() || !viewer.scene || !container) return;

    removeScreenCompass();

    const labels = {
      north: getReplay3DText('BUSSOLA_NORTE_SIGLA') || 'N',
      east: getReplay3DText('BUSSOLA_LESTE_SIGLA') || 'L',
      south: getReplay3DText('BUSSOLA_SUL_SIGLA') || 'S',
      west: getReplay3DText('BUSSOLA_OESTE_SIGLA') || 'O'
    };

    const overlay = document.createElement('div');
    overlay.className = 'replay3d-screen-compass';
    overlay.setAttribute('aria-hidden', 'true');

    state.screenCompassElements = {};
    Object.keys(labels).forEach((key) => {
      const cardinal = document.createElement('span');
      cardinal.className = 'replay3d-screen-compass-cardinal screen-compass-' + key;
      cardinal.textContent = labels[key];
      overlay.appendChild(cardinal);
      state.screenCompassElements[key] = cardinal;
    });

    container.appendChild(overlay);
    state.screenCompassOverlay = overlay;
    state.screenCompassPostRenderListener = updateScreenCompassCardinals;
    viewer.scene.postRender.addEventListener(state.screenCompassPostRenderListener);
    updateScreenCompassCardinals();
  }

  function removeScreenCompass() {
    const viewer = state.viewer;
    if (viewer && !viewer.isDestroyed() && viewer.scene && state.screenCompassPostRenderListener) {
      try { viewer.scene.postRender.removeEventListener(state.screenCompassPostRenderListener); } catch (error) { }
    }
    if (state.screenCompassOverlay && state.screenCompassOverlay.parentNode) {
      state.screenCompassOverlay.parentNode.removeChild(state.screenCompassOverlay);
    }
    state.screenCompassElements = {};
    state.screenCompassOverlay = null;
    state.screenCompassPostRenderListener = null;
  }

  function createViewer() {
    const viewer = new Cesium.Viewer("cesiumContainer", {
      shouldAnimate: false,
      animation: false,
      timeline: false,
      geocoder: false,
      homeButton: false,
      sceneModePicker: false,
      navigationHelpButton: false,
      baseLayerPicker: false,
      infoBox: false,
      selectionIndicator: false,
      shadows: false,
      terrainShadows: Cesium.ShadowMode.DISABLED,
      requestRenderMode: false
    });

    viewer.scene.rethrowRenderErrors = false;
    viewer.useBrowserRecommendedResolution = true;
    viewer.targetFrameRate = 60;

    const cameraController = viewer.scene?.screenSpaceCameraController;
    if (cameraController) {
      cameraController.enableRotate = true;
      cameraController.enableZoom = true;
      cameraController.enableTranslate = true;
      cameraController.enableTilt = true;
      cameraController.enableLook = true;
    }

    return viewer;
  }

  function installRenderErrorRecovery() {
    if (!state.viewer?.scene?.renderError) {
      return;
    }

    state.viewer.scene.renderError.addEventListener((_scene, error) => {
      const summary = String(error?.message || "Erro de renderização");

      const stepMessage = applyRenderRecoveryStep();

      state.viewer.useDefaultRenderLoop = true;
      state.viewer.scene.requestRender();

      if (stepMessage) {
        setStatus(`${stepMessage} (${summary})`, true);
        return;
      }
      setStatus(`Erro de renderização do Cesium: ${summary}`, true);
    });
  }

  function applyRenderRecoveryStep() {
    if (state.renderRecoveryLevel === 0) {
      state.renderRecoveryLevel = 1;
      state.disableModelSilhouette = true;
      applyModelSilhouetteState();
      return "Fallback 1/3: silhueta da aeronave desativada";
    }

    if (state.renderRecoveryLevel === 1) {
      state.renderRecoveryLevel = 2;
      state.sprayFootprintGpuSafeMode = true;
      rebuildSprayFootprintEntities();
      return "Fallback 2/3: faixa de aplicação em modo GPU seguro";
    }

    if (state.renderRecoveryLevel === 2) {
      state.renderRecoveryLevel = 3;
      state.disableSprayFootprintRendering = true;
      rebuildSprayFootprintEntities();
      return "Fallback 3/3: faixa no terreno desativada para estabilidade";
    }

    return "";
  }

  function applyModelSilhouetteState() {
    if (!state.flightEntity?.model) {
      return;
    }

    if (state.disableModelSilhouette) {
      state.flightEntity.model.silhouetteSize = 0;
      state.flightEntity.model.silhouetteColor = Cesium.Color.TRANSPARENT;
      return;
    }

    state.flightEntity.model.silhouetteSize = 1;
    state.flightEntity.model.silhouetteColor = Cesium.Color.WHITE;
  }

  function rebuildSprayFootprintEntities() {
    if (!state.viewer) {
      return;
    }

    const previousRuns = state.sprayFootprintRuns || [];
    const previousAreaLabels = state.sprayFootprintAreaLabels || [];
    if (previousRuns.length || previousAreaLabels.length) {
      const removeSet = new Set();
      for (const run of previousRuns) {
        if (run?.entity) {
          state.viewer.entities.remove(run.entity);
          removeSet.add(run.entity);
        }
        if (Array.isArray(run?.qualitySegments)) {
          for (let i = 0; i < run.qualitySegments.length; i++) {
            if (run.qualitySegments[i]?.entity) {
              state.viewer.entities.remove(run.qualitySegments[i].entity);
              removeSet.add(run.qualitySegments[i].entity);
            }
          }
        }
        if (run?.labelEntity) {
          state.viewer.entities.remove(run.labelEntity);
          removeSet.add(run.labelEntity);
        }
      }
      for (const areaLabel of previousAreaLabels) {
        if (areaLabel?.labelEntity) {
          state.viewer.entities.remove(areaLabel.labelEntity);
          removeSet.add(areaLabel.labelEntity);
        }
      }
      state.pathEntities = state.pathEntities.filter((entity) => !removeSet.has(entity));
    }

    if (!state.timelinePoints.length) {
      state.sprayFootprintRuns = [];
      state.sprayFootprintAreaLabels = [];
      state.sprayFootprintLastIndex = -1;
      return;
    }

    state.segmentSprayDecisions = buildSegmentSprayDecisions(state.timelinePoints);
    state.sprayFlags = derivePointSprayFlagsFromSegments(state.timelinePoints, state.segmentSprayDecisions);
    buildSprayFootprintRuns(state.timelinePoints, state.segmentSprayDecisions);
    const nearestIndex = findNearestPointIndex(currentClockSec());
    updateSprayFootprint(nearestIndex);
  }

  function configureMouseMapControls() {
    const viewer = state.viewer;
    const cameraController = viewer?.scene?.screenSpaceCameraController;
    if (!viewer || !cameraController) {
      return;
    }

    if (state.mouseMapInputHandler) {
      state.mouseMapInputHandler.destroy();
      state.mouseMapInputHandler = null;
    }

    const inputHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
    const ORBIT_MOUSE_HEADING_SENSITIVITY = 0.25;
    const ORBIT_MOUSE_PITCH_SENSITIVITY = 0.18;
    const ORBIT_MOUSE_WHEEL_SENSITIVITY = 0.12;
    let orbitDragging = false;
    let orbitLastPosition = null;

    const isOrbitManualMode = () => !!state.flightEntity && state.cameraMode === "orbit";
    const beginOrbitDrag = (movement) => {
      if (!isOrbitManualMode()) {
        return false;
      }
      const pos = movement?.position || movement?.startPosition;
      if (!pos) {
        return false;
      }
      orbitDragging = true;
      orbitLastPosition = Cesium.Cartesian2.clone(pos, new Cesium.Cartesian2());
      return true;
    };
    const endOrbitDrag = () => {
      orbitDragging = false;
      orbitLastPosition = null;
    };
    const handleOrbitMouseMove = (movement) => {
      if (!orbitDragging || !isOrbitManualMode()) {
        return false;
      }
      const end = movement?.endPosition;
      if (!end) {
        return false;
      }
      if (!orbitLastPosition) {
        orbitLastPosition = Cesium.Cartesian2.clone(end, new Cesium.Cartesian2());
        return true;
      }

      const dx = end.x - orbitLastPosition.x;
      const dy = end.y - orbitLastPosition.y;
      orbitLastPosition = Cesium.Cartesian2.clone(end, orbitLastPosition);
      if (!Number.isFinite(dx) || !Number.isFinite(dy)) {
        return true;
      }

      state.cameraOffsets.headingDeg = normalizeAngleDeg(
        state.cameraOffsets.headingDeg + dx * ORBIT_MOUSE_HEADING_SENSITIVITY
      );
      state.cameraOffsets.pitchDeg = clamp(
        state.cameraOffsets.pitchDeg + dy * ORBIT_MOUSE_PITCH_SENSITIVITY,
        -89,
        -5
      );
      syncCameraControlsUI();
      updateCameraForMode();
      return true;
    };
    const handleOrbitMouseWheel = (movement) => {
      if (!isOrbitManualMode()) {
        return false;
      }
      const rawDelta = Number(
        typeof movement === "number"
          ? movement
          : (movement?.deltaY ?? movement?.wheelDelta ?? 0)
      );
      if (!Number.isFinite(rawDelta) || rawDelta === 0) {
        return true;
      }

      const step = clamp(Math.abs(rawDelta) * ORBIT_MOUSE_WHEEL_SENSITIVITY, 30, 220);
      const deltaRange = rawDelta > 0 ? step : -step;
      state.cameraOffsets.rangeMeters = clamp(state.cameraOffsets.rangeMeters + deltaRange, 80, 3000);
      syncCameraControlsUI();
      updateCameraForMode();
      return true;
    };

    const unlockFreeModeFromMouse = () => {
      if (!state.flightEntity) {
        return;
      }
      if (isOrbitManualMode()) {
        return;
      }
      if (state.cameraMode === "free") {
        return;
      }
      onViewModeSelectChanged("free");
      if (!state.hasShownMouseFreeModeHint) {
        setStatus(getReplay3DText("CONTROLE_MOUSE_ATIVADO_CAMERA_LIVRE"));
        state.hasShownMouseFreeModeHint = true;
      }
    };

    bindScreenSpaceInputAction(inputHandler, (movement) => {
      if (beginOrbitDrag(movement)) {
        return;
      }
      unlockFreeModeFromMouse();
    }, "LEFT_DOWN");
    bindScreenSpaceInputAction(inputHandler, endOrbitDrag, "LEFT_UP");
    bindScreenSpaceInputAction(inputHandler, (movement) => {
      if (beginOrbitDrag(movement)) {
        return;
      }
      unlockFreeModeFromMouse();
    }, "RIGHT_DOWN");
    bindScreenSpaceInputAction(inputHandler, endOrbitDrag, "RIGHT_UP");
    bindScreenSpaceInputAction(inputHandler, (movement) => {
      if (handleOrbitMouseMove(movement)) {
        return;
      }
    }, "MOUSE_MOVE");
    bindScreenSpaceInputAction(inputHandler, (movement) => {
      if (handleOrbitMouseWheel(movement)) {
        return;
      }
      unlockFreeModeFromMouse();
    }, "WHEEL");
    bindScreenSpaceInputAction(inputHandler, unlockFreeModeFromMouse, "MIDDLE_DOWN");
    bindScreenSpaceInputAction(inputHandler, unlockFreeModeFromMouse, "PINCH_START");
    bindScreenSpaceInputAction(inputHandler, endOrbitDrag, "PINCH_END");

    state.mouseMapInputHandler = inputHandler;
  }

  function bindScreenSpaceInputAction(handler, callback, eventName) {
    const eventType = Cesium.ScreenSpaceEventType?.[eventName];
    if (!handler || !eventType) {
      return;
    }
    handler.setInputAction(callback, eventType);
  }

  function zoomInMap() {
    if (state.flightEntity && (state.cameraMode === "chase" || state.cameraMode === "top" || state.cameraMode === "orbit")) {
      nudgeCameraRange(-60);
      return;
    }
    const camera = state.viewer.camera;
    const amount = Math.max(30, camera.positionCartographic.height * 0.28);
    camera.zoomIn(amount);
  }

  function zoomOutMap() {
    if (state.flightEntity && (state.cameraMode === "chase" || state.cameraMode === "top" || state.cameraMode === "orbit")) {
      nudgeCameraRange(60);
      return;
    }
    const camera = state.viewer.camera;
    const amount = Math.max(30, camera.positionCartographic.height * 0.35);
    camera.zoomOut(amount);
  }

  function centerOnAircraft() {
    if (!state.flightEntity) {
      return;
    }
    state.viewer.zoomTo(
      state.flightEntity,
      new Cesium.HeadingPitchRange(
        Cesium.Math.toRadians(state.cameraOffsets.headingDeg),
        Cesium.Math.toRadians(state.cameraOffsets.pitchDeg),
        clamp(state.cameraOffsets.rangeMeters * 1.6, 180, 6000)
      )
    );
  }

  function togglePathVisibility() {
    state.pathVisibilityMode = state.pathVisibilityMode === "all" ? "none" : "all";
    applyPathVisibility();
    syncPathToggleButtonUI();
  }

  function togglePathVisibilityMini() {
    state.pathVisibilityMode = state.pathVisibilityMode === "orange_only" ? "none" : "orange_only";
    applyPathVisibility();
    syncPathToggleButtonUI();
  }

  function toggleProgressivePathVisibility() {
    state.progressivePathVisible = !state.progressivePathVisible;
    applyProgressivePathVisibility();
    syncProgressivePathToggleButtonUI();
  }

  function syncPathToggleButtonUI() {
    if (state.pathVisibilityMode === "all") {
      UI.pathToggleBtn.textContent = getReplay3DText("OCULTAR_TRACADO_COMPLETO_VOO");
    } else {
      UI.pathToggleBtn.textContent = getReplay3DText("MOSTRAR_TRACADO_COMPLETO_VOO");
    }

    if (UI.miniPathToggleBtn) {
      UI.miniPathToggleBtn.textContent = state.pathVisibilityMode === "orange_only"
        ? getReplay3DText("OCULTAR_TRACADO_COMPLETO_VOO")
        : getReplay3DText("MOSTRAR_TRACADO_COMPLETO_VOO");
    }
  }

  function syncProgressivePathToggleButtonUI() {
    if (!UI.progressivePathToggleBtn) {
      return;
    }
    UI.progressivePathToggleBtn.textContent = state.progressivePathVisible
      ? getReplay3DText("OCULTAR_TRACADO_VOO")
      : getReplay3DText("MOSTRAR_TRACADO_VOO");
    UI.progressivePathToggleBtn.setAttribute("aria-pressed", state.progressivePathVisible ? "true" : "false");
  }

  function toggleAircraftMarkerVisibility() {
    state.aircraftMarkerVisible = !state.aircraftMarkerVisible;
    applyAircraftMarkerVisibility();
    syncAircraftMarkerToggleButtonUI();
  }

  function syncAircraftMarkerToggleButtonUI() {
    const text = state.aircraftMarkerVisible ? getReplay3DText("OCULTAR_MARCADOR") : getReplay3DText("MOSTRAR_MARCADOR");
    UI.aircraftMarkerToggleBtn.textContent = text;
    if (UI.miniAircraftMarkerToggleBtn) {
      UI.miniAircraftMarkerToggleBtn.textContent = text;
    }
  }

  function applyAircraftMarkerVisibility() {
    if (!state.aircraftMarker) {
      return;
    }
    state.aircraftMarker.show = state.aircraftMarkerVisible;
  }

  function toggleTransitFocusMode() {
    if (!state.sprayAreaReferencePoint) {
      state.transitFocusEnabled = false;
      syncTransitFocusToggleButtonUI();
      return;
    }
    state.transitFocusEnabled = !state.transitFocusEnabled;
    syncTransitFocusToggleButtonUI();
    setStatus(
      state.transitFocusEnabled
        ? `${getReplay3DText("FOCO_AREA_ATIVADO")} (${Math.round(resolveTransitFocusDistanceMeters() / 1000)} km): ${getReplay3DText("TRANSLADOS_LONGOS_ENCURTADOS")}`
        : getReplay3DText("FOCO_AREA_DESATIVADO")
    );
  }

  function syncTransitFocusToggleButtonUI() {
    const available = !!state.sprayAreaReferencePoint;
    const text = !available
      ? getReplay3DText("FOCO_4KM_INDISPONIVEL")
      : (state.transitFocusEnabled ? getReplay3DText("FOCO_4KM_ON") : getReplay3DText("FOCO_4KM_OFF"));

    if (UI.transitFocusToggleBtn) {
      UI.transitFocusToggleBtn.textContent = text;
      UI.transitFocusToggleBtn.setAttribute("aria-pressed", state.transitFocusEnabled ? "true" : "false");
    }
    if (UI.miniTransitFocusToggleBtn) {
      UI.miniTransitFocusToggleBtn.textContent = text;
      UI.miniTransitFocusToggleBtn.setAttribute("aria-pressed", state.transitFocusEnabled ? "true" : "false");
    }
  }

  function toggleMeasureVisibility() {
    state.measureVisible = !state.measureVisible;
    applyMeasureVisibility();
    syncMeasureToggleButtonUI();
  }

  function syncMeasureToggleButtonUI() {
    if (!UI.measureToggleBtn) {
      return;
    }
    if (!state.measureAvailable) {
      UI.measureToggleBtn.textContent = getReplay3DText("MEDICAO_INDISPONIVEL");
      return;
    }
    UI.measureToggleBtn.textContent = state.measureVisible ? getReplay3DText("OCULTAR_MEDICAO") : getReplay3DText("MOSTRAR_MEDICAO");
  }

  function applyMeasureVisibility() {
    if (!Array.isArray(state.measureEntities) || !state.measureEntities.length) {
      return;
    }
    for (const entity of state.measureEntities) {
      if (entity) {
        entity.show = state.measureVisible;
      }
    }
  }

  function clearMeasureEntities() {
    if (!Array.isArray(state.measureEntities) || !state.measureEntities.length) {
      state.measureEntities = [];
      state.measureAvailable = false;
      return;
    }
    for (const entity of state.measureEntities) {
      if (entity) {
        state.viewer?.entities.remove(entity);
      }
    }
    state.measureEntities = [];
    state.measureAvailable = false;
  }

  function buildStartToFirstSprayMeasurement(points) {
    clearMeasureEntities();
    if (!Array.isArray(points) || points.length < 2 || !state.viewer) {
      syncMeasureToggleButtonUI();
      return;
    }

    const firstSprayIndex = points.findIndex((_, idx) => !!state.sprayFlags[idx]);
    if (firstSprayIndex < 0) {
      syncMeasureToggleButtonUI();
      return;
    }

    const startPoint = points[0];
    const sprayPoint = points[firstSprayIndex];
    if (!startPoint || !sprayPoint) {
      syncMeasureToggleButtonUI();
      return;
    }

    const startPos = toGroundCartesian(startPoint);
    const sprayPos = toGroundCartesian(sprayPoint);
    const midpoint = Cesium.Cartesian3.midpoint(startPos, sprayPos, new Cesium.Cartesian3());
    const distanceMeters = computeSurfaceDistanceMeters(startPoint, sprayPoint);
    const distanceText = formatDistanceMeters(distanceMeters);

    const lineEntity = state.viewer.entities.add({
      name: "Medição deslocamento até aplicação",
      show: state.measureVisible,
      polyline: {
        positions: [startPos, sprayPos],
        width: 2.5,
        clampToGround: true,
        material: Cesium.Color.fromCssColorString("#56a3f2").withAlpha(0.95)
      }
    });

    const startPinEntity = state.viewer.entities.add({
      name: "PIN início",
      show: state.measureVisible,
      position: startPos,
      point: {
        pixelSize: 10,
        color: Cesium.Color.fromCssColorString("#f2c14e"),
        outlineColor: Cesium.Color.fromCssColorString("#1e2618"),
        outlineWidth: 2,
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      },
      label: {
        text: "Início",
        font: '12px "Segoe UI", sans-serif',
        fillColor: Cesium.Color.WHITE,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        showBackground: true,
        backgroundColor: new Cesium.Color(0.1, 0.14, 0.11, 0.75),
        pixelOffset: new Cesium.Cartesian2(0, -18),
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      }
    });

    const sprayPinEntity = state.viewer.entities.add({
      name: "PIN primeira aplicação",
      show: state.measureVisible,
      position: sprayPos,
      point: {
        pixelSize: 10,
        color: Cesium.Color.fromCssColorString("#20a85a"),
        outlineColor: Cesium.Color.fromCssColorString("#1e2618"),
        outlineWidth: 2,
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      },
      label: {
        text: "1ª aplicação",
        font: '12px "Segoe UI", sans-serif',
        fillColor: Cesium.Color.WHITE,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        showBackground: true,
        backgroundColor: new Cesium.Color(0.1, 0.14, 0.11, 0.75),
        pixelOffset: new Cesium.Cartesian2(0, -18),
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      }
    });

    const measureLabelEntity = state.viewer.entities.add({
      name: "Distância início até primeira aplicação",
      show: state.measureVisible,
      position: midpoint,
      label: {
        text: `Deslocamento: ${distanceText}`,
        font: '13px "Segoe UI", sans-serif',
        fillColor: Cesium.Color.WHITE,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        showBackground: true,
        backgroundColor: new Cesium.Color(0.06, 0.1, 0.08, 0.82),
        pixelOffset: new Cesium.Cartesian2(0, -12),
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      }
    });

    state.measureEntities = [lineEntity, startPinEntity, sprayPinEntity, measureLabelEntity];
    state.measureAvailable = true;
    syncMeasureToggleButtonUI();
  }

  function computeSurfaceDistanceMeters(p0, p1) {
    if (!p0 || !p1) {
      return null;
    }
    const c0 = Cesium.Cartographic.fromDegrees(p0.lon, p0.lat);
    const c1 = Cesium.Cartographic.fromDegrees(p1.lon, p1.lat);
    const geodesic = new Cesium.EllipsoidGeodesic(c0, c1);
    const surface = geodesic.surfaceDistance;
    if (Number.isFinite(surface)) {
      return surface;
    }
    return Cesium.Cartesian3.distance(
      Cesium.Cartesian3.fromDegrees(p0.lon, p0.lat, 0),
      Cesium.Cartesian3.fromDegrees(p1.lon, p1.lat, 0)
    );
  }


  function distanceMeters(p0, p1) {
    if (!p0 || !p1) {
      return 0;
    }

    const p0Lon = Number(p0.lon !== undefined && p0.lon !== null ? p0.lon : p0.lng);
    const p0Lat = Number(p0.lat);
    const p1Lon = Number(p1.lon !== undefined && p1.lon !== null ? p1.lon : p1.lng);
    const p1Lat = Number(p1.lat);

    if (!Number.isFinite(p0Lon) || !Number.isFinite(p0Lat) || !Number.isFinite(p1Lon) || !Number.isFinite(p1Lat)) {
      return 0;
    }

    const distance = computeSurfaceDistanceMeters({ lon: p0Lon, lat: p0Lat }, { lon: p1Lon, lat: p1Lat });

    return Number.isFinite(distance) ? distance : 0;
  }

  function buildSprayAreaReferencePoint(points) {
    if (!Array.isArray(points) || !points.length || !Array.isArray(state.sprayFlags)) {
      return null;
    }

    let lonSum = 0;
    let latSum = 0;
    let count = 0;
    const n = Math.min(points.length, state.sprayFlags.length);
    for (let i = 0; i < n; i++) {
      if (!state.sprayFlags[i]) {
        continue;
      }
      const p = points[i];
      if (!p || !Number.isFinite(p.lon) || !Number.isFinite(p.lat)) {
        continue;
      }
      lonSum += p.lon;
      latSum += p.lat;
      count++;
    }

    if (!count) {
      return null;
    }
    return {
      lon: lonSum / count,
      lat: latSum / count
    };
  }

  function resolveTransitFocusDistanceMeters() {
    const raw = Number(
      state.appConfig.transitFocusDistanceMeters
      ?? defaultAppConfig.transitFocusDistanceMeters
    );
    if (!Number.isFinite(raw)) {
      return defaultAppConfig.transitFocusDistanceMeters;
    }
    return clamp(raw, 500, 20000);
  }

  function isOutsideTransitFocusArea(point) {
    if (!point || !state.sprayAreaReferencePoint) {
      return false;
    }
    const dist = computeSurfaceDistanceMeters(point, state.sprayAreaReferencePoint);
    if (!Number.isFinite(dist)) {
      return false;
    }
    return dist > resolveTransitFocusDistanceMeters();
  }

  function resolveTransitFocusJumpSec(startIndex) {
    if (!state.transitFocusEnabled || !state.sprayAreaReferencePoint) {
      return null;
    }
    if (!Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      return null;
    }

    const idx = clamp(Math.round(startIndex), 0, state.timelinePoints.length - 1);
    const startPoint = state.timelinePoints[idx];
    if (!startPoint || !!state.sprayFlags[idx] || !isOutsideTransitFocusArea(startPoint)) {
      return null;
    }

    for (let j = idx + 1; j < state.timelinePoints.length; j++) {
      const p = state.timelinePoints[j];
      if (!p) {
        continue;
      }
      if (!!state.sprayFlags[j] || !isOutsideTransitFocusArea(p)) {
        return Number(p.tSec);
      }
    }

    return null;
  }

  function formatDistanceMeters(distanceMeters) {
    if (!Number.isFinite(distanceMeters) || distanceMeters < 0) {
      return "--";
    }
    if (distanceMeters >= 1000) {
      return `${(distanceMeters / 1000).toFixed(2)} km`;
    }
    return `${Math.round(distanceMeters)} m`;
  }

  function formatDurationHms(totalSec) {
    if (!Number.isFinite(totalSec) || totalSec < 0) {
      return "--:--:--";
    }
    const sec = Math.max(0, Math.floor(totalSec));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  function setTelemetryValue(el, value) {
    if (!el) {
      return;
    }
    el.textContent = String(value ?? "--");
  }

  function resetTelemetryBoard() {
    setTelemetryValue(UI.telemetryHectaresApplied, "--");
    setTelemetryValue(UI.telemetryAircraftSpeed, "--");
    setTelemetryValue(UI.telemetryFlowInstant, "--");
    setTelemetryValue(UI.telemetryFlowAverage, "--");
    setTelemetryValue(UI.telemetryAltitude, "--");
    setTelemetryValue(UI.telemetryAltitudeAverage, "--");
    setTelemetryValue(UI.telemetryYieldHaPerHour, "--");
    setTelemetryValue(UI.telemetryShot, "--");
    setTelemetryValue(UI.telemetryStrip, "--");
    setTelemetryValue(UI.telemetryTimeSpray, "--:--:--");
    setTelemetryValue(UI.telemetryTimeBalloon, "--:--:--");
    setTelemetryValue(UI.telemetryTimeTransit, "--:--:--");
    setTelemetryValue(UI.telemetryTimeRefuel, "--");
    setTelemetryValue(UI.telemetryTimeTotal, "--:--:--");
    setTelemetryValue(UI.telemetryFuelLevel, "--");
    setTelemetryValue(UI.telemetryFuelPercent, "--");
    setTelemetryValue(UI.telemetryRefuelCount, "--");
  }

  function buildTelemetryCaches(points) {
    const n = Array.isArray(points) ? points.length : 0;
    state.telemetryCumulativeSpraySec = new Array(n).fill(0);
    state.telemetryCumulativeBalloonSec = new Array(n).fill(0);
    state.telemetryCumulativeTransitSec = new Array(n).fill(0);
    state.telemetryCumulativeRefuelSec = new Array(n).fill(0);
    state.telemetrySegmentTypes = new Array(Math.max(0, n - 1)).fill("transit");
    state.telemetryCumulativeAreaM2 = new Array(n).fill(0);
    state.telemetryAverageAltitudeMeters = null;

    if (n < 2 || !Array.isArray(state.segmentSprayDecisions)) {
      return;
    }

    let altSum = 0;
    let altCount = 0;
    for (const p of points) {
      const alt = Number.isFinite(p?.altAdjusted) ? p.altAdjusted : p?.alt;
      if (Number.isFinite(alt)) {
        altSum += alt;
        altCount++;
      }
    }
    if (altCount > 0) {
      state.telemetryAverageAltitudeMeters = altSum / altCount;
    }

    const defaultWidth = resolveSprayDefaultWidthMeters(points);
    state.telemetrySegmentTypes = buildTelemetrySegmentTypes(points);

    for (let i = 1; i < n; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const dtSec = Math.max(0, Number(p1.tSec) - Number(p0.tSec));
      const telemetryType = state.telemetrySegmentTypes[i - 1] || "transit";

      state.telemetryCumulativeSpraySec[i] = state.telemetryCumulativeSpraySec[i - 1];
      state.telemetryCumulativeBalloonSec[i] = state.telemetryCumulativeBalloonSec[i - 1];
      state.telemetryCumulativeTransitSec[i] = state.telemetryCumulativeTransitSec[i - 1];
      state.telemetryCumulativeRefuelSec[i] = state.telemetryCumulativeRefuelSec[i - 1];
      state.telemetryCumulativeAreaM2[i] = state.telemetryCumulativeAreaM2[i - 1];

      const distM = computeSurfaceDistanceMeters(p0, p1);

      if (telemetryType === "spray") {
        state.telemetryCumulativeSpraySec[i] += dtSec;
        if (Number.isFinite(distM) && distM > 0) {
          const widthM = resolveSprayWidthMetersForSegment(p0, p1, defaultWidth);
          state.telemetryCumulativeAreaM2[i] += Math.max(0, widthM * distM);
        }
      } else if (telemetryType === "refuel") {
        state.telemetryCumulativeRefuelSec[i] += dtSec;
      } else if (telemetryType === "balloon") {
        state.telemetryCumulativeBalloonSec[i] += dtSec;
      } else {
        state.telemetryCumulativeTransitSec[i] += dtSec;
      }
    }
  }

  function buildTelemetrySegmentTypes(points) {
    const n = Array.isArray(points) ? points.length : 0;
    const types = new Array(Math.max(0, n - 1)).fill("transit");
    if (n < 2) {
      return types;
    }

    const applicationFlags = buildTelemetryApplicationFlags(points);
    const balloonRunByPoint = buildTelemetryBalloonRunByPoint(points, applicationFlags);
    const applicationReferencePoints = buildTelemetryApplicationReferencePoints(points, applicationFlags);

    for (let i = 1; i < n; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const dtSec = Math.max(0, Number(p1.tSec) - Number(p0.tSec));
      const distM = computeSurfaceDistanceMeters(p0, p1);
      const isStopped = dtSec >= 10 && Number.isFinite(distM) && distM <= 30;
      const p0Refuel = isTimelineRefuelPoint(p0);
      const p1Refuel = isTimelineRefuelPoint(p1);
      const isRefuelSegment = (p0Refuel && p1Refuel) || ((p0Refuel || p1Refuel) && isStopped);
      const p0TelemetryType = String(p0 && p0.telemetryType ? p0.telemetryType : '').trim().toLowerCase();
      const p1TelemetryType = String(p1 && p1.telemetryType ? p1.telemetryType : '').trim().toLowerCase();
      const isExplicitTransitSegment = p0TelemetryType === "transit" && p1TelemetryType === "transit";
      const isApplicationSegment = isTelemetryApplicationSegment(points, applicationFlags, i);
      const isBalloonSegment = !isExplicitTransitSegment && isTelemetryBalloonSegment(
        points,
        applicationFlags,
        balloonRunByPoint,
        applicationReferencePoints,
        i
      );

      if (isRefuelSegment || (isStopped && !isApplicationSegment && !isExplicitTransitSegment)) {
        types[i - 1] = "refuel";
      } else if (isApplicationSegment) {
        types[i - 1] = "spray";
      } else if (isExplicitTransitSegment) {
        types[i - 1] = "transit";
      } else if (isBalloonSegment) {
        types[i - 1] = "balloon";
      } else {
        types[i - 1] = "transit";
      }
    }

    return types;
  }

  function buildTelemetryApplicationFlags(points) {
    const flags = new Array(points.length).fill(false);
    let hasExplicitApplication = false;

    for (let i = 0; i < points.length; i++) {
      if (isExplicitTelemetryApplicationPoint(points[i])) {
        flags[i] = true;
        hasExplicitApplication = true;
      }
    }

    if (hasExplicitApplication) {
      return flags;
    }

    for (let i = 0; i < points.length; i++) {
      flags[i] = !!state.sprayFlags[i];
    }

    return flags;
  }

  function isExplicitTelemetryApplicationPoint(point) {
    if (!point || !point.spray) {
      return false;
    }

    if (point.spraySource === "explicit_track") {
      return true;
    }

    return point.applicationType === "app" || point.applicationType === "over" || point.applicationType === "out";
  }

  function buildTelemetryBalloonRunByPoint(points, applicationFlags) {
    const runByPoint = new Array(points.length).fill(-1);
    let runIndex = 0;

    for (let i = 0; i < points.length - 1; i++) {
      const applicationEndsHere = !!applicationFlags[i] && !applicationFlags[i + 1];
      if (!applicationEndsHere) {
        continue;
      }

      let nextApplicationStart = -1;
      for (let j = i + 1; j < points.length; j++) {
        if (!!applicationFlags[j] && !applicationFlags[j - 1]) {
          nextApplicationStart = j;
          break;
        }
      }

      if (nextApplicationStart <= i + 1) {
        continue;
      }

      for (let k = i + 1; k < nextApplicationStart; k++) {
        runByPoint[k] = runIndex;
      }

      runIndex++;
      i = Math.max(i, nextApplicationStart - 1);
    }

    return runByPoint;
  }

  function buildTelemetryApplicationReferencePoints(points, applicationFlags) {
    const applicationPoints = [];
    for (let i = 0; i < points.length; i++) {
      if (applicationFlags[i]) {
        applicationPoints.push(points[i]);
      }
    }

    if (!applicationPoints.length) {
      return [];
    }

    const step = Math.max(1, Math.ceil(applicationPoints.length / 250));
    const referencePoints = [];
    for (let i = 0; i < applicationPoints.length; i += step) {
      referencePoints.push(applicationPoints[i]);
    }

    const lastPoint = applicationPoints[applicationPoints.length - 1];
    if (referencePoints[referencePoints.length - 1] !== lastPoint) {
      referencePoints.push(lastPoint);
    }

    return referencePoints;
  }

  function isTelemetryApplicationSegment(points, applicationFlags, segmentIndex) {
    if (!applicationFlags[segmentIndex - 1] || !applicationFlags[segmentIndex]) {
      return false;
    }

    return !isTelemetryManeuverSegment(points, segmentIndex);
  }

  function isTelemetryBalloonSegment(points, applicationFlags, balloonRunByPoint, applicationReferencePoints, segmentIndex) {
    if (Number.isFinite(balloonRunByPoint[segmentIndex]) && balloonRunByPoint[segmentIndex] >= 0) {
      return true;
    }

    const isApplicationManeuver = (applicationFlags[segmentIndex - 1] || applicationFlags[segmentIndex])
      && isTelemetryManeuverSegment(points, segmentIndex);
    if (isApplicationManeuver) {
      return true;
    }

    if (!hasTelemetryApplicationBefore(applicationFlags, segmentIndex) || !hasTelemetryApplicationAfter(applicationFlags, segmentIndex)) {
      return false;
    }

    return isTelemetryPointNearApplicationArea(points[segmentIndex], applicationReferencePoints, 1700);
  }

  function isTelemetryManeuverSegment(points, segmentIndex) {
    const previousHeading = segmentIndex > 1
      ? computeTrackHeadingDeg(points[segmentIndex - 2], points[segmentIndex - 1])
      : null;
    const currentHeading = computeTrackHeadingDeg(points[segmentIndex - 1], points[segmentIndex]);
    const nextHeading = segmentIndex < points.length - 1
      ? computeTrackHeadingDeg(points[segmentIndex], points[segmentIndex + 1])
      : null;

    const previousDelta = Number.isFinite(previousHeading) && Number.isFinite(currentHeading)
      ? Math.abs(shortestAngleDiffDeg(currentHeading, previousHeading))
      : 0;
    const nextDelta = Number.isFinite(currentHeading) && Number.isFinite(nextHeading)
      ? Math.abs(shortestAngleDiffDeg(nextHeading, currentHeading))
      : 0;

    return previousDelta >= 25 || nextDelta >= 25;
  }

  function shortestAngleDiffDeg(a, b) {
    let diff = (Number(a) - Number(b) + 540) % 360 - 180;
    if (!Number.isFinite(diff)) {
      diff = 0;
    }
    return diff;
  }

  function hasTelemetryApplicationBefore(applicationFlags, segmentIndex) {
    for (let i = segmentIndex - 1; i >= 0; i--) {
      if (applicationFlags[i]) {
        return true;
      }
    }
    return false;
  }

  function hasTelemetryApplicationAfter(applicationFlags, segmentIndex) {
    for (let i = segmentIndex; i < applicationFlags.length; i++) {
      if (applicationFlags[i]) {
        return true;
      }
    }
    return false;
  }

  function isTelemetryPointNearApplicationArea(point, applicationReferencePoints, maxDistanceMeters) {
    if (!point || !Array.isArray(applicationReferencePoints) || !applicationReferencePoints.length) {
      return false;
    }

    for (let i = 0; i < applicationReferencePoints.length; i++) {
      const distance = computeSurfaceDistanceMeters(point, applicationReferencePoints[i]);
      if (Number.isFinite(distance) && distance <= maxDistanceMeters) {
        return true;
      }
    }

    return false;
  }


  function normalizeOfficialRelativeAltitude(rawAltitude, minAltitudeMeters) {
    const altitude = Number(rawAltitude);
    const minimumAltitude = Number.isFinite(minAltitudeMeters) ? Math.max(0, minAltitudeMeters) : 3;

    if (!Number.isFinite(altitude)) {
      return Math.max(minimumAltitude, 6);
    }

    if (altitude > 300 && altitude <= 30000) {
      return Math.max(minimumAltitude, Math.min(80, altitude / 1000));
    }

    if (altitude > 80) {
      return Math.max(minimumAltitude, 6);
    }

    return Math.max(minimumAltitude, altitude);
  }

  function isTimelineRefuelPoint(point) {
    if (!point) {
      return false;
    }

    return point.telemetryType === "refuel" || point.applicationType === "refuel";
  }

  function normalizeTimelinePointRelativeAltitude(point) {
    const minimumAltitude = isTimelineRefuelPoint(point) ? 0.5 : 3;
    const rawAltitude = point && Number.isFinite(point.alt) ? point.alt : (point && Number.isFinite(point.altAdjusted) ? point.altAdjusted : null);
    return normalizeOfficialRelativeAltitude(rawAltitude, minimumAltitude);
  }

  function isTelemetryRefuelAtTime(currentSec, currentPointIndex) {
    const segmentIndex = findCurrentTelemetrySegmentIndex(currentSec);
    if (segmentIndex >= 0 && state.telemetrySegmentTypes && state.telemetrySegmentTypes[segmentIndex] === "refuel") {
      return true;
    }

    const safeIndex = clamp(Math.round(currentPointIndex), 0, state.timelinePoints.length - 1);
    return isTimelineRefuelPoint(state.timelinePoints[safeIndex]);
  }

  function getTimelinePointNumber(point, fieldNames, fallback = null) {
    if (!point) {
      return fallback;
    }

    for (const fieldName of fieldNames) {
      const value = Number(point[fieldName]);
      if (Number.isFinite(value)) {
        return value;
      }
    }

    return fallback;
  }

  function formatTelemetryDecimal(value, decimals, suffix = "") {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) {
      return "--";
    }

    return `${numberValue.toFixed(decimals)}${suffix}`;
  }

  function formatTelemetryDecimalWithUnit(value, decimals, unitKey) {
    const unit = getReplay3DText(unitKey) || unitKey;
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) {
      return "--";
    }

    return `${Units.formatValue(numberValue, replay3DTexts)} ${unit}`;
  }

  function computeCumulativeRefuelSeconds(points) {
    const cumulative = new Array(points.length).fill(0);
    let total = 0;
    for (let i = 1; i < points.length; i++) {
      const prev = points[i - 1];
      const cur = points[i];
      const dt = Math.max(0, Number(cur.tSec || 0) - Number(prev.tSec || 0));
      const dist = distanceMeters(prev, cur);
      const isStopped = dt >= 10 && dist <= 30;
      const isSpraying = !!(cur.spray || cur.app || cur.over || cur.out);
      if (isStopped && !isSpraying) {
        total += dt;
      }
      cumulative[i] = total;
    }
    return cumulative;
  }

  function findCurrentTelemetrySegmentIndex(currentSec) {
    if (!Array.isArray(state.timelinePoints) || state.timelinePoints.length < 2) {
      return -1;
    }

    for (let i = 1; i < state.timelinePoints.length; i++) {
      const startSec = Number(state.timelinePoints[i - 1].tSec);
      const endSec = Number(state.timelinePoints[i].tSec);

      if (Number.isFinite(startSec) && Number.isFinite(endSec) && currentSec >= startSec && currentSec <= endSec) {
        return i;
      }
    }

    return currentSec >= state.timelinePoints[state.timelinePoints.length - 1].tSec ? state.timelinePoints.length - 1 : 1;
  }

  function getInterpolatedTimelineNumber(currentSec, fieldNames, fallback = null) {
    const segmentIndex = findCurrentTelemetrySegmentIndex(currentSec);

    if (segmentIndex <= 0 || segmentIndex >= state.timelinePoints.length) {
      const point = state.timelinePoints[clamp(Math.round(segmentIndex), 0, state.timelinePoints.length - 1)] || state.timelinePoints[0];
      return getTimelinePointNumber(point, fieldNames, fallback);
    }

    const previous = state.timelinePoints[segmentIndex - 1];
    const current = state.timelinePoints[segmentIndex];
    const previousValue = getTimelinePointNumber(previous, fieldNames, fallback);
    const currentValue = getTimelinePointNumber(current, fieldNames, fallback);

    if (!Number.isFinite(previousValue) || !Number.isFinite(currentValue)) {
      return Number.isFinite(currentValue) ? currentValue : previousValue;
    }

    const startSec = Number(previous.tSec);
    const endSec = Number(current.tSec);
    const ratio = endSec > startSec ? clamp((currentSec - startSec) / (endSec - startSec), 0, 1) : 1;

    return previousValue + ((currentValue - previousValue) * ratio);
  }

  function getTelemetrySecondsAtCurrentTime(currentSec, idx) {
    const safeIdx = clamp(Math.round(idx), 0, state.timelinePoints.length - 1);
    const result = {
      spraySec: state.telemetryCumulativeSpraySec[safeIdx] || 0,
      balloonSec: state.telemetryCumulativeBalloonSec[safeIdx] || 0,
      transitSec: state.telemetryCumulativeTransitSec[safeIdx] || 0,
      refuelSec: state.telemetryCumulativeRefuelSec[safeIdx] || 0,
      areaM2: state.telemetryCumulativeAreaM2[safeIdx] || 0
    };

    const segmentIndex = findCurrentTelemetrySegmentIndex(currentSec);
    if (segmentIndex <= 0 || segmentIndex >= state.timelinePoints.length) {
      return result;
    }

    const p0 = state.timelinePoints[segmentIndex - 1];
    const p1 = state.timelinePoints[segmentIndex];
    const startSec = Number(p0.tSec);
    const endSec = Number(p1.tSec);
    const partialSec = Math.max(0, Math.min(Number(currentSec) || startSec, endSec) - startSec);

    result.spraySec = state.telemetryCumulativeSpraySec[segmentIndex - 1] || 0;
    result.balloonSec = state.telemetryCumulativeBalloonSec[segmentIndex - 1] || 0;
    result.transitSec = state.telemetryCumulativeTransitSec[segmentIndex - 1] || 0;
    result.refuelSec = state.telemetryCumulativeRefuelSec[segmentIndex - 1] || 0;
    result.areaM2 = state.telemetryCumulativeAreaM2[segmentIndex - 1] || 0;

    const telemetryType = state.telemetrySegmentTypes[segmentIndex - 1] || "transit";
    const segmentDtSec = Math.max(0, endSec - startSec);
    const distM = computeSurfaceDistanceMeters(p0, p1);

    if (telemetryType === "spray") {
      result.spraySec += partialSec;
      if (segmentDtSec > 0 && Number.isFinite(distM) && distM > 0) {
        const defaultWidth = resolveSprayDefaultWidthMeters(state.timelinePoints);
        const widthM = resolveSprayWidthMetersForSegment(p0, p1, defaultWidth);
        result.areaM2 += Math.max(0, widthM * distM * (partialSec / segmentDtSec));
      }
    } else if (telemetryType === "refuel") {
      result.refuelSec += partialSec;
    } else if (telemetryType === "balloon") {
      result.balloonSec += partialSec;
    } else {
      result.transitSec += partialSec;
    }

    return result;
  }


  function resolveTelemetryFlow(currentSec) {
    return getInterpolatedTimelineNumber(currentSec, ["flow", "fluxo", "flowRate", "setFluxo", "iFluxo"], null);
  }

  function resolveTelemetryFlowAverage(currentSec, idx) {
    let sprayFlowSum = 0;
    let sprayFlowCount = 0;
    let generalFlowSum = 0;
    let generalFlowCount = 0;
    const limit = clamp(Math.round(idx), 0, state.timelinePoints.length - 1);

    for (let i = 0; i <= limit && i < state.timelinePoints.length; i++) {
      const item = state.timelinePoints[i];
      const itemFlow = getTimelinePointNumber(item, ["flow", "fluxo", "flowRate", "setFluxo", "iFluxo"], null);

      if (!Number.isFinite(itemFlow)) {
        continue;
      }

      generalFlowSum += itemFlow;
      generalFlowCount++;

      if (itemFlow > 0 && (state.sprayFlags[i] || item.spray || item.app || item.over || item.out)) {
        sprayFlowSum += itemFlow;
        sprayFlowCount++;
      }
    }

    const currentFlow = resolveTelemetryFlow(currentSec);
    const currentSpray = !!state.sprayFlags[limit];
    if (Number.isFinite(currentFlow)) {
      generalFlowSum += currentFlow;
      generalFlowCount++;
      if (currentFlow > 0 && currentSpray) {
        sprayFlowSum += currentFlow;
        sprayFlowCount++;
      }
    }

    if (sprayFlowCount > 0) {
      return sprayFlowSum / sprayFlowCount;
    }

    return generalFlowCount > 0 ? generalFlowSum / generalFlowCount : null;
  }
  function resolveTimelineNearestNumber(idx, keys, fallback) {
    const safeIdx = clamp(Math.round(idx), 0, state.timelinePoints.length - 1);
    const current = state.timelinePoints[safeIdx] || {};
    const direct = getTimelinePointNumber(current, keys, null);

    if (Number.isFinite(direct)) {
      return direct;
    }

    for (let offset = 1; offset < state.timelinePoints.length; offset++) {
      const previous = state.timelinePoints[safeIdx - offset];
      if (previous) {
        const value = getTimelinePointNumber(previous, keys, null);
        if (Number.isFinite(value)) {
          return value;
        }
      }

      const next = state.timelinePoints[safeIdx + offset];
      if (next) {
        const value = getTimelinePointNumber(next, keys, null);
        if (Number.isFinite(value)) {
          return value;
        }
      }
    }

    return fallback;
  }

  function resolveTelemetrySpeedKmh(currentSec, idx) {
    const atTimelineStart = Number.isFinite(currentSec) && Number.isFinite(state.startSec) && currentSec <= state.startSec + 0.25 && Math.round(idx) <= 0;
    if (atTimelineStart) {
      return 0;
    }

    const directSpeed = getInterpolatedTimelineNumber(currentSec, ["speed", "speedKmh", "velocidade", "setVelocidade", "iVelocidade"], null);
    if (Number.isFinite(directSpeed) && directSpeed > 0) {
      return directSpeed;
    }

    const segmentIndex = findCurrentTelemetrySegmentIndex(currentSec);
    if (segmentIndex > 0 && segmentIndex < state.timelinePoints.length) {
      const p0 = state.timelinePoints[segmentIndex - 1];
      const p1 = state.timelinePoints[segmentIndex];
      const dtSec = Math.max(0, Number(p1.tSec) - Number(p0.tSec));
      const distM = computeSurfaceDistanceMeters(p0, p1);
      if (dtSec > 0 && Number.isFinite(distM)) {
        return (distM / dtSec) * 3.6;
      }
    }

    const safeIdx = clamp(Math.round(idx), 1, state.timelinePoints.length - 1);
    const previous = state.timelinePoints[safeIdx - 1];
    const current = state.timelinePoints[safeIdx];
    if (previous && current) {
      const dtSec = Math.max(0, Number(current.tSec) - Number(previous.tSec));
      const distM = computeSurfaceDistanceMeters(previous, current);
      if (dtSec > 0 && Number.isFinite(distM)) {
        return (distM / dtSec) * 3.6;
      }
    }

    return null;
  }

  function getPlanningReplay3DTotalAreaM2Override() {
    const sourceData = state.officialSprayFootprintSourceData || {};
    const value = Number(sourceData.planningTotalAreaM2);

    if (Number.isFinite(value) && value > 0) {
      return value;
    }

    const hectares = Number(sourceData.planningTotalAreaHa);
    return Number.isFinite(hectares) && hectares > 0 ? hectares * 10000 : null;
  }

  function getTelemetryAreaScaleFactor() {
    const planningTotalAreaM2 = getPlanningReplay3DTotalAreaM2Override();
    const telemetryTotalAreaM2 = state.telemetryCumulativeAreaM2 && state.telemetryCumulativeAreaM2.length
      ? Number(state.telemetryCumulativeAreaM2[state.telemetryCumulativeAreaM2.length - 1])
      : null;

    if (
      Number.isFinite(planningTotalAreaM2) &&
      planningTotalAreaM2 > 0 &&
      Number.isFinite(telemetryTotalAreaM2) &&
      telemetryTotalAreaM2 > 0
    ) {
      return planningTotalAreaM2 / telemetryTotalAreaM2;
    }

    return 1;
  }

  function getPlanningReplay3DOfficialTimeSec(keys) {
    const sourceData = state.officialSprayFootprintSourceData || {};
    if (!Array.isArray(keys)) {
      keys = [keys];
    }

    for (let i = 0; i < keys.length; i++) {
      const value = Number(sourceData[keys[i]]);
      if (Number.isFinite(value) && value >= 0) {
        return value;
      }
    }

    return null;
  }

  function getTelemetryTimeScaleFactor(officialTimeKeys, telemetryTotalSec) {
    const officialTimeSec = getPlanningReplay3DOfficialTimeSec(officialTimeKeys);

    if (Number.isFinite(officialTimeSec) && officialTimeSec >= 0) {
      if (Number.isFinite(telemetryTotalSec) && telemetryTotalSec > 0) {
        return officialTimeSec / telemetryTotalSec;
      }

      return officialTimeSec > 0 ? 1 : 0;
    }

    return 1;
  }


  function resolveTelemetryShotLabel(pointIndex) {
    const idx = clamp(Math.round(pointIndex), 0, state.timelinePoints.length - 1);
    const point = state.timelinePoints[idx] || {};

    if (!point || !point.spray) {
      return "--";
    }

    const directShot = Number(point.shotNumber ?? point.tiroNumber ?? point.tiro);
    if (Number.isFinite(directShot) && directShot > 0) {
      return `${getReplay3DText("TIRO")} ${Math.round(directShot)}`;
    }

    let shotCount = 0;
    let wasSpraying = false;
    for (let i = 0; i <= idx && i < state.timelinePoints.length; i++) {
      const item = state.timelinePoints[i] || {};
      const spraying = !!item.spray;
      if (spraying && !wasSpraying) {
        shotCount++;
      }
      wasSpraying = spraying;
    }

    return shotCount > 0 ? `${getReplay3DText("TIRO")} ${shotCount}` : "--";
  }

  function resolveTelemetryStripLabel(pointIndex) {
    const idx = clamp(Math.round(pointIndex), 0, state.timelinePoints.length - 1);
    const point = state.timelinePoints[idx] || {};

    if (!point || !point.spray) {
      return "--";
    }

    const rawName = point.planningStripName || point.faixaName || point.stripName || "";
    if (rawName) {
      const normalizedName = String(rawName).trim();
      if (normalizedName) {
        return normalizedName;
      }
    }

    const rawKey = point.planningStripKey !== undefined && point.planningStripKey !== null
      ? point.planningStripKey
      : (point.faixaKey !== undefined && point.faixaKey !== null ? point.faixaKey : point.stripKey);

    if (rawKey === undefined || rawKey === null || rawKey === "") {
      return "--";
    }

    return `${getReplay3DText("FAIXA_APP")} ${rawKey}`;
  }

  function resolveTelemetryTotalSeconds(currentSec, spraySec, balloonSec, transitSec, refuelSec) {
    const officialTotal = Number(state.telemetryOfficialTotalSec);
    if (Number.isFinite(officialTotal) && officialTotal >= 0 && Number.isFinite(state.startSec) && Number.isFinite(state.endSec) && state.endSec > state.startSec) {
      const ratio = clamp((currentSec - state.startSec) / Math.max(1, state.endSec - state.startSec), 0, 1);
      return officialTotal * ratio;
    }

    const sum = Number(spraySec) + Number(balloonSec) + Number(transitSec) + Number(refuelSec);
    if (Number.isFinite(sum) && sum >= 0) {
      return sum;
    }

    if (Number.isFinite(currentSec) && Number.isFinite(state.startSec)) {
      return Math.max(0, currentSec - state.startSec);
    }

    return null;
  }

  function resolveOfficialTotalSeconds(data) {
    if (!data || typeof data !== "object") {
      return null;
    }

    const candidates = [
      data.planningTotalTimeSec,
      data.totalTimeSec,
      data.totalSeconds,
      data.durationSec,
      data && data.total ? data.total.tempo : null,
      data && data.total ? data.total.time : null
    ];

    for (let i = 0; i < candidates.length; i++) {
      const value = Number(candidates[i]);
      if (Number.isFinite(value) && value >= 0) {
        return value;
      }
    }

    return null;
  }

  function updateTelemetryBoard(currentPointIndex, currentSec, force = false) {
    applyTelemetryBoardTextColor();
    if (!Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      if (force) {
        resetTelemetryBoard();
      }
      return;
    }

    const nowMs = performance.now();
    if (!force && (nowMs - state.telemetryLastUiUpdateMs) < 120) {
      return;
    }
    state.telemetryLastUiUpdateMs = nowMs;

    const idx = clamp(Math.round(currentPointIndex), 0, state.timelinePoints.length - 1);
    const point = state.timelinePoints[idx] || {};
    const telemetryAtTime = getTelemetrySecondsAtCurrentTime(currentSec, idx);
    const areaScaleFactor = getTelemetryAreaScaleFactor();
    const areaM2 = telemetryAtTime.areaM2 * areaScaleFactor;
    const hectares = areaM2 / 10000;
    const telemetryFinalSpraySec = state.telemetryCumulativeSpraySec && state.telemetryCumulativeSpraySec.length
      ? Number(state.telemetryCumulativeSpraySec[state.telemetryCumulativeSpraySec.length - 1])
      : null;
    const telemetryFinalBalloonSec = state.telemetryCumulativeBalloonSec && state.telemetryCumulativeBalloonSec.length
      ? Number(state.telemetryCumulativeBalloonSec[state.telemetryCumulativeBalloonSec.length - 1])
      : null;
    const telemetryFinalTransitSec = state.telemetryCumulativeTransitSec && state.telemetryCumulativeTransitSec.length
      ? Number(state.telemetryCumulativeTransitSec[state.telemetryCumulativeTransitSec.length - 1])
      : null;
    const telemetryFinalRefuelSec = state.telemetryCumulativeRefuelSec && state.telemetryCumulativeRefuelSec.length
      ? Number(state.telemetryCumulativeRefuelSec[state.telemetryCumulativeRefuelSec.length - 1])
      : null;
    const spraySec = telemetryAtTime.spraySec * getTelemetryTimeScaleFactor(
      ["planningTimeSpraySec", "planningSpraySec", "timeSpraySec"],
      telemetryFinalSpraySec
    );
    const balloonSec = telemetryAtTime.balloonSec * getTelemetryTimeScaleFactor(
      ["planningTimeBalloonSec", "planningBalloonSec", "timeBalloonSec"],
      telemetryFinalBalloonSec
    );
    const transitSec = telemetryAtTime.transitSec * getTelemetryTimeScaleFactor(
      ["planningTimeTransitSec", "planningTransitSec", "timeTransitSec"],
      telemetryFinalTransitSec
    );
    const refuelSec = telemetryAtTime.refuelSec * getTelemetryTimeScaleFactor(
      ["planningTimeRefuelSec", "planningRefuelSec", "timeRefuelSec"],
      telemetryFinalRefuelSec
    );
    const totalSec = resolveTelemetryTotalSeconds(currentSec, spraySec, balloonSec, transitSec, refuelSec);

    const altitude = normalizeOfficialRelativeAltitude(
      getInterpolatedTimelineNumber(currentSec, ["alt"], null),
      isTelemetryRefuelAtTime(currentSec, idx) ? 0.5 : 3
    );
    const speed = resolveTelemetrySpeedKmh(currentSec, idx);
    const flow = resolveTelemetryFlow(currentSec);
    const fuelLevel = resolveTimelineNearestNumber(idx, ["fuelLevel"], null);
    const fuelCapacity = resolveTimelineNearestNumber(idx, ["fuelCapacity"], Number(state.officialSprayFootprintSourceData && state.officialSprayFootprintSourceData.fuelCapacity));
    const fuelPercent = Number.isFinite(fuelLevel) && Number.isFinite(fuelCapacity) && fuelCapacity > 0
      ? (fuelLevel / fuelCapacity) * 100
      : resolveTimelineNearestNumber(idx, ["fuelPercent"], null);
    const refuelCountPoint = resolveTimelineNearestNumber(idx, ["refuelCount"], null);
    const refuelCount = Number.isFinite(refuelCountPoint)
      ? refuelCountPoint
      : Number(state.officialSprayFootprintSourceData && state.officialSprayFootprintSourceData.refuelCount);

    let altitudeSum = 0;
    let altitudeCount = 0;
    let flowSum = 0;
    let flowCount = 0;

    for (let i = 0; i <= idx && i < state.timelinePoints.length; i++) {
      const item = state.timelinePoints[i];
      const itemAltitude = normalizeOfficialRelativeAltitude(
        getTimelinePointNumber(item, ["alt"], null),
        isTimelineRefuelPoint(item) ? 0.5 : 3
      );
      const itemFlow = getTimelinePointNumber(item, ["flow", "fluxo"], null);

      if (Number.isFinite(itemAltitude)) {
        altitudeSum += itemAltitude;
        altitudeCount++;
      }

      if (Number.isFinite(itemFlow)) {
        flowSum += itemFlow;
        flowCount++;
      }
    }

    const altitudeAverage = altitudeCount > 0 ? altitudeSum / altitudeCount : null;
    const flowAverage = resolveTelemetryFlowAverage(currentSec, idx);
    const yieldHaPerHour = spraySec > 0 ? hectares / (spraySec / 3600) : null;

    setTelemetryValue(UI.telemetryHectaresApplied, formatTelemetryDecimalWithUnit(Units.convertArea(hectares, "ha", replay3DTexts), 1, Units.getAreaUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryAircraftSpeed, formatTelemetryDecimalWithUnit(Units.convertSpeed(speed, "km/h", replay3DTexts), 1, Units.getSpeedUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryFlowInstant, formatTelemetryDecimalWithUnit(Units.convertFlow(flow, "L", "ha", replay3DTexts), 1, Units.getFlowUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryFlowAverage, formatTelemetryDecimalWithUnit(Units.convertFlow(flowAverage, "L", "ha", replay3DTexts), 1, Units.getFlowUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryAltitude, formatTelemetryDecimalWithUnit(Units.convertLength(altitude, "m", replay3DTexts), 1, Units.getLengthUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryAltitudeAverage, formatTelemetryDecimalWithUnit(Units.convertLength(altitudeAverage, "m", replay3DTexts), 1, Units.getLengthUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryYieldHaPerHour, formatTelemetryDecimalWithUnit(Units.convertAreaRate(yieldHaPerHour, "ha", replay3DTexts), 1, Units.getAreaRateUnit(replay3DTexts)));
    setTelemetryValue(UI.telemetryShot, resolveTelemetryShotLabel(idx));
    setTelemetryValue(UI.telemetryStrip, resolveTelemetryStripLabel(idx));
    setTelemetryValue(UI.telemetryTimeSpray, formatDurationHms(spraySec));
    setTelemetryValue(UI.telemetryTimeBalloon, formatDurationHms(balloonSec));
    setTelemetryValue(UI.telemetryTimeTransit, formatDurationHms(transitSec));
    setTelemetryValue(UI.telemetryTimeRefuel, formatDurationHms(refuelSec));
    setTelemetryValue(UI.telemetryTimeTotal, formatDurationHms(totalSec));
    setTelemetryValue(UI.telemetryFuelLevel, Number.isFinite(fuelLevel) && Number.isFinite(fuelCapacity) && fuelCapacity > 0
      ? `${fuelLevel.toFixed(0)} / ${fuelCapacity.toFixed(0)} ${getReplay3DText("L")}`
      : "--");
    setTelemetryValue(UI.telemetryFuelPercent, Number.isFinite(fuelPercent) ? `${Math.max(0, Math.min(100, fuelPercent)).toFixed(0)}%` : "--");
    setTelemetryValue(UI.telemetryRefuelCount, Number.isFinite(refuelCount) ? String(Math.round(refuelCount)) : "--");
  }
  function formatDistanceMetersFluent(distanceMeters) {
    if (!Number.isFinite(distanceMeters) || distanceMeters < 0) {
      return "--";
    }
    if (distanceMeters >= 1000) {
      return `${(distanceMeters / 1000).toFixed(2)} km`;
    }
    return `${distanceMeters.toFixed(1)} m`;
  }

  function extractCurrentAircraftLonLat() {
    const time = state.viewer?.clock?.currentTime;
    const positionProperty = state.aircraftMarker?.position || state.flightEntity?.position;
    if (!time || !positionProperty) {
      return null;
    }

    const position = positionProperty.getValue(time, scratchCurrentPosition);
    if (!position) {
      return null;
    }

    const cartographic = Cesium.Cartographic.fromCartesian(position, undefined, scratchCurrentCartographic);
    if (!cartographic) {
      return null;
    }

    return {
      lon: Cesium.Math.toDegrees(cartographic.longitude),
      lat: Cesium.Math.toDegrees(cartographic.latitude),
      cartesian: Cesium.Cartesian3.clone(position)
    };
  }

  function computePointToSegmentDistanceMeters(pointLon, pointLat, segmentStartPoint, segmentEndPoint) {
    if (!segmentStartPoint || !segmentEndPoint) {
      return null;
    }
    const a = projectLonLatToMeters(segmentStartPoint.lon, segmentStartPoint.lat);
    const b = projectLonLatToMeters(segmentEndPoint.lon, segmentEndPoint.lat);
    const p = projectLonLatToMeters(pointLon, pointLat);
    if (!a || !b || !p) {
      return null;
    }

    const vx = b.x - a.x;
    const vy = b.y - a.y;
    const wx = p.x - a.x;
    const wy = p.y - a.y;
    const vv = (vx * vx) + (vy * vy);
    if (vv <= 1e-9) {
      return Math.hypot(p.x - a.x, p.y - a.y);
    }

    const t = clamp(((wx * vx) + (wy * vy)) / vv, 0, 1);
    const projX = a.x + (vx * t);
    const projY = a.y + (vy * t);
    return Math.hypot(p.x - projX, p.y - projY);
  }

  function resolveBalloonMeasureTransladoHideDistanceMeters() {
    const raw = Number(
      state.appConfig.balloonMeasureTransladoHideDistanceMeters
      ?? defaultAppConfig.balloonMeasureTransladoHideDistanceMeters
    );
    if (!Number.isFinite(raw)) {
      return defaultAppConfig.balloonMeasureTransladoHideDistanceMeters;
    }
    return clamp(raw, 200, 10000);
  }

  function resolveBalloonLengthLabelOffsetY() {
    const rangeMeters = Number(state.cameraOffsets?.rangeMeters);
    if (!Number.isFinite(rangeMeters)) {
      return -42;
    }
    if (rangeMeters <= 220) return -62;
    if (rangeMeters <= 380) return -56;
    if (rangeMeters <= 620) return -50;
    if (rangeMeters <= 900) return -44;
    return -38;
  }

  function toggleBalloonMeasureVisibility() {
    state.balloonMeasureVisible = !state.balloonMeasureVisible;
    syncBalloonMeasureToggleButtonUI();

    if (!state.balloonMeasureVisible) {
      setBalloonMeasureEntitiesVisibility(false);
      state.balloonMeasureActiveRunIndex = -1;
      state.balloonMeasureSmoothedLengthMeters = null;
      state.balloonMeasureSmoothedWidthMeters = null;
      return;
    }

    if (!state.timelinePoints.length) {
      return;
    }

    const idx = findNearestPointIndex(currentClockSec());
    const spraying = !!state.sprayFlags[idx];
    updateCurrentBalloonMeasure(idx, spraying);
  }

  function syncBalloonMeasureToggleButtonUI() {
    if (!UI.balloonMeasureToggleBtn) {
      return;
    }
    if (!state.balloonMeasureAvailable) {
      UI.balloonMeasureToggleBtn.textContent = getReplay3DText("MEDICAO_BALAO_INDISPONIVEL");
      return;
    }
    UI.balloonMeasureToggleBtn.textContent = state.balloonMeasureVisible
      ? getReplay3DText("OCULTAR_MEDICAO_BALAO")
      : getReplay3DText("MOSTRAR_MEDICAO_BALAO");
  }

  function clearBalloonMeasureEntities() {
    const entities = state.balloonMeasureEntities || {};
    if (entities.lengthLine) state.viewer?.entities.remove(entities.lengthLine);
    if (entities.widthLine) state.viewer?.entities.remove(entities.widthLine);
    if (entities.lengthLabel) state.viewer?.entities.remove(entities.lengthLabel);
    if (entities.widthLabel) state.viewer?.entities.remove(entities.widthLabel);
    state.balloonMeasureEntities = {
      lengthLine: null,
      widthLine: null,
      lengthLabel: null,
      widthLabel: null
    };
  }

  function clearBalloonMeasureData() {
    clearBalloonMeasureEntities();
    state.balloonMeasureRuns = [];
    state.balloonMeasureRunByPoint = [];
    state.trackCumulativeMeters = [];
    state.balloonMeasureAvailable = false;
    state.balloonMeasureActiveRunIndex = -1;
    state.balloonMeasureSmoothedLengthMeters = null;
    state.balloonMeasureSmoothedWidthMeters = null;
    state.balloonMeasureSuppressedRunIndex = -1;
  }

  function setBalloonMeasureEntitiesVisibility(visible) {
    const entities = state.balloonMeasureEntities || {};
    if (entities.lengthLine) entities.lengthLine.show = !!visible;
    if (entities.widthLine) entities.widthLine.show = !!visible;
    if (entities.lengthLabel) entities.lengthLabel.show = !!visible;
    if (entities.widthLabel) entities.widthLabel.show = !!visible;
  }

  function ensureBalloonMeasureEntities() {
    if (!state.viewer) {
      return false;
    }
    const entities = state.balloonMeasureEntities || {};
    if (entities.lengthLine && entities.widthLine && entities.lengthLabel && entities.widthLabel) {
      return true;
    }

    clearBalloonMeasureEntities();
    state.balloonMeasureLengthLinePositions = [];
    state.balloonMeasureWidthLinePositions = [];
    state.balloonMeasureEntities = {
      lengthLine: state.viewer.entities.add({
        name: "Comprimento do balão (corrente)",
        show: false,
        polyline: {
          positions: new Cesium.CallbackProperty(() => state.balloonMeasureLengthLinePositions || [], false),
          width: 6,
          arcType: Cesium.ArcType.NONE,
          material: Cesium.Color.fromCssColorString("#ffdd57").withAlpha(0.98),
          depthFailMaterial: Cesium.Color.fromCssColorString("#ffdd57").withAlpha(0.98)
        }
      }),
      widthLine: state.viewer.entities.add({
        name: "Largura do balão (corrente)",
        show: false,
        polyline: {
          positions: new Cesium.CallbackProperty(() => state.balloonMeasureWidthLinePositions || [], false),
          width: 5,
          arcType: Cesium.ArcType.NONE,
          material: Cesium.Color.fromCssColorString("#63c7ff").withAlpha(0.98),
          depthFailMaterial: Cesium.Color.fromCssColorString("#63c7ff").withAlpha(0.98)
        }
      }),
      lengthLabel: state.viewer.entities.add({
        name: "Label comprimento balão",
        show: false,
        position: Cesium.Cartesian3.fromDegrees(0, 0, 0),
        label: {
          text: "",
          font: 'bold 15px "Segoe UI", sans-serif',
          fillColor: Cesium.Color.WHITE,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 4,
          showBackground: true,
          backgroundColor: new Cesium.Color(0.02, 0.03, 0.02, 0.94),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -58),
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      }),
      widthLabel: state.viewer.entities.add({
        name: "Label largura balão",
        show: false,
        position: Cesium.Cartesian3.fromDegrees(0, 0, 0),
        label: {
          text: "",
          font: 'bold 15px "Segoe UI", sans-serif',
          fillColor: Cesium.Color.WHITE,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 4,
          showBackground: true,
          backgroundColor: new Cesium.Color(0.02, 0.04, 0.06, 0.94),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, 18),
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      })
    };

    return true;
  }

  function buildTrackCumulativeMeters(points) {
    const cumulative = new Array(points.length).fill(0);
    for (let i = 1; i < points.length; i++) {
      const segDist = computeSurfaceDistanceMeters(points[i - 1], points[i]);
      cumulative[i] = cumulative[i - 1] + (Number.isFinite(segDist) ? segDist : 0);
    }
    return cumulative;
  }

  function buildBalloonMeasureLocalFrame(points, offIndex, onIndex) {
    if (!Array.isArray(points) || !points[offIndex] || !points[onIndex] || onIndex <= offIndex) {
      return null;
    }

    const origin = projectLonLatToMeters(points[offIndex].lon, points[offIndex].lat);
    if (!origin) {
      return null;
    }

    let directionSourceIndex = Math.min(onIndex, offIndex + 5);
    let directionPoint = null;
    for (let i = offIndex + 1; i <= directionSourceIndex; i++) {
      if (!points[i]) continue;
      const projected = projectLonLatToMeters(points[i].lon, points[i].lat);
      if (!projected) continue;
      const dx = projected.x - origin.x;
      const dy = projected.y - origin.y;
      if (Math.hypot(dx, dy) > 1e-3) {
        directionPoint = projected;
        break;
      }
    }

    if (!directionPoint) {
      const projectedEnd = projectLonLatToMeters(points[onIndex].lon, points[onIndex].lat);
      if (projectedEnd) {
        directionPoint = projectedEnd;
      }
    }

    if (!directionPoint) {
      return null;
    }

    let ux = directionPoint.x - origin.x;
    let uy = directionPoint.y - origin.y;
    const dirLength = Math.hypot(ux, uy);
    if (!Number.isFinite(dirLength) || dirLength <= 1e-6) {
      return null;
    }

    ux /= dirLength;
    uy /= dirLength;

    const nx = -uy;
    const ny = ux;
    const localPoints = [];
    let minX = Number.POSITIVE_INFINITY;
    let maxX = Number.NEGATIVE_INFINITY;
    let minY = Number.POSITIVE_INFINITY;
    let maxY = Number.NEGATIVE_INFINITY;

    for (let i = offIndex; i <= onIndex; i++) {
      const point = points[i];
      if (!point) continue;
      const projected = projectLonLatToMeters(point.lon, point.lat);
      if (!projected) continue;
      const dx = projected.x - origin.x;
      const dy = projected.y - origin.y;
      const localX = (dx * ux) + (dy * uy);
      const localY = (dx * nx) + (dy * ny);
      localPoints.push({
        index: i,
        lon: point.lon,
        lat: point.lat,
        x: localX,
        y: localY
      });
      minX = Math.min(minX, localX);
      maxX = Math.max(maxX, localX);
      minY = Math.min(minY, localY);
      maxY = Math.max(maxY, localY);
    }

    if (!localPoints.length) {
      return null;
    }

    return {
      origin: origin,
      ux: ux,
      uy: uy,
      nx: nx,
      ny: ny,
      localPoints: localPoints,
      minX: minX,
      maxX: maxX,
      minY: minY,
      maxY: maxY
    };
  }

  function balloonMeasureLocalToLonLat(frame, x, y) {
    if (!frame || !Number.isFinite(x) || !Number.isFinite(y)) {
      return null;
    }

    const cartographic = webMercatorProjection.unproject(new Cesium.Cartesian3(
      frame.origin.x + (frame.ux * x) + (frame.nx * y),
      frame.origin.y + (frame.uy * x) + (frame.ny * y),
      0
    ));

    if (!cartographic) {
      return null;
    }

    return {
      lon: Cesium.Math.toDegrees(cartographic.longitude),
      lat: Cesium.Math.toDegrees(cartographic.latitude)
    };
  }

  function projectPointToBalloonMeasureLocal(frame, point) {
    if (!frame || !point) {
      return null;
    }

    const projected = projectLonLatToMeters(point.lon, point.lat);
    if (!projected) {
      return null;
    }

    const dx = projected.x - frame.origin.x;
    const dy = projected.y - frame.origin.y;
    return {
      x: (dx * frame.ux) + (dy * frame.uy),
      y: (dx * frame.nx) + (dy * frame.ny)
    };
  }

  function dedupeBalloonMeasureIntersections(values) {
    if (!Array.isArray(values) || !values.length) {
      return [];
    }

    const sorted = values
      .filter((value) => Number.isFinite(value))
      .sort((a, b) => a - b);

    const deduped = [];
    for (let i = 0; i < sorted.length; i++) {
      if (!deduped.length || Math.abs(sorted[i] - deduped[deduped.length - 1]) > 0.8) {
        deduped.push(sorted[i]);
      }
    }

    return deduped;
  }

  function collectBalloonMeasureXIntersectionsAtY(frame, targetY) {
    const intersections = [];
    if (!frame || !Array.isArray(frame.localPoints) || frame.localPoints.length < 2) {
      return intersections;
    }

    for (let i = 1; i < frame.localPoints.length; i++) {
      const p0 = frame.localPoints[i - 1];
      const p1 = frame.localPoints[i];
      if (!p0 || !p1) continue;

      if (Math.abs(p1.y - p0.y) <= 1e-6) {
        if (Math.abs(targetY - p0.y) <= 1e-6) {
          intersections.push(p0.x, p1.x);
        }
        continue;
      }

      const minY = Math.min(p0.y, p1.y);
      const maxY = Math.max(p0.y, p1.y);
      if (targetY < minY || targetY > maxY) {
        continue;
      }

      const t = (targetY - p0.y) / (p1.y - p0.y);
      if (t < -1e-6 || t > 1 + 1e-6) continue;
      intersections.push(p0.x + ((p1.x - p0.x) * t));
    }

    return dedupeBalloonMeasureIntersections(intersections);
  }

  function collectBalloonMeasureYIntersectionsAtX(frame, targetX) {
    const intersections = [];
    if (!frame || !Array.isArray(frame.localPoints) || frame.localPoints.length < 2) {
      return intersections;
    }

    for (let i = 1; i < frame.localPoints.length; i++) {
      const p0 = frame.localPoints[i - 1];
      const p1 = frame.localPoints[i];
      if (!p0 || !p1) continue;

      if (Math.abs(p1.x - p0.x) <= 1e-6) {
        if (Math.abs(targetX - p0.x) <= 1e-6) {
          intersections.push(p0.y, p1.y);
        }
        continue;
      }

      const minX = Math.min(p0.x, p1.x);
      const maxX = Math.max(p0.x, p1.x);
      if (targetX < minX || targetX > maxX) {
        continue;
      }

      const t = (targetX - p0.x) / (p1.x - p0.x);
      if (t < -1e-6 || t > 1 + 1e-6) continue;
      intersections.push(p0.y + ((p1.y - p0.y) * t));
    }

    return dedupeBalloonMeasureIntersections(intersections);
  }

  function buildBalloonMeasureGeometryData(points, offIndex, onIndex) {
    const fallbackPoint = points[offIndex];
    let configuredWidthMeters = 0;
    let configuredLengthMeters = 0;
    let configuredWidthMaxMeters = 0;
    let configuredLengthMaxMeters = 0;
    for (let i = offIndex; i <= onIndex && Array.isArray(points); i++) {
      const point = points[i];
      const pointWidth = Number(point && point.balloonMeasureWidthMeters);
      const pointLength = Number(point && point.balloonMeasureLengthMeters);
      const pointWidthMax = Number(point && point.balloonMeasureWidthMaxMeters);
      const pointLengthMax = Number(point && point.balloonMeasureLengthMaxMeters);
      if (Number.isFinite(pointWidth) && pointWidth > configuredWidthMeters) {
        configuredWidthMeters = pointWidth;
      }
      if (Number.isFinite(pointLength) && pointLength > configuredLengthMeters) {
        configuredLengthMeters = pointLength;
      }
      if (Number.isFinite(pointWidthMax) && pointWidthMax > configuredWidthMaxMeters) {
        configuredWidthMaxMeters = pointWidthMax;
      }
      if (Number.isFinite(pointLengthMax) && pointLengthMax > configuredLengthMaxMeters) {
        configuredLengthMaxMeters = pointLengthMax;
      }
    }

    const frame = buildBalloonMeasureLocalFrame(points, offIndex, onIndex);

    if (!frame) {
      return {
        frame: null,
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0,
        lengthMeters: 0,
        widthMeters: 0,
        lengthStartPoint: fallbackPoint,
        lengthEndPoint: fallbackPoint,
        lengthMidPoint: fallbackPoint,
        widthStartPoint: fallbackPoint,
        widthEndPoint: fallbackPoint,
        widthMidPoint: fallbackPoint,
        lengthMaxMeters: configuredLengthMaxMeters || configuredLengthMeters || 0,
        widthMaxMeters: configuredWidthMaxMeters || configuredWidthMeters || 0
      };
    }

    let bestLengthMeters = 0;
    let bestLengthY = (frame.minY + frame.maxY) / 2;
    let bestLengthStartX = frame.minX;
    let bestLengthEndX = frame.maxX;
    const ySamples = Math.max(24, Math.min(160, Math.ceil(Math.max(1, frame.maxY - frame.minY) / 4)));

    for (let i = 0; i <= ySamples; i++) {
      const targetY = frame.minY + (((frame.maxY - frame.minY) * i) / Math.max(1, ySamples));
      const xs = collectBalloonMeasureXIntersectionsAtY(frame, targetY);
      if (xs.length < 2) continue;
      const span = xs[xs.length - 1] - xs[0];
      if (span > bestLengthMeters) {
        bestLengthMeters = span;
        bestLengthY = targetY;
        bestLengthStartX = xs[0];
        bestLengthEndX = xs[xs.length - 1];
      }
    }

    if (!Number.isFinite(bestLengthMeters) || bestLengthMeters <= 0) {
      bestLengthMeters = Math.max(0, frame.maxX - frame.minX);
      bestLengthStartX = frame.minX;
      bestLengthEndX = frame.maxX;
      bestLengthY = (frame.minY + frame.maxY) / 2;
    }

    let bestWidthMeters = 0;
    let bestWidthX = (frame.minX + frame.maxX) / 2;
    let bestWidthStartY = frame.minY;
    let bestWidthEndY = frame.maxY;
    const xSamples = Math.max(24, Math.min(220, Math.ceil(Math.max(1, frame.maxX - frame.minX) / 6)));

    for (let i = 0; i <= xSamples; i++) {
      const targetX = frame.minX + (((frame.maxX - frame.minX) * i) / Math.max(1, xSamples));
      const ys = collectBalloonMeasureYIntersectionsAtX(frame, targetX);
      if (ys.length < 2) continue;
      const span = ys[ys.length - 1] - ys[0];
      if (span > bestWidthMeters) {
        bestWidthMeters = span;
        bestWidthX = targetX;
        bestWidthStartY = ys[0];
        bestWidthEndY = ys[ys.length - 1];
      }
    }

    if (!Number.isFinite(bestWidthMeters) || bestWidthMeters <= 0) {
      bestWidthMeters = Math.max(0, frame.maxY - frame.minY);
      bestWidthX = (frame.minX + frame.maxX) / 2;
      bestWidthStartY = frame.minY;
      bestWidthEndY = frame.maxY;
    }

    if (Number.isFinite(configuredWidthMeters) && configuredWidthMeters > bestWidthMeters) {
      const widthCenterY = (bestWidthStartY + bestWidthEndY) / 2;
      bestWidthMeters = configuredWidthMeters;
      bestWidthStartY = widthCenterY - (configuredWidthMeters / 2);
      bestWidthEndY = widthCenterY + (configuredWidthMeters / 2);
    }

    const targetLengthMeters = Number.isFinite(configuredLengthMaxMeters) && configuredLengthMaxMeters > 0
      ? configuredLengthMaxMeters
      : configuredLengthMeters;

    if (Number.isFinite(targetLengthMeters) && targetLengthMeters > 0 && targetLengthMeters > bestLengthMeters) {
      const lengthCenterX = (bestLengthStartX + bestLengthEndX) / 2;
      bestLengthMeters = targetLengthMeters;
      bestLengthStartX = lengthCenterX - (targetLengthMeters / 2);
      bestLengthEndX = lengthCenterX + (targetLengthMeters / 2);
    }

    const lengthStartPoint = balloonMeasureLocalToLonLat(frame, bestLengthStartX, bestLengthY) || fallbackPoint;
    const lengthEndPoint = balloonMeasureLocalToLonLat(frame, bestLengthEndX, bestLengthY) || fallbackPoint;
    const lengthMidPoint = balloonMeasureLocalToLonLat(frame, (bestLengthStartX + bestLengthEndX) / 2, bestLengthY) || fallbackPoint;
    const widthStartPoint = balloonMeasureLocalToLonLat(frame, bestWidthX, bestWidthStartY) || fallbackPoint;
    const widthEndPoint = balloonMeasureLocalToLonLat(frame, bestWidthX, bestWidthEndY) || fallbackPoint;
    const widthMidPoint = balloonMeasureLocalToLonLat(frame, bestWidthX, (bestWidthStartY + bestWidthEndY) / 2) || fallbackPoint;

    return {
      frame: frame,
      minX: frame.minX,
      maxX: frame.maxX,
      minY: frame.minY,
      maxY: frame.maxY,
      lengthMeters: bestLengthMeters,
      widthMeters: bestWidthMeters,
      lengthStartPoint: lengthStartPoint,
      lengthEndPoint: lengthEndPoint,
      lengthMidPoint: lengthMidPoint,
      widthStartPoint: widthStartPoint,
      widthEndPoint: widthEndPoint,
      widthMidPoint: widthMidPoint,
      lengthMaxMeters: (Number.isFinite(configuredLengthMaxMeters) && configuredLengthMaxMeters > 0)
        ? configuredLengthMaxMeters
        : bestLengthMeters,
      widthMaxMeters: (Number.isFinite(configuredWidthMaxMeters) && configuredWidthMaxMeters > 0)
        ? configuredWidthMaxMeters
        : bestWidthMeters
    };
  }


  function buildBalloonMeasureRuns(points) {
    clearBalloonMeasureData();
    if (!Array.isArray(points) || points.length < 3) {
      syncBalloonMeasureToggleButtonUI();
      return;
    }

    state.trackCumulativeMeters = buildTrackCumulativeMeters(points);
    const flags = state.sprayFlags;
    const runByPoint = new Array(points.length).fill(-1);
    const runs = [];

    for (let i = 0; i < points.length - 1; i++) {
      const sprayEndsHere = !!flags[i] && !flags[i + 1];
      if (!sprayEndsHere) {
        continue;
      }

      let nextSprayStart = -1;
      for (let j = i + 1; j < points.length; j++) {
        if (!!flags[j] && !flags[j - 1]) {
          nextSprayStart = j;
          break;
        }
      }

      if (nextSprayStart <= i + 1) {
        continue;
      }

      const offPoint = points[i];
      const onPoint = points[nextSprayStart];
      const geometryData = buildBalloonMeasureGeometryData(points, i, nextSprayStart);
      const pathPositions = [];
      for (let k = i; k <= nextSprayStart; k++) {
        pathPositions.push(toGroundCartesian(points[k]));
      }

      const startPos = pathPositions[0];
      const endPos = pathPositions[pathPositions.length - 1];
      const widthStartPos = toGroundCartesian(geometryData.widthStartPoint);
      const widthEndPos = toGroundCartesian(geometryData.widthEndPoint);
      const widthMidpoint = toGroundCartesian(geometryData.widthMidPoint);
      const lengthStartPos = toGroundCartesian(geometryData.lengthStartPoint);
      const lengthEndPos = toGroundCartesian(geometryData.lengthEndPoint);
      const lengthMidpoint = toGroundCartesian(geometryData.lengthMidPoint);

      const run = {
        offIndex: i,
        onIndex: nextSprayStart,
        offPoint,
        onPoint,
        pathPositions,
        startPos,
        endPos,
        widthMidpoint,
        widthStartPos,
        widthEndPos,
        widthMeters: Number.isFinite(geometryData.widthMeters) ? geometryData.widthMeters : 0,
        maxWidthMeters: Number.isFinite(geometryData.widthMaxMeters) ? geometryData.widthMaxMeters : (Number.isFinite(geometryData.widthMeters) ? geometryData.widthMeters : 0),
        lengthMidpoint,
        lengthStartPos,
        lengthEndPos,
        maxLengthMeters: Number.isFinite(geometryData.lengthMaxMeters) ? geometryData.lengthMaxMeters : (Number.isFinite(geometryData.lengthMeters) ? geometryData.lengthMeters : 0),
        lengthStartPoint: geometryData.lengthStartPoint,
        lengthEndPoint: geometryData.lengthEndPoint,
        widthStartPoint: geometryData.widthStartPoint,
        widthEndPoint: geometryData.widthEndPoint,
        frame: geometryData.frame,
        minLocalX: geometryData.minX,
        maxLocalX: geometryData.maxX,
        minLocalY: geometryData.minY,
        maxLocalY: geometryData.maxY
      };

      const runIndex = runs.length;
      runs.push(run);
      for (let k = i; k <= nextSprayStart; k++) {
        runByPoint[k] = runIndex;
      }

      i = Math.max(i, nextSprayStart - 1);
    }

    state.balloonMeasureRuns = runs;
    state.balloonMeasureRunByPoint = runByPoint;
    state.balloonMeasureAvailable = runs.length > 0;
    syncBalloonMeasureToggleButtonUI();
  }

  function resolveActiveBalloonMeasureRunIndex(pointIndex) {
    const idx = clamp(Math.round(pointIndex), 0, state.timelinePoints.length - 1);
    const mappedRunIndex = state.balloonMeasureRunByPoint[idx];
    if (
      Number.isFinite(mappedRunIndex) &&
      mappedRunIndex >= 0 &&
      mappedRunIndex < state.balloonMeasureRuns.length
    ) {
      return mappedRunIndex;
    }

    for (let i = 0; i < state.balloonMeasureRuns.length; i++) {
      const run = state.balloonMeasureRuns[i];
      if (run && idx > run.offIndex && idx < run.onIndex) {
        return i;
      }
    }

    return -1;
  }

  function updateCurrentBalloonMeasure(currentPointIndex, sprayingNow) {
    if (!state.balloonMeasureVisible || !state.balloonMeasureAvailable) {
      setBalloonMeasureEntitiesVisibility(false);
      return;
    }
    if (sprayingNow) {
      setBalloonMeasureEntitiesVisibility(false);
      return;
    }
    if (!ensureBalloonMeasureEntities()) {
      return;
    }

    const idx = clamp(Math.round(currentPointIndex), 0, state.timelinePoints.length - 1);
    let runIndex = resolveActiveBalloonMeasureRunIndex(idx);
    if (!Number.isFinite(runIndex) || runIndex < 0 || runIndex >= state.balloonMeasureRuns.length) {
      const point = state.timelinePoints[idx] || {};
      const pointName = String(point.name || "").toLowerCase();
      const isBalloonPoint = point.telemetryType === "balloon" || pointName.indexOf("bal") >= 0 || pointName.indexOf("curva") >= 0;

      if (isBalloonPoint) {
        let nearestRunIndex = -1;
        let nearestRunDistance = Number.POSITIVE_INFINITY;

        for (let i = 0; i < state.balloonMeasureRuns.length; i++) {
          const run = state.balloonMeasureRuns[i];
          if (!run) continue;

          const distanceToRun = idx < run.offIndex
            ? run.offIndex - idx
            : (idx > run.onIndex ? idx - run.onIndex : 0);

          if (distanceToRun < nearestRunDistance) {
            nearestRunDistance = distanceToRun;
            nearestRunIndex = i;
          }
        }

        if (nearestRunDistance <= 8) {
          runIndex = nearestRunIndex;
        }
      }
    }

    if (!Number.isFinite(runIndex) || runIndex < 0 || runIndex >= state.balloonMeasureRuns.length) {
      setBalloonMeasureEntitiesVisibility(false);
      return;
    }

    const run = state.balloonMeasureRuns[runIndex];
    const currentAircraft = extractCurrentAircraftLonLat();
    const localEndIdx = clamp(idx, run.offIndex + 1, run.onIndex - 1);
    let currentPoint = state.timelinePoints[localEndIdx];

    if (currentAircraft) {
      currentPoint = {
        lon: currentAircraft.lon,
        lat: currentAircraft.lat
      };
    }

    let currentLocal = projectPointToBalloonMeasureLocal(run.frame, currentPoint);
    if (!currentLocal) {
      currentLocal = projectPointToBalloonMeasureLocal(run.frame, state.timelinePoints[localEndIdx]);
    }

    let currentLengthMeters = Number.isFinite(run.maxLengthMeters) ? run.maxLengthMeters : 0;
    if (currentLocal && Number.isFinite(currentLocal.x)) {
      currentLengthMeters = Math.max(0, Math.min(run.maxLengthMeters || 0, currentLocal.x - run.minLocalX));
    }

    let currentWidthMeters = 0;
    if (run.frame && Array.isArray(run.frame.localPoints)) {
      let minCurrentY = Number.POSITIVE_INFINITY;
      let maxCurrentY = Number.NEGATIVE_INFINITY;

      for (let i = 0; i < run.frame.localPoints.length; i++) {
        const localPoint = run.frame.localPoints[i];
        if (!localPoint || !Number.isFinite(localPoint.index) || localPoint.index > localEndIdx) {
          continue;
        }
        if (!Number.isFinite(localPoint.y)) {
          continue;
        }
        minCurrentY = Math.min(minCurrentY, localPoint.y);
        maxCurrentY = Math.max(maxCurrentY, localPoint.y);
      }

      if (currentLocal && Number.isFinite(currentLocal.y)) {
        minCurrentY = Math.min(minCurrentY, currentLocal.y);
        maxCurrentY = Math.max(maxCurrentY, currentLocal.y);
      }

      if (Number.isFinite(minCurrentY) && Number.isFinite(maxCurrentY)) {
        currentWidthMeters = Math.max(0, Math.min(run.widthMeters || 0, maxCurrentY - minCurrentY));
      }
    }

    if (!Number.isFinite(currentWidthMeters) || currentWidthMeters <= 0) {
      currentWidthMeters = Number.isFinite(run.widthMeters) ? run.widthMeters : 0;
    }

    if (state.balloonMeasureActiveRunIndex !== runIndex || !Number.isFinite(state.balloonMeasureSmoothedLengthMeters)) {
      state.balloonMeasureSmoothedLengthMeters = currentLengthMeters;
    } else {
      const alpha = 0.32;
      state.balloonMeasureSmoothedLengthMeters += (currentLengthMeters - state.balloonMeasureSmoothedLengthMeters) * alpha;
    }

    if (state.balloonMeasureActiveRunIndex !== runIndex || !Number.isFinite(state.balloonMeasureSmoothedWidthMeters)) {
      state.balloonMeasureSmoothedWidthMeters = currentWidthMeters;
    } else {
      const alpha = 0.32;
      state.balloonMeasureSmoothedWidthMeters += (currentWidthMeters - state.balloonMeasureSmoothedWidthMeters) * alpha;
    }
    state.balloonMeasureActiveRunIndex = runIndex;

    const currentLengthText = formatDistanceMetersFluent(state.balloonMeasureSmoothedLengthMeters);
    const maxLengthText = formatDistanceMeters(run.maxLengthMeters);
    const currentWidthText = formatDistanceMetersFluent(state.balloonMeasureSmoothedWidthMeters);
    const maxWidthText = formatDistanceMeters(run.maxWidthMeters);

    const entities = state.balloonMeasureEntities;
    state.balloonMeasureLengthLinePositions = [
      toBalloonMeasureCartesian(run.lengthStartPoint || run.offPoint),
      toBalloonMeasureCartesian(run.lengthEndPoint || run.onPoint)
    ];
    state.balloonMeasureWidthLinePositions = [
      toBalloonMeasureCartesian(run.widthStartPoint || run.offPoint),
      toBalloonMeasureCartesian(run.widthEndPoint || run.onPoint)
    ];

    entities.lengthLabel.position = run.lengthMidpoint || run.lengthEndPos || run.endPos;
    entities.lengthLabel.label.pixelOffset = new Cesium.Cartesian2(0, -58);
    entities.lengthLabel.label.text = `Comp. balão\n${currentLengthText} / máx ${maxLengthText}`;

    entities.widthLabel.position = run.widthMidpoint;
    entities.widthLabel.label.pixelOffset = new Cesium.Cartesian2(0, 18);
    entities.widthLabel.label.text = `Larg. balão\n${currentWidthText} / máx ${maxWidthText}`;

    setBalloonMeasureEntitiesVisibility(true);
    if (state.viewer && state.viewer.scene && state.viewer.scene.requestRender) {
      state.viewer.scene.requestRender();
    }
  }

  function applyPathVisibility() {
    for (const entity of state.pathEntities) {
      if (entity?.polyline) {
        if (state.pathVisibilityMode === "all") {
          entity.show = true;
          continue;
        }
        if (state.pathVisibilityMode === "orange_only") {
          entity.show = entity.pathKind === "no_spray";
          continue;
        }
        entity.show = false;
      }
    }

    const hasTimeline = state.timelinePoints.length > 0;
    if (hasTimeline) {
      updateSprayFootprint(findNearestPointIndex(currentClockSec()));
    }
  }

  function applyProgressivePathVisibility() {
    if (state.progressivePathEntity) {
      state.progressivePathEntity.show = state.progressivePathVisible;
    }

    if (state.progressivePathVisible && state.timelinePoints.length) {
      updateProgressivePathEntity(findNearestPointIndex(currentClockSec()));
    }
  }

  function applyViewMode(mode) {
    state.cameraMode = normalizeViewMode(mode);
    syncViewModeSelectUI();
    resetCameraHeadingSmoothing();
    if (!state.flightEntity) {
      return;
    }

    if (state.cameraMode === "follow") {
      state.viewer.trackedEntity = state.flightEntity;
      return;
    }

    state.viewer.trackedEntity = undefined;
    state.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
    if (state.cameraMode === "chase" || state.cameraMode === "top" || state.cameraMode === "orbit") {
      updateCameraForMode();
    }
  }

  function getProgressivePathPositionsUntilIndex(nearestIndex) {
    const positions = [];
    const limit = Math.max(0, Math.min(nearestIndex, state.timelinePoints.length - 1));
    for (let i = 0; i <= limit; i++) {
      const p = state.timelinePoints[i];
      if (!p) continue;
      const baseAltitude = normalizeOfficialRelativeAltitude(Number.isFinite(p.alt) ? p.alt : p.altAdjusted);
      positions.push(Cesium.Cartesian3.fromDegrees(p.lon, p.lat, baseAltitude + 8));
    }
    return positions;
  }

  function ensureProgressivePathEntity() {
    if (state.progressivePathEntity || !state.viewer) {
      return;
    }

    state.progressivePathPositions = [];
    state.progressivePathEntity = state.viewer.entities.add({
      name: "Traçado progressivo do voo",
      show: state.progressivePathVisible,
      polyline: {
        positions: new Cesium.CallbackProperty(function () {
          return state.progressivePathPositions;
        }, false),
        width: 3,
        material: Cesium.Color.WHITE.withAlpha(0.95),
        depthFailMaterial: Cesium.Color.WHITE.withAlpha(0.95)
      }
    });
  }

  function updateProgressivePathEntity(nearestIndex) {
    if (!state.viewer || !state.timelinePoints.length) {
      return;
    }

    ensureProgressivePathEntity();

    if (!state.progressivePathEntity) {
      return;
    }

    if (!state.progressivePathVisible) {
      state.progressivePathEntity.show = false;
      return;
    }

    const positions = getProgressivePathPositionsUntilIndex(nearestIndex);
    state.progressivePathPositions = positions;
    state.progressivePathEntity.show = positions.length >= 2;
  }

  function updateCameraForMode() {
    if (!state.flightEntity) {
      return;
    }
    if (state.cameraMode !== "chase" && state.cameraMode !== "top" && state.cameraMode !== "orbit") {
      return;
    }

    const time = state.viewer.clock.currentTime;
    const position = state.flightEntity.position?.getValue(time);
    if (!position) {
      return;
    }

    if (state.cameraMode === "top") {
      state.viewer.camera.lookAt(
        position,
        new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(state.cameraOffsets.headingDeg),
          Cesium.Math.toRadians(-89),
          clamp(state.cameraOffsets.rangeMeters * 1.2, 120, 4000)
        )
      );
      return;
    }

    if (state.cameraMode === "orbit") {
      state.viewer.camera.lookAt(
        position,
        new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(state.cameraOffsets.headingDeg),
          Cesium.Math.toRadians(state.cameraOffsets.pitchDeg),
          state.cameraOffsets.rangeMeters
        )
      );
      return;
    }

    const baseHeading = resolveCameraChaseHeading(time);
    const heading = smoothCameraHeading(baseHeading + Cesium.Math.toRadians(state.cameraOffsets.headingDeg));
    state.viewer.camera.lookAt(
      position,
      new Cesium.HeadingPitchRange(
        heading,
        Cesium.Math.toRadians(state.cameraOffsets.pitchDeg),
        state.cameraOffsets.rangeMeters
      )
    );
  }

  function resolveDefaultFlightFileName(fileUrl) {
    const normalized = String(fileUrl || "").split("?")[0].split("#")[0];
    const parts = normalized.split(/[\\/]/);
    const rawName = parts[parts.length - 1] || "voo_padrao.kmz";
    return rawName.trim() || "voo_padrao.kmz";
  }

  async function createFileFromFlightUrl(fileUrl) {
    const response = await fetch(fileUrl, { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`Não foi possível baixar o KMZ padrão (${response.status}).`);
    }
    const blob = await response.blob();
    const fileName = resolveDefaultFlightFileName(fileUrl);
    return new File([blob], fileName, { type: blob.type || "application/vnd.google-earth.kmz" });
  }

  async function loadFlightFromFile(file, options = {}) {
    const {
      startMessage = "Lendo arquivo de voo...",
      loadedPrefix = "Voo carregado"
    } = options;

    const ionToken = (state.appConfig.cesiumIonToken || "").trim();
    if (state.appConfig.useWorldTerrain && !ionToken) {
      throw new Error("Token do Cesium ausente para usar terreno mundial. Preencha o config.json.");
    }

    if (ionToken) {
      Cesium.Ion.defaultAccessToken = ionToken;
    }
    if (state.appConfig.useWorldTerrain) {
      state.viewer.terrainProvider = await Cesium.createWorldTerrainAsync();
    } else {
      state.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
    }

    clearFlight();
    setStatus(startMessage);
    const parsed = await parseFlightFile(file);

    if (parsed.points.length < 2) {
      throw new Error("Arquivo sem pontos suficientes para animar o voo.");
    }

    const optimized = optimizeTrackPoints(parsed.points, Number(state.appConfig.maxTrackPoints || defaultAppConfig.maxTrackPoints));
    state.timelinePoints = optimized.points;
    applyRealSpeedAltitudeAdjustment(state.timelinePoints);
    const initialStableAltitudeTrim = trimInitialAltitudeJumpPoints(state.timelinePoints);
    state.timelinePoints = initialStableAltitudeTrim.points;
    state.segmentSprayDecisions = buildSegmentSprayDecisions(state.timelinePoints);
    state.sprayFlags = derivePointSprayFlagsFromSegments(state.timelinePoints, state.segmentSprayDecisions);
    state.sprayAreaReferencePoint = buildSprayAreaReferencePoint(state.timelinePoints);
    if (!state.sprayAreaReferencePoint) {
      state.transitFocusEnabled = false;
    }
    syncTransitFocusToggleButtonUI();
    buildBalloonMeasureRuns(state.timelinePoints);
    buildTelemetryCaches(state.timelinePoints);
    state.startSec = state.timelinePoints[0].tSec;
    state.endSec = state.timelinePoints[state.timelinePoints.length - 1].tSec;
    state.durationSec = state.endSec - state.startSec;

    drawSprayPaths(state.timelinePoints, state.segmentSprayDecisions);
    buildSprayFootprintRuns(state.timelinePoints, state.segmentSprayDecisions);
    createAircraftEntity(state.timelinePoints);
    buildStartToFirstSprayMeasurement(state.timelinePoints);
    syncModelAlignmentUI();
    syncModelScaleUI();
    syncSprayFootprintStyleUI();
    syncCameraControlsUI();

    state.viewer.clock.startTime = Cesium.JulianDate.fromDate(new Date(state.startSec * 1000));
    state.viewer.clock.stopTime = Cesium.JulianDate.fromDate(new Date(state.endSec * 1000));
    state.viewer.clock.currentTime = Cesium.JulianDate.clone(state.viewer.clock.startTime);
    state.viewer.clock.multiplier = 1;
    state.viewer.clock.shouldAnimate = false;

    setFlightControlsEnabled(true);
    UI.timelineSlider.value = "0";

    state.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        state.timelinePoints[0].lon,
        state.timelinePoints[0].lat,
        (Number.isFinite(state.timelinePoints[0].altAdjusted) ? state.timelinePoints[0].altAdjusted : state.timelinePoints[0].alt) + 900
      ),
      orientation: {
        heading: 0,
        pitch: Cesium.Math.toRadians(-45),
        roll: 0
      },
      duration: 1.6
    });

    if (state.flightEntity) {
      state.viewer.trackedEntity = state.flightEntity;
    }
    onViewModeSelectChanged(UI.viewModeSelect.value || state.cameraMode || "follow");

    setCurrentTime(state.startSec, true);
    const sprayCount = state.sprayFlags.filter(Boolean).length;
    setStatus(`${loadedPrefix}: ${optimized.originalCount} pontos (${state.timelinePoints.length} usados), ${sprayCount} pontos em pulverização.`);
  }

  async function handleLoadFlight() {
    const file = UI.kmzFile.files?.[0];
    if (!file) {
      setStatus(getReplay3DText("SELECIONE_ARQUIVO_KMZ_KML"), true);
      return;
    }

    try {
      await loadFlightFromFile(file, {
        startMessage: "Lendo arquivo de voo...",
        loadedPrefix: "Voo carregado"
      });
    } catch (error) {

    }
  }

  async function tryAutoLoadDefaultFlight() {
    const defaultUrl = String(state.appConfig.defaultFlightFileUrl || "").trim();
    if (!defaultUrl) {
      setStatus(getReplay3DText("AGUARDANDO_ARQUIVO_VOO"));
      return;
    }

    try {
      const file = await createFileFromFlightUrl(defaultUrl);
      await loadFlightFromFile(file, {
        startMessage: `Carregando voo padrão (${file.name})...`,
        loadedPrefix: getReplay3DText("VOO_PADRAO_CARREGADO")
      });
    } catch (error) { }
  }

  function clearFlight() {
    pause();
    if (state.flightEntity) {
      state.viewer.entities.remove(state.flightEntity);
      state.flightEntity = null;
    }
    if (state.aircraftMarker) {
      state.viewer.entities.remove(state.aircraftMarker);
      state.aircraftMarker = null;
    }
    if (state.progressivePathEntity) {
      state.viewer.entities.remove(state.progressivePathEntity);
      state.progressivePathEntity = null;
    }
    state.progressivePathPositions = [];
    clearSprayMistEntities();
    clearMeasureEntities();
    clearBalloonMeasureData();
    for (const e of state.pathEntities) {
      state.viewer.entities.remove(e);
    }
    state.pathEntities = [];
    state.timelinePoints = [];
    state.sprayFlags = [];
    state.segmentSprayDecisions = [];
    state.viewer.trackedEntity = undefined;
    state.orientationProperty = null;
    state.flightHeadingProperty = null;
    state.turnBankProperty = null;
    state.estimatedSprayWidthMeters = null;
    state.lastStatusUpdateMs = 0;
    state.lastShownNearestIndex = -1;
    state.lastQuerySec = null;
    state.currentBankDeg = 0;
    state.sprayFootprintRuns = [];
    state.sprayFootprintAreaLabels = [];
    state.sprayFootprintLastIndex = -1;
    state.sprayDefaultWidthMeters = null;
    state.sprayAreaReferencePoint = null;
    state.sprayQualityAvailability = {};
    resetSprayDisplaySmoothing();
    state.pathVisibilityMode = "none";
    state.progressivePathVisible = true;
    state.aircraftMarkerVisible = false;
    state.measureVisible = false;
    state.balloonMeasureVisible = false;
    state.telemetryCumulativeSpraySec = [];
    state.telemetryCumulativeBalloonSec = [];
    state.telemetryCumulativeTransitSec = [];
    state.telemetryCumulativeAreaM2 = [];
    state.telemetryAverageAltitudeMeters = null;
    state.telemetryLastUiUpdateMs = 0;
    state.initialStableAltitudeTrimInfo = null;
    state.obstacleAltitudeDropFilterInfo = null;
    state.lastAltitudeValueLogIndex = -1;
    state.cameraSmoothedHeadingRad = null;
    state.cameraHeadingLastUpdateMs = 0;
    syncPathToggleButtonUI();
    syncSprayQualityControlsUI();
    syncProgressivePathToggleButtonUI();
    syncAircraftMarkerToggleButtonUI();
    syncTransitFocusToggleButtonUI();
    syncMeasureToggleButtonUI();
    syncBalloonMeasureToggleButtonUI();
    setFlightControlsEnabled(false);
    resetTelemetryBoard();
  }

  async function parseFlightFile(file) {
    let kmlText;
    const lower = file.name.toLowerCase();

    if (lower.endsWith(".kml")) {
      kmlText = await file.text();
    } else if (lower.endsWith(".kmz")) {
      kmlText = await readKmlFromKmz(file);
    } else {
      throw new Error(getReplay3DText("FORMATO_NAO_SUPORTADO"));
    }

    const parser = new DOMParser();
    const xml = parser.parseFromString(kmlText, "application/xml");

    const trackPoints = parseGxTrack(xml);
    if (trackPoints.length >= 2) {
      return normalizeTrack(trackPoints);
    }

    const linePoints = parseLineStringTracks(xml);
    if (linePoints.length >= 2) {
      return normalizeTrack(linePoints);
    }

    throw new Error(getReplay3DText("TRILHA_VOO_NAO_ENCONTRADA"));
  }

  async function readKmlFromKmz(file) {
    const zipBlob = await file.arrayBuffer();
    try {
      const importModule = window.__travicarReplay3DImportModule || new Function('url', 'return import(url);');
      window.__travicarReplay3DImportModule = importModule;
      const mod = await importModule("https://cdn.jsdelivr.net/npm/jszip@3.10.1/+esm");
      const jszip = new mod.default();
      const archive = await jszip.loadAsync(zipBlob);
      const entries = Object.values(archive.files)
        .filter((f) => !f.dir && f.name.toLowerCase().endsWith(".kml"))
        .sort((a, b) => {
          if (a.name.toLowerCase() === "doc.kml") return -1;
          if (b.name.toLowerCase() === "doc.kml") return 1;
          return 0;
        });

      if (!entries.length) {
        throw new Error("KMZ sem arquivo KML interno.");
      }

      return await entries[0].async("text");
    } catch (err) {
      throw new Error("Falha ao descompactar KMZ. Verifique se o arquivo esta valido.");
    }
  }

  function parseGxTrack(xml) {
    const tracks = Array.from(xml.getElementsByTagNameNS("http://www.google.com/kml/ext/2.2", "Track"));
    const all = [];

    for (const track of tracks) {
      const whens = Array.from(track.getElementsByTagName("when")).map((n) => n.textContent?.trim() || "");
      const coords = Array.from(track.getElementsByTagNameNS("http://www.google.com/kml/ext/2.2", "coord")).map((n) => n.textContent?.trim() || "");

      const sprayValues = extractSprayArray(track.parentElement || track);
      const sprayWidthMeters = extractSprayWidthMeters(track.parentElement || track);
      const hasExplicitSprayArray = sprayValues.length > 0;

      const count = Math.min(whens.length, coords.length);
      for (let i = 0; i < count; i++) {
        const when = whens[i];
        const coord = coords[i].split(/\s+/).map(Number);
        if (coord.length < 2) {
          continue;
        }
        const spray = sprayValues[i] ?? sprayValues[0] ?? false;
        all.push({
          tSec: dateToSec(when, i),
          lon: coord[0],
          lat: coord[1],
          alt: Number.isFinite(coord[2]) ? coord[2] : 80,
          spray: toBoolSpray(spray),
          spraySource: hasExplicitSprayArray ? "explicit_track" : "none",
          sprayAxisHeadingDeg: null,
          tiroName: null,
          sprayAreaName: null,
          sprayAreaKey: null,
          sprayAreaCentroidLon: null,
          sprayAreaCentroidLat: null,
          sprayWidthMeters: Number.isFinite(sprayWidthMeters) && sprayWidthMeters > 0 ? sprayWidthMeters : null
        });
      }
    }

    return all;
  }

  function parseLineStringTracks(xml) {
    const sprayPolygons = parseSprayPolygons(xml);
    const trajectoryPlacemark = findTrajectoryPlacemark(xml);
    let points = [];

    if (trajectoryPlacemark) {
      points = extractLinePointsFromNode(trajectoryPlacemark);
    }

    if (points.length < 2) {
      points = extractLinePointsFromNode(xml);
    }

    points = dedupeSequentialPoints(points);
    if (points.length < 2) {
      return points;
    }

    const stepSec = estimateSyntheticStep(points.length);
    const startSec = Date.now() / 1000;
    for (let i = 0; i < points.length; i++) {
      points[i].tSec = startSec + i * stepSec;
    }

    if (sprayPolygons.length) {
      for (const p of points) {
        const hit = findSprayPolygonForPoint(p.lon, p.lat, sprayPolygons);
        p.spray = !!hit;
        p.spraySource = hit ? "inferred_polygon" : "none";
        p.sprayAxisHeadingDeg = Number.isFinite(hit?.axisHeadingDeg) ? hit.axisHeadingDeg : null;
        p.tiroName = hit?.name || null;
        p.sprayAreaName = hit?.areaName || null;
        p.sprayAreaKey = hit?.areaKey || null;
        p.sprayAreaCentroidLon = Number.isFinite(hit?.areaCentroidLon) ? hit.areaCentroidLon : null;
        p.sprayAreaCentroidLat = Number.isFinite(hit?.areaCentroidLat) ? hit.areaCentroidLat : null;
        p.sprayWidthMeters = Number.isFinite(hit?.widthMeters) && hit.widthMeters > 0 ? hit.widthMeters : null;
      }
      if (state.appConfig.enableInferredSprayDirectionFilter !== false) {
        applyInferredSprayDirectionFilter(points);
      }
    }

    return points;
  }

  function findTrajectoryPlacemark(xml) {
    const placemarks = Array.from(xml.getElementsByTagName("Placemark"));
    for (const placemark of placemarks) {
      const lines = placemark.getElementsByTagName("LineString");
      if (!lines.length) {
        continue;
      }

      const name = (placemark.getElementsByTagName("name")[0]?.textContent || "").toLowerCase();
      const styleUrl = (placemark.getElementsByTagName("styleUrl")[0]?.textContent || "").toLowerCase();
      if (name.includes("trajet") || styleUrl.includes("flight")) {
        return placemark;
      }
    }
    return null;
  }

  function extractLinePointsFromNode(node) {
    const lineStrings = Array.from(node.getElementsByTagName("LineString"));
    const all = [];

    for (const lineString of lineStrings) {
      const coordsNode = lineString.getElementsByTagName("coordinates")[0];
      if (!coordsNode?.textContent) {
        continue;
      }

      const altitudeMode = (lineString.getElementsByTagName("altitudeMode")[0]?.textContent || "").toLowerCase();
      const isRelativeAlt = altitudeMode.includes("relative") || altitudeMode.includes("clamp");
      const offsetNode = lineString.getElementsByTagNameNS("http://www.google.com/kml/ext/2.2", "altitudeOffset")[0];
      const altitudeOffset = Number.parseFloat(offsetNode?.textContent || "0") || 0;

      const tuples = coordsNode.textContent
        .trim()
        .split(/\s+/)
        .map((chunk) => chunk.split(",").map(Number))
        .filter((arr) => arr.length >= 2 && Number.isFinite(arr[0]) && Number.isFinite(arr[1]));

      for (const t of tuples) {
        let alt = Number.isFinite(t[2]) ? t[2] : 0;
        if (isRelativeAlt) {
          alt += altitudeOffset + 25;
        } else if (!Number.isFinite(t[2])) {
          alt = 80;
        }

        all.push({
          tSec: 0,
          lon: t[0],
          lat: t[1],
          alt,
          spray: false,
          spraySource: "none",
          sprayAxisHeadingDeg: null,
          tiroName: null,
          sprayAreaName: null,
          sprayAreaKey: null,
          sprayAreaCentroidLon: null,
          sprayAreaCentroidLat: null,
          sprayWidthMeters: null
        });
      }
    }

    return all;
  }

  function dedupeSequentialPoints(points) {
    if (points.length < 2) {
      return points;
    }

    const out = [points[0]];
    for (let i = 1; i < points.length; i++) {
      const prev = out[out.length - 1];
      const cur = points[i];
      const sameLon = Math.abs(prev.lon - cur.lon) < 1e-10;
      const sameLat = Math.abs(prev.lat - cur.lat) < 1e-10;
      const sameAlt = Math.abs(prev.alt - cur.alt) < 1e-8;
      if (sameLon && sameLat && sameAlt) {
        continue;
      }
      out.push(cur);
    }
    return out;
  }

  function estimateSyntheticStep(pointCount) {
    const targetDurationSec = 900;
    const raw = targetDurationSec / Math.max(1, pointCount - 1);
    return Math.min(1, Math.max(0.05, raw));
  }

  function parseSprayPolygons(xml) {
    const placemarks = Array.from(xml.getElementsByTagName("Placemark"));
    const polygons = [];
    const collectedWidths = [];

    for (const placemark of placemarks) {
      const polygonNodes = Array.from(placemark.getElementsByTagName("Polygon"));
      if (!polygonNodes.length) {
        continue;
      }

      if (!isLikelySprayPlacemark(placemark)) {
        continue;
      }

      for (const polygonNode of polygonNodes) {
        const coordsNode = polygonNode.getElementsByTagName("coordinates")[0];
        if (!coordsNode?.textContent) {
          continue;
        }

        const ring = coordsNode.textContent
          .trim()
          .split(/\s+/)
          .map((chunk) => chunk.split(",").map(Number))
          .filter((arr) => arr.length >= 2 && Number.isFinite(arr[0]) && Number.isFinite(arr[1]))
          .map((arr) => ({ lon: arr[0], lat: arr[1] }));

        if (ring.length < 3) {
          continue;
        }

        let minLon = Infinity;
        let maxLon = -Infinity;
        let minLat = Infinity;
        let maxLat = -Infinity;
        for (const pt of ring) {
          if (pt.lon < minLon) minLon = pt.lon;
          if (pt.lon > maxLon) maxLon = pt.lon;
          if (pt.lat < minLat) minLat = pt.lat;
          if (pt.lat > maxLat) maxLat = pt.lat;
        }

        const name = (placemark.getElementsByTagName("name")[0]?.textContent || "").trim() || "Tiro";
        const areaName = resolveSprayAreaNameFromPlacemark(placemark);
        const widthMeters = extractSprayWidthMeters(placemark);
        const axisHeadingDeg = estimateSprayPolygonAxisHeadingDeg(ring);
        if (Number.isFinite(widthMeters) && widthMeters > 0) {
          collectedWidths.push(widthMeters);
        }
        polygons.push({ name, areaName, ring, minLon, maxLon, minLat, maxLat, widthMeters, axisHeadingDeg });
      }
    }

    if (collectedWidths.length) {
      state.estimatedSprayWidthMeters = collectedWidths.reduce((acc, x) => acc + x, 0) / collectedWidths.length;
    } else {
      state.estimatedSprayWidthMeters = null;
    }

    annotateSprayPolygonsWithAreaKeys(polygons);
    return polygons;
  }

  function resolveSprayAreaNameFromPlacemark(placemark) {
    let cursor = placemark?.parentElement || null;
    while (cursor) {
      const isFolder = cursor.localName === "Folder" || cursor.tagName === "Folder";
      if (isFolder) {
        const folderName = resolveDirectNameText(cursor);
        if (folderName) {
          return folderName;
        }
      }
      cursor = cursor.parentElement || null;
    }
    return null;
  }

  function resolveDirectNameText(node) {
    if (!node?.children?.length) {
      return "";
    }
    for (let i = 0; i < node.children.length; i++) {
      const child = node.children[i];
      const isName = child?.localName === "name" || child?.tagName === "name";
      if (isName) {
        return (child.textContent || "").trim();
      }
    }
    return "";
  }

  function annotateSprayPolygonsWithAreaKeys(polygons) {
    if (!Array.isArray(polygons) || !polygons.length) {
      return;
    }

    const groupsByBaseArea = new Map();
    for (let i = 0; i < polygons.length; i++) {
      const poly = polygons[i];
      const baseArea = normalizeAreaName(poly?.areaName) || "__sem_area__";
      if (!groupsByBaseArea.has(baseArea)) {
        groupsByBaseArea.set(baseArea, []);
      }
      groupsByBaseArea.get(baseArea).push(i);
    }

    for (const [baseArea, indexes] of groupsByBaseArea.entries()) {
      const linkGapMeters = resolveAreaClusterLinkGapMeters(polygons, indexes);
      const clusters = clusterPolygonIndexesByProximity(polygons, indexes, linkGapMeters);
      for (let clusterIndex = 0; clusterIndex < clusters.length; clusterIndex++) {
        const cluster = clusters[clusterIndex];
        const centroid = computePolygonsCentroid(polygons, cluster);
        const areaKey = clusters.length > 1
          ? `area:${baseArea}#${clusterIndex + 1}`
          : `area:${baseArea}`;

        for (const idx of cluster) {
          const poly = polygons[idx];
          poly.areaKey = areaKey;
          poly.areaCentroidLon = Number.isFinite(centroid?.lon) ? centroid.lon : null;
          poly.areaCentroidLat = Number.isFinite(centroid?.lat) ? centroid.lat : null;
        }
      }
    }
  }

  function resolveAreaClusterLinkGapMeters(polygons, indexes) {
    const widths = [];
    for (const idx of indexes) {
      const width = Number(polygons[idx]?.widthMeters);
      if (Number.isFinite(width) && width > 0) {
        widths.push(width);
      }
    }
    const avgWidth = widths.length
      ? widths.reduce((acc, x) => acc + x, 0) / widths.length
      : (Number.isFinite(state.estimatedSprayWidthMeters) ? state.estimatedSprayWidthMeters : 35);
    return clamp(avgWidth * 4, 120, 450);
  }

  function clusterPolygonIndexesByProximity(polygons, indexes, linkGapMeters) {
    if (!indexes.length) {
      return [];
    }

    const visited = new Set();
    const clusters = [];
    for (const seed of indexes) {
      if (visited.has(seed)) {
        continue;
      }
      const queue = [seed];
      visited.add(seed);
      const cluster = [];

      while (queue.length) {
        const current = queue.shift();
        cluster.push(current);
        for (const candidate of indexes) {
          if (visited.has(candidate)) {
            continue;
          }
          const gapMeters = computePolygonLinkGapMeters(polygons[current], polygons[candidate]);
          if (Number.isFinite(gapMeters) && gapMeters <= linkGapMeters) {
            visited.add(candidate);
            queue.push(candidate);
          }
        }
      }
      clusters.push(cluster);
    }
    return clusters;
  }

  function computePolygonLinkGapMeters(a, b) {
    if (!a || !b) {
      return Infinity;
    }
    const lonGap = Math.max(0, Math.max(a.minLon - b.maxLon, b.minLon - a.maxLon));
    const latGap = Math.max(0, Math.max(a.minLat - b.maxLat, b.minLat - a.maxLat));
    const refLatDeg = (a.minLat + a.maxLat + b.minLat + b.maxLat) * 0.25;
    const metersPerLon = 111320 * Math.max(0.01, Math.cos(Cesium.Math.toRadians(refLatDeg)));
    const metersPerLat = 110540;
    return Math.hypot(lonGap * metersPerLon, latGap * metersPerLat);
  }

  function computePolygonsCentroid(polygons, indexes) {
    let lonSum = 0;
    let latSum = 0;
    let count = 0;

    for (const idx of indexes) {
      const ring = polygons[idx]?.ring;
      if (!Array.isArray(ring)) {
        continue;
      }
      for (const pt of ring) {
        if (!Number.isFinite(pt?.lon) || !Number.isFinite(pt?.lat)) {
          continue;
        }
        lonSum += pt.lon;
        latSum += pt.lat;
        count += 1;
      }
    }

    if (!count) {
      return null;
    }
    return { lon: lonSum / count, lat: latSum / count };
  }

  function extractSprayWidthMeters(placemark) {
    const dataNodes = Array.from(placemark.getElementsByTagName("Data"));
    for (const d of dataNodes) {
      const dataName = (d.getAttribute("name") || "").toLowerCase();
      const displayName = (d.getElementsByTagName("displayName")[0]?.textContent || "").toLowerCase();
      if (!dataName.includes("width") && !dataName.includes("faixa") && !displayName.includes("faixa")) {
        continue;
      }

      const raw = d.getElementsByTagName("value")[0]?.textContent || "";
      const match = raw.replace(",", ".").match(/([0-9]+(?:\.[0-9]+)?)/);
      if (match) {
        const meters = Number(match[1]);
        if (Number.isFinite(meters) && meters >= 2 && meters <= 200) {
          return meters;
        }
      }
    }
    return null;
  }

  function isLikelySprayPlacemark(placemark) {
    const name = (placemark.getElementsByTagName("name")[0]?.textContent || "").toLowerCase();
    if (name.startsWith("tiro")) {
      return true;
    }

    const displayNames = Array.from(placemark.getElementsByTagName("displayName"))
      .map((n) => (n.textContent || "").toLowerCase());
    if (displayNames.some((x) => x.includes("faixa"))) {
      return true;
    }

    const dataNodes = Array.from(placemark.getElementsByTagName("Data"));
    for (const d of dataNodes) {
      const dataName = (d.getAttribute("name") || "").toLowerCase();
      const value = (d.getElementsByTagName("value")[0]?.textContent || "").toLowerCase();
      if (dataName.includes("width") || dataName.includes("faixa")) {
        return true;
      }
      if (value.includes(" m")) {
        return true;
      }
    }

    return false;
  }

  function findSprayPolygonForPoint(lon, lat, polygons) {
    const innerBufferMeters = resolveSprayPolygonInnerBufferMeters();
    for (const poly of polygons) {
      if (lon < poly.minLon || lon > poly.maxLon || lat < poly.minLat || lat > poly.maxLat) {
        continue;
      }
      if (pointInPolygon(lon, lat, poly.ring)) {
        if (innerBufferMeters > 0) {
          const edgeDistanceMeters = pointToPolygonEdgeDistanceMeters(lon, lat, poly.ring);
          if (Number.isFinite(edgeDistanceMeters) && edgeDistanceMeters < innerBufferMeters) {
            continue;
          }
        }
        return poly;
      }
    }
    return null;
  }

  function resolveSprayPolygonInnerBufferMeters() {
    const raw = Number(
      state.appConfig.sprayPolygonInnerBufferMeters ?? defaultAppConfig.sprayPolygonInnerBufferMeters
    );
    if (!Number.isFinite(raw)) {
      return defaultAppConfig.sprayPolygonInnerBufferMeters;
    }
    return clamp(raw, 0, 30);
  }

  function pointToPolygonEdgeDistanceMeters(lon, lat, ring) {
    if (!Array.isArray(ring) || ring.length < 2) {
      return Infinity;
    }

    const latRad = Cesium.Math.toRadians(lat);
    const metersPerLon = 111320 * Math.max(0.01, Math.cos(latRad));
    const metersPerLat = 110540;
    let best = Infinity;

    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
      const a = ring[j];
      const b = ring[i];
      const ax = (a.lon - lon) * metersPerLon;
      const ay = (a.lat - lat) * metersPerLat;
      const bx = (b.lon - lon) * metersPerLon;
      const by = (b.lat - lat) * metersPerLat;
      const dist = pointToSegmentDistance2D(0, 0, ax, ay, bx, by);
      if (dist < best) {
        best = dist;
      }
    }

    return best;
  }

  function pointToSegmentDistance2D(px, py, ax, ay, bx, by) {
    const abx = bx - ax;
    const aby = by - ay;
    const apx = px - ax;
    const apy = py - ay;
    const abLen2 = abx * abx + aby * aby;
    if (abLen2 <= 1e-12) {
      return Math.hypot(apx, apy);
    }

    const t = clamp((apx * abx + apy * aby) / abLen2, 0, 1);
    const cx = ax + abx * t;
    const cy = ay + aby * t;
    return Math.hypot(px - cx, py - cy);
  }

  function estimateSprayPolygonAxisHeadingDeg(ring) {
    if (!Array.isArray(ring) || ring.length < 2) {
      return null;
    }

    const cleaned = ring.slice();
    if (cleaned.length >= 2) {
      const first = cleaned[0];
      const last = cleaned[cleaned.length - 1];
      if (Math.abs(first.lon - last.lon) < 1e-12 && Math.abs(first.lat - last.lat) < 1e-12) {
        cleaned.pop();
      }
    }
    if (cleaned.length < 2) {
      return null;
    }

    let bestA = null;
    let bestB = null;
    let bestMetric = -Infinity;

    for (let i = 0; i < cleaned.length; i++) {
      const a = cleaned[i];
      const b = cleaned[(i + 1) % cleaned.length];
      const midLatRad = Cesium.Math.toRadians((a.lat + b.lat) * 0.5);
      const dx = (b.lon - a.lon) * Math.cos(midLatRad);
      const dy = (b.lat - a.lat);
      const metric = dx * dx + dy * dy;
      if (metric > bestMetric) {
        bestMetric = metric;
        bestA = a;
        bestB = b;
      }
    }

    if (!bestA || !bestB || bestMetric <= 0) {
      return null;
    }
    return computeTrackHeadingDeg(bestA, bestB);
  }

  function applyInferredSprayDirectionFilter(points) {
    if (!points.length) {
      return;
    }

    const toleranceRaw = Number(
      state.appConfig.inferredSprayDirectionToleranceDeg ?? defaultAppConfig.inferredSprayDirectionToleranceDeg
    );
    const toleranceDeg = clamp(
      Number.isFinite(toleranceRaw)
        ? toleranceRaw
        : defaultAppConfig.inferredSprayDirectionToleranceDeg,
      5,
      85
    );
    const minAlignedPointsRaw = Number(
      state.appConfig.inferredSprayMinAlignedPoints ?? defaultAppConfig.inferredSprayMinAlignedPoints
    );
    const minAlignedPoints = clamp(
      Math.round(Number.isFinite(minAlignedPointsRaw)
        ? minAlignedPointsRaw
        : defaultAppConfig.inferredSprayMinAlignedPoints),
      1,
      12
    );
    const gapBridgePointsRaw = Number(
      state.appConfig.inferredSprayGapBridgePoints ?? defaultAppConfig.inferredSprayGapBridgePoints
    );
    const gapBridgePoints = clamp(
      Math.round(Number.isFinite(gapBridgePointsRaw)
        ? gapBridgePointsRaw
        : defaultAppConfig.inferredSprayGapBridgePoints),
      0,
      12
    );

    const groups = collectInferredSprayPointGroups(points);
    for (const group of groups) {
      const keepMask = new Array(group.length).fill(false);
      const axisDeltasDeg = new Array(group.length).fill(null);

      for (let i = 0; i < group.length; i++) {
        const pointIndex = group[i];
        const p = points[pointIndex];
        if (!Number.isFinite(p?.sprayAxisHeadingDeg)) {
          continue;
        }

        const moveHeadingDeg = resolvePointMotionHeadingDeg(points, pointIndex);
        if (!Number.isFinite(moveHeadingDeg)) {
          continue;
        }

        const axisDeltaDeg = angleDistanceToAxisDeg(moveHeadingDeg, p.sprayAxisHeadingDeg);
        axisDeltasDeg[i] = axisDeltaDeg;
        keepMask[i] = axisDeltaDeg <= toleranceDeg;
      }

      bridgeShortFalseGaps(keepMask, gapBridgePoints);
      removeShortTrueRuns(keepMask, minAlignedPoints);
      recoverDiscardedInferredGroup(
        keepMask,
        axisDeltasDeg,
        toleranceDeg,
        gapBridgePoints,
        minAlignedPoints
      );

      for (let i = 0; i < group.length; i++) {
        if (keepMask[i]) {
          continue;
        }

        const pointIndex = group[i];
        points[pointIndex].spray = false;
        points[pointIndex].spraySource = "none";
      }
    }
  }

  function recoverDiscardedInferredGroup(mask, axisDeltasDeg, toleranceDeg, gapBridgePoints, minAlignedPoints) {
    if (!Array.isArray(mask) || !mask.length || countTrueMask(mask) > 0) {
      return;
    }

    const relaxedToleranceDeg = Math.min(85, toleranceDeg + 12);
    const relaxedGapBridgePoints = Math.min(12, Math.max(0, gapBridgePoints + 1));
    const relaxedMinAlignedPoints = Math.max(2, minAlignedPoints - 1);

    for (let i = 0; i < mask.length; i++) {
      const delta = axisDeltasDeg[i];
      mask[i] = Number.isFinite(delta) && delta <= relaxedToleranceDeg;
    }

    bridgeShortFalseGaps(mask, relaxedGapBridgePoints);
    removeShortTrueRuns(mask, relaxedMinAlignedPoints);
  }

  function countTrueMask(mask) {
    let count = 0;
    for (let i = 0; i < mask.length; i++) {
      if (mask[i]) {
        count++;
      }
    }
    return count;
  }

  function collectInferredSprayPointGroups(points) {
    const groups = [];
    let currentGroup = [];
    let lastGroupKey = "";
    let lastIndex = -2;

    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      const isCandidate = !!p?.spray && p.spraySource === "inferred_polygon";
      if (!isCandidate) {
        if (currentGroup.length) {
          groups.push(currentGroup);
        }
        currentGroup = [];
        lastGroupKey = "";
        lastIndex = -2;
        continue;
      }

      const groupKey = normalizeTiroName(p.tiroName) || "__sem_tiro__";
      const isContinuous = currentGroup.length > 0 && i === lastIndex + 1 && groupKey === lastGroupKey;
      if (!isContinuous) {
        if (currentGroup.length) {
          groups.push(currentGroup);
        }
        currentGroup = [];
      }
      currentGroup.push(i);
      lastGroupKey = groupKey;
      lastIndex = i;
    }

    if (currentGroup.length) {
      groups.push(currentGroup);
    }

    return groups;
  }

  function bridgeShortFalseGaps(mask, maxGapLength) {
    if (!Array.isArray(mask) || mask.length < 3 || maxGapLength <= 0) {
      return;
    }

    let i = 0;
    while (i < mask.length) {
      if (mask[i]) {
        i++;
        continue;
      }

      const gapStart = i;
      while (i < mask.length && !mask[i]) {
        i++;
      }
      const gapLength = i - gapStart;
      const hasTrueLeft = gapStart > 0 && !!mask[gapStart - 1];
      const hasTrueRight = i < mask.length && !!mask[i];

      if (hasTrueLeft && hasTrueRight && gapLength <= maxGapLength) {
        for (let j = gapStart; j < i; j++) {
          mask[j] = true;
        }
      }
    }
  }

  function removeShortTrueRuns(mask, minRunLength) {
    if (!Array.isArray(mask) || !mask.length || minRunLength <= 1) {
      return;
    }

    let i = 0;
    while (i < mask.length) {
      if (!mask[i]) {
        i++;
        continue;
      }

      const runStart = i;
      while (i < mask.length && mask[i]) {
        i++;
      }

      const runLength = i - runStart;
      if (runLength >= minRunLength) {
        continue;
      }

      for (let j = runStart; j < i; j++) {
        mask[j] = false;
      }
    }
  }

  function resolvePointMotionHeadingDeg(points, index) {
    const prev = index > 0 ? points[index - 1] : null;
    const curr = points[index];
    const next = index + 1 < points.length ? points[index + 1] : null;

    if (prev && next) {
      return computeTrackHeadingDeg(prev, next);
    }
    if (prev) {
      return computeTrackHeadingDeg(prev, curr);
    }
    if (next) {
      return computeTrackHeadingDeg(curr, next);
    }
    return null;
  }

  function angleDistanceToAxisDeg(headingDeg, axisHeadingDeg) {
    const d = Math.abs(normalizeAngleDeg(headingDeg - axisHeadingDeg));
    return Math.min(d, Math.abs(180 - d));
  }

  function pointInPolygon(x, y, ring) {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
      const xi = ring[i].lon;
      const yi = ring[i].lat;
      const xj = ring[j].lon;
      const yj = ring[j].lat;

      const intersects = ((yi > y) !== (yj > y))
        && (x < ((xj - xi) * (y - yi)) / ((yj - yi) || 1e-16) + xi);
      if (intersects) {
        inside = !inside;
      }
    }
    return inside;
  }

  function extractSprayArray(node) {
    const out = [];

    const simpleArrays = Array.from(node.getElementsByTagNameNS("http://www.google.com/kml/ext/2.2", "SimpleArrayData"));
    for (const sa of simpleArrays) {
      const name = (sa.getAttribute("name") || "").toLowerCase();
      if (!isSprayField(name)) {
        continue;
      }
      const values = Array.from(sa.getElementsByTagNameNS("http://www.google.com/kml/ext/2.2", "value"))
        .map((v) => v.textContent?.trim() || "");
      if (values.length) {
        return values;
      }
    }

    const dataNodes = Array.from(node.getElementsByTagName("Data"));
    for (const d of dataNodes) {
      const name = (d.getAttribute("name") || "").toLowerCase();
      if (!isSprayField(name)) {
        continue;
      }
      const valueNode = d.getElementsByTagName("value")[0];
      const raw = valueNode?.textContent?.trim() || "";
      if (raw.includes(";")) {
        return raw.split(";").map((x) => x.trim());
      }
      if (raw.includes(",")) {
        return raw.split(",").map((x) => x.trim());
      }
      out.push(raw);
    }

    return out;
  }

  function isSprayField(name) {
    return name.includes("faixa") || name.includes("spray") || name.includes("pulver");
  }

  function toBoolSpray(value) {
    if (typeof value === "boolean") {
      return value;
    }
    const v = String(value || "").trim().toLowerCase();
    if (!v) return false;
    return v === "1" || v === "true" || v === "sim" || v === "yes" || v === "on" || v === "pulverizando";
  }

  function dateToSec(raw, fallbackIndex) {
    const t = Date.parse(raw);
    if (Number.isFinite(t)) {
      return Math.floor(t / 1000);
    }
    return Math.floor(Date.now() / 1000) + fallbackIndex;
  }

  function normalizeTrack(points) {
    const sorted = points
      .filter((p) => Number.isFinite(p.lon) && Number.isFinite(p.lat) && Number.isFinite(p.tSec))
      .sort((a, b) => a.tSec - b.tSec);

    for (let i = 1; i < sorted.length; i++) {
      if (sorted[i].tSec <= sorted[i - 1].tSec) {
        sorted[i].tSec = sorted[i - 1].tSec + 0.001;
      }
    }

    return {
      points: sorted,
      sprayFlags: sorted.map((p) => !!p.spray)
    };
  }

  function optimizeTrackPoints(points, maxPoints) {
    const safeMax = Math.max(1000, Number.isFinite(maxPoints) ? maxPoints : defaultAppConfig.maxTrackPoints);
    if (points.length <= safeMax) {
      return { points, originalCount: points.length };
    }

    const stride = Math.ceil(points.length / safeMax);
    const preservedIndexes = new Set();

    const preserveIndex = (index) => {
      if (index >= 0 && index < points.length) {
        preservedIndexes.add(index);
      }
    };

    const pointType = (point) => String(
      point && (point.telemetryType || point.applicationType) || ''
    ).trim().toLowerCase();

    const isRefuelPoint = (point) => pointType(point) === 'refuel';

    for (let i = 0; i < points.length; i += stride) {
      preserveIndex(i);
    }
    preserveIndex(points.length - 1);

    for (let i = 0; i < points.length; i++) {
      const current = points[i];
      const previous = i > 0 ? points[i - 1] : null;
      const next = i + 1 < points.length ? points[i + 1] : null;
      if (isRefuelPoint(current)) {
        preserveIndex(i - 1);
        preserveIndex(i);
        preserveIndex(i + 1);
      }

      if (previous) {
        const sprayChanged = !!previous.spray !== !!current.spray;
        const typeChanged = pointType(previous) !== pointType(current);
        const refuelCountChanged = Number(previous.refuelCount) !== Number(current.refuelCount);
        const refuelIndexChanged = Number(previous.refuelIndex) !== Number(current.refuelIndex);

        if (sprayChanged || typeChanged || refuelCountChanged || refuelIndexChanged) {
          preserveIndex(i - 1);
          preserveIndex(i);
        }
      }

      if (next && isRefuelPoint(next)) {
        preserveIndex(i);
      }
    }

    const optimized = Array.from(preservedIndexes)
      .sort((a, b) => a - b)
      .map((index) => points[index]);

    return { points: optimized, originalCount: points.length };
  }

  function trimInitialAltitudeJumpPoints(points) {
    const info = {
      enabled: !!state.appConfig.enableInitialStableAltitudeStart,
      applied: false,
      removedPoints: 0,
      originalCount: Array.isArray(points) ? points.length : 0,
      finalCount: Array.isArray(points) ? points.length : 0,
      startIndex: 0,
      originalStartSec: null,
      newStartSec: null,
      previousPeakAltitudeMeters: null,
      stableAltitudeMeters: null,
      reason: "disabled"
    };

    if (!info.enabled) {
      state.initialStableAltitudeTrimInfo = info;
      return { points, info };
    }

    if (!Array.isArray(points) || points.length < 8) {
      info.reason = "not_enough_points";
      state.initialStableAltitudeTrimInfo = info;
      return { points, info };
    }

    const startIndex = findInitialStableAltitudeStartIndex(points);
    if (!Number.isFinite(startIndex) || startIndex <= 0 || startIndex >= points.length - 1) {
      info.reason = "stable_start_not_found";
      state.initialStableAltitudeTrimInfo = info;
      return { points, info };
    }

    const keepBackSeconds = clamp(Number(state.appConfig.initialStableAltitudeKeepBackSeconds), 0, 10);
    let trimIndex = startIndex;
    if (keepBackSeconds > 0) {
      const stableStartPoint = points[startIndex];
      const stableStartSec = stableStartPoint && Number.isFinite(stableStartPoint.tSec) ? stableStartPoint.tSec : null;
      const stableMaxAltitude = resolveInitialStableAltitudeMaxMeters();
      if (Number.isFinite(stableStartSec)) {
        for (let i = startIndex - 1; i >= 0; i--) {
          const pointSec = Number.isFinite(points[i].tSec) ? points[i].tSec : null;
          const pointAltitude = getPointStableStartAltitude(points[i]);
          if (!Number.isFinite(pointSec) || stableStartSec - pointSec > keepBackSeconds) {
            break;
          }
          if (!Number.isFinite(pointAltitude) || pointAltitude > stableMaxAltitude) {
            break;
          }
          trimIndex = i;
        }
      }
    }

    if (trimIndex <= 0) {
      info.reason = "trim_index_zero";
      state.initialStableAltitudeTrimInfo = info;
      return { points, info };
    }

    const trimmedPoints = points.slice(trimIndex);
    if (trimmedPoints.length < 2) {
      info.reason = "trimmed_not_enough_points";
      state.initialStableAltitudeTrimInfo = info;
      return { points, info };
    }

    const peakInfo = getInitialPreviousPeakAltitude(points, startIndex);
    const stableAltitude = getPointStableStartAltitude(points[startIndex]);

    info.applied = true;
    info.removedPoints = trimIndex;
    info.finalCount = trimmedPoints.length;
    info.startIndex = trimIndex;
    info.originalStartSec = Number.isFinite(points[0].tSec) ? points[0].tSec : null;
    info.newStartSec = Number.isFinite(trimmedPoints[0].tSec) ? trimmedPoints[0].tSec : null;
    info.previousPeakAltitudeMeters = peakInfo && Number.isFinite(peakInfo.altitude) ? peakInfo.altitude : null;
    info.stableAltitudeMeters = Number.isFinite(stableAltitude) ? stableAltitude : null;
    info.reason = "initial_altitude_jump_removed";
    state.initialStableAltitudeTrimInfo = info;
    return { points: trimmedPoints, info };
  }

  function findInitialStableAltitudeStartIndex(points) {
    const stableMaxAltitude = resolveInitialStableAltitudeMaxMeters();
    const stableWindowSeconds = resolveInitialStableAltitudeWindowSeconds();
    const stableRangeMeters = resolveInitialStableAltitudeRangeMeters();
    const requiredPeakMeters = resolveInitialStableRequiredPreviousPeakMeters();
    const requiredDropMeters = resolveInitialStableRequiredDropMeters();
    const maxSearchSeconds = resolveInitialStableMaxSearchSeconds();
    const firstSec = Number.isFinite(points[0].tSec) ? points[0].tSec : null;

    for (let i = 1; i < points.length - 2; i++) {
      if (Number.isFinite(firstSec) && Number.isFinite(points[i].tSec) && points[i].tSec - firstSec > maxSearchSeconds) {
        break;
      }

      const stableAltitude = getPointStableStartAltitude(points[i]);
      if (!Number.isFinite(stableAltitude) || stableAltitude > stableMaxAltitude) {
        continue;
      }

      const peakInfo = getInitialPreviousPeakAltitude(points, i);
      if (!peakInfo || !Number.isFinite(peakInfo.altitude)) {
        continue;
      }

      if (peakInfo.altitude < requiredPeakMeters || peakInfo.altitude - stableAltitude < requiredDropMeters) {
        continue;
      }

      const windowInfo = getStableAltitudeWindowInfo(points, i, stableWindowSeconds);
      if (!windowInfo || windowInfo.count < 3 || windowInfo.durationSec < stableWindowSeconds) {
        continue;
      }

      if (windowInfo.maxAltitude > stableMaxAltitude || windowInfo.altitudeRange > stableRangeMeters) {
        continue;
      }

      return i;
    }

    return -1;
  }

  function getStableAltitudeWindowInfo(points, startIndex, stableWindowSeconds) {
    const startPoint = points[startIndex];
    if (!startPoint || !Number.isFinite(startPoint.tSec)) {
      return null;
    }

    let count = 0;
    let minAltitude = Infinity;
    let maxAltitude = -Infinity;
    let endSec = startPoint.tSec;

    for (let i = startIndex; i < points.length; i++) {
      const point = points[i];
      if (!point || !Number.isFinite(point.tSec)) {
        continue;
      }
      if (point.tSec - startPoint.tSec > stableWindowSeconds) {
        break;
      }

      const altitude = getPointStableStartAltitude(point);
      if (!Number.isFinite(altitude)) {
        return null;
      }

      count++;
      minAltitude = Math.min(minAltitude, altitude);
      maxAltitude = Math.max(maxAltitude, altitude);
      endSec = point.tSec;
    }

    if (!count || !Number.isFinite(minAltitude) || !Number.isFinite(maxAltitude)) {
      return null;
    }

    return {
      count,
      durationSec: Math.max(0, endSec - startPoint.tSec),
      minAltitude,
      maxAltitude,
      altitudeRange: maxAltitude - minAltitude
    };
  }

  function getInitialPreviousPeakAltitude(points, endIndex) {
    let peakAltitude = -Infinity;
    let peakIndex = -1;
    for (let i = 0; i < endIndex; i++) {
      const altitude = getPointStableStartAltitude(points[i]);
      if (Number.isFinite(altitude) && altitude > peakAltitude) {
        peakAltitude = altitude;
        peakIndex = i;
      }
    }

    if (peakIndex < 0) {
      return null;
    }

    return {
      index: peakIndex,
      altitude: peakAltitude
    };
  }

  function getPointStableStartAltitude(point) {
    if (!point) {
      return null;
    }
    if (Number.isFinite(point.altAdjusted)) {
      return normalizeOfficialRelativeAltitude(point.altAdjusted);
    }
    if (Number.isFinite(point.alt)) {
      return normalizeOfficialRelativeAltitude(point.alt);
    }
    if (Number.isFinite(point.altOriginal)) {
      return normalizeOfficialRelativeAltitude(point.altOriginal);
    }
    return null;
  }

  function resolveInitialStableAltitudeMaxMeters() {
    const value = Number(state.appConfig.initialStableAltitudeMaxMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeMaxMeters, 5, 80);
  }

  function resolveInitialStableAltitudeWindowSeconds() {
    const value = Number(state.appConfig.initialStableAltitudeWindowSeconds);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeWindowSeconds, 3, 30);
  }

  function resolveInitialStableAltitudeRangeMeters() {
    const value = Number(state.appConfig.initialStableAltitudeRangeMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeRangeMeters, 1, 20);
  }

  function resolveInitialStableRequiredPreviousPeakMeters() {
    const value = Number(state.appConfig.initialStableAltitudeRequiredPreviousPeakMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeRequiredPreviousPeakMeters, 10, 150);
  }

  function resolveInitialStableRequiredDropMeters() {
    const value = Number(state.appConfig.initialStableAltitudeRequiredDropMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeRequiredDropMeters, 8, 120);
  }

  function resolveInitialStableMaxSearchSeconds() {
    const value = Number(state.appConfig.initialStableAltitudeMaxSearchSeconds);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.initialStableAltitudeMaxSearchSeconds, 20, 600);
  }

  function applyObstacleAltitudeDropFilter(points) {
    const info = {
      applied: false,
      adjustedPoints: 0,
      runs: 0,
      reason: "not_applied"
    };
    state.obstacleAltitudeDropFilterInfo = info;

    if (state.appConfig.enableObstacleAltitudeDropFilter === false) {
      info.reason = "disabled";
      return info;
    }

    if (!Array.isArray(points) || points.length < 3) {
      info.reason = "not_enough_points";
      return info;
    }

    const minDropMeters = resolveObstacleAltitudeDropMinMeters();
    const minRateMetersPerSecond = resolveObstacleAltitudeDropMinRateMetersPerSecond();
    const maxRecoverySeconds = resolveObstacleAltitudeDropMaxRecoverySeconds();
    const maxRecoveryDistanceMeters = resolveObstacleAltitudeDropMaxRecoveryDistanceMeters();
    const recoveryToleranceMeters = resolveObstacleAltitudeDropRecoveryToleranceMeters();
    const minStartAltitudeMeters = resolveObstacleAltitudeDropMinStartAltitudeMeters();
    const maxPasses = resolveObstacleAltitudeDropMaxPasses();
    let adjustedTotal = 0;
    let runTotal = 0;

    for (let pass = 0; pass < maxPasses; pass++) {
      const originalAltitudes = points.map((point) => getObstacleFilterAltitude(point));
      let adjustedThisPass = 0;
      let i = 1;

      while (i < points.length - 1) {
        if (isTimelineRefuelPoint(points[i - 1]) || isTimelineRefuelPoint(points[i])) {
          i++;
          continue;
        }

        const previousAltitude = originalAltitudes[i - 1];
        const currentAltitude = originalAltitudes[i];

        if (!Number.isFinite(previousAltitude) || !Number.isFinite(currentAltitude)) {
          i++;
          continue;
        }

        const dropMeters = previousAltitude - currentAltitude;
        if (previousAltitude < minStartAltitudeMeters || dropMeters < minDropMeters) {
          i++;
          continue;
        }

        const dtSec = Math.max(0, Number(points[i].tSec) - Number(points[i - 1].tSec));
        const dropRate = dtSec > 0 ? dropMeters / dtSec : dropMeters;
        if (dropRate < minRateMetersPerSecond) {
          i++;
          continue;
        }

        const recoveryIndex = findObstacleAltitudeDropRecoveryIndex(
          points,
          originalAltitudes,
          i - 1,
          i,
          previousAltitude,
          maxRecoverySeconds,
          maxRecoveryDistanceMeters,
          recoveryToleranceMeters
        );

        if (recoveryIndex <= i) {
          i++;
          continue;
        }

        const adjusted = bridgeObstacleAltitudeDrop(points, originalAltitudes, i - 1, recoveryIndex);
        if (adjusted > 0) {
          adjustedThisPass += adjusted;
          adjustedTotal += adjusted;
          runTotal++;
          i = recoveryIndex + 1;
          continue;
        }

        i++;
      }

      if (!adjustedThisPass) {
        break;
      }
    }

    info.applied = adjustedTotal > 0;
    info.adjustedPoints = adjustedTotal;
    info.runs = runTotal;
    info.reason = info.applied ? "obstacle_abrupt_altitude_drop_filtered" : "no_matching_drop";
    state.obstacleAltitudeDropFilterInfo = info;

    return info;
  }

  function findObstacleAltitudeDropRecoveryIndex(points, altitudes, highIndex, dropIndex, highAltitude, maxRecoverySeconds, maxRecoveryDistanceMeters, recoveryToleranceMeters) {
    const highPoint = points[highIndex];
    const dropPoint = points[dropIndex];
    if (!highPoint || !dropPoint || !Number.isFinite(highAltitude)) {
      return -1;
    }

    const startSec = Number(dropPoint.tSec);
    for (let i = dropIndex + 1; i < points.length; i++) {
      const point = points[i];
      const altitude = altitudes[i];
      if (!point || !Number.isFinite(altitude)) {
        continue;
      }

      const elapsedSec = Number.isFinite(point.tSec) && Number.isFinite(startSec) ? point.tSec - startSec : 0;
      if (elapsedSec > maxRecoverySeconds) {
        break;
      }

      const distanceMeters = computeSurfaceDistanceMeters(highPoint, point);
      if (Number.isFinite(distanceMeters) && distanceMeters > maxRecoveryDistanceMeters) {
        break;
      }

      if (altitude >= highAltitude - recoveryToleranceMeters) {
        return i;
      }
    }

    return -1;
  }

  function bridgeObstacleAltitudeDrop(points, altitudes, startIndex, endIndex) {
    const startPoint = points[startIndex];
    const endPoint = points[endIndex];
    const startAltitude = altitudes[startIndex];
    const endAltitude = altitudes[endIndex];

    if (!startPoint || !endPoint || !Number.isFinite(startAltitude) || !Number.isFinite(endAltitude) || endIndex <= startIndex + 1) {
      return 0;
    }

    const startSec = Number(startPoint.tSec);
    const endSec = Number(endPoint.tSec);
    const durationSec = Number.isFinite(startSec) && Number.isFinite(endSec) ? Math.max(0, endSec - startSec) : 0;
    let adjusted = 0;

    for (let i = startIndex + 1; i < endIndex; i++) {
      const point = points[i];
      const rawAltitude = altitudes[i];
      if (!point || !Number.isFinite(rawAltitude)) {
        continue;
      }

      let ratio = (i - startIndex) / Math.max(1, endIndex - startIndex);
      if (durationSec > 0 && Number.isFinite(point.tSec)) {
        ratio = clamp((point.tSec - startSec) / durationSec, 0, 1);
      }

      const bridgeAltitude = startAltitude + (endAltitude - startAltitude) * ratio;
      if (isTimelineRefuelPoint(point)) {
        continue;
      }

      const finalAltitude = normalizeOfficialRelativeAltitude(Math.max(rawAltitude, bridgeAltitude), isTimelineRefuelPoint(point) ? 0.5 : 3);

      if (Number.isFinite(finalAltitude) && Math.abs(finalAltitude - rawAltitude) > 0.25) {
        if (!Number.isFinite(point.altRawBeforeObstacleFilter)) {
          point.altRawBeforeObstacleFilter = rawAltitude;
        }
        if (!Number.isFinite(point.altOriginalRawBeforeObstacleFilter) && Number.isFinite(point.altOriginal)) {
          point.altOriginalRawBeforeObstacleFilter = point.altOriginal;
        }
        if (!Number.isFinite(point.altAdjustedRawBeforeObstacleFilter) && Number.isFinite(point.altAdjusted)) {
          point.altAdjustedRawBeforeObstacleFilter = point.altAdjusted;
        }

        point.alt = finalAltitude;
        point.altOriginal = finalAltitude;
        point.altAdjusted = finalAltitude;
        adjusted++;
      }
    }

    return adjusted;
  }

  function getObstacleFilterAltitude(point) {
    if (!point) {
      return null;
    }
    if (Number.isFinite(point.alt)) {
      return normalizeOfficialRelativeAltitude(point.alt, isTimelineRefuelPoint(point) ? 0.5 : 3);
    }
    if (Number.isFinite(point.altAdjusted)) {
      return normalizeOfficialRelativeAltitude(point.altAdjusted, isTimelineRefuelPoint(point) ? 0.5 : 3);
    }
    if (Number.isFinite(point.altOriginal)) {
      return normalizeOfficialRelativeAltitude(point.altOriginal, isTimelineRefuelPoint(point) ? 0.5 : 3);
    }
    return null;
  }

  function resolveObstacleAltitudeDropMinMeters() {
    const value = Number(state.appConfig.obstacleAltitudeDropMinMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMinMeters, 3, 30);
  }

  function resolveObstacleAltitudeDropMinRateMetersPerSecond() {
    const value = Number(state.appConfig.obstacleAltitudeDropMinRateMetersPerSecond);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMinRateMetersPerSecond, 0.5, 20);
  }

  function resolveObstacleAltitudeDropMaxRecoverySeconds() {
    const value = Number(state.appConfig.obstacleAltitudeDropMaxRecoverySeconds);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMaxRecoverySeconds, 3, 60);
  }

  function resolveObstacleAltitudeDropMaxRecoveryDistanceMeters() {
    const value = Number(state.appConfig.obstacleAltitudeDropMaxRecoveryDistanceMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMaxRecoveryDistanceMeters, 50, 3000);
  }

  function resolveObstacleAltitudeDropRecoveryToleranceMeters() {
    const value = Number(state.appConfig.obstacleAltitudeDropRecoveryToleranceMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropRecoveryToleranceMeters, 1, 20);
  }

  function resolveObstacleAltitudeDropMinStartAltitudeMeters() {
    const value = Number(state.appConfig.obstacleAltitudeDropMinStartAltitudeMeters);
    return clamp(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMinStartAltitudeMeters, 4, 80);
  }

  function resolveObstacleAltitudeDropMaxPasses() {
    const value = Number(state.appConfig.obstacleAltitudeDropMaxPasses);
    return clamp(Math.round(Number.isFinite(value) ? value : defaultAppConfig.obstacleAltitudeDropMaxPasses), 1, 5);
  }

  function applyRealSpeedAltitudeAdjustment(points) {
    if (!Array.isArray(points) || !points.length) {
      return;
    }

    for (const p of points) {
      const altitudeMeters = normalizeOfficialRelativeAltitude(Number.isFinite(p.alt) ? p.alt : p.altOriginal, isTimelineRefuelPoint(p) ? 0.5 : 3);
      p.alt = altitudeMeters;
      p.altOriginal = altitudeMeters;
      p.altAdjusted = altitudeMeters;
    }

    if (state.appConfig.enableRealSpeedAltitudeAdjustment === false || points.length < 2) {
      return;
    }

    const cfg = getRealSpeedAltitudeConfig();
    const speedsMps = computePointGroundSpeedsMps(points);
    const avgSegmentMeters = computeAverageGroundSegmentMeters(points);
    const smoothingAlpha = resolveRealSpeedAltitudeSmoothingAlpha(
      cfg.smoothingAlpha,
      cfg.blendDistanceMeters,
      avgSegmentMeters
    );
    const smoothedSpeedsMps = smoothSeries(speedsMps, smoothingAlpha);
    const denom = Math.max(0.1, cfg.highSpeedMps - cfg.lowSpeedMps);

    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      const baseAlt = normalizeOfficialRelativeAltitude(Number.isFinite(p.altOriginal) ? p.altOriginal : p.alt, isTimelineRefuelPoint(p) ? 0.5 : 3);

      let deltaMeters = 0;
      const speedMps = smoothedSpeedsMps[i];
      if (Number.isFinite(speedMps)) {
        const t = clamp((speedMps - cfg.lowSpeedMps) / denom, 0, 1);
        deltaMeters = cfg.lowSpeedDeltaMeters + t * (cfg.highSpeedDeltaMeters - cfg.lowSpeedDeltaMeters);
      }

      if (cfg.applyOnlyWhenSpraying && !p.spray) {
        deltaMeters = 0;
      }

      p.speedMps = Number.isFinite(speedMps) ? speedMps : null;
      p.altAdjusted = normalizeOfficialRelativeAltitude(baseAlt + deltaMeters, isTimelineRefuelPoint(p) ? 0.5 : 3);
    }
  }

  function getRealSpeedAltitudeConfig() {
    const lowSpeedRaw = Number(
      state.appConfig.realSpeedAltitudeLowSpeedMps ?? defaultAppConfig.realSpeedAltitudeLowSpeedMps
    );
    const highSpeedRaw = Number(
      state.appConfig.realSpeedAltitudeHighSpeedMps ?? defaultAppConfig.realSpeedAltitudeHighSpeedMps
    );
    const lowDeltaRaw = Number(
      state.appConfig.realSpeedAltitudeLowSpeedDeltaMeters ?? defaultAppConfig.realSpeedAltitudeLowSpeedDeltaMeters
    );
    const highDeltaRaw = Number(
      state.appConfig.realSpeedAltitudeHighSpeedDeltaMeters ?? defaultAppConfig.realSpeedAltitudeHighSpeedDeltaMeters
    );
    const smoothingRaw = Number(
      state.appConfig.realSpeedAltitudeSmoothing ?? defaultAppConfig.realSpeedAltitudeSmoothing
    );
    const blendDistanceRaw = Number(
      state.appConfig.realSpeedAltitudeBlendDistanceMeters ?? defaultAppConfig.realSpeedAltitudeBlendDistanceMeters
    );
    const minClampRaw = Number(
      state.appConfig.realSpeedAltitudeMinClampMeters ?? defaultAppConfig.realSpeedAltitudeMinClampMeters
    );

    let lowSpeedMps = Number.isFinite(lowSpeedRaw) ? lowSpeedRaw : defaultAppConfig.realSpeedAltitudeLowSpeedMps;
    let highSpeedMps = Number.isFinite(highSpeedRaw) ? highSpeedRaw : defaultAppConfig.realSpeedAltitudeHighSpeedMps;
    lowSpeedMps = clamp(lowSpeedMps, 0, 200);
    highSpeedMps = clamp(highSpeedMps, 0.1, 300);
    if (highSpeedMps <= lowSpeedMps + 0.1) {
      highSpeedMps = lowSpeedMps + 0.1;
    }

    return {
      lowSpeedMps,
      highSpeedMps,
      lowSpeedDeltaMeters: clamp(Number.isFinite(lowDeltaRaw) ? lowDeltaRaw : -8, -200, 200),
      highSpeedDeltaMeters: clamp(Number.isFinite(highDeltaRaw) ? highDeltaRaw : 0, -200, 200),
      smoothingAlpha: clamp(Number.isFinite(smoothingRaw) ? smoothingRaw : 0.45, 0, 0.95),
      blendDistanceMeters: clamp(
        Number.isFinite(blendDistanceRaw) ? blendDistanceRaw : defaultAppConfig.realSpeedAltitudeBlendDistanceMeters,
        30,
        5000
      ),
      minClampMeters: clamp(Number.isFinite(minClampRaw) ? minClampRaw : 3, -500, 5000),
      applyOnlyWhenSpraying: !!state.appConfig.realSpeedAltitudeApplyOnlyWhenSpraying
    };
  }

  function resolveRealSpeedAltitudeSmoothingAlpha(baseAlpha, blendDistanceMeters, avgSegmentMeters) {
    let alpha = clamp(Number.isFinite(baseAlpha) ? baseAlpha : 0.45, 0, 0.95);
    if (!Number.isFinite(blendDistanceMeters) || blendDistanceMeters <= 0) {
      return alpha;
    }
    if (!Number.isFinite(avgSegmentMeters) || avgSegmentMeters <= 0) {
      return alpha;
    }

    const byDistance = clamp(avgSegmentMeters / blendDistanceMeters, 0.01, 0.95);
    return Math.min(alpha, byDistance);
  }

  function computePointGroundSpeedsMps(points) {
    const n = points.length;
    const segmentSpeeds = new Array(Math.max(0, n - 1)).fill(null);
    for (let i = 1; i < n; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const dtSec = Number(p1.tSec) - Number(p0.tSec);
      if (!Number.isFinite(dtSec) || dtSec <= 1e-6) {
        continue;
      }
      const distMeters = computeGroundDistanceMeters(p0, p1);
      if (!Number.isFinite(distMeters) || distMeters < 0) {
        continue;
      }
      segmentSpeeds[i - 1] = distMeters / dtSec;
    }

    const pointSpeeds = new Array(n).fill(null);
    for (let i = 0; i < n; i++) {
      const prev = i > 0 ? segmentSpeeds[i - 1] : null;
      const next = i < n - 1 ? segmentSpeeds[i] : null;
      const prevOk = Number.isFinite(prev);
      const nextOk = Number.isFinite(next);
      if (prevOk && nextOk) {
        pointSpeeds[i] = (prev + next) * 0.5;
      } else if (prevOk) {
        pointSpeeds[i] = prev;
      } else if (nextOk) {
        pointSpeeds[i] = next;
      }
    }

    return pointSpeeds;
  }

  function computeGroundDistanceMeters(p0, p1) {
    const midLatRad = Cesium.Math.toRadians((p0.lat + p1.lat) * 0.5);
    const dxMeters = (p1.lon - p0.lon) * 111320 * Math.cos(midLatRad);
    const dyMeters = (p1.lat - p0.lat) * 110540;
    return Math.hypot(dxMeters, dyMeters);
  }

  function computeAverageGroundSegmentMeters(points) {
    if (!Array.isArray(points) || points.length < 2) {
      return null;
    }

    let sum = 0;
    let count = 0;
    for (let i = 1; i < points.length; i++) {
      const d = computeGroundDistanceMeters(points[i - 1], points[i]);
      if (!Number.isFinite(d) || d <= 0) {
        continue;
      }
      sum += d;
      count++;
    }

    if (!count) {
      return null;
    }
    return sum / count;
  }

  function smoothSeries(values, alpha) {
    if (!Array.isArray(values) || !values.length || alpha <= 0) {
      return Array.isArray(values) ? values.slice() : [];
    }

    const out = values.slice();
    for (let i = 1; i < out.length; i++) {
      if (!Number.isFinite(out[i])) {
        out[i] = out[i - 1];
        continue;
      }
      if (!Number.isFinite(out[i - 1])) {
        continue;
      }
      out[i] = out[i - 1] + alpha * (out[i] - out[i - 1]);
    }

    for (let i = out.length - 2; i >= 0; i--) {
      if (!Number.isFinite(out[i])) {
        out[i] = out[i + 1];
        continue;
      }
      if (!Number.isFinite(out[i + 1])) {
        continue;
      }
      out[i] = out[i + 1] + alpha * (out[i] - out[i + 1]);
    }

    return out;
  }

  function derivePointSprayFlagsFromSegments(points, segmentDecisions) {
    const n = points.length;
    if (!n) {
      return [];
    }
    if (n === 1) {
      return [false];
    }

    const decisions = Array.isArray(segmentDecisions) ? segmentDecisions : buildSegmentSprayDecisions(points);
    const flags = new Array(n).fill(false);

    for (let i = 0; i < decisions.length; i++) {
      if (!decisions[i]?.isSpraying) {
        continue;
      }
      flags[i] = true;
      flags[i + 1] = true;
    }

    return flags;
  }

  function buildSegmentSprayDecisions(points) {
    const decisions = [];
    if (!Array.isArray(points) || points.length < 2) {
      return decisions;
    }

    const cfg = getSprayStateMachineConfig();
    const completedInferredTiros = new Set();

    let activeKey = "";
    let activeSource = "none";
    let activeTiro = null;
    let outsideStreak = 0;
    let cooldownRemaining = 0;
    let enterKey = "";
    let enterIndexes = [];
    let previousHeadingDeg = null;

    for (let i = 1; i < points.length; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const base = resolveSegmentSprayInfo(p0, p1);
      const headingDeg = computeTrackHeadingDeg(p0, p1);
      const maneuver = isSegmentManeuver(previousHeadingDeg, headingDeg, cfg.maneuverHeadingDeltaDeg);
      previousHeadingDeg = headingDeg;

      if (maneuver) {
        cooldownRemaining = cfg.maneuverCooldownSegments + 1;
      }
      const forcedOff = maneuver || cooldownRemaining > 0;

      let candidate = !!base.isSpraying;
      let key = "";
      if (candidate) {
        key = base.source === "inferred_polygon"
          ? `inferred:${base.inferredTiroName || ""}`
          : "explicit";
        if (base.source === "inferred_polygon" && completedInferredTiros.has(base.inferredTiroName || "")) {
          candidate = false;
          key = "";
        }
      }

      if (forcedOff) {
        candidate = false;
        key = "";
      }

      let isSpraying = false;
      let source = "none";
      let inferredTiroName = null;

      if (activeKey) {
        if (candidate && key === activeKey) {
          outsideStreak = 0;
          isSpraying = true;
          source = activeSource;
          inferredTiroName = activeTiro;
        } else {
          outsideStreak++;
          if (!forcedOff && outsideStreak <= cfg.sprayBridgeGapSegments) {
            isSpraying = true;
            source = activeSource;
            inferredTiroName = activeTiro;
          }

          if (outsideStreak >= cfg.sprayExitConfirmSegments) {
            if (activeSource === "inferred_polygon" && activeTiro) {
              completedInferredTiros.add(activeTiro);
            }
            activeKey = "";
            activeSource = "none";
            activeTiro = null;
            outsideStreak = 0;
            enterKey = "";
            enterIndexes = [];
          }
        }
      }

      if (!activeKey) {
        if (candidate) {
          if (enterKey === key) {
            enterIndexes.push(i - 1);
          } else {
            enterKey = key;
            enterIndexes = [i - 1];
          }

          if (enterIndexes.length >= cfg.sprayEnterConfirmSegments) {
            activeKey = key;
            activeSource = base.source;
            activeTiro = base.source === "inferred_polygon" ? (base.inferredTiroName || null) : null;
            outsideStreak = 0;

            for (const pendingSegIndex of enterIndexes) {
              decisions[pendingSegIndex] = {
                isSpraying: true,
                source: activeSource,
                inferredTiroName: activeTiro
              };
            }

            isSpraying = true;
            source = activeSource;
            inferredTiroName = activeTiro;
            enterKey = "";
            enterIndexes = [];
          }
        } else {
          enterKey = "";
          enterIndexes = [];
        }
      }

      decisions[i - 1] = decisions[i - 1] || {
        isSpraying: !!isSpraying,
        source: isSpraying ? source : "none",
        inferredTiroName: isSpraying ? inferredTiroName : null
      };

      if (cooldownRemaining > 0) {
        cooldownRemaining--;
      }
    }

    applyAntiRepaintToSegmentDecisions(points, decisions, cfg.sprayAntiRepaintGridMeters);
    return decisions;
  }

  function getSprayStateMachineConfig() {
    const enterConfirmRaw = Number(
      state.appConfig.sprayEnterConfirmSegments ?? defaultAppConfig.sprayEnterConfirmSegments
    );
    const exitConfirmRaw = Number(
      state.appConfig.sprayExitConfirmSegments ?? defaultAppConfig.sprayExitConfirmSegments
    );
    const bridgeGapRaw = Number(
      state.appConfig.sprayBridgeGapSegments ?? defaultAppConfig.sprayBridgeGapSegments
    );
    const maneuverDeltaRaw = Number(
      state.appConfig.sprayManeuverHeadingDeltaDeg ?? defaultAppConfig.sprayManeuverHeadingDeltaDeg
    );
    const maneuverCooldownRaw = Number(
      state.appConfig.sprayManeuverCooldownSegments ?? defaultAppConfig.sprayManeuverCooldownSegments
    );
    const antiRepaintGridRaw = Number(
      state.appConfig.sprayAntiRepaintGridMeters ?? defaultAppConfig.sprayAntiRepaintGridMeters
    );

    return {
      sprayEnterConfirmSegments: clamp(Math.round(Number.isFinite(enterConfirmRaw) ? enterConfirmRaw : 2), 1, 8),
      sprayExitConfirmSegments: clamp(Math.round(Number.isFinite(exitConfirmRaw) ? exitConfirmRaw : 3), 1, 12),
      sprayBridgeGapSegments: clamp(Math.round(Number.isFinite(bridgeGapRaw) ? bridgeGapRaw : 1), 0, 8),
      maneuverHeadingDeltaDeg: clamp(Number.isFinite(maneuverDeltaRaw) ? maneuverDeltaRaw : 30, 5, 120),
      maneuverCooldownSegments: clamp(Math.round(Number.isFinite(maneuverCooldownRaw) ? maneuverCooldownRaw : 3), 0, 30),
      sprayAntiRepaintGridMeters: clamp(Number.isFinite(antiRepaintGridRaw) ? antiRepaintGridRaw : 2.5, 0.5, 30)
    };
  }

  function isSegmentManeuver(previousHeadingDeg, currentHeadingDeg, thresholdDeg) {
    if (!Number.isFinite(previousHeadingDeg) || !Number.isFinite(currentHeadingDeg)) {
      return false;
    }
    const deltaDeg = Math.abs(normalizeAngleDeg(currentHeadingDeg - previousHeadingDeg));
    return deltaDeg >= thresholdDeg;
  }

  function applyAntiRepaintToSegmentDecisions(points, decisions, gridMeters) {
    if (!Array.isArray(decisions) || !decisions.length || !Number.isFinite(gridMeters) || gridMeters <= 0) {
      return;
    }

    const paintedCells = new Set();
    for (let i = 0; i < decisions.length; i++) {
      const d = decisions[i];
      if (!d?.isSpraying || d.source !== "inferred_polygon") {
        continue;
      }

      const p0 = points[i];
      const p1 = points[i + 1];
      if (!p0 || !p1) {
        continue;
      }

      const gridKeys = buildSegmentGridKeys(p0, p1, gridMeters);
      if (!gridKeys.length) {
        continue;
      }

      let hasNewCell = false;
      for (const key of gridKeys) {
        if (!paintedCells.has(key)) {
          hasNewCell = true;
          break;
        }
      }

      if (!hasNewCell) {
        d.isSpraying = false;
        d.source = "none";
        d.inferredTiroName = null;
        continue;
      }

      for (const key of gridKeys) {
        paintedCells.add(key);
      }
    }
  }

  function buildSegmentGridKeys(p0, p1, gridMeters) {
    const startMeters = projectLonLatToMeters(p0.lon, p0.lat);
    const endMeters = projectLonLatToMeters(p1.lon, p1.lat);
    if (!startMeters || !endMeters) {
      return [];
    }

    const dx = endMeters.x - startMeters.x;
    const dy = endMeters.y - startMeters.y;
    const dist = Math.hypot(dx, dy);
    const stepMeters = Math.max(0.25, gridMeters * 0.75);
    const samples = Math.max(2, Math.ceil(dist / stepMeters) + 1);
    const keys = [];
    const seen = new Set();

    for (let i = 0; i < samples; i++) {
      const t = samples === 1 ? 0 : i / (samples - 1);
      const x = startMeters.x + dx * t;
      const y = startMeters.y + dy * t;
      const key = `${Math.floor(x / gridMeters)}:${Math.floor(y / gridMeters)}`;
      if (!seen.has(key)) {
        seen.add(key);
        keys.push(key);
      }
    }

    return keys;
  }

  function projectLonLatToMeters(lonDeg, latDeg) {
    if (!Number.isFinite(lonDeg) || !Number.isFinite(latDeg)) {
      return null;
    }
    scratchGridCartographic.longitude = Cesium.Math.toRadians(lonDeg);
    scratchGridCartographic.latitude = Cesium.Math.toRadians(latDeg);
    scratchGridCartographic.height = 0;

    const projected = webMercatorProjection.project(scratchGridCartographic, scratchGridCartesian);
    if (!projected) {
      return null;
    }
    return { x: projected.x, y: projected.y };
  }

  function drawSprayPaths(points, segmentDecisions) {
    const spraySegments = [];
    const noSpraySegments = [];
    const decisions = Array.isArray(segmentDecisions) ? segmentDecisions : buildSegmentSprayDecisions(points);

    for (let i = 1; i < points.length; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const decision = decisions[i - 1];
      const isSpray = !!decision?.isSpraying;
      const target = isSpray ? spraySegments : noSpraySegments;
      target.push(p0.lon, p0.lat, p0.alt, p1.lon, p1.lat, p1.alt);
    }

    if (spraySegments.length) {
      const sprayEntity = state.viewer.entities.add({
        name: "Trecho pulverizando",
        show: state.pathVisibilityMode === "all",
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights(spraySegments),
          width: 4,
          material: Cesium.Color.fromCssColorString("#20a85a")
        }
      });
      sprayEntity.pathKind = "spray";
      state.pathEntities.push(sprayEntity);
    }

    if (noSpraySegments.length) {
      const noSprayEntity = state.viewer.entities.add({
        name: "Trecho sem pulverização",
        show: state.pathVisibilityMode === "all" || state.pathVisibilityMode === "orange_only",
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights(noSpraySegments),
          width: 3,
          material: Cesium.Color.fromCssColorString("#d88c2a").withAlpha(0.8)
        }
      });
      noSprayEntity.pathKind = "no_spray";
      state.pathEntities.push(noSprayEntity);
    }
  }


  function buildOfficialSprayFootprintRuns(points) {
    state.sprayFootprintRuns = [];
    state.sprayFootprintAreaLabels = [];
    state.sprayFootprintLastIndex = -1;
    state.officialSprayFootprintAvailable = false;

    const data = state.officialSprayFootprintSourceData;
    if (!data || !Array.isArray(points) || points.length < 2 || state.disableSprayFootprintRendering) {
      return false;
    }

    const items = collectOfficialSprayFootprintItems(data);
    if (!items.length) {
      return false;
    }

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const leftPoints = normalizeOfficialSpraySidePoints(item.leftPoints);
      const rightRawPoints = normalizeOfficialSpraySidePoints(item.rightPoints);
      if (leftPoints.length < 2 || rightRawPoints.length < 2) {
        continue;
      }

      const rightProgressPoints = item.rightAlreadyReversed ? rightRawPoints.slice().reverse() : rightRawPoints.slice();
      const maxPairs = Math.min(leftPoints.length, rightProgressPoints.length);
      if (maxPairs < 2) {
        continue;
      }

      const pairPointIndexes = [];
      let lastNearestIndex = -1;
      for (let pairIndex = 0; pairIndex < maxPairs; pairIndex++) {
        const center = {
          lon: (leftPoints[pairIndex].lon + rightProgressPoints[pairIndex].lon) / 2,
          lat: (leftPoints[pairIndex].lat + rightProgressPoints[pairIndex].lat) / 2
        };
        lastNearestIndex = findNearestTimelinePointIndex(center, points, lastNearestIndex);
        pairPointIndexes.push(lastNearestIndex);
      }

      const fullPositions = buildOfficialSprayPolygonPositions(leftPoints, rightProgressPoints, maxPairs);
      if (fullPositions.length < 3) {
        continue;
      }

      const firstIndex = Math.max(0, pairPointIndexes[0] || 0);
      const lastIndex = Math.max(firstIndex, pairPointIndexes[pairPointIndexes.length - 1] || firstIndex);
      const qualityColor = resolveOfficialSprayTypeColor(item.type);
      const run = {
        geometryType: "official_polygon",
        startIndex: firstIndex,
        endIndex: lastIndex,
        widthMeters: state.sprayDefaultWidthMeters || resolveSprayDefaultWidthMeters(points),
        runType: "official_" + item.type,
        inferredTiroName: item.name || null,
        inferredAreaName: item.areaName || item.name || null,
        inferredAreaKey: item.areaKey || item.key || ("official:" + item.type + ":" + i),
        qualityColor,
        leftPoints,
        rightPoints: rightProgressPoints,
        pairPointIndexes,
        maxPairs,
        pointCount: maxPairs,
        areaKey: item.areaKey || item.key || ("official:" + item.type + ":" + i),
        plannedAreaM2: Number.isFinite(item.areaM2) && item.areaM2 > 0 ? item.areaM2 : null,
        estimatedFullAreaM2: Math.max(0, maxPairs * (state.sprayDefaultWidthMeters || resolveSprayDefaultWidthMeters(points)) * 8),
        lastAppliedEndIndex: firstIndex,
        lastAppliedAreaM2: 0,
        areaM2: 0,
        entity: null,
        qualitySegments: []
      };

      run.entity = state.viewer.entities.add({
        name: "Faixa aplicada oficial",
        show: false,
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(fullPositions),
          material: makeSprayFootprintFillColor(qualityColor),
          outline: !state.sprayFootprintGpuSafeMode,
          outlineColor: makeSprayFootprintOutlineColor(qualityColor),
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          classificationType: Cesium.ClassificationType.TERRAIN
        }
      });

      run.qualitySegments = buildOfficialSprayQualitySegments(run, points);
      state.sprayFootprintRuns.push(run);
      state.pathEntities.push(run.entity);
      for (let j = 0; j < run.qualitySegments.length; j++) {
        state.pathEntities.push(run.qualitySegments[j].entity);
      }
    }

    if (!state.sprayFootprintRuns.length) {
      return false;
    }

    state.officialSprayFootprintAvailable = true;
    buildOfficialQualityLineRuns(points);
    buildOfficialSprayAreaLabels(points);
    return true;
  }

  function collectOfficialSprayFootprintItems(data) {
    const out = [];

    appendOfficialSprayItemsFromSideObject(out, data.app, "app", false);
    appendOfficialSprayItemsFromSideObject(out, data.fora, "out", false);
    appendOfficialSprayItemsFromSideObject(out, data.sobre, "over", true);

    return out;
  }

  function collectOfficialQualityLineItems(data) {
    const out = [];
    appendOfficialQualityLineItems(out, data && data.altura, "altura");
    appendOfficialQualityLineItems(out, data && data.fluxo, "fluxo");
    appendOfficialQualityLineItems(out, data && data.velocidade, "velocidade");
    appendOfficialQualityLineItems(out, data && data.vento_velocidade, "velocidadeVento");
    appendOfficialQualityLineItems(out, data && data.vento_angulo, "direcaoVento");
    appendOfficialQualityLineItems(out, data && data.deltaT, "deltaT");
    appendOfficialQualityLineItems(out, data && data.temperatura, "temperatura");
    appendOfficialQualityLineItems(out, data && data.humidade, "humidade");
    return out;
  }

  function appendOfficialQualityLineItems(out, source, parameter) {
    if (!Array.isArray(source)) {
      return;
    }

    for (let i = 0; i < source.length; i++) {
      const group = source[i];
      const items = group && Array.isArray(group.item) ? group.item : [];
      for (let j = 0; j < items.length; j++) {
        const item = items[j];
        const points = normalizeOfficialSpraySidePoints(item && item.points);
        const color = item && typeof item.color === "string" ? item.color.trim() : "";
        const widthMeters = Number(item && item.weight);
        if (points.length < 2 || !color) {
          continue;
        }
        out.push({
          parameter,
          points,
          color,
          widthMeters: Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : null,
          key: parameter + ":" + i + ":" + j
        });
      }
    }
  }

  function buildOfficialQualityLineRuns(points) {
    const data = state.officialSprayFootprintSourceData;
    if (!data || !Array.isArray(points) || points.length < 2 || state.disableSprayFootprintRendering) {
      return;
    }

    const items = collectOfficialQualityLineItems(data);
    if (!items.length) {
      return;
    }

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const linePoints = item.points || [];
      if (linePoints.length < 2) {
        continue;
      }

      const pointIndexes = [];
      let lastNearestIndex = -1;
      for (let j = 0; j < linePoints.length; j++) {
        lastNearestIndex = findNearestTimelinePointIndex(linePoints[j], points, lastNearestIndex);
        pointIndexes.push(lastNearestIndex);
      }

      const positionsFull = [];
      for (let j = 0; j < linePoints.length; j++) {
        positionsFull.push(Cesium.Cartesian3.fromDegrees(linePoints[j].lon, linePoints[j].lat));
      }

      const validIndexes = pointIndexes.filter((idx) => Number.isFinite(idx) && idx >= 0);
      const startIndex = validIndexes.length ? Math.min.apply(null, validIndexes) : 0;
      const endIndex = validIndexes.length ? Math.max.apply(null, validIndexes) : startIndex;
      const widthMeters = item.widthMeters || state.sprayDefaultWidthMeters || resolveSprayDefaultWidthMeters(points);

      const corridorGraphics = {
        positions: positionsFull.slice(0, 2),
        width: widthMeters,
        material: makeSprayFootprintFillColor(item.color),
        outline: !state.sprayFootprintGpuSafeMode
      };
      if (!state.sprayFootprintGpuSafeMode) {
        corridorGraphics.outlineColor = makeSprayFootprintOutlineColor(item.color);
        corridorGraphics.classificationType = Cesium.ClassificationType.TERRAIN;
        corridorGraphics.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
      }

      const entity = state.viewer.entities.add({
        name: "Faixa qualidade oficial",
        show: false,
        corridor: corridorGraphics
      });

      state.sprayFootprintRuns.push({
        geometryType: "official_quality_line",
        qualityParameter: item.parameter,
        startIndex,
        endIndex,
        widthMeters,
        runType: "official_quality_" + item.parameter,
        qualityColor: item.color,
        positionsFull,
        pointIndexes,
        pointCount: positionsFull.length,
        areaKey: item.key,
        lastAppliedEndIndex: startIndex,
        lastAppliedAreaM2: 0,
        areaM2: 0,
        entity
      });
      state.pathEntities.push(entity);
    }
  }

  function appendOfficialSprayItemsFromSideObject(out, source, type, rightAlreadyReversed) {
    if (!Array.isArray(source)) {
      return;
    }

    for (let i = 0; i < source.length; i++) {
      const item = source[i];
      if (!item) {
        continue;
      }

      const leftPoints = item.left && Array.isArray(item.left.points) ? item.left.points : item.left_points;
      const rightPoints = item.right && Array.isArray(item.right.points) ? item.right.points : item.right_points;
      if (!Array.isArray(leftPoints) || !Array.isArray(rightPoints)) {
        continue;
      }

      out.push({
        type,
        leftPoints,
        rightPoints,
        rightAlreadyReversed,
        name: item.name || item.tiro || item.title || null,
        areaName: item.areaName || item.name || item.tiro || item.title || null,
        key: item.key || (type + ":" + i),
        areaKey: item.areaKey || item.polygonKey || item.area_id || item.id_polygon || item.id_area || null,
        areaM2: resolveOfficialSprayItemAreaM2(item)
      });
    }
  }

  function resolveOfficialSprayItemAreaM2(item) {
    if (!item) {
      return null;
    }

    const directAreaM2 = Number(item.areaM2);
    if (Number.isFinite(directAreaM2) && directAreaM2 > 0) {
      return directAreaM2;
    }

    const planningAreaM2 = Number(item.planningAreaM2);
    if (Number.isFinite(planningAreaM2) && planningAreaM2 > 0) {
      return planningAreaM2;
    }

    const hectares = Number(item.areaHa || item.planningAreaHa || item.hectares || item.hectaresApplied);
    return Number.isFinite(hectares) && hectares > 0 ? hectares * 10000 : null;
  }

  function normalizeOfficialSpraySidePoints(points) {
    if (!Array.isArray(points)) {
      return [];
    }

    const out = [];
    for (let i = 0; i < points.length; i++) {
      const point = __travicarReplay3DNormalizeLatLng(points[i]);
      if (!point || !Number.isFinite(point.lat) || !Number.isFinite(point.lon)) {
        continue;
      }
      out.push({ lat: point.lat, lon: point.lon });
    }
    return out;
  }

  function buildOfficialSprayPolygonPositions(leftPoints, rightPoints, pairCount) {
    const positions = [];
    const count = Math.min(pairCount, leftPoints.length, rightPoints.length);
    for (let i = 0; i < count; i++) {
      positions.push(Cesium.Cartesian3.fromDegrees(leftPoints[i].lon, leftPoints[i].lat));
    }
    for (let i = count - 1; i >= 0; i--) {
      positions.push(Cesium.Cartesian3.fromDegrees(rightPoints[i].lon, rightPoints[i].lat));
    }
    return positions;
  }

  function buildOfficialSprayPolygonPositionsRange(leftPoints, rightPoints, startPairIndex, endPairIndex) {
    const positions = [];
    const start = clamp(Math.floor(startPairIndex), 0, Math.min(leftPoints.length, rightPoints.length) - 1);
    const end = clamp(Math.floor(endPairIndex), start, Math.min(leftPoints.length, rightPoints.length) - 1);

    for (let i = start; i <= end; i++) {
      positions.push(Cesium.Cartesian3.fromDegrees(leftPoints[i].lon, leftPoints[i].lat));
    }
    for (let i = end; i >= start; i--) {
      positions.push(Cesium.Cartesian3.fromDegrees(rightPoints[i].lon, rightPoints[i].lat));
    }
    return positions;
  }

  function buildOfficialSprayQualitySegments(run, points) {
    const segments = [];
    if (!run || !Array.isArray(run.leftPoints) || !Array.isArray(run.rightPoints) || !Array.isArray(run.pairPointIndexes)) {
      return segments;
    }

    let groupStart = 0;
    let groupColor = resolveOfficialSprayQualityColorForPair(run, points, 0);

    for (let pairIndex = 1; pairIndex < run.maxPairs; pairIndex++) {
      const color = resolveOfficialSprayQualityColorForPair(run, points, pairIndex);
      if (color === groupColor) {
        continue;
      }
      appendOfficialSprayQualitySegment(segments, run, groupStart, pairIndex, groupColor);
      groupStart = pairIndex - 1;
      groupColor = color;
    }

    appendOfficialSprayQualitySegment(segments, run, groupStart, run.maxPairs - 1, groupColor);
    return segments;
  }

  function appendOfficialSprayQualitySegment(segments, run, startPairIndex, endPairIndex, color) {
    if (!Number.isFinite(startPairIndex) || !Number.isFinite(endPairIndex) || endPairIndex <= startPairIndex) {
      return;
    }

    const positions = buildOfficialSprayPolygonPositionsRange(run.leftPoints, run.rightPoints, startPairIndex, endPairIndex);
    if (positions.length < 3) {
      return;
    }

    const entity = state.viewer.entities.add({
      name: "Faixa aplicada oficial qualidade",
      show: false,
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(positions),
        material: makeSprayFootprintFillColor(color),
        outline: !state.sprayFootprintGpuSafeMode,
        outlineColor: makeSprayFootprintOutlineColor(color),
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        classificationType: Cesium.ClassificationType.TERRAIN
      }
    });

    segments.push({
      startPairIndex,
      endPairIndex,
      lastVisibleEndPairIndex: -1,
      color,
      entity
    });
  }

  function refreshOfficialSprayQualitySegments() {
    if (!state.viewer || !Array.isArray(state.sprayFootprintRuns) || !state.sprayFootprintRuns.length) {
      return;
    }

    const removedEntities = new Set();

    for (const run of state.sprayFootprintRuns) {
      if (!run || run.geometryType !== "official_polygon") {
        continue;
      }

      if (Array.isArray(run.qualitySegments)) {
        for (let i = 0; i < run.qualitySegments.length; i++) {
          const segment = run.qualitySegments[i];
          if (segment && segment.entity) {
            state.viewer.entities.remove(segment.entity);
            removedEntities.add(segment.entity);
          }
        }
      }

      run.qualitySegments = buildOfficialSprayQualitySegments(run, state.timelinePoints);
      for (let i = 0; i < run.qualitySegments.length; i++) {
        state.pathEntities.push(run.qualitySegments[i].entity);
      }
    }

    if (removedEntities.size) {
      state.pathEntities = state.pathEntities.filter((entity) => !removedEntities.has(entity));
    }
  }

  function hasOfficialPolygonSprayFootprintRuns() {
    if (!Array.isArray(state.sprayFootprintRuns)) {
      return false;
    }

    for (let i = 0; i < state.sprayFootprintRuns.length; i++) {
      if (state.sprayFootprintRuns[i] && state.sprayFootprintRuns[i].geometryType === "official_polygon") {
        return true;
      }
    }

    return false;
  }

  function resolveOfficialSprayQualityColorForPair(run, points, pairIndex) {
    const pointIndex = Array.isArray(run.pairPointIndexes) ? run.pairPointIndexes[pairIndex] : -1;
    const point = pointIndex >= 0 && points && points[pointIndex] ? points[pointIndex] : null;
    const parameter = state.sprayQualityParameter || "aplicacao";

    if (parameter === "aplicacao") {
      if (run.runType === "official_out") return "#ffd500";
      if (run.runType === "official_over") return "#467580";
      return "#32a852";
    }

    const officialLineColor = resolveOfficialQualityLineColorForPair(run, pairIndex, parameter);
    if (officialLineColor) {
      return officialLineColor;
    }

    if (!point) {
      return run.qualityColor || state.sprayFootprintStyle.color;
    }

    const directColor = resolvePointQualityColor(point, parameter);
    if (directColor) {
      return directColor;
    }

    return resolveQualityColorByParameter(parameter, point.qualityValues ? Number(point.qualityValues[parameter]) : null);
  }

  function resolveOfficialQualityLineColorForPair(run, pairIndex, parameter) {
    if (!run || parameter === "aplicacao" || !Array.isArray(state.sprayFootprintRuns)) {
      return null;
    }

    const pairPointIndex = Array.isArray(run.pairPointIndexes) ? Number(run.pairPointIndexes[pairIndex]) : null;
    if (!Number.isFinite(pairPointIndex)) {
      return null;
    }

    let nearestColor = null;
    let nearestDistance = Infinity;

    for (let i = 0; i < state.sprayFootprintRuns.length; i++) {
      const qualityRun = state.sprayFootprintRuns[i];
      if (!qualityRun || qualityRun.geometryType !== "official_quality_line" || qualityRun.qualityParameter !== parameter) {
        continue;
      }

      const pointIndexes = Array.isArray(qualityRun.pointIndexes) ? qualityRun.pointIndexes : [];
      if (!pointIndexes.length || !qualityRun.qualityColor) {
        continue;
      }

      let minIndex = Infinity;
      let maxIndex = -Infinity;
      for (let j = 0; j < pointIndexes.length; j++) {
        const value = Number(pointIndexes[j]);
        if (!Number.isFinite(value)) {
          continue;
        }
        minIndex = Math.min(minIndex, value);
        maxIndex = Math.max(maxIndex, value);
      }

      if (!Number.isFinite(minIndex) || !Number.isFinite(maxIndex)) {
        continue;
      }

      let distance = 0;
      if (pairPointIndex < minIndex) {
        distance = minIndex - pairPointIndex;
      } else if (pairPointIndex > maxIndex) {
        distance = pairPointIndex - maxIndex;
      }

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestColor = qualityRun.qualityColor;
      }
    }

    return nearestColor;
  }

  function resolvePointQualityColor(point, parameter) {
    if (!point || !point.qualityColors) {
      return null;
    }

    const color = point.qualityColors[parameter];
    if (typeof color !== "string") {
      return null;
    }

    const normalized = color.trim();
    if (!normalized) {
      return null;
    }

    return normalized;
  }

  function findNearestTimelinePointIndex(point, timelinePoints, previousIndex) {
    if (!point || !Array.isArray(timelinePoints) || !timelinePoints.length) {
      return 0;
    }

    let start = 0;
    let end = timelinePoints.length - 1;
    if (Number.isFinite(previousIndex) && previousIndex >= 0) {
      start = Math.max(0, previousIndex - 80);
      end = Math.min(timelinePoints.length - 1, previousIndex + 260);
    }

    let bestIndex = start;
    let bestDistance = Number.POSITIVE_INFINITY;
    for (let i = start; i <= end; i++) {
      const dist = distanceMeters(point, timelinePoints[i]);
      if (dist < bestDistance) {
        bestDistance = dist;
        bestIndex = i;
      }
    }

    return bestIndex;
  }

  function resolveOfficialSprayTypeColor(type) {
    if (type === "out") {
      return "#ffd500";
    }
    if (type === "over") {
      return "#0d1763";
    }
    return state.sprayFootprintStyle.color;
  }

  function buildOfficialSprayAreaLabels(points) {
    if (!state.sprayFootprintRuns.length) {
      return;
    }

    const areaMap = new Map();

    for (let i = 0; i < state.sprayFootprintRuns.length; i++) {
      const run = state.sprayFootprintRuns[i];
      if (
        !run ||
        run.geometryType !== "official_polygon" ||
        !Array.isArray(run.leftPoints) ||
        !Array.isArray(run.rightPoints) ||
        !Number.isFinite(run.maxPairs) ||
        run.maxPairs < 2
      ) {
        continue;
      }

      const areaKey = run.areaKey || run.inferredAreaKey || ("official:app:" + i);
      if (!areaMap.has(areaKey)) {
        areaMap.set(areaKey, {
          key: areaKey,
          lonSum: 0,
          latSum: 0,
          count: 0,
          originalAreaM2: null,
          plannedAreaM2Sum: 0,
          totalGeometryM2: 0,
          labelEntity: null
        });
      }

      const area = areaMap.get(areaKey);
      if (Number.isFinite(run.plannedAreaM2) && run.plannedAreaM2 > 0) {
        area.plannedAreaM2Sum += run.plannedAreaM2;
      }
      area.totalGeometryM2 += Math.max(0, Number(run.estimatedFullAreaM2 || 0));
      const maxPairs = Math.min(run.maxPairs, run.leftPoints.length, run.rightPoints.length);
      for (let j = 0; j < maxPairs; j++) {
        area.lonSum += (run.leftPoints[j].lon + run.rightPoints[j].lon) / 2;
        area.latSum += (run.leftPoints[j].lat + run.rightPoints[j].lat) / 2;
        area.count++;
      }
    }

    const areasWithPoints = Array.from(areaMap.values()).filter((area) => !!area && !!area.count);
    const totalPlanningAreaM2Override = getPlanningReplay3DTotalAreaM2Override();
    const totalPlannedLabelAreaM2 = areasWithPoints.reduce((total, area) => {
      const value = Number(area && area.plannedAreaM2Sum);
      return total + (Number.isFinite(value) && value > 0 ? value : 0);
    }, 0);
    const totalGeometryLabelAreaM2 = areasWithPoints.reduce((total, area) => {
      const value = Number(area && area.totalGeometryM2);
      return total + (Number.isFinite(value) && value > 0 ? value : 0);
    }, 0);

    for (const area of areasWithPoints) {
      if (
        Number.isFinite(totalPlanningAreaM2Override) &&
        totalPlanningAreaM2Override > 0
      ) {
        if (areasWithPoints.length === 1) {
          area.originalAreaM2 = totalPlanningAreaM2Override;
        } else if (Number.isFinite(totalPlannedLabelAreaM2) && totalPlannedLabelAreaM2 > 0) {
          area.originalAreaM2 = totalPlanningAreaM2Override * (Math.max(0, Number(area.plannedAreaM2Sum) || 0) / totalPlannedLabelAreaM2);
        } else if (Number.isFinite(totalGeometryLabelAreaM2) && totalGeometryLabelAreaM2 > 0) {
          area.originalAreaM2 = totalPlanningAreaM2Override * (Math.max(0, Number(area.totalGeometryM2) || 0) / totalGeometryLabelAreaM2);
        } else {
          area.originalAreaM2 = totalPlanningAreaM2Override / areasWithPoints.length;
        }
      } else if (Number.isFinite(area.plannedAreaM2Sum) && area.plannedAreaM2Sum > 0) {
        area.originalAreaM2 = area.plannedAreaM2Sum;
      }

      area.labelEntity = state.viewer.entities.add({
        name: "Hectares da área aplicada",
        show: false,
        position: Cesium.Cartesian3.fromDegrees(area.lonSum / area.count, area.latSum / area.count, 0),
        label: {
          text: "0.00 ha",
          font: 'bold 14px "Segoe UI", sans-serif',
          fillColor: Cesium.Color.fromCssColorString("#f8ffcc"),
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 3,
          showBackground: true,
          backgroundColor: new Cesium.Color(0.03, 0.11, 0.08, 0.9),
          backgroundPadding: new Cesium.Cartesian2(10, 6),
          pixelOffset: new Cesium.Cartesian2(0, -14),
          scale: 1.06,
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      });

      state.pathEntities.push(area.labelEntity);
      state.sprayFootprintAreaLabels.push(area);
    }
  }

  function applyOfficialSprayFlagsFromRuns(points) {
    if (!state.officialSprayFootprintAvailable || !Array.isArray(points) || !points.length) {
      return false;
    }

    const decisions = new Array(Math.max(0, points.length - 1));
    for (let i = 0; i < decisions.length; i++) {
      decisions[i] = { isSpraying: false, source: "none", inferredTiroName: null };
    }

    for (let i = 0; i < state.sprayFootprintRuns.length; i++) {
      const run = state.sprayFootprintRuns[i];
      if (!run || run.geometryType !== "official_polygon" || !Array.isArray(run.pairPointIndexes)) {
        continue;
      }

      for (let j = 1; j < run.pairPointIndexes.length; j++) {
        const start = Math.max(0, Math.min(run.pairPointIndexes[j - 1], run.pairPointIndexes[j]) - 1);
        const end = Math.min(decisions.length - 1, Math.max(run.pairPointIndexes[j - 1], run.pairPointIndexes[j]));
        for (let index = start; index <= end; index++) {
          decisions[index] = {
            isSpraying: true,
            source: "official_polygon",
            inferredTiroName: run.inferredTiroName
          };
        }
      }
    }

    state.segmentSprayDecisions = decisions;
    state.sprayFlags = derivePointSprayFlagsFromSegments(points, decisions);
    return true;
  }

  function buildSprayFootprintRuns(points, segmentDecisions) {
    state.sprayDefaultWidthMeters = resolveSprayDefaultWidthMeters(points);

    if (buildOfficialSprayFootprintRuns(points)) {
      applyOfficialSprayFlagsFromRuns(points);
      return;
    }

    state.sprayFootprintRuns = [];
    state.sprayFootprintAreaLabels = [];
    state.sprayFootprintLastIndex = -1;

    if (state.disableSprayFootprintRendering || points.length < 2) {
      return;
    }

    const decisions = Array.isArray(segmentDecisions) ? segmentDecisions : buildSegmentSprayDecisions(points);
    let currentRun = null;

    for (let i = 1; i < points.length; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      const segmentInfo = decisions[i - 1] || { isSpraying: false, source: "none", inferredTiroName: null };
      const isSpraying = !!segmentInfo.isSpraying;
      const inferredTiroName = segmentInfo.inferredTiroName || null;
      const inferredAreaName = segmentInfo.source === "inferred_polygon"
        ? (resolveInferredAreaNameForSegment(p0, p1) || null)
        : null;
      const inferredAreaKey = segmentInfo.source === "inferred_polygon"
        ? (resolveInferredAreaKeyForSegment(p0, p1) || null)
        : null;
      const inferredAreaCentroid = segmentInfo.source === "inferred_polygon"
        ? resolveInferredAreaCentroidForSegment(p0, p1)
        : null;

      if (!isSpraying) {
        currentRun = null;
        continue;
      }

      const widthMeters = resolveSprayWidthMetersForSegment(p0, p1, state.sprayDefaultWidthMeters);
      const qualityColor = resolveSprayFootprintColorForSegment(p0, p1);
      const runType = segmentInfo.source;
      const shouldStartNewRun = !currentRun
        || Math.abs(currentRun.widthMeters - widthMeters) > 0.25
        || currentRun.runType !== runType
        || currentRun.inferredTiroName !== inferredTiroName
        || currentRun.qualityColor !== qualityColor
        || currentRun.inferredAreaName !== inferredAreaName
        || currentRun.inferredAreaKey !== inferredAreaKey;

      if (shouldStartNewRun) {
        const firstSegDistMeters = computeSurfaceDistanceMeters(p0, p1);
        const firstSegAreaM2 = Math.max(0, (Number.isFinite(firstSegDistMeters) ? firstSegDistMeters : 0) * widthMeters);
        const run = {
          startIndex: i - 1,
          endIndex: i,
          widthMeters,
          runType,
          inferredTiroName,
          inferredAreaName,
          inferredAreaKey,
          qualityColor,
          positionsFull: [toGroundCartesian(p0), toGroundCartesian(p1)],
          lonSum: Number(p0.lon) + Number(p1.lon),
          latSum: Number(p0.lat) + Number(p1.lat),
          pointCount: 2,
          areaM2: firstSegAreaM2,
          cumulativeAreaM2ByPointOffset: [0, firstSegAreaM2],
          areaKey: "",
          areaCentroidLon: Number.isFinite(inferredAreaCentroid?.lon) ? inferredAreaCentroid.lon : null,
          areaCentroidLat: Number.isFinite(inferredAreaCentroid?.lat) ? inferredAreaCentroid.lat : null,
          lastAppliedEndIndex: i - 1,
          lastAppliedAreaM2: 0,
          entity: null
        };
        run.areaKey = resolveSprayAreaKeyFromRun(run);

        const corridorGraphics = {
          positions: run.positionsFull.slice(0, 2),
          width: widthMeters,
          material: makeSprayFootprintFillColor(qualityColor),
          outline: !state.sprayFootprintGpuSafeMode
        };
        if (!state.sprayFootprintGpuSafeMode) {
          corridorGraphics.outlineColor = makeSprayFootprintOutlineColor(qualityColor);
          corridorGraphics.classificationType = Cesium.ClassificationType.TERRAIN;
          corridorGraphics.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        }

        run.entity = state.viewer.entities.add({
          name: "Faixa aplicada",
          show: false,
          corridor: corridorGraphics
        });

        state.sprayFootprintRuns.push(run);
        state.pathEntities.push(run.entity);
        currentRun = run;
        continue;
      }

      const segDistMeters = computeSurfaceDistanceMeters(p0, p1);
      const segAreaM2 = Math.max(0, (Number.isFinite(segDistMeters) ? segDistMeters : 0) * currentRun.widthMeters);
      currentRun.endIndex = i;
      currentRun.positionsFull.push(toGroundCartesian(p1));
      currentRun.lonSum += Number(p1.lon);
      currentRun.latSum += Number(p1.lat);
      currentRun.pointCount += 1;
      currentRun.areaM2 += segAreaM2;
      const lastCumM2 = currentRun.cumulativeAreaM2ByPointOffset[currentRun.cumulativeAreaM2ByPointOffset.length - 1] || 0;
      currentRun.cumulativeAreaM2ByPointOffset.push(lastCumM2 + segAreaM2);
    }

    const areaMap = new Map();
    for (const run of state.sprayFootprintRuns) {
      if (!run?.positionsFull?.length || !Number.isFinite(run.pointCount) || run.pointCount <= 0 || !run.areaKey) {
        continue;
      }
      if (!areaMap.has(run.areaKey)) {
        areaMap.set(run.areaKey, {
          key: run.areaKey,
          lonSum: 0,
          latSum: 0,
          pointCount: 0,
          totalAreaM2: 0,
          originalAreaM2: null,
          totalGeometryM2: 0,
          centroidLon: null,
          centroidLat: null,
          hasPresetCentroid: false,
          labelEntity: null
        });
      }
      const area = areaMap.get(run.areaKey);
      if (!area.hasPresetCentroid
        && Number.isFinite(run.areaCentroidLon)
        && Number.isFinite(run.areaCentroidLat)) {
        area.centroidLon = run.areaCentroidLon;
        area.centroidLat = run.areaCentroidLat;
        area.hasPresetCentroid = true;
      }
      area.lonSum += run.lonSum;
      area.latSum += run.latSum;
      area.pointCount += run.pointCount;
      area.totalAreaM2 += Math.max(0, Number(run.areaM2 || 0));
      area.totalGeometryM2 += Math.max(0, Number(run.areaM2 || 0));
    }

    for (const area of areaMap.values()) {
      const hasPointCentroid = Number.isFinite(area.pointCount) && area.pointCount > 0;
      const hasPresetCentroid = Number.isFinite(area.centroidLon) && Number.isFinite(area.centroidLat);
      if (!hasPointCentroid && !hasPresetCentroid) {
        continue;
      }
      const centroidLon = hasPresetCentroid ? area.centroidLon : (area.lonSum / area.pointCount);
      const centroidLat = hasPresetCentroid ? area.centroidLat : (area.latSum / area.pointCount);
      area.labelEntity = state.viewer.entities.add({
        name: "Hectares da área aplicada",
        show: false,
        position: Cesium.Cartesian3.fromDegrees(centroidLon, centroidLat, 0),
        label: {
          text: "0.00 ha",
          font: 'bold 14px "Segoe UI", sans-serif',
          fillColor: Cesium.Color.fromCssColorString("#f8ffcc"),
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 3,
          showBackground: true,
          backgroundColor: new Cesium.Color(0.03, 0.11, 0.08, 0.9),
          backgroundPadding: new Cesium.Cartesian2(10, 6),
          pixelOffset: new Cesium.Cartesian2(0, -14),
          scale: 1.06,
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      });
      state.pathEntities.push(area.labelEntity);
      state.sprayFootprintAreaLabels.push(area);
    }
  }

  function resolveSprayAreaKeyFromRun(run) {
    if (!run) {
      return "area:__geral__";
    }
    if (run.runType === "inferred_polygon") {
      const areaKey = normalizeAreaKey(run.inferredAreaKey);
      return areaKey || "area:__inferred__";
    }
    return "area:__geral__";
  }

  function resolveInferredTiroNameForSegment(p0, p1) {
    const source0 = p0?.spraySource === "inferred_polygon";
    const source1 = p1?.spraySource === "inferred_polygon";
    if (!source0 && !source1) {
      return null;
    }

    return resolveTiroNameForSegment(p0, p1);
  }

  function resolveInferredAreaNameForSegment(p0, p1) {
    const source0 = p0?.spraySource === "inferred_polygon";
    const source1 = p1?.spraySource === "inferred_polygon";
    if (!source0 && !source1) {
      return null;
    }

    return resolveAreaNameForSegment(p0, p1);
  }

  function resolveInferredAreaKeyForSegment(p0, p1) {
    const source0 = p0?.spraySource === "inferred_polygon";
    const source1 = p1?.spraySource === "inferred_polygon";
    if (!source0 && !source1) {
      return null;
    }
    return resolveAreaKeyForSegment(p0, p1);
  }

  function resolveInferredAreaCentroidForSegment(p0, p1) {
    const source0 = p0?.spraySource === "inferred_polygon";
    const source1 = p1?.spraySource === "inferred_polygon";
    if (!source0 && !source1) {
      return null;
    }
    return resolveAreaCentroidForSegment(p0, p1);
  }

  function resolveSegmentSprayInfo(p0, p1) {
    const bothSpray = !!p0?.spray && !!p1?.spray;
    if (!bothSpray) {
      return {
        isSpraying: false,
        source: "none",
        inferredTiroName: null
      };
    }

    const isExplicitSegment = p0?.spraySource === "explicit_track" && p1?.spraySource === "explicit_track";
    if (isExplicitSegment) {
      return {
        isSpraying: true,
        source: "explicit_track",
        inferredTiroName: null
      };
    }

    const inferredTiroName = resolveInferredTiroNameForSegment(p0, p1);
    if (inferredTiroName) {
      return {
        isSpraying: true,
        source: "inferred_polygon",
        inferredTiroName
      };
    }

    return {
      isSpraying: false,
      source: "none",
      inferredTiroName: null
    };
  }

  function resolveTiroNameForSegment(p0, p1) {
    const tiro0 = normalizeTiroName(p0?.tiroName);
    const tiro1 = normalizeTiroName(p1?.tiroName);
    if (tiro0 && tiro1) {
      return tiro0 === tiro1 ? tiro0 : null;
    }
    return tiro0 || tiro1 || null;
  }

  function resolveAreaNameForSegment(p0, p1) {
    const area0 = normalizeAreaName(p0?.sprayAreaName);
    const area1 = normalizeAreaName(p1?.sprayAreaName);
    if (area0 && area1) {
      return area0 === area1 ? area0 : null;
    }
    return area0 || area1 || null;
  }

  function resolveAreaKeyForSegment(p0, p1) {
    const key0 = normalizeAreaKey(p0?.sprayAreaKey);
    const key1 = normalizeAreaKey(p1?.sprayAreaKey);
    if (key0 && key1) {
      return key0 === key1 ? key0 : null;
    }
    return key0 || key1 || null;
  }

  function resolveAreaCentroidForSegment(p0, p1) {
    const c0 = resolvePointAreaCentroid(p0);
    const c1 = resolvePointAreaCentroid(p1);
    if (!c0 && !c1) {
      return null;
    }
    const key0 = normalizeAreaKey(p0?.sprayAreaKey);
    const key1 = normalizeAreaKey(p1?.sprayAreaKey);
    if (c0 && c1 && key0 && key1 && key0 !== key1) {
      return null;
    }
    if (c0 && c1) {
      return { lon: (c0.lon + c1.lon) * 0.5, lat: (c0.lat + c1.lat) * 0.5 };
    }
    return c0 || c1;
  }

  function resolvePointAreaCentroid(point) {
    const lon = Number(point?.sprayAreaCentroidLon);
    const lat = Number(point?.sprayAreaCentroidLat);
    if (!Number.isFinite(lon) || !Number.isFinite(lat)) {
      return null;
    }
    return { lon, lat };
  }

  function normalizeTiroName(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeAreaName(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeAreaKey(value) {
    const key = String(value || "").trim().toLowerCase();
    return key || "";
  }

  function resetSprayDisplaySmoothing() {
    state.sprayDisplayActive = false;
    state.sprayDisplayOnStreak = 0;
    state.sprayDisplayOffStreak = 0;
    state.sprayDisplayLastIndex = -1;
  }

  function isOfficialSprayMistAllowedAtPointIndex(currentPointIndex) {
    if (!state.officialSprayFootprintAvailable || !Array.isArray(state.sprayFootprintRuns) || !state.sprayFootprintRuns.length) {
      return null;
    }

    const idx = clamp(Math.round(currentPointIndex), 0, Math.max(0, state.timelinePoints.length - 1));
    const point = state.timelinePoints[idx];
    if (!point) {
      return false;
    }

    for (let i = 0; i < state.sprayFootprintRuns.length; i++) {
      const run = state.sprayFootprintRuns[i];
      if (!run || run.geometryType !== "official_polygon" || !Array.isArray(run.pairPointIndexes)) {
        continue;
      }

      for (let pairIndex = 1; pairIndex < run.pairPointIndexes.length; pairIndex++) {
        const pointIndex = run.pairPointIndexes[pairIndex];
        if (Math.abs(pointIndex - idx) > 2) {
          continue;
        }

        const center = {
          lon: (run.leftPoints[pairIndex].lon + run.rightPoints[pairIndex].lon) / 2,
          lat: (run.leftPoints[pairIndex].lat + run.rightPoints[pairIndex].lat) / 2
        };
        const allowedDistance = Math.max(35, Number(run.widthMeters || state.sprayDefaultWidthMeters || 30) * 1.75);
        if (distanceMeters(point, center) <= allowedDistance) {
          return true;
        }
      }
    }

    return false;
  }

  function getSmoothedSprayDisplayState(currentPointIndex) {
    if (!Array.isArray(state.sprayFlags) || !state.sprayFlags.length) {
      resetSprayDisplaySmoothing();
      return false;
    }

    const idx = clamp(Math.round(currentPointIndex), 0, state.sprayFlags.length - 1);
    if (state.sprayDisplayLastIndex >= 0 && idx < state.sprayDisplayLastIndex) {
      resetSprayDisplaySmoothing();
    }

    const prevIndex = state.sprayDisplayLastIndex;
    const indexStep = prevIndex >= 0 ? Math.max(1, idx - prevIndex) : 1;
    const rawSpraying = !!state.sprayFlags[idx];
    const onConfirmPoints = 1;
    const offConfirmPoints = 2;

    if (rawSpraying) {
      state.sprayDisplayOnStreak += indexStep;
      state.sprayDisplayOffStreak = 0;
    } else {
      state.sprayDisplayOffStreak += indexStep;
      state.sprayDisplayOnStreak = 0;
    }

    if (state.sprayDisplayActive) {
      if (!rawSpraying && state.sprayDisplayOffStreak >= offConfirmPoints) {
        state.sprayDisplayActive = false;
      }
    } else if (rawSpraying && state.sprayDisplayOnStreak >= onConfirmPoints) {
      state.sprayDisplayActive = true;
    }

    state.sprayDisplayLastIndex = idx;
    return state.sprayDisplayActive;
  }

  function updateSprayFootprint(currentPointIndex) {
    if (!state.sprayFootprintRuns.length) {
      return;
    }
    if (currentPointIndex === state.sprayFootprintLastIndex) {
      return;
    }

    const areaAppliedM2ByKey = new Map();

    for (const run of state.sprayFootprintRuns) {
      if (currentPointIndex <= run.startIndex) {
        if (run.entity.show) {
          run.entity.show = false;
        }
        run.lastAppliedEndIndex = run.startIndex;
        run.lastAppliedAreaM2 = 0;
        continue;
      }

      if (run.geometryType === "official_polygon") {
        const revealPointIndex = Math.max(0, currentPointIndex - 1);
        let pairCount = 0;
        for (let pairIndex = 0; pairIndex < run.pairPointIndexes.length; pairIndex++) {
          if (run.pairPointIndexes[pairIndex] <= revealPointIndex) {
            pairCount = pairIndex + 1;
          } else {
            break;
          }
        }

        const isVisible = pairCount >= 2;
        const useQualitySegments = !!state.sprayQualityEnabled && Array.isArray(run.qualitySegments) && run.qualitySegments.length > 0;
        run.entity.show = isVisible && !useQualitySegments;

        if (Array.isArray(run.qualitySegments)) {
          for (let segmentIndex = 0; segmentIndex < run.qualitySegments.length; segmentIndex++) {
            const segment = run.qualitySegments[segmentIndex];
            if (!segment || !segment.entity) {
              continue;
            }

            const visibleEndPairIndex = Math.min(segment.endPairIndex, pairCount - 1);
            const segmentVisible = isVisible && useQualitySegments && visibleEndPairIndex > segment.startPairIndex;
            segment.entity.show = segmentVisible;

            if (segmentVisible && segment.lastVisibleEndPairIndex !== visibleEndPairIndex) {
              const positions = buildOfficialSprayPolygonPositionsRange(run.leftPoints, run.rightPoints, segment.startPairIndex, visibleEndPairIndex);
              if (positions.length >= 3) {
                segment.entity.polygon.hierarchy = new Cesium.PolygonHierarchy(positions);
              }
              segment.lastVisibleEndPairIndex = visibleEndPairIndex;
            }
          }
        }

        if (!isVisible) {
          run.lastAppliedEndIndex = run.startIndex;
          run.lastAppliedAreaM2 = 0;
          continue;
        }

        if (!useQualitySegments && pairCount !== run.lastAppliedEndIndex) {
          const positions = buildOfficialSprayPolygonPositions(run.leftPoints, run.rightPoints, pairCount);
          if (positions.length >= 3) {
            run.entity.polygon.hierarchy = new Cesium.PolygonHierarchy(positions);
          }
        }

        run.lastAppliedEndIndex = pairCount;
        run.lastAppliedAreaM2 = Math.max(0, pairCount * run.widthMeters * 8);
        if (run.areaKey) {
          const currentAreaM2 = areaAppliedM2ByKey.get(run.areaKey) || 0;
          areaAppliedM2ByKey.set(run.areaKey, currentAreaM2 + run.lastAppliedAreaM2);
        }
        continue;
      }

      if (run.geometryType === "official_quality_line") {
        if (hasOfficialPolygonSprayFootprintRuns()) {
          run.entity.show = false;
          run.lastAppliedEndIndex = run.startIndex;
          run.lastAppliedAreaM2 = 0;
          continue;
        }

        const activeQualityParameter = state.sprayQualityParameter || "aplicacao";
        const isActive = !!state.sprayQualityEnabled && activeQualityParameter === run.qualityParameter;
        if (!isActive || currentPointIndex <= run.startIndex) {
          run.entity.show = false;
          run.lastAppliedEndIndex = run.startIndex;
          run.lastAppliedAreaM2 = 0;
          continue;
        }

        const revealPointIndex = Math.max(0, currentPointIndex - 1);
        let visibleCount = 0;
        for (let pointIndex = 0; pointIndex < run.pointIndexes.length; pointIndex++) {
          if (run.pointIndexes[pointIndex] <= revealPointIndex) {
            visibleCount = pointIndex + 1;
          } else {
            break;
          }
        }

        if (visibleCount < 2) {
          run.entity.show = false;
          run.lastAppliedEndIndex = run.startIndex;
          run.lastAppliedAreaM2 = 0;
          continue;
        }

        run.entity.show = true;
        if (run.entity.corridor) {
          run.entity.corridor.positions = run.positionsFull.slice(0, visibleCount);
          run.entity.corridor.material = makeSprayFootprintFillColor(run.qualityColor);
          if (run.entity.corridor.outlineColor) {
            run.entity.corridor.outlineColor = makeSprayFootprintOutlineColor(run.qualityColor);
          }
        }
        run.lastAppliedEndIndex = visibleCount;
        run.lastAppliedAreaM2 = Math.max(0, visibleCount * run.widthMeters * 8);
        continue;
      }

      const localEndIndex = Math.min(currentPointIndex, run.endIndex);
      const isVisible = localEndIndex > run.startIndex;
      run.entity.show = isVisible;

      if (!isVisible) {
        run.lastAppliedEndIndex = run.startIndex;
        run.lastAppliedAreaM2 = 0;
        continue;
      }

      const appliedSegments = clamp(
        localEndIndex - run.startIndex,
        0,
        Math.max(0, (run.cumulativeAreaM2ByPointOffset?.length || 1) - 1)
      );
      const appliedAreaM2 = Number(run.cumulativeAreaM2ByPointOffset?.[appliedSegments] || 0);
      run.lastAppliedAreaM2 = Math.max(0, appliedAreaM2);
      if (run.lastAppliedAreaM2 > 0 && run.areaKey) {
        const currentAreaM2 = areaAppliedM2ByKey.get(run.areaKey) || 0;
        areaAppliedM2ByKey.set(run.areaKey, currentAreaM2 + run.lastAppliedAreaM2);
      }

      if (localEndIndex === run.lastAppliedEndIndex) {
        continue;
      }

      const pointCount = Math.max(2, localEndIndex - run.startIndex + 1);
      run.entity.corridor.positions = run.positionsFull.slice(0, pointCount);
      run.lastAppliedEndIndex = localEndIndex;
    }

    const telemetryAreaM2 = Math.max(0, Number(state.telemetryCumulativeAreaM2[currentPointIndex] || 0));
    const areaScaleFactor = getTelemetryAreaScaleFactor();
    const scaledTelemetryAreaM2 = telemetryAreaM2 * areaScaleFactor;
    const hasSingleAreaLabel = state.sprayFootprintAreaLabels.length === 1;
    const useTelemetryAreaForSingleLabel = hasSingleAreaLabel && Number.isFinite(telemetryAreaM2);
    const hectareUnit = getReplay3DText("HA");

    for (const area of state.sprayFootprintAreaLabels) {
      if (!area?.labelEntity?.label) {
        continue;
      }

      const rawAppliedAreaM2 = useTelemetryAreaForSingleLabel
        ? telemetryAreaM2
        : Math.max(0, Number(areaAppliedM2ByKey.get(area.key) || 0));
      let appliedAreaM2 = useTelemetryAreaForSingleLabel
        ? scaledTelemetryAreaM2
        : rawAppliedAreaM2 * areaScaleFactor;

      if (
        !useTelemetryAreaForSingleLabel &&
        Number.isFinite(area.originalAreaM2) &&
        area.originalAreaM2 > 0 &&
        Number.isFinite(area.totalGeometryM2) &&
        area.totalGeometryM2 > 0
      ) {
        const areaProgress = clamp(rawAppliedAreaM2 / area.totalGeometryM2, 0, 1);
        appliedAreaM2 = area.originalAreaM2 * areaProgress;
      }

      const hectares = appliedAreaM2 / 10000;
      area.labelEntity.show = hectares > 0;
      area.labelEntity.label.text = `${hectares.toFixed(2)} ${hectareUnit}`;
    }

    state.sprayFootprintLastIndex = currentPointIndex;
  }


  function resolveSprayFootprintColorForSegment(p0, p1) {
    if (!state.sprayQualityEnabled) {
      return state.sprayFootprintStyle.color;
    }

    const parameter = state.sprayQualityParameter || "aplicacao";
    if (parameter === "aplicacao") {
      return resolveApplicationQualityColor(p0, p1);
    }

    const value = resolveSegmentQualityValue(p0, p1, parameter);
    return resolveQualityColorByParameter(parameter, value);
  }

  function resolveApplicationQualityColor(p0, p1) {
    const type = resolveSegmentApplicationType(p0, p1);
    if (type === "over") return "#467580";
    if (type === "out") return "#ffd500";
    return "#32a852";
  }

  function resolveSegmentApplicationType(p0, p1) {
    const type0 = p0 && p0.applicationType ? p0.applicationType : "";
    const type1 = p1 && p1.applicationType ? p1.applicationType : "";
    if (type0 === "out" || type1 === "out") return "out";
    if (type0 === "over" || type1 === "over") return "over";
    return "app";
  }

  function resolveSegmentQualityValue(p0, p1, parameter) {
    const v0 = p0 && p0.qualityValues ? Number(p0.qualityValues[parameter]) : null;
    const v1 = p1 && p1.qualityValues ? Number(p1.qualityValues[parameter]) : null;
    if (Number.isFinite(v0) && Number.isFinite(v1)) return (v0 + v1) / 2;
    if (Number.isFinite(v1)) return v1;
    if (Number.isFinite(v0)) return v0;
    return null;
  }

  function resolveQualityColorByParameter(parameter, value) {
    if (!Number.isFinite(value)) {
      return state.sprayFootprintStyle.color;
    }

    if (parameter === "direcaoVento") {
      return resolveWindDirectionQualityColor(value);
    }

    const limits = resolveQualityLimits(parameter);
    if (!limits) {
      return state.sprayFootprintStyle.color;
    }

    if (value >= limits.minT && value <= limits.maxT) return "#5db445";
    if (value >= limits.min && value < limits.minT) return "#f1da0f";
    if (value > limits.maxT && value <= limits.max) return "#6dbfbf";
    if (value < limits.min) return "#e74c3c";
    if (value > limits.max) return "#a536f5";
    return state.sprayFootprintStyle.color;
  }

  function resolveWindDirectionQualityColor(value) {
    const absValue = Math.abs(Number(value));
    if (!Number.isFinite(absValue)) return state.sprayFootprintStyle.color;
    if (absValue <= 50) return "#5db445";
    if (absValue <= 70) return "#f1da0f";
    if (absValue <= 110) return "#6dbfbf";
    if (absValue <= 140) return "#e74c3c";
    return "#a536f5";
  }

  function resolveQualityLimits(parameter) {
    const cfg = state.sprayQualityConfig && state.sprayQualityConfig[parameter] ? state.sprayQualityConfig[parameter] : null;
    if (!cfg) return null;
    const setValue = Number(cfg.setValue);
    const marginDown = Number(cfg.marginDown);
    const marginUp = Number(cfg.marginUp);
    const limitDown = Number(cfg.limitDown);
    const limitUp = Number(cfg.limitUp);
    if (!Number.isFinite(setValue) || !Number.isFinite(marginDown) || !Number.isFinite(marginUp) || !Number.isFinite(limitDown) || !Number.isFinite(limitUp)) {
      return null;
    }
    return {
      min: setValue - marginDown - limitDown,
      minT: setValue - marginDown,
      maxT: setValue + marginUp,
      max: setValue + marginUp + limitUp
    };
  }

  function applySprayFootprintStyleToAllRuns() {
    if (!state.sprayFootprintRuns.length) {
      return;
    }

    for (const run of state.sprayFootprintRuns) {
      if (run?.entity?.polygon) {
        run.entity.polygon.material = makeSprayFootprintFillColor(run.qualityColor);
        run.entity.polygon.outlineColor = makeSprayFootprintOutlineColor(run.qualityColor);
      } else if (run?.entity?.corridor) {
        run.entity.corridor.material = makeSprayFootprintFillColor(run.qualityColor);
        run.entity.corridor.outlineColor = makeSprayFootprintOutlineColor(run.qualityColor);
      }

      if (Array.isArray(run?.qualitySegments)) {
        for (let i = 0; i < run.qualitySegments.length; i++) {
          const segment = run.qualitySegments[i];
          if (segment?.entity?.polygon) {
            segment.entity.polygon.material = makeSprayFootprintFillColor(segment.color);
            segment.entity.polygon.outlineColor = makeSprayFootprintOutlineColor(segment.color);
          }
        }
      }
    }
  }

  function makeSprayFootprintFillColor(color) {
    const baseColor = color || state.sprayFootprintStyle.color;
    return Cesium.Color.fromCssColorString(baseColor)
      .withAlpha(clamp(state.sprayFootprintStyle.opacity, 0, 1));
  }

  function makeSprayFootprintOutlineColor(color) {
    const outlineOpacity = clamp(state.sprayFootprintStyle.opacity + 0.25, 0.15, 1);
    const baseColor = color || state.sprayFootprintStyle.color;
    return Cesium.Color.fromCssColorString(baseColor)
      .withAlpha(outlineOpacity);
  }

  function resolveSprayMistConfig() {
    const lineCountRaw = Number(state.appConfig.sprayMistLineCount ?? defaultAppConfig.sprayMistLineCount);
    const whitenessRaw = Number(state.appConfig.sprayMistWhiteness ?? defaultAppConfig.sprayMistWhiteness);
    const turbulenceRaw = Number(
      state.appConfig.sprayMistTurbulenceMeters ?? defaultAppConfig.sprayMistTurbulenceMeters
    );
    const verticalTurbulenceRaw = Number(
      state.appConfig.sprayMistVerticalTurbulenceMeters ?? defaultAppConfig.sprayMistVerticalTurbulenceMeters
    );
    const turbulenceFreqRaw = Number(
      state.appConfig.sprayMistTurbulenceFrequency ?? defaultAppConfig.sprayMistTurbulenceFrequency
    );
    const laneBackSpreadRaw = Number(
      state.appConfig.sprayMistLaneBackSpreadMeters ?? defaultAppConfig.sprayMistLaneBackSpreadMeters
    );
    const maxTrailPointsRaw = Number(state.appConfig.sprayMistMaxTrailPoints ?? defaultAppConfig.sprayMistMaxTrailPoints);
    const spacingRaw = Number(state.appConfig.sprayMistTrailSpacingMeters ?? defaultAppConfig.sprayMistTrailSpacingMeters);
    const activeModel = findAircraftById(state.activeAircraftId) || findAircraftByUrl(UI.modelUrl.value);
    const backOffsetRaw = Number(
      activeModel?.sprayMistBackOffsetMeters
      ?? state.appConfig.sprayMistBackOffsetMeters
      ?? defaultAppConfig.sprayMistBackOffsetMeters
    );
    const verticalOffsetRaw = Number(
      activeModel?.sprayMistVerticalOffsetMeters
      ?? state.appConfig.sprayMistVerticalOffsetMeters
      ?? defaultAppConfig.sprayMistVerticalOffsetMeters
    );
    const widthFactorRaw = Number(state.appConfig.sprayMistWidthFactor ?? defaultAppConfig.sprayMistWidthFactor);
    const opacityRaw = Number(state.appConfig.sprayMistOpacity ?? defaultAppConfig.sprayMistOpacity);
    const glowPowerRaw = Number(state.appConfig.sprayMistGlowPower ?? defaultAppConfig.sprayMistGlowPower);
    const fadeRaw = Number(state.appConfig.sprayMistFadeOutSeconds ?? defaultAppConfig.sprayMistFadeOutSeconds);
    const lineWidthFactorRaw = Number(
      state.appConfig.sprayMistLineWidthFactor ?? defaultAppConfig.sprayMistLineWidthFactor
    );
    const minLinePxRaw = Number(state.appConfig.sprayMistMinLineWidthPx ?? defaultAppConfig.sprayMistMinLineWidthPx);
    const maxLinePxRaw = Number(state.appConfig.sprayMistMaxLineWidthPx ?? defaultAppConfig.sprayMistMaxLineWidthPx);

    const minLineWidthPx = clamp(Number.isFinite(minLinePxRaw) ? minLinePxRaw : 1.8, 1, 24);
    const maxLineWidthPx = clamp(
      Number.isFinite(maxLinePxRaw) ? Math.max(minLineWidthPx, maxLinePxRaw) : 6,
      minLineWidthPx,
      40
    );

    return {
      enabled: state.appConfig.enableSprayMist !== false,
      lineCount: clamp(Math.round(Number.isFinite(lineCountRaw) ? lineCountRaw : 8), 1, 12),
      whiteness: clamp(Number.isFinite(whitenessRaw) ? whitenessRaw : 0.62, 0, 0.95),
      turbulenceMeters: clamp(Number.isFinite(turbulenceRaw) ? turbulenceRaw : 0.95, 0, 4),
      verticalTurbulenceMeters: clamp(Number.isFinite(verticalTurbulenceRaw) ? verticalTurbulenceRaw : 0.36, 0, 2),
      turbulenceFrequency: clamp(Number.isFinite(turbulenceFreqRaw) ? turbulenceFreqRaw : 1.35, 0.2, 6),
      laneBackSpreadMeters: clamp(Number.isFinite(laneBackSpreadRaw) ? laneBackSpreadRaw : 1.45, 0, 8),
      maxTrailPoints: clamp(Math.round(Number.isFinite(maxTrailPointsRaw) ? maxTrailPointsRaw : 42), 8, 220),
      trailSpacingMeters: clamp(Number.isFinite(spacingRaw) ? spacingRaw : 4.8, 0.8, 25),
      backOffsetMeters: clamp(Number.isFinite(backOffsetRaw) ? backOffsetRaw : 4.5, 0, 30),
      verticalOffsetMeters: clamp(Number.isFinite(verticalOffsetRaw) ? verticalOffsetRaw : -1.4, -30, 30),
      widthFactor: clamp(Number.isFinite(widthFactorRaw) ? widthFactorRaw : 1, 0.2, 3),
      opacity: clamp(Number.isFinite(opacityRaw) ? opacityRaw : 0.72, 0.05, 1),
      glowPower: clamp(Number.isFinite(glowPowerRaw) ? glowPowerRaw : 0.55, 0, 0.95),
      fadeOutSeconds: clamp(Number.isFinite(fadeRaw) ? fadeRaw : 1.1, 0, 6),
      lineWidthFactor: clamp(Number.isFinite(lineWidthFactorRaw) ? lineWidthFactorRaw : 0.14, 0.02, 1.2),
      minLineWidthPx,
      maxLineWidthPx
    };
  }

  function resolveSprayMistColor() {
    const configured = String(state.appConfig.sprayMistColor || "").trim();
    const fallback = state.sprayFootprintStyle.color || defaultAppConfig.sprayFootprintColor;
    return normalizeHexColor(configured || fallback, fallback);
  }

  function makeSprayMistLineColor(alphaScale = 1) {
    const cfg = resolveSprayMistConfig();
    const base = Cesium.Color.fromCssColorString(resolveSprayMistColor());
    const mistTone = Cesium.Color.lerp(base, Cesium.Color.WHITE, cfg.whiteness, new Cesium.Color());
    return mistTone.withAlpha(clamp(cfg.opacity * alphaScale, 0, 1));
  }

  function buildSprayMistLaneMeta(lineCount) {
    const lanes = [];
    for (let i = 0; i < lineCount; i++) {
      const t = lineCount <= 1 ? 0.5 : i / (lineCount - 1);
      const normalized = (t * 2) - 1;
      const centerWeight = 1 - Math.abs(normalized);
      const jitter = lineCount <= 2 ? 0 : ((i % 2 === 0 ? -1 : 1) * 0.02);
      let lateralFactor = clamp((normalized * 0.92) + jitter, -0.96, 0.96);
      if (lineCount > 1 && i === 0) {
        lateralFactor = -1;
      } else if (lineCount > 1 && i === lineCount - 1) {
        lateralFactor = 1;
      }
      lanes.push({
        lateralFactor,
        centerWeight,
        alphaScale: clamp(0.4 + (centerWeight * 0.5), 0.25, 1),
        widthScale: clamp(0.5 + (centerWeight * 0.55), 0.45, 1.1),
        glowScale: clamp(0.82 + (centerWeight * 0.35), 0.7, 1.25),
        phase: (i + 1) * 1.71
      });
    }
    return lanes;
  }

  function resetSprayMistTrails() {
    if (!Array.isArray(state.sprayMistTrails) || !state.sprayMistTrails.length) {
      state.sprayMistTrails = [];
    } else {
      state.sprayMistTrails = state.sprayMistTrails.map(() => []);
    }
    state.sprayMistLastNearestIndex = -1;
    state.sprayMistLastSpraySec = null;
  }

  function setSprayMistVisibility(visible) {
    if (!Array.isArray(state.sprayMistEntities)) {
      return;
    }
    for (const lane of state.sprayMistEntities) {
      if (lane?.core?.polyline) {
        lane.core.show = !!visible;
      }
      if (lane?.haze?.polyline) {
        lane.haze.show = !!visible;
      }
    }
  }

  function clearSprayMistEntities() {
    if (Array.isArray(state.sprayMistEntities)) {
      for (const lane of state.sprayMistEntities) {
        if (lane?.core) {
          state.viewer?.entities.remove(lane.core);
        }
        if (lane?.haze) {
          state.viewer?.entities.remove(lane.haze);
        }
      }
    }
    state.sprayMistEntities = [];
    state.sprayMistLaneMeta = [];
    state.sprayMistMaterials = [];
    state.sprayMistStyleSignature = "";
    resetSprayMistTrails();
  }

  function createSprayMistEntities() {
    clearSprayMistEntities();
    const cfg = resolveSprayMistConfig();
    if (!cfg.enabled || !state.viewer) {
      return;
    }

    state.sprayMistLaneMeta = buildSprayMistLaneMeta(cfg.lineCount);
    state.sprayMistTrails = state.sprayMistLaneMeta.map(() => []);
    state.sprayMistMaterials = state.sprayMistLaneMeta.map(() => null);

    const trailCallback = (laneIndex) => new Cesium.CallbackProperty(() => {
      const arr = state.sprayMistTrails[laneIndex];
      return arr.length >= 2 ? arr : [];
    }, false);

    state.sprayMistCurrentLineWidthPx = clamp(
      Number(state.sprayMistCurrentLineWidthPx || cfg.minLineWidthPx),
      cfg.minLineWidthPx,
      cfg.maxLineWidthPx
    );

    const basePolyline = {
      arcType: Cesium.ArcType.NONE,
      clampToGround: false,
      followSurface: false,
      shadows: Cesium.ShadowMode.DISABLED
    };

    state.sprayMistEntities = state.sprayMistLaneMeta.map((_, laneIndex) => {
      const haze = state.viewer.entities.add({
        name: `Névoa pulverização difusa (${laneIndex + 1})`,
        show: false,
        polyline: {
          ...basePolyline,
          positions: trailCallback(laneIndex),
          width: state.sprayMistCurrentLineWidthPx
        }
      });
      const core = state.viewer.entities.add({
        name: `Névoa pulverização núcleo (${laneIndex + 1})`,
        show: false,
        polyline: {
          ...basePolyline,
          positions: trailCallback(laneIndex),
          width: state.sprayMistCurrentLineWidthPx
        }
      });
      return { core, haze };
    });

    applySprayMistStyleToAllEntities(true);
  }

  function buildSprayMistStyleSignature(cfg) {
    return [
      resolveSprayMistColor(),
      cfg.opacity.toFixed(3),
      cfg.glowPower.toFixed(3),
      cfg.whiteness.toFixed(3),
      String(cfg.lineCount)
    ].join("|");
  }

  function applySprayMistLineWidths(widthPx, cfg) {
    if (!Array.isArray(state.sprayMistEntities) || !state.sprayMistEntities.length) {
      return;
    }

    const baseWidth = clamp(widthPx, cfg.minLineWidthPx, cfg.maxLineWidthPx);
    for (let i = 0; i < state.sprayMistEntities.length; i++) {
      const corePolyline = state.sprayMistEntities[i]?.core?.polyline;
      const hazePolyline = state.sprayMistEntities[i]?.haze?.polyline;
      const laneMeta = state.sprayMistLaneMeta[i];
      if (!corePolyline || !hazePolyline || !laneMeta) {
        continue;
      }
      const laneWidth = clamp(baseWidth * laneMeta.widthScale, Math.max(0.8, cfg.minLineWidthPx * 0.8), cfg.maxLineWidthPx);
      const coreWidth = clamp(laneWidth * 0.62, 0.8, cfg.maxLineWidthPx * 1.1);
      const hazeWidth = clamp(laneWidth * 1.95, coreWidth + 0.4, cfg.maxLineWidthPx * 2.6);

      if (Math.abs(Number(corePolyline.width || 0) - coreWidth) > 0.05) {
        corePolyline.width = coreWidth;
      }
      if (Math.abs(Number(hazePolyline.width || 0) - hazeWidth) > 0.05) {
        hazePolyline.width = hazeWidth;
      }
    }
  }

  function applySprayMistStyleToAllEntities(force = false) {
    const cfg = resolveSprayMistConfig();
    if (!Array.isArray(state.sprayMistEntities) || !state.sprayMistEntities.length) {
      return;
    }

    if (!cfg.enabled) {
      setSprayMistVisibility(false);
      return;
    }

    const widthPx = clamp(state.sprayMistCurrentLineWidthPx, cfg.minLineWidthPx, cfg.maxLineWidthPx);
    const styleSignature = buildSprayMistStyleSignature(cfg);
    const needsMaterialRefresh = force
      || !Array.isArray(state.sprayMistMaterials)
      || state.sprayMistMaterials.length !== state.sprayMistEntities.length
      || state.sprayMistMaterials.some((m) => !m?.core || !m?.haze)
      || state.sprayMistStyleSignature !== styleSignature;

    if (needsMaterialRefresh) {
      state.sprayMistMaterials = state.sprayMistLaneMeta.map((laneMeta, i) => {
        const coreMaterial = new Cesium.PolylineGlowMaterialProperty({
          color: makeSprayMistLineColor(clamp(laneMeta.alphaScale * 0.72, 0.08, 1)),
          glowPower: clamp(cfg.glowPower * laneMeta.glowScale * 0.56, 0, 0.95),
          taperPower: 0.66
        });
        const hazeMaterial = new Cesium.PolylineGlowMaterialProperty({
          color: makeSprayMistLineColor(clamp(laneMeta.alphaScale * 0.42, 0.06, 1)),
          glowPower: clamp(cfg.glowPower * laneMeta.glowScale * 0.9, 0, 0.95),
          taperPower: 0.88
        });

        const corePolyline = state.sprayMistEntities[i]?.core?.polyline;
        if (corePolyline) {
          corePolyline.material = coreMaterial;
          corePolyline.depthFailMaterial = coreMaterial;
        }
        const hazePolyline = state.sprayMistEntities[i]?.haze?.polyline;
        if (hazePolyline) {
          hazePolyline.material = hazeMaterial;
          hazePolyline.depthFailMaterial = hazeMaterial;
        }
        return {
          core: coreMaterial,
          haze: hazeMaterial
        };
      });
      state.sprayMistStyleSignature = styleSignature;
    }

    applySprayMistLineWidths(widthPx, cfg);
  }

  function resolveSprayWidthMetersAtPointIndex(index) {
    if (!Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      return clamp(Number(state.sprayDefaultWidthMeters) || 30, 2, 200);
    }

    const i = clamp(Math.round(index), 0, state.timelinePoints.length - 1);
    const p = state.timelinePoints[i];
    if (Number.isFinite(p?.sprayWidthMeters) && p.sprayWidthMeters > 0) {
      return clamp(Number(p.sprayWidthMeters), 2, 200);
    }

    if (i > 0) {
      return resolveSprayWidthMetersForSegment(
        state.timelinePoints[i - 1],
        state.timelinePoints[i],
        state.sprayDefaultWidthMeters
      );
    }
    return clamp(Number(state.sprayDefaultWidthMeters) || 30, 2, 200);
  }

  function computeSprayMistSample(currentPointIndex, cfg) {
    const time = state.viewer?.clock?.currentTime;
    const sprayReferencePosition = state.flightEntity?.position || state.aircraftMarker?.position;
    if (!time || !sprayReferencePosition) {
      return null;
    }

    const position = sprayReferencePosition.getValue(time, scratchMistPosition);
    if (!position) {
      return null;
    }

    const headingRadRaw = Number(state.flightHeadingProperty?.getValue(time));
    const fallbackIndex = clamp(Math.round(currentPointIndex), 0, Math.max(0, state.timelinePoints.length - 2));
    const fallbackHeadingDeg = state.timelinePoints.length >= 2
      ? computeTrackHeadingDeg(state.timelinePoints[fallbackIndex], state.timelinePoints[fallbackIndex + 1])
      : 0;
    const headingRad = Number.isFinite(headingRadRaw) ? headingRadRaw : Cesium.Math.toRadians(fallbackHeadingDeg);

    Cesium.Transforms.eastNorthUpToFixedFrame(position, undefined, scratchMistEnuMatrix4);
    Cesium.Matrix4.getMatrix3(scratchMistEnuMatrix4, scratchMistEnuMatrix3);
    Cesium.Matrix3.getColumn(scratchMistEnuMatrix3, 0, scratchMistEast);
    Cesium.Matrix3.getColumn(scratchMistEnuMatrix3, 1, scratchMistNorth);
    Cesium.Matrix3.getColumn(scratchMistEnuMatrix3, 2, scratchMistUp);

    Cesium.Cartesian3.multiplyByScalar(scratchMistNorth, Math.cos(headingRad), scratchMistScaledNorth);
    Cesium.Cartesian3.multiplyByScalar(scratchMistEast, Math.sin(headingRad), scratchMistScaledEast);
    Cesium.Cartesian3.add(scratchMistScaledNorth, scratchMistScaledEast, scratchMistForward);
    if (Cesium.Cartesian3.magnitude(scratchMistForward) < 1e-6) {
      return null;
    }
    Cesium.Cartesian3.normalize(scratchMistForward, scratchMistForward);

    Cesium.Cartesian3.multiplyByScalar(scratchMistEast, Math.cos(headingRad), scratchMistScaledEast);
    Cesium.Cartesian3.multiplyByScalar(scratchMistNorth, -Math.sin(headingRad), scratchMistScaledNorth);
    Cesium.Cartesian3.add(scratchMistScaledEast, scratchMistScaledNorth, scratchMistRight);
    if (Cesium.Cartesian3.magnitude(scratchMistRight) < 1e-6) {
      return null;
    }
    Cesium.Cartesian3.normalize(scratchMistRight, scratchMistRight);

    const sprayWidthMeters = resolveSprayWidthMetersAtPointIndex(currentPointIndex);
    const lateralHalfWidthMeters = Math.max(0.7, sprayWidthMeters * 0.5);
    const maxLateralMeters = lateralHalfWidthMeters * 0.99;
    const lineWidthPx = clamp(
      sprayWidthMeters * cfg.lineWidthFactor,
      cfg.minLineWidthPx,
      cfg.maxLineWidthPx
    );

    Cesium.Cartesian3.multiplyByScalar(scratchMistForward, -cfg.backOffsetMeters, scratchMistOffset);
    Cesium.Cartesian3.add(position, scratchMistOffset, scratchMistCenter);
    Cesium.Cartesian3.multiplyByScalar(scratchMistUp, cfg.verticalOffsetMeters, scratchMistOffset);
    Cesium.Cartesian3.add(scratchMistCenter, scratchMistOffset, scratchMistCenter);

    const points = new Array(state.sprayMistLaneMeta.length);
    const turbulenceBase = currentPointIndex * cfg.turbulenceFrequency;
    for (let i = 0; i < state.sprayMistLaneMeta.length; i++) {
      const laneMeta = state.sprayMistLaneMeta[i];
      const phase = turbulenceBase + laneMeta.phase;
      const lateralWave = Math.sin(phase) + (Math.sin((phase * 0.61) + 1.4) * 0.45);
      const turbulenceStrength = cfg.turbulenceMeters * (0.35 + ((1 - laneMeta.centerWeight) * 0.85));
      const turbulentOffsetMeters = lateralWave * turbulenceStrength;
      const baseLaneOffsetMeters = lateralHalfWidthMeters * laneMeta.lateralFactor;
      const laneOffsetMeters = clamp(baseLaneOffsetMeters + turbulentOffsetMeters, -maxLateralMeters, maxLateralMeters);

      Cesium.Cartesian3.multiplyByScalar(scratchMistRight, laneOffsetMeters, scratchMistOffset);
      Cesium.Cartesian3.add(scratchMistCenter, scratchMistOffset, scratchMistRightPos);

      if (cfg.laneBackSpreadMeters > 0) {
        const backSpreadMeters = cfg.laneBackSpreadMeters
          * (0.35 + ((1 - laneMeta.centerWeight) * 0.75))
          * (0.6 + (0.4 * Math.abs(Math.sin((phase * 0.37) + 0.3))));
        Cesium.Cartesian3.multiplyByScalar(scratchMistForward, -backSpreadMeters, scratchMistOffset);
        Cesium.Cartesian3.add(scratchMistRightPos, scratchMistOffset, scratchMistRightPos);
      }

      if (cfg.verticalTurbulenceMeters > 0) {
        const verticalWave = Math.cos((phase * 0.83) + 0.6) + (Math.cos((phase * 1.29) + 1.9) * 0.22);
        const verticalOffsetMeters = verticalWave
          * cfg.verticalTurbulenceMeters
          * (0.35 + (laneMeta.alphaScale * 0.65));
        Cesium.Cartesian3.multiplyByScalar(scratchMistUp, verticalOffsetMeters, scratchMistOffset);
        Cesium.Cartesian3.add(scratchMistRightPos, scratchMistOffset, scratchMistRightPos);
      }

      points[i] = Cesium.Cartesian3.clone(scratchMistRightPos);
    }

    return {
      center: Cesium.Cartesian3.clone(scratchMistCenter),
      points,
      lineWidthPx
    };
  }

  function trimSprayMistTrails(maxTrailPoints, popOnlyTail = false, popFromStart = false) {
    if (!Array.isArray(state.sprayMistTrails)) {
      return;
    }
    for (const trail of state.sprayMistTrails) {
      if (!Array.isArray(trail) || !trail.length) {
        continue;
      }
      if (popOnlyTail) {
        if (popFromStart) {
          trail.shift();
        } else {
          trail.pop();
        }
        continue;
      }
      while (trail.length > maxTrailPoints) {
        trail.shift();
      }
    }
  }

  function updateSprayMist(currentPointIndex, currentSec, sprayingOverride) {
    const cfg = resolveSprayMistConfig();
    if (!cfg.enabled || !Array.isArray(state.sprayMistEntities) || !state.sprayMistEntities.length) {
      return;
    }
    if (!Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      setSprayMistVisibility(false);
      return;
    }

    const idx = clamp(Math.round(currentPointIndex), 0, state.timelinePoints.length - 1);
    if (state.sprayMistLastNearestIndex >= 0 && idx < state.sprayMistLastNearestIndex) {
      resetSprayMistTrails();
    }
    state.sprayMistLastNearestIndex = idx;

    const spraying = typeof sprayingOverride === "boolean"
      ? sprayingOverride
      : getSmoothedSprayDisplayState(idx);
    if (!spraying) {
      const referenceTrail = state.sprayMistTrails[Math.floor(state.sprayMistTrails.length / 2)] || state.sprayMistTrails[0] || [];
      const fading = Number.isFinite(state.sprayMistLastSpraySec)
        && (currentSec - state.sprayMistLastSpraySec) <= cfg.fadeOutSeconds;
      if (fading && referenceTrail.length > 1) {
        trimSprayMistTrails(cfg.maxTrailPoints, true, true);
        setSprayMistVisibility(referenceTrail.length > 1);
        return;
      }
      resetSprayMistTrails();
      setSprayMistVisibility(false);
      return;
    }

    const sample = computeSprayMistSample(idx, cfg);
    if (!sample) {
      setSprayMistVisibility(false);
      return;
    }

    state.sprayMistLastSpraySec = currentSec;
    state.sprayMistCurrentLineWidthPx = sample.lineWidthPx;
    applySprayMistLineWidths(sample.lineWidthPx, cfg);

    const referenceTrail = state.sprayMistTrails[Math.floor(state.sprayMistTrails.length / 2)] || state.sprayMistTrails[0] || [];
    const lastCenter = referenceTrail.length ? referenceTrail[referenceTrail.length - 1] : null;
    if (lastCenter) {
      const stepDist = Cesium.Cartesian3.distance(lastCenter, sample.center);
      if (stepDist < cfg.trailSpacingMeters) {
        setSprayMistVisibility(referenceTrail.length > 1);
        return;
      }
    }

    for (let i = 0; i < state.sprayMistTrails.length; i++) {
      const trail = state.sprayMistTrails[i];
      const lanePoint = sample.points[i];
      if (trail && lanePoint) {
        trail.push(lanePoint);
      }
    }
    trimSprayMistTrails(cfg.maxTrailPoints);
    setSprayMistVisibility(referenceTrail.length > 1);
  }

  function resolveSprayDefaultWidthMeters(points) {
    const widths = [];
    for (const p of points) {
      if (Number.isFinite(p.sprayWidthMeters) && p.sprayWidthMeters > 0) {
        widths.push(Number(p.sprayWidthMeters));
      }
    }

    if (widths.length) {
      return widths.reduce((acc, v) => acc + v, 0) / widths.length;
    }

    if (Number.isFinite(state.estimatedSprayWidthMeters) && state.estimatedSprayWidthMeters > 0) {
      return state.estimatedSprayWidthMeters;
    }

    return 30;
  }

  function resolveSprayWidthMetersForSegment(p0, p1, fallbackWidthMeters) {
    const segmentWidths = [];
    if (Number.isFinite(p0.sprayWidthMeters) && p0.sprayWidthMeters > 0) {
      segmentWidths.push(Number(p0.sprayWidthMeters));
    }
    if (Number.isFinite(p1.sprayWidthMeters) && p1.sprayWidthMeters > 0) {
      segmentWidths.push(Number(p1.sprayWidthMeters));
    }

    if (segmentWidths.length) {
      const avg = segmentWidths.reduce((acc, v) => acc + v, 0) / segmentWidths.length;
      return clamp(avg, 2, 200);
    }

    return clamp(Number(fallbackWidthMeters) || 30, 2, 200);
  }

  function toGroundCartesian(point) {
    return Cesium.Cartesian3.fromDegrees(point.lon, point.lat);
  }

  function toBalloonMeasureCartesian(point) {
    const measureLineHeightMeters = 120;
    if (!point) {
      return Cesium.Cartesian3.fromDegrees(0, 0, measureLineHeightMeters);
    }

    return Cesium.Cartesian3.fromDegrees(point.lon, point.lat, measureLineHeightMeters);
  }

  function createAircraftEntity(points) {
    const modelAltitudeOffsetMeters = resolveModelAltitudeOffsetMeters();
    const originalPosition = buildFlightPositionProperty(points, modelAltitudeOffsetMeters);
    const originalMarkerPosition = buildFlightPositionProperty(points, 0);
    const position = buildRefuelHoldPositionProperty(points, modelAltitudeOffsetMeters, originalPosition);
    const markerPosition = buildRefuelHoldPositionProperty(points, 0, originalMarkerPosition);

    const modelUri = UI.modelUrl.value.trim() || defaultAppConfig.modelUrl;
    const modelScale = resolveModelScale();
    const minimumPixelSize = resolveMinimumPixelSize();
    state.flightHeadingProperty = buildFlightHeadingProperty(points);
    state.turnBankProperty = buildTurnBankProperty(points);
    state.orientationProperty = buildAircraftOrientationProperty(position, state.turnBankProperty, points);

    state.flightEntity = state.viewer.entities.add({
      name: "Aeronave",
      position,
      orientation: state.orientationProperty,
      model: {
        uri: modelUri,
        minimumPixelSize,
        maximumScale: 20000,
        scale: modelScale,
        nodeTransformations: buildPropellerNodeTransformations(),
        heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        shadows: Cesium.ShadowMode.DISABLED,
        silhouetteColor: state.disableModelSilhouette ? Cesium.Color.TRANSPARENT : Cesium.Color.WHITE,
        silhouetteSize: state.disableModelSilhouette ? 0 : 1
      },
      path: {
        show: false
      }
    });

    state.aircraftMarker = state.viewer.entities.add({
      name: "Marcador Aeronave",
      show: state.aircraftMarkerVisible,
      position: markerPosition,
      point: {
        pixelSize: 10,
        color: Cesium.Color.YELLOW,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      },
      label: {
        text: "Aeronave",
        font: "12px sans-serif",
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        fillColor: Cesium.Color.YELLOW,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 3,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(0, -14),
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      }
    });
    createSprayMistEntities();
    applyModelAppearanceToEntity();
    applyModelSilhouetteState();
    applyAircraftMarkerVisibility();
    syncAircraftMarkerToggleButtonUI();
  }

  function buildFlightHeadingProperty(points) {
    const sampled = new Cesium.SampledProperty(Number);
    if (points.length < 2) {
      return sampled;
    }

    const n = points.length;
    const segmentHeadingsRad = new Array(n - 1);
    for (let i = 0; i < n - 1; i++) {
      segmentHeadingsRad[i] = Cesium.Math.toRadians(computeTrackHeadingDeg(points[i], points[i + 1]));
    }

    const pointHeadingsRad = new Array(n);
    pointHeadingsRad[0] = segmentHeadingsRad[0];
    for (let i = 1; i < n - 1; i++) {
      pointHeadingsRad[i] = averageAnglesRad(segmentHeadingsRad[i - 1], segmentHeadingsRad[i]);
    }
    pointHeadingsRad[n - 1] = segmentHeadingsRad[n - 2];

    const unwrapped = new Array(n);
    unwrapped[0] = pointHeadingsRad[0];
    for (let i = 1; i < n; i++) {
      const delta = Cesium.Math.negativePiToPi(pointHeadingsRad[i] - pointHeadingsRad[i - 1]);
      unwrapped[i] = unwrapped[i - 1] + delta;
    }

    for (let i = 0; i < n; i++) {
      const t = Cesium.JulianDate.fromDate(new Date(points[i].tSec * 1000));
      sampled.addSample(t, unwrapped[i]);
    }

    const interpolationAlgorithm = resolvePositionInterpolationAlgorithm();
    const interpolationDegree = resolvePositionInterpolationDegree(interpolationAlgorithm);
    sampled.setInterpolationOptions({
      interpolationDegree,
      interpolationAlgorithm
    });

    return sampled;
  }

  function averageAnglesRad(a, b) {
    const x = Math.cos(a) + Math.cos(b);
    const y = Math.sin(a) + Math.sin(b);
    if (Math.abs(x) < 1e-8 && Math.abs(y) < 1e-8) {
      return a;
    }
    return Math.atan2(y, x);
  }

  function resolveCameraChaseHeading(time) {
    const propertyHeading = Number(state.flightHeadingProperty?.getValue(time));
    if (Number.isFinite(propertyHeading)) {
      return propertyHeading;
    }

    const position = state.flightEntity?.position;
    const current = position?.getValue(time, scratchCurrentPosition);
    if (!current) {
      return 0;
    }

    const lookAheadSec = 0.15;
    const nextTime = Cesium.JulianDate.addSeconds(time, lookAheadSec, scratchAheadTime);
    const next = position?.getValue(nextTime, scratchNextPosition);
    if (!next) {
      return 0;
    }

    const currentGeo = Cesium.Cartographic.fromCartesian(current, undefined, scratchCurrentCartographic);
    const nextGeo = Cesium.Cartographic.fromCartesian(next, undefined, scratchNextCartographic);
    const headingDeg = computeTrackHeadingDeg(
      { lon: Cesium.Math.toDegrees(currentGeo.longitude), lat: Cesium.Math.toDegrees(currentGeo.latitude) },
      { lon: Cesium.Math.toDegrees(nextGeo.longitude), lat: Cesium.Math.toDegrees(nextGeo.latitude) }
    );
    return Cesium.Math.toRadians(headingDeg);
  }

  function resolveCameraChaseHeadingSmoothingSec() {
    const raw = Number(state.appConfig.cameraChaseHeadingSmoothingSec ?? defaultAppConfig.cameraChaseHeadingSmoothingSec);
    if (!Number.isFinite(raw)) {
      return defaultAppConfig.cameraChaseHeadingSmoothingSec;
    }
    return clamp(raw, 0, 1.5);
  }

  function resolvePositionInterpolationAlgorithm() {
    const raw = String(
      state.appConfig.positionInterpolationAlgorithm ?? defaultAppConfig.positionInterpolationAlgorithm
    ).trim().toLowerCase();

    if (raw === "linear") {
      return Cesium.LinearApproximation;
    }
    if (raw === "lagrange") {
      return Cesium.LagrangePolynomialApproximation || Cesium.LinearApproximation;
    }
    return Cesium.HermitePolynomialApproximation || Cesium.LinearApproximation;
  }

  function resolvePositionInterpolationDegree(algorithm) {
    if (algorithm === Cesium.LinearApproximation) {
      return 1;
    }

    const raw = Number(state.appConfig.positionInterpolationDegree ?? defaultAppConfig.positionInterpolationDegree);
    if (!Number.isFinite(raw)) {
      return defaultAppConfig.positionInterpolationDegree;
    }
    return clamp(Math.round(raw), 2, 5);
  }

  function smoothCameraHeading(targetHeadingRad) {
    const nowMs = performance.now();
    const dt = state.cameraHeadingLastUpdateMs > 0
      ? Math.min(0.25, (nowMs - state.cameraHeadingLastUpdateMs) / 1000)
      : 0;
    state.cameraHeadingLastUpdateMs = nowMs;

    if (!Number.isFinite(state.cameraSmoothedHeadingRad) || dt <= 0 || state.isScrubbing) {
      state.cameraSmoothedHeadingRad = targetHeadingRad;
      return targetHeadingRad;
    }

    const smoothingSec = resolveCameraChaseHeadingSmoothingSec();
    if (smoothingSec <= 0.001) {
      state.cameraSmoothedHeadingRad = targetHeadingRad;
      return targetHeadingRad;
    }

    const alpha = 1 - Math.exp(-dt / smoothingSec);
    const delta = Cesium.Math.negativePiToPi(targetHeadingRad - state.cameraSmoothedHeadingRad);
    state.cameraSmoothedHeadingRad += delta * alpha;
    return state.cameraSmoothedHeadingRad;
  }

  function resetCameraHeadingSmoothing() {
    state.cameraSmoothedHeadingRad = null;
    state.cameraHeadingLastUpdateMs = 0;
  }

  function buildTurnBankProperty(points) {
    const sampled = new Cesium.SampledProperty(Number);
    if (!points.length) {
      return sampled;
    }

    const useBanking = state.appConfig.enableTurnBanking !== false;
    const bankSeries = useBanking ? computeTurnBankSeries(points) : new Array(points.length).fill(0);

    for (let i = 0; i < points.length; i++) {
      const t = Cesium.JulianDate.fromDate(new Date(points[i].tSec * 1000));
      sampled.addSample(t, bankSeries[i] || 0);
    }

    sampled.setInterpolationOptions({
      interpolationDegree: 1,
      interpolationAlgorithm: Cesium.LinearApproximation
    });

    return sampled;
  }

  function computeTurnBankSeries(points) {
    const n = points.length;
    const bank = new Array(n).fill(0);
    if (n < 3) {
      return bank;
    }

    const maxDeg = Math.max(1, Number(state.appConfig.turnBankMaxDeg ?? defaultAppConfig.turnBankMaxDeg));
    const factor = Number(state.appConfig.turnBankFactor ?? defaultAppConfig.turnBankFactor) || 3.2;
    const deadzone = Math.max(0, Number(state.appConfig.turnBankDeadzoneDegPerSec ?? defaultAppConfig.turnBankDeadzoneDegPerSec));
    const sign = Number(state.appConfig.turnBankSign ?? defaultAppConfig.turnBankSign) >= 0 ? 1 : -1;
    const smoothing = clamp(Number(state.appConfig.turnBankSmoothing ?? defaultAppConfig.turnBankSmoothing), 0, 0.95);
    const alpha = clamp(1 - smoothing, 0.05, 1);

    const segmentHeadings = [];
    for (let i = 0; i < n - 1; i++) {
      segmentHeadings.push(computeTrackHeadingDeg(points[i], points[i + 1]));
    }

    const target = new Array(n).fill(0);
    for (let i = 1; i < n - 1; i++) {
      const deltaDeg = normalizeAngleDeg(segmentHeadings[i] - segmentHeadings[i - 1]);
      const prevIndex = Math.max(0, i - 2);
      const nextIndex = Math.min(segmentHeadings.length - 1, i + 1);
      const windowDeltaDeg = normalizeAngleDeg(segmentHeadings[nextIndex] - segmentHeadings[prevIndex]);
      const dt = Math.max(0.05, points[i + 1].tSec - points[i - 1].tSec);
      const turnRateDegPerSec = deltaDeg / dt;
      const curveDeltaDeg = Math.max(Math.abs(deltaDeg), Math.abs(windowDeltaDeg) * 0.45);

      if (Math.abs(turnRateDegPerSec) <= deadzone && curveDeltaDeg <= 0.12) {
        target[i] = 0;
        continue;
      }

      const rateBank = turnRateDegPerSec * factor;
      const curveBank = (Math.abs(windowDeltaDeg) > Math.abs(deltaDeg) ? windowDeltaDeg : deltaDeg) * Math.max(10, factor * 3.5);
      const desired = (Math.abs(curveBank) > Math.abs(rateBank) ? curveBank : rateBank) * sign;
      target[i] = clamp(desired, -maxDeg, maxDeg);
    }

    bank[0] = target[0];
    for (let i = 1; i < n; i++) {
      bank[i] = bank[i - 1] + alpha * (target[i] - bank[i - 1]);
    }
    for (let i = n - 2; i >= 0; i--) {
      bank[i] = bank[i + 1] + alpha * (bank[i] - bank[i + 1]);
    }

    bank[0] = 0;
    bank[n - 1] = 0;
    return bank.map((x) => clamp(x, -maxDeg, maxDeg));
  }

  function computeTrackHeadingDeg(p0, p1) {
    const lat1 = Cesium.Math.toRadians(p0.lat);
    const lat2 = Cesium.Math.toRadians(p1.lat);
    const dLon = Cesium.Math.toRadians(p1.lon - p0.lon);
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2)
      - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    return Cesium.Math.toDegrees(Math.atan2(y, x));
  }

  function normalizeAngleDeg(angle) {
    let a = angle;
    while (a > 180) a -= 360;
    while (a < -180) a += 360;
    return a;
  }

  function buildAircraftOrientationProperty(positionProperty, turnBankProperty, points) {
    const velocityOrientation = new Cesium.VelocityOrientationProperty(positionProperty);
    return new Cesium.CallbackProperty((time, result) => {
      const segmentIndex = findTimelineSegmentIndexBySecond(points || state.timelinePoints, Cesium.JulianDate.toDate(time).getTime() / 1000);
      let base = null;

      if (segmentIndex >= 0 && state.telemetrySegmentTypes[segmentIndex] === "refuel") {
        const position = positionProperty && positionProperty.getValue(time, scratchCurrentPosition);
        if (position) {
          const headingRad = state.flightHeadingProperty ? Number(state.flightHeadingProperty.getValue(time) || 0) : 0;
          scratchBankHpr.heading = Number.isFinite(headingRad) ? headingRad : 0;
          scratchBankHpr.pitch = 0;
          scratchBankHpr.roll = 0;
          base = Cesium.Transforms.headingPitchRollQuaternion(position, scratchBankHpr, Cesium.Ellipsoid.WGS84, undefined, scratchBaseOrientation);
        }
      }

      if (!base) {
        base = velocityOrientation.getValue(time, scratchBaseOrientation);
      }

      if (!base) {
        return undefined;
      }

      const bankDeg = segmentIndex >= 0 && state.telemetrySegmentTypes[segmentIndex] === "refuel"
        ? 0
        : (turnBankProperty ? Number(turnBankProperty.getValue(time) || 0) : 0);
      state.currentBankDeg = bankDeg;

      scratchBankHpr.heading = 0;
      scratchBankHpr.pitch = 0;
      scratchBankHpr.roll = Cesium.Math.toRadians(bankDeg);
      Cesium.Quaternion.fromHeadingPitchRoll(scratchBankHpr, scratchBankQuat);
      Cesium.Quaternion.multiply(base, scratchBankQuat, scratchWithBankOrientation);

      scratchModelHpr.heading = Cesium.Math.toRadians(state.modelOffsetsDeg.heading);
      scratchModelHpr.pitch = Cesium.Math.toRadians(state.modelOffsetsDeg.pitch);
      scratchModelHpr.roll = Cesium.Math.toRadians(state.modelOffsetsDeg.roll);
      Cesium.Quaternion.fromHeadingPitchRoll(scratchModelHpr, scratchModelOffsetQuat);
      const out = result || scratchFinalOrientation;
      return Cesium.Quaternion.multiply(scratchWithBankOrientation, scratchModelOffsetQuat, out);
    }, false);
  }

  function play() {
    if (!state.timelinePoints.length) {
      return;
    }
    if (state.isPlaying) {
      return;
    }
    state.isPlaying = true;
    state.lastFrameMs = performance.now();
    loop();
    setStatus(getReplay3DText("REPRODUCAO_INICIADA"));
  }

  function pause() {
    state.isPlaying = false;
    if (state.rafId) {
      cancelAnimationFrame(state.rafId);
      state.rafId = null;
    }
  }

  function toggleRepeatMode() {
    state.repeatEnabled = !state.repeatEnabled;
    syncRepeatButtonUI();
    setStatus(state.repeatEnabled
      ? getReplay3DText("REPETICAO_ATIVADA")
      : getReplay3DText("REPETICAO_DESATIVADA"));
  }

  function syncRepeatButtonUI() {
    const applyToButton = (button) => {
      if (!button) {
        return;
      }
      button.classList.toggle("is-active", state.repeatEnabled);
      button.setAttribute("aria-pressed", state.repeatEnabled ? "true" : "false");
      button.textContent = state.repeatEnabled ? getReplay3DText("REPETIR_LIGADO") : getReplay3DText("REPETIR_DESLIGADO");
    };

    applyToButton(UI.repeatBtn);
    applyToButton(UI.miniRepeatBtn);
  }

  function togglePanelVisibility() {
    state.panelCollapsed = !state.panelCollapsed;
    applyPanelVisibility();
  }

  function syncPanelToggleButtonUI() {
    const collapsed = !!state.panelCollapsed;
    if (UI.panelToggleBtn) {
      UI.panelToggleBtn.textContent = collapsed ? getReplay3DText("MOSTRAR_MENU") : getReplay3DText("OCULTAR_MENU");
      UI.panelToggleBtn.setAttribute("aria-pressed", collapsed ? "true" : "false");
      UI.panelToggleBtn.title = collapsed ? getReplay3DText("MOSTRAR_MENU_LATERAL") : getReplay3DText("OCULTAR_MENU_LATERAL");
    }
    if (UI.panelRestoreBtn) {
      UI.panelRestoreBtn.textContent = getReplay3DText("MOSTRAR_MENU");
      UI.panelRestoreBtn.setAttribute("aria-pressed", collapsed ? "true" : "false");
      UI.panelRestoreBtn.title = getReplay3DText("MOSTRAR_MENU_LATERAL");
    }
  }

  function applyPanelVisibility() {
    UI.appRoot?.classList.toggle("panel-collapsed", !!state.panelCollapsed);
    if (UI.compactControls) {
      UI.compactControls.setAttribute("aria-hidden", state.panelCollapsed ? "false" : "true");
    }
    syncPanelToggleButtonUI();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (state.viewer && typeof state.viewer.resize === "function") {
          state.viewer.resize();
        }
        if (state.viewer?.scene?.requestRender) {
          state.viewer.scene.requestRender();
        }
      });
    });
  }

  function loop() {
    if (!state.isPlaying) {
      return;
    }

    const now = performance.now();
    const dt = Math.min(0.08, (now - state.lastFrameMs) / 1000);
    state.lastFrameMs = now;

    const currentSec = currentClockSec();
    let nextSec = currentSec + dt * state.speed;
    nextSec = adjustPlaybackTimeForVisualSpeed(currentSec, nextSec);

    const candidateIndex = findNearestPointIndex(nextSec);
    const jumpSec = resolveTransitFocusJumpSec(candidateIndex);
    if (Number.isFinite(jumpSec) && jumpSec > nextSec) {
      nextSec = jumpSec;
    }

    if (nextSec >= state.endSec) {
      if (state.repeatEnabled) {
        nextSec = state.startSec;
      } else {
        nextSec = state.endSec;
        pause();
        setCurrentTime(nextSec, false);
        setStatus(getReplay3DText("REPRODUCAO_FINALIZADA"));
        return;
      }
    }

    setCurrentTime(nextSec, false);
    if (state.isPlaying) {
      state.rafId = requestAnimationFrame(loop);
    }
  }

  function currentClockSec() {
    return Cesium.JulianDate.toDate(state.viewer.clock.currentTime).getTime() / 1000;
  }

  function adjustPlaybackTimeForVisualSpeed(currentSec, proposedSec) {
    if (!Number.isFinite(currentSec) || !Number.isFinite(proposedSec) || proposedSec <= currentSec) {
      return proposedSec;
    }

    if (!Array.isArray(state.timelinePoints) || state.timelinePoints.length < 2) {
      return proposedSec;
    }

    let adjustedSec = currentSec;
    let remainingBaseSec = proposedSec - currentSec;
    let guard = 0;
    let maxFactorUsed = 1;
    let normalizedSegment = null;

    while (remainingBaseSec > 0.0001 && adjustedSec < state.endSec && guard < 24) {
      guard += 1;

      const segmentIndex = findCurrentTelemetrySegmentIndex(adjustedSec);
      if (segmentIndex <= 0 || segmentIndex >= state.timelinePoints.length) {
        adjustedSec += remainingBaseSec;
        break;
      }

      const segmentStartSec = Number(state.timelinePoints[segmentIndex - 1].tSec);
      const segmentEndSec = Number(state.timelinePoints[segmentIndex].tSec);
      if (!Number.isFinite(segmentStartSec) || !Number.isFinite(segmentEndSec) || segmentEndSec <= segmentStartSec) {
        adjustedSec += remainingBaseSec;
        break;
      }

      const availableSegmentSec = Math.max(0.001, segmentEndSec - adjustedSec);
      const baseStepSec = Math.min(remainingBaseSec, availableSegmentSec);
      const factor = resolvePlaybackVisualSpeedFactor(segmentIndex);
      maxFactorUsed = Math.max(maxFactorUsed, factor);

      if (factor > 1.001 && !normalizedSegment) {
        normalizedSegment = buildPlaybackVisualSpeedLog(segmentIndex, factor);
      }

      adjustedSec += baseStepSec * factor;
      remainingBaseSec -= baseStepSec;
    }

    const resultSec = Math.min(state.endSec, adjustedSec);
    maybeLogPlaybackVisualSpeedNormalization(currentSec, proposedSec, resultSec, maxFactorUsed, normalizedSegment);
    return resultSec;
  }

  function resolvePlaybackVisualSpeedFactor(segmentIndex) {
    const pts = state.timelinePoints;
    if (!Array.isArray(pts) || segmentIndex <= 0 || segmentIndex >= pts.length) {
      return 1;
    }

    const previous = pts[segmentIndex - 1];
    const current = pts[segmentIndex];
    const dtSec = Number(current.tSec) - Number(previous.tSec);
    if (!Number.isFinite(dtSec) || dtSec <= 0.2) {
      return 1;
    }

    const distM = distanceMeters(previous, current);
    if (!Number.isFinite(distM) || distM <= 8) {
      return 1;
    }

    const speedKmh = (distM / dtSec) * 3.6;
    if (!Number.isFinite(speedKmh) || speedKmh <= 8) {
      return 1;
    }

    const spraying = !!state.sprayFlags[segmentIndex] || !!state.sprayFlags[segmentIndex - 1];
    const segmentType = state.telemetrySegmentTypes && state.telemetrySegmentTypes[segmentIndex]
      ? state.telemetrySegmentTypes[segmentIndex]
      : "";
    const isBalloon = segmentType === "balloon";
    const targetSpeedKmh = spraying ? 175 : (isBalloon ? 175 : 135);
    const minimumExpectedSpeedKmh = spraying ? 125 : (isBalloon ? 165 : 95);

    if (speedKmh >= minimumExpectedSpeedKmh) {
      return 1;
    }

    return clamp(targetSpeedKmh / Math.max(speedKmh, 1), 1, 16);
  }

  function buildPlaybackVisualSpeedLog(segmentIndex, factor) {
    const previous = state.timelinePoints[segmentIndex - 1];
    const current = state.timelinePoints[segmentIndex];
    const dtSec = Number(current.tSec) - Number(previous.tSec);
    const distM = distanceMeters(previous, current);
    const speedKmh = dtSec > 0 && Number.isFinite(distM) ? (distM / dtSec) * 3.6 : null;

    return {
      segmentIndex,
      previousTsec: Number(previous.tSec),
      currentTsec: Number(current.tSec),
      dtSec: Number.isFinite(dtSec) ? Number(dtSec.toFixed(3)) : dtSec,
      distM: Number.isFinite(distM) ? Number(distM.toFixed(2)) : distM,
      speedKmh: Number.isFinite(speedKmh) ? Number(speedKmh.toFixed(1)) : speedKmh,
      factor: Number(factor.toFixed(2)),
      spraying: !!state.sprayFlags[segmentIndex] || !!state.sprayFlags[segmentIndex - 1],
      previousTiroName: previous.tiroName || "",
      currentTiroName: current.tiroName || ""
    };
  }

  function maybeLogPlaybackVisualSpeedNormalization(currentSec, proposedSec, resultSec, factor, segment) {
    if (!segment || factor <= 1.15) {
      return;
    }

    const nowMs = performance.now();
    if (state.lastPlaybackVisualSpeedLogMs && (nowMs - state.lastPlaybackVisualSpeedLogMs) < 900) {
      return;
    }

    state.lastPlaybackVisualSpeedLogMs = nowMs;
  }

  function logAltitudeValueAtPoint(index, fromSlider) {
    if (state.appConfig.enableAltitudeValuePointLog === false) {
      return;
    }

    if (!Array.isArray(state.timelinePoints) || !state.timelinePoints.length) {
      return;
    }

    const safeIndex = clamp(Math.round(index), 0, state.timelinePoints.length - 1);
    if (safeIndex === state.lastAltitudeValueLogIndex) {
      return;
    }

    const point = state.timelinePoints[safeIndex];
    if (!point) {
      return;
    }

    const previousPoint = safeIndex > 0 ? state.timelinePoints[safeIndex - 1] : null;
    const altitudeUsed = getAltitudeValueUsedForReplayLog(point);
    const previousAltitude = previousPoint ? getAltitudeValueUsedForReplayLog(previousPoint) : null;
    const diff = Number.isFinite(altitudeUsed) && Number.isFinite(previousAltitude) ? altitudeUsed - previousAltitude : null;
    const originalAltitude = getOriginalAltitudeValueForReplayLog(point);
    const adjustedByFilter = Number.isFinite(originalAltitude) && Number.isFinite(altitudeUsed) && Math.abs(originalAltitude - altitudeUsed) >= 0.01;
    const jumpMinMeters = resolveAltitudeValueJumpLogMinMeters();
    const isJump = Number.isFinite(diff) && Math.abs(diff) >= jumpMinMeters;
    const timeText = point.timeText || point.time || (Number.isFinite(point.tSec) ? new Date(point.tSec * 1000).toLocaleTimeString("pt-BR", { hour12: false }) : "");
    const sprayText = state.sprayFlags && state.sprayFlags[safeIndex] ? "SIM" : "NAO";
    const marker = adjustedByFilter ? " FILTRADO" : (isJump ? " SALTO" : "");

    state.lastAltitudeValueLogIndex = safeIndex;
  }

  function getAltitudeValueUsedForReplayLog(point) {
    if (!point) {
      return null;
    }

    const altitude = Number(point.alt);
    if (Number.isFinite(altitude)) {
      return altitude;
    }

    const adjusted = Number(point.altAdjusted);
    if (Number.isFinite(adjusted)) {
      return adjusted;
    }

    const original = Number(point.altOriginal);
    if (Number.isFinite(original)) {
      return original;
    }

    return null;
  }

  function getOriginalAltitudeValueForReplayLog(point) {
    if (!point) {
      return null;
    }

    const rawOriginal = Number(point.altOriginalRaw);
    if (Number.isFinite(rawOriginal)) {
      return rawOriginal;
    }

    const original = Number(point.altOriginal);
    if (Number.isFinite(original)) {
      return original;
    }

    const adjusted = Number(point.altAdjusted);
    if (Number.isFinite(adjusted)) {
      return adjusted;
    }

    const altitude = Number(point.alt);
    if (Number.isFinite(altitude)) {
      return altitude;
    }

    return null;
  }

  function resolveAltitudeValueJumpLogMinMeters() {
    const value = Number(state.appConfig.altitudeValueJumpLogMinMeters);
    const fallback = Number(defaultAppConfig.altitudeValueJumpLogMinMeters);
    return clamp(Number.isFinite(value) ? value : fallback, 1, 80);
  }

  function formatAltitudeValueForReplayLog(value) {
    const numberValue = Number(value);
    if (!Number.isFinite(numberValue)) {
      return "NA";
    }

    return String(Number(numberValue.toFixed(2)));
  }

  function setCurrentTime(tSec, fromSlider) {
    const clamped = Math.min(state.endSec, Math.max(state.startSec, tSec));
    state.viewer.clock.currentTime = Cesium.JulianDate.fromDate(new Date(clamped * 1000));

    if (!state.isScrubbing || fromSlider) {
      const sliderValue = String(timeToSlider(clamped));
      UI.timelineSlider.value = sliderValue;
      if (UI.miniTimelineSlider) {
        UI.miniTimelineSlider.value = sliderValue;
      }
    }

    const nearestIndex = findNearestPointIndex(clamped);
    logAltitudeValueAtPoint(nearestIndex, fromSlider);
    const officialSprayMistAllowed = isOfficialSprayMistAllowedAtPointIndex(nearestIndex);
    const sprayingForDisplay = officialSprayMistAllowed === null ? getSmoothedSprayDisplayState(nearestIndex) : officialSprayMistAllowed;
    const sprayingRaw = !!state.sprayFlags[nearestIndex];
    updateSprayFootprint(nearestIndex);
    updateProgressivePathEntity(nearestIndex);
    updateSprayMist(nearestIndex, clamped, sprayingForDisplay);
    updateCurrentBalloonMeasure(nearestIndex, sprayingRaw);
    updateTelemetryBoard(nearestIndex, clamped, fromSlider);
    const nowMs = performance.now();
    const shouldThrottleStatus = !fromSlider && (nowMs - state.lastStatusUpdateMs) < 180;
    if (shouldThrottleStatus && nearestIndex === state.lastShownNearestIndex) {
      state.lastShownNearestIndex = nearestIndex;
      return;
    }

    const spray = sprayingForDisplay ? "SIM" : "NAO";
    const tiroAtual = state.timelinePoints[nearestIndex]?.tiroName || "Fora de faixa";
    const bankTxt = `${state.currentBankDeg >= 0 ? "+" : ""}${state.currentBankDeg.toFixed(1)}°`;
    const stamp = new Date(clamped * 1000).toLocaleString("pt-BR", { hour12: false });
    setStatus(`Tempo: ${stamp} | Pulverizando: ${spray} | Tiro atual: ${tiroAtual} | Bank: ${bankTxt}`);
    state.lastStatusUpdateMs = nowMs;
    state.lastShownNearestIndex = nearestIndex;
  }

  function findNearestPointIndex(tSec) {
    const pts = state.timelinePoints;
    if (!pts.length) {
      return 0;
    }

    if (Number.isFinite(state.lastQuerySec) && tSec >= state.lastQuerySec && state.lastShownNearestIndex >= 0) {
      let idx = state.lastShownNearestIndex;
      while (idx + 1 < pts.length && pts[idx + 1].tSec <= tSec) {
        idx++;
      }
      state.lastQuerySec = tSec;
      return idx;
    }

    let lo = 0;
    let hi = pts.length - 1;

    while (lo < hi) {
      const mid = Math.floor((lo + hi) / 2);
      if (pts[mid].tSec < tSec) {
        lo = mid + 1;
      } else {
        hi = mid;
      }
    }

    const idx = lo;
    state.lastQuerySec = tSec;
    if (idx <= 0) {
      return 0;
    }
    return pts[idx].tSec > tSec ? idx - 1 : idx;
  }

  function sliderToTime(value) {
    const ratio = value / 1000;
    return state.startSec + ratio * state.durationSec;
  }

  function timeToSlider(tSec) {
    const ratio = (tSec - state.startSec) / Math.max(1, state.durationSec);
    return Math.round(ratio * 1000);
  }

  function setStatus(message, isError = false) {
    UI.statusBox.textContent = message;
    UI.statusBox.style.borderColor = isError ? "#e2a7a7" : "#d4e3c8";
    UI.statusBox.style.background = isError ? "#fceeee" : "#eef6e5";
  }


  function __travicarReplay3DGetOfficialValue(point, key) {
    if (!point && point !== 0) return null;
    if (key === undefined || key === null || key === '') return null;
    if (typeof key === 'number') return point[key];
    return point[key];
  }

  function __travicarReplay3DReadNumber(point, keys) {
    if (!point || !Array.isArray(keys)) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key === undefined || key === null || key === '') {
        continue;
      }

      const value = Number(__travicarReplay3DGetOfficialValue(point, key));
      if (Number.isFinite(value)) {
        return value;
      }
    }

    return null;
  }

  function __travicarReplay3DNormalizeLatLng(raw) {
    if (!raw) return null;
    if (Array.isArray(raw)) {
      if (raw.length < 2) return null;
      return { lat: Number(raw[0]), lon: Number(raw[1]), alt: Number(raw[2] || 0) };
    }
    const lat = raw.lat !== undefined && raw.lat !== null ? raw.lat : raw.latitude;
    const lon = raw.lng !== undefined && raw.lng !== null ? raw.lng : (raw.lon !== undefined && raw.lon !== null ? raw.lon : raw.longitude);
    const alt = raw.altitude !== undefined && raw.altitude !== null ? raw.altitude : (raw.alt !== undefined && raw.alt !== null ? raw.alt : raw.height);
    return { lat: Number(lat), lon: Number(lon), alt: Number(alt || 0) };
  }
  function __travicarReplay3DNormalizeOfficialFlag(value) {
    if (Array.isArray(value)) return value.length > 0;
    if (value && typeof value === 'object') return Object.keys(value).length > 0;
    return !!value;
  }
  function __travicarReplay3DDefaultField() {
    return {
      bearing: 'bearing', tempo: 'tempo', size: 'size', size_cross: 'size_cross', is_out: 'is_out',
      restante: 'restante', setAltura: 'setAltura', setFluxo: 'setFluxo', setLargura: 'setLargura',
      setVelocidade: 'setVelocidade', setVelocidadeV: 'setVelocidadeV', setDirecaoV: 'setDirecaoV',
      setTemperatura: 'setTemperatura', setUmidade: 'setUmidade', iApp: 'iApp', iSobre: 'iSobre',
      iFora: 'iFora', iLatlng: 'iLatlng', iAltura: 'iAltura', iFluxo: 'iFluxo', iVelocidade: 'iVelocidade',
      iVelocidadeV: 'iVelocidadeV', iDirecaoV: 'iDirecaoV', iTemperatura: 'iTemperatura', iHumidade: 'iHumidade'
    };
  }

  function __travicarReplay3DResolveIndexedItem(source, indexValue) {
    if (!Array.isArray(source) || !Array.isArray(indexValue) || indexValue.length < 4) {
      return null;
    }

    const group = source[indexValue[0]];
    const item = group && Array.isArray(group.item) ? group.item[indexValue[1]] : null;
    return item || null;
  }

  function __travicarReplay3DResolveIndexedValue(source, indexValue) {
    const item = __travicarReplay3DResolveIndexedItem(source, indexValue);
    if (!item || !Array.isArray(item.valor)) {
      return null;
    }

    const value = Number(item.valor[indexValue[3]]);
    return Number.isFinite(value) ? value : null;
  }

  function __travicarReplay3DResolveIndexedColor(source, indexValue) {
    const item = __travicarReplay3DResolveIndexedItem(source, indexValue);
    if (!item || typeof item.color !== "string") {
      return null;
    }

    const color = item.color.trim();
    return color ? color : null;
  }

  function __travicarReplay3DHasIndexedValue(source, indexValue) {
    return Number.isFinite(__travicarReplay3DResolveIndexedValue(source, indexValue));
  }

  function __travicarReplay3DReadQualityValue(data, zjobPoint, field, indexKey, sourceKey, fallbackKeys) {
    const indexValue = __travicarReplay3DGetOfficialValue(zjobPoint, indexKey);
    const indexedValue = __travicarReplay3DResolveIndexedValue(data && data[sourceKey], indexValue);
    if (Number.isFinite(indexedValue)) {
      return indexedValue;
    }
    return __travicarReplay3DReadNumber(zjobPoint, fallbackKeys || []);
  }

  function __travicarReplay3DBuildQualityConfig(data, config) {
    const cfg = config || {};
    const readMargin = function (name, fallback) {
      const value = Number(cfg[name]);
      return Number.isFinite(value) ? value : fallback;
    };
    const readSet = function (name, dataName, fallback) {
      const fromConfig = Number(cfg[name]);
      if (Number.isFinite(fromConfig)) return fromConfig;
      const fromData = Number(data && data[dataName]);
      if (Number.isFinite(fromData)) return fromData;
      return fallback;
    };

    return {
      altura: {
        setValue: readSet("alturaSet", "alturaSet", 4),
        marginDown: readMargin("alturaMargemDown", 1),
        marginUp: readMargin("alturaMargemUp", 1),
        limitDown: readMargin("alturaLimiteDown", 1),
        limitUp: readMargin("alturaLimiteUp", 1)
      },
      fluxo: {
        setValue: readSet("fluxoSet", "fluxoSet", 10),
        marginDown: readMargin("fluxoMargemDown", 2),
        marginUp: readMargin("fluxoMargemUp", 2),
        limitDown: readMargin("fluxoLimiteDown", 3),
        limitUp: readMargin("fluxoLimiteUp", 3)
      },
      velocidade: {
        setValue: readSet("velocidadeSet", "velocidadeSet", 180),
        marginDown: readMargin("velocidadeMargemDown", 10),
        marginUp: readMargin("velocidadeMargemUp", 10),
        limitDown: readMargin("velocidadeLimiteDown", 30),
        limitUp: readMargin("velocidadeLimiteUp", 30)
      },
      velocidadeVento: {
        setValue: readSet("velocidadeVSet", "velocidadeVSet", 10),
        marginDown: readMargin("velocidadeVMargemDown", 8),
        marginUp: readMargin("velocidadeVMargemUp", 8),
        limitDown: readMargin("velocidadeVLimiteDown", 2),
        limitUp: readMargin("velocidadeVLimiteUp", 12)
      },
      deltaT: {
        setValue: readSet("deltaTSet", "deltaTSet", 7),
        marginDown: readMargin("deltaTMargemDown", 2),
        marginUp: readMargin("deltaTMargemUp", 2),
        limitDown: readMargin("deltaTLimiteDown", 2),
        limitUp: readMargin("deltaTLimiteUp", 2)
      },
      temperatura: {
        setValue: readSet("temperaturaSet", "temperaturaSet", 22.5),
        marginDown: readMargin("temperaturaMargemDown", 17.5),
        marginUp: readMargin("temperaturaMargemUp", 17.5),
        limitDown: readMargin("temperaturaLimiteDown", 5),
        limitUp: readMargin("temperaturaLimiteUp", 10)
      },
      humidade: {
        setValue: readSet("umidadeSet", "umidadeSet", 52.5),
        marginDown: readMargin("umidadeMargemDown", 37.5),
        marginUp: readMargin("umidadeMargemUp", 37.5),
        limitDown: readMargin("umidadeLimiteDown", 5),
        limitUp: readMargin("umidadeLimiteUp", 10)
      }
    };
  }

  function __travicarReplay3DUpdateQualityAvailability(points) {
    const availability = { aplicacao: true };
    const keys = ["altura", "fluxo", "velocidade", "velocidadeVento", "direcaoVento", "deltaT", "temperatura", "humidade"];
    for (let i = 0; i < keys.length; i++) {
      availability[keys[i]] = false;
    }

    const officialQualityItems = collectOfficialQualityLineItems(state.officialSprayFootprintSourceData || {});
    for (let i = 0; i < officialQualityItems.length; i++) {
      if (officialQualityItems[i] && officialQualityItems[i].parameter) {
        availability[officialQualityItems[i].parameter] = true;
      }
    }

    if (!officialQualityItems.length) {
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        for (let j = 0; j < points.length; j++) {
          const point = points[j];
          if (point && point.qualityAvailable && point.qualityAvailable[key]) {
            availability[key] = true;
            break;
          }
        }
      }
    }

    state.sprayQualityAvailability = availability;
    if (!isSprayQualityParameterAvailable(state.sprayQualityParameter)) {
      state.sprayQualityParameter = resolveFirstAvailableSprayQualityParameter();
    }
  }

  function __travicarReplay3DBuildOfficialTimeline(data, field) {
    const f = field || __travicarReplay3DDefaultField();
    const path = Array.isArray(data && data.path) ? data.path : [];
    const pontos = Array.isArray(data && data.pontos) ? data.pontos : [];
    const hasPontos = pontos.length > 0;
    const count = hasPontos ? pontos.length : path.length;
    const rawPoints = [];
    for (let i = 0; i < count; i++) {
      const zjobPoint = pontos[i] || {};
      const pathLatLng = __travicarReplay3DNormalizeLatLng(path[i]);
      const pointLatLng = __travicarReplay3DNormalizeLatLng(__travicarReplay3DGetOfficialValue(zjobPoint, f.iLatlng));
      const latLng = pointLatLng && Number.isFinite(pointLatLng.lat) && Number.isFinite(pointLatLng.lon) ? pointLatLng : pathLatLng;
      if (!latLng || !Number.isFinite(latLng.lat) || !Number.isFinite(latLng.lon)) continue;
      const appFlag = __travicarReplay3DNormalizeOfficialFlag(__travicarReplay3DGetOfficialValue(zjobPoint, f.iApp));
      const overFlag = __travicarReplay3DNormalizeOfficialFlag(__travicarReplay3DGetOfficialValue(zjobPoint, f.iSobre));
      const outFlag = __travicarReplay3DNormalizeOfficialFlag(__travicarReplay3DGetOfficialValue(zjobPoint, f.iFora));
      const rawApplicationType = String(zjobPoint && zjobPoint.applicationType ? zjobPoint.applicationType : '').trim().toLowerCase();
      const rawTelemetryType = String(zjobPoint && zjobPoint.telemetryType ? zjobPoint.telemetryType : '').trim().toLowerCase();
      const refuelFlag = rawApplicationType === 'refuel' || rawTelemetryType === 'refuel';
      const alturaIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iAltura);
      const fluxoIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iFluxo);
      const velocidadeIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iVelocidade);
      const velocidadeVentoIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iVelocidadeV);
      const direcaoVentoIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iDirecaoV);
      const temperaturaIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iTemperatura);
      const humidadeIndex = __travicarReplay3DGetOfficialValue(zjobPoint, f.iHumidade);
      const rawAlturaIndexed = __travicarReplay3DResolveIndexedValue(data && data.altura, alturaIndex);
      const rawAltura = Number.isFinite(rawAlturaIndexed) ? rawAlturaIndexed : __travicarReplay3DReadNumber(zjobPoint, [f.iAltura, 'iAltura', 'altura', 'altitude']);
      const rawTempo = Number(__travicarReplay3DGetOfficialValue(zjobPoint, f.tempo));
      const rawWidth = Number(__travicarReplay3DGetOfficialValue(zjobPoint, f.setLargura));
      const rawFluxoIndexed = __travicarReplay3DResolveIndexedValue(data && data.fluxo, fluxoIndex);
      const rawFluxoDirect = __travicarReplay3DReadNumber(zjobPoint, [f.iFluxo, 'iFluxo', 'setFluxo', 'fluxo', 'flow', 'flowRate']);
      const rawFluxoSet = Number(data && data.fluxoSet);
      const rawFluxo = Number.isFinite(rawFluxoIndexed)
        ? rawFluxoIndexed
        : (Number.isFinite(rawFluxoDirect)
          ? rawFluxoDirect
          : (Number.isFinite(rawFluxoSet) ? rawFluxoSet : null));
      const rawVelocidade = __travicarReplay3DResolveIndexedValue(data && data.velocidade, velocidadeIndex);
      const rawVelocidadeVento = __travicarReplay3DResolveIndexedValue(data && data.vento_velocidade, velocidadeVentoIndex);
      const rawDirecaoVento = __travicarReplay3DResolveIndexedValue(data && data.vento_angulo, direcaoVentoIndex);
      const rawTemperatura = __travicarReplay3DResolveIndexedValue(data && data.temperatura, temperaturaIndex);
      const rawHumidade = __travicarReplay3DResolveIndexedValue(data && data.humidade, humidadeIndex);
      const rawDeltaT = __travicarReplay3DResolveIndexedValue(data && data.deltaT, temperaturaIndex);
      const qualityColors = {
        altura: __travicarReplay3DResolveIndexedColor(data && data.altura, alturaIndex),
        fluxo: __travicarReplay3DResolveIndexedColor(data && data.fluxo, fluxoIndex),
        velocidade: __travicarReplay3DResolveIndexedColor(data && data.velocidade, velocidadeIndex),
        velocidadeVento: __travicarReplay3DResolveIndexedColor(data && data.vento_velocidade, velocidadeVentoIndex),
        direcaoVento: __travicarReplay3DResolveIndexedColor(data && data.vento_angulo, direcaoVentoIndex),
        deltaT: __travicarReplay3DResolveIndexedColor(data && data.deltaT, temperaturaIndex),
        temperatura: __travicarReplay3DResolveIndexedColor(data && data.temperatura, temperaturaIndex),
        humidade: __travicarReplay3DResolveIndexedColor(data && data.humidade, humidadeIndex)
      };
      const qualityAvailable = {
        altura: __travicarReplay3DHasIndexedValue(data && data.altura, alturaIndex),
        fluxo: __travicarReplay3DHasIndexedValue(data && data.fluxo, fluxoIndex),
        velocidade: __travicarReplay3DHasIndexedValue(data && data.velocidade, velocidadeIndex),
        velocidadeVento: __travicarReplay3DHasIndexedValue(data && data.vento_velocidade, velocidadeVentoIndex),
        direcaoVento: __travicarReplay3DHasIndexedValue(data && data.vento_angulo, direcaoVentoIndex),
        deltaT: __travicarReplay3DHasIndexedValue(data && data.deltaT, temperaturaIndex),
        temperatura: __travicarReplay3DHasIndexedValue(data && data.temperatura, temperaturaIndex),
        humidade: __travicarReplay3DHasIndexedValue(data && data.humidade, humidadeIndex)
      };
      const altitudeMeters = normalizeOfficialRelativeAltitude(
        Number.isFinite(rawAltura) && rawAltura > 0 ? rawAltura : (Number.isFinite(latLng.alt) && latLng.alt > 0 ? latLng.alt : 6),
        refuelFlag ? 0.5 : 3
      );
      rawPoints.push({
        originalIndex: i,
        rawTempo: Number.isFinite(rawTempo) ? rawTempo : null,
        lon: latLng.lon,
        lat: latLng.lat,
        alt: altitudeMeters,
        altOriginal: altitudeMeters,
        altAdjusted: altitudeMeters,
        flow: Number.isFinite(rawFluxo) ? rawFluxo : null,
        speed: Number.isFinite(rawVelocidade) ? rawVelocidade : null,
        fuelLevel: __travicarReplay3DReadNumber(zjobPoint, ['fuelLevel', 'cargaAtual', 'carga_restante']),
        fuelCapacity: __travicarReplay3DReadNumber(zjobPoint, ['fuelCapacity', 'cargaMaxima', 'capacidadeCarga']),
        fuelPercent: __travicarReplay3DReadNumber(zjobPoint, ['fuelPercent', 'nivelCarga', 'nivelCombustivel']),
        refuelIndex: __travicarReplay3DReadNumber(zjobPoint, ['refuelIndex', 'abastecimentoIndex']),
        refuelCount: __travicarReplay3DReadNumber(zjobPoint, ['refuelCount', 'abastecimentos']),
        telemetryType: refuelFlag ? "refuel" : rawTelemetryType,
        applicationType: refuelFlag ? "refuel" : (outFlag ? "out" : (overFlag ? "over" : (appFlag ? "app" : null))),
        qualityValues: {
          altura: Number.isFinite(rawAltura) ? rawAltura : altitudeMeters,
          fluxo: Number.isFinite(rawFluxo) ? rawFluxo : null,
          velocidade: Number.isFinite(rawVelocidade) ? rawVelocidade : null,
          velocidadeVento: Number.isFinite(rawVelocidadeVento) ? rawVelocidadeVento : null,
          direcaoVento: Number.isFinite(rawDirecaoVento) ? rawDirecaoVento : null,
          deltaT: Number.isFinite(rawDeltaT) ? rawDeltaT : null,
          temperatura: Number.isFinite(rawTemperatura) ? rawTemperatura : null,
          humidade: Number.isFinite(rawHumidade) ? rawHumidade : null
        },
        qualityColors,
        qualityAvailable,
        spray: appFlag || overFlag || outFlag,
        spraySource: appFlag || overFlag || outFlag ? 'explicit_track' : 'none',
        sprayAxisHeadingDeg: null,
        tiroName: zjobPoint && zjobPoint.tiroName ? zjobPoint.tiroName : (appFlag ? 'Aplicação' : (overFlag ? 'Sobreposição' : (outFlag ? 'Fora' : null))),
        shotNumber: __travicarReplay3DReadNumber(zjobPoint, ['shotNumber', 'tiroNumber', 'tiro']),
        planningStripKey: zjobPoint && zjobPoint.planningStripKey !== undefined && zjobPoint.planningStripKey !== null ? zjobPoint.planningStripKey : (zjobPoint && zjobPoint.faixaKey !== undefined && zjobPoint.faixaKey !== null ? zjobPoint.faixaKey : null),
        planningStripName: zjobPoint && zjobPoint.planningStripName ? zjobPoint.planningStripName : null,
        sprayAreaName: null,
        sprayAreaKey: null,
        sprayAreaCentroidLon: null,
        sprayAreaCentroidLat: null,
        balloonMeasureWidthMeters: __travicarReplay3DReadNumber(zjobPoint, ['balloonMeasureWidthMeters']),
        balloonMeasureLengthMeters: __travicarReplay3DReadNumber(zjobPoint, ['balloonMeasureLengthMeters']),
        balloonMeasureWidthMaxMeters: __travicarReplay3DReadNumber(zjobPoint, ['balloonMeasureWidthMaxMeters', 'balloonMeasureWidthMeters']),
        balloonMeasureLengthMaxMeters: __travicarReplay3DReadNumber(zjobPoint, ['balloonMeasureLengthMaxMeters', 'balloonMeasureLengthMeters']),
        sprayWidthMeters: Number.isFinite(rawWidth) && rawWidth > 0 ? rawWidth : Number(data && data.larguraSet) || 30
      });
    }
    if (rawPoints.length < 2) return [];
    const times = rawPoints.map(p => p.rawTempo).filter(v => Number.isFinite(v));
    let divideBy = 1;
    if (times.length > 2) {
      const diffs = [];
      for (let i = 1; i < times.length; i++) if (times[i] > times[i - 1]) diffs.push(times[i] - times[i - 1]);
      diffs.sort((a, b) => a - b);
      const mid = diffs.length ? diffs[Math.floor(diffs.length / 2)] : 0;
      if (mid > 100 && mid < 10000) divideBy = 1000;
    }
    let previous = null;
    let synthetic = Date.now() / 1000;
    for (let i = 0; i < rawPoints.length; i++) {
      let t = Number.isFinite(rawPoints[i].rawTempo) ? rawPoints[i].rawTempo / divideBy : null;
      if (!Number.isFinite(t) || (previous !== null && t <= previous)) t = previous === null ? synthetic : previous + 1;
      rawPoints[i].tSec = t;
      previous = t;
    }
    if (rawPoints[0].tSec < 1000000000) {
      const baseSec = Date.now() / 1000;
      const start = rawPoints[0].tSec;
      for (let i = 0; i < rawPoints.length; i++) rawPoints[i].tSec = baseSec + (rawPoints[i].tSec - start);
    }
    return rawPoints;
  }
  async function __travicarPlanningReplay3DLoadOfficialData(data, polygons, field, modelUrl, qualityConfig, defaultAircraftId) {
    try {
      if (!state.viewer) { setStatus(getReplay3DText("AGUARDANDO_INICIALIZACAO_CESIUM"), false); return; }
      const requestedAircraftId = defaultAircraftId || getRuntimeDefaultAircraftId();
      const requestedModelById = requestedAircraftId ? findAircraftByRequestedId(requestedAircraftId) : null;
      const requestedModelByUrl = typeof modelUrl === "string" && modelUrl ? findAircraftByUrl(modelUrl) : null;
      const requestedModel = requestedModelById || requestedModelByUrl;
      let activeModel = requestedModel || findAircraftById(state.activeAircraftId) || state.aircraftModels[0] || null;
      if (activeModel) {
        applyAircraftModelSelection(activeModel, true);
      } else if (modelUrl) {
        state.appConfig.modelUrl = modelUrl;
        if (UI.modelUrl) UI.modelUrl.value = modelUrl;
      }
      activeModel = findAircraftById(state.activeAircraftId) || activeModel;
      const modelScale = Number.isFinite(activeModel?.scale) ? activeModel.scale : 0.2;
      const modelHeadingOffsetDeg = Number.isFinite(activeModel?.modelHeadingOffsetDeg) ? activeModel.modelHeadingOffsetDeg : 0;
      const modelPitchOffsetDeg = Number.isFinite(activeModel?.modelPitchOffsetDeg) ? activeModel.modelPitchOffsetDeg : 90;
      const modelRollOffsetDeg = Number.isFinite(activeModel?.modelRollOffsetDeg) ? activeModel.modelRollOffsetDeg : 0;
      const modelAltitudeOffsetMeters = Number.isFinite(activeModel?.modelAltitudeOffsetMeters) ? activeModel.modelAltitudeOffsetMeters : 5;
      state.appConfig.modelScale = modelScale;
      state.modelScale = modelScale;
      state.appConfig.cameraRangeMeters = 1300;
      state.appConfig.cameraPitchDeg = -30;
      state.appConfig.cameraHeadingOffsetDeg = 0;
      state.appConfig.modelAltitudeOffsetMeters = modelAltitudeOffsetMeters;
      state.appConfig.enableRealSpeedAltitudeAdjustment = false;
      state.appConfig.enableInitialStableAltitudeStart = false;
      state.modelOffsetsDeg = { heading: modelHeadingOffsetDeg, pitch: modelPitchOffsetDeg, roll: modelRollOffsetDeg };
      state.cameraOffsets = { headingDeg: 0, pitchDeg: -30, rangeMeters: 1300 };
      if (UI.modelScale) UI.modelScale.value = String(modelScale);
      if (UI.modelScaleValue) UI.modelScaleValue.textContent = `${Number(modelScale.toFixed(2))}x`;
      if (UI.cameraRange) UI.cameraRange.value = '1300';
      if (UI.cameraRangeValue) UI.cameraRangeValue.textContent = '1300 m';
      if (UI.cameraPitch) UI.cameraPitch.value = '-30';
      if (UI.cameraPitchValue) UI.cameraPitchValue.textContent = '-20°';
      if (UI.cameraHeadingOffset) UI.cameraHeadingOffset.value = '0';
      if (UI.cameraHeadingOffsetValue) UI.cameraHeadingOffsetValue.textContent = '0°';
      if (UI.modelHeadingOffset) UI.modelHeadingOffset.value = String(modelHeadingOffsetDeg);
      if (UI.modelHeadingOffsetValue) UI.modelHeadingOffsetValue.textContent = `${Number(modelHeadingOffsetDeg.toFixed(1))}°`;
      if (UI.modelPitchOffset) UI.modelPitchOffset.value = String(modelPitchOffsetDeg);
      if (UI.modelPitchOffsetValue) UI.modelPitchOffsetValue.textContent = `${Number(modelPitchOffsetDeg.toFixed(1))}°`;
      if (UI.modelRollOffset) UI.modelRollOffset.value = String(modelRollOffsetDeg);
      if (UI.modelRollOffsetValue) UI.modelRollOffsetValue.textContent = `${Number(modelRollOffsetDeg.toFixed(1))}°`;
      if (UI.modelAltitudeOffset) UI.modelAltitudeOffset.value = String(modelAltitudeOffsetMeters);
      if (UI.modelAltitudeOffsetValue) UI.modelAltitudeOffsetValue.textContent = `${Number(modelAltitudeOffsetMeters.toFixed(1))} m`;
      state.sprayQualityConfig = __travicarReplay3DBuildQualityConfig(data || {}, qualityConfig || {});
      state.telemetryOfficialTotalSec = resolveOfficialTotalSeconds(data || {});
      const points = __travicarReplay3DBuildOfficialTimeline(data || {}, field || __travicarReplay3DDefaultField());
      __travicarReplay3DUpdateQualityAvailability(points);
      syncSprayQualityControlsUI();
      if (points.length < 2) { setStatus(getReplay3DText("DADOS_INSUFICIENTES_REPLAY_3D"), true); return; }
      clearFlight();
      setStatus(getReplay3DText("CARREGANDO_REPLAY_3D_TRABALHO_ATUAL"));
      state.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
      const optimized = optimizeTrackPoints(points, Number(state.appConfig.maxTrackPoints || defaultAppConfig.maxTrackPoints));
      state.timelinePoints = optimized.points;
      state.lastAltitudeValueLogIndex = -1;
      __travicarReplay3DUpdateQualityAvailability(state.timelinePoints);
      syncSprayQualityControlsUI();
      for (let i = 0; i < state.timelinePoints.length; i++) {
        const altitudeMeters = normalizeOfficialRelativeAltitude(state.timelinePoints[i].alt, isTimelineRefuelPoint(state.timelinePoints[i]) ? 0.5 : 3);
        state.timelinePoints[i].alt = altitudeMeters;
        state.timelinePoints[i].altOriginal = altitudeMeters;
        state.timelinePoints[i].altAdjusted = altitudeMeters;
      }
      applyRealSpeedAltitudeAdjustment(state.timelinePoints);
      const initialStableAltitudeTrim = trimInitialAltitudeJumpPoints(state.timelinePoints);
      state.timelinePoints = initialStableAltitudeTrim.points;
      const obstacleAltitudeDropFilter = applyObstacleAltitudeDropFilter(state.timelinePoints);
      state.segmentSprayDecisions = buildSegmentSprayDecisions(state.timelinePoints);
      state.sprayFlags = derivePointSprayFlagsFromSegments(state.timelinePoints, state.segmentSprayDecisions);
      state.sprayAreaReferencePoint = buildSprayAreaReferencePoint(state.timelinePoints);
      if (!state.sprayAreaReferencePoint) state.transitFocusEnabled = false;
      syncTransitFocusToggleButtonUI();
      buildBalloonMeasureRuns(state.timelinePoints);
      buildTelemetryCaches(state.timelinePoints);
      state.startSec = state.timelinePoints[0].tSec;
      state.endSec = state.timelinePoints[state.timelinePoints.length - 1].tSec;
      state.durationSec = state.endSec - state.startSec;
      state.officialSprayFootprintSourceData = data || null;
      buildSprayFootprintRuns(state.timelinePoints, state.segmentSprayDecisions);
      drawSprayPaths(state.timelinePoints, state.segmentSprayDecisions);
      state.sprayAreaReferencePoint = buildSprayAreaReferencePoint(state.timelinePoints);
      if (!state.sprayAreaReferencePoint) state.transitFocusEnabled = false;
      syncTransitFocusToggleButtonUI();
      buildTelemetryCaches(state.timelinePoints);
      createAircraftEntity(state.timelinePoints);
      if (activeModel) {
        applyAircraftModelSelection(activeModel, true);
      }
      buildStartToFirstSprayMeasurement(state.timelinePoints);
      syncModelAlignmentUI();
      syncModelScaleUI();
      syncSprayFootprintStyleUI();
      syncCameraControlsUI();
      state.viewer.clock.startTime = Cesium.JulianDate.fromDate(new Date(state.startSec * 1000));
      state.viewer.clock.stopTime = Cesium.JulianDate.fromDate(new Date(state.endSec * 1000));
      state.viewer.clock.currentTime = Cesium.JulianDate.clone(state.viewer.clock.startTime);
      state.viewer.clock.multiplier = 1;
      state.viewer.clock.shouldAnimate = false;
      setFlightControlsEnabled(true);
      UI.timelineSlider.value = '0';
      if (UI.miniTimelineSlider) UI.miniTimelineSlider.value = '0';
      state.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(state.timelinePoints[0].lon, state.timelinePoints[0].lat, (Number.isFinite(state.timelinePoints[0].altAdjusted) ? state.timelinePoints[0].altAdjusted : state.timelinePoints[0].alt) + 900),
        orientation: { heading: 0, pitch: Cesium.Math.toRadians(-45), roll: 0 },
        duration: 1.2
      });
      if (state.flightEntity) state.viewer.trackedEntity = state.flightEntity;
      onViewModeSelectChanged(UI.viewModeSelect.value || state.cameraMode || 'follow');
      setCurrentTime(state.startSec, true);
      setStatus(getReplay3DText("REPLAY_3D_CARREGADO_DADOS_TRABALHO_ATUAL"));
      scheduleInitialTilesReadyNotification();
    } catch (error) {
      setStatus(error && error.message ? error.message : getReplay3DText("ERRO_CARREGAR_REPLAY_3D"), true);
    }
  }
  window.__travicarReplay3DLoadOfficialData = __travicarPlanningReplay3DLoadOfficialData;
  window.__travicarReplay3DDestroy = function () {
    try { pause(); } catch (err) { }
    try { clearInitialTilesReadyNotification(); } catch (err) { }
    try { removeScreenCompass(); } catch (err) { }
    try { if (state.viewer && !state.viewer.isDestroyed()) state.viewer.destroy(); } catch (err) { }
    window.__travicarReplay3DLoadOfficialData = null;
    window.__travicarReplay3DDestroy = null;
  };
}
